import { useQuery, useMutation, UseQueryOptions, UseMutationOptions } from '@tanstack/react-query';
import { request } from '../lib/graphqlRequest';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AbilityRule: { input: any; output: any; }
  BigInt: { input: number; output: number; }
  Cursor: { input: any; output: any; }
  Date: { input: string; output: string; }
  DateMonth: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  ExchangeRates: { input: any; output: any; }
  FloatPerYear: { input: any; output: any; }
  IntPerYear: { input: any; output: any; }
  JSON: { input: Record<string, any>; output: Record<string, any>; }
  LikertScaleValue: { input: any; output: any; }
  ObjectID: { input: string; output: string; }
  PathElement: { input: any; output: any; }
  PathKey: { input: any; output: any; }
  QuestionnaireTypeWeightsPerYear: { input: any; output: any; }
  SafeInt: { input: any; output: any; }
  StringFilterRegexOptions: { input: "i" | "g" | "m" | "u" | undefined; output: "i" | "g" | "m" | "u" | undefined; }
  SurveyAnsweredFor: { input: any; output: any; }
  SurveyItemDependencyAnswerValue: { input: any; output: any; }
  TranslationKey: { input: any; output: any; }
  URL: { input: any; output: any; }
  _Key: { input: any; output: any; }
};

export type Ability = {
  __typename?: 'Ability';
  /** @deprecated Gateway access only */
  _personId?: Maybe<Scalars['BigInt']['output']>;
  apex: Array<Scalars['JSON']['output']>;
  common: Array<Scalars['JSON']['output']>;
  dashboard: Array<Scalars['JSON']['output']>;
  /** @deprecated Use fieldForceManagementSubset.rules */
  fieldForceManagement: Array<Scalars['JSON']['output']>;
  fieldForceManagementSubset: FieldForceManagementAbility;
  greenland: Array<Scalars['JSON']['output']>;
  multisensoryExperience: Array<Scalars['JSON']['output']>;
  networkPlanning: Array<Scalars['JSON']['output']>;
  pcRoadmap: Array<Scalars['JSON']['output']>;
  porscheImportAgreements: Array<Scalars['JSON']['output']>;
  porscheStrategy2030: Array<Scalars['JSON']['output']>;
  realEstate: Array<Scalars['JSON']['output']>;
  retailDesign: Array<Scalars['JSON']['output']>;
  /** @deprecated Use common or the app abilities instead */
  rules: Array<Scalars['JSON']['output']>;
  survey: Array<Scalars['JSON']['output']>;
};

export type AbilityCheckResult = {
  __typename?: 'AbilityCheckResult';
  allowed: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type AcknowledgePcRoadmapCommitmentJointAgreementInput = {
  afterSalesFieldForce?: InputMaybe<Scalars['Boolean']['input']>;
  headOfSales?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ObjectID']['input'];
  managingDirector?: InputMaybe<Scalars['Boolean']['input']>;
  pfsFieldForce?: InputMaybe<Scalars['Boolean']['input']>;
  salesFieldForce?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActionItem = {
  __typename?: 'ActionItem';
  agendaItems?: Maybe<Array<AgendaItem>>;
  attachments?: Maybe<Array<Attachment>>;
  author: PersonReference;
  categories?: Maybe<Array<Category>>;
  changeHistory: Array<ActionItemChangeHistory>;
  /** @deprecated Use changeHistory field instead */
  changelog?: Maybe<Array<Changelog>>;
  coachingModules?: Maybe<Array<CoachingModule>>;
  comments: Array<Comment>;
  confidentialExceptForPersons?: Maybe<Array<Person>>;
  createdAt: Scalars['DateTime']['output'];
  createdByResource?: Maybe<Resources>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate: Scalars['DateTime']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  filledInAudit?: Maybe<FilledInAudit>;
  filledInAudits?: Maybe<Array<FilledInAudit>>;
  filledInSurveys?: Maybe<Array<FilledInSurvey>>;
  /** ffmAlias: actionItemId */
  id: Scalars['ObjectID']['output'];
  isConfidential?: Maybe<Scalars['Boolean']['output']>;
  isCreatedAsStandalone?: Maybe<Scalars['Boolean']['output']>;
  isFollowUp?: Maybe<Scalars['Boolean']['output']>;
  isOnVisibleAgenda?: Maybe<Scalars['Boolean']['output']>;
  kind?: Maybe<ActionItemKind>;
  kpiActualValue?: Maybe<Scalars['Float']['output']>;
  kpiInitialValue?: Maybe<Scalars['Float']['output']>;
  kpiTargetValue?: Maybe<Scalars['Float']['output']>;
  kpiUnit?: Maybe<Scalars['String']['output']>;
  kpiUnitCategory?: Maybe<KpiUnitCategory>;
  kpiUnitId?: Maybe<Scalars['ObjectID']['output']>;
  maskedMeetings?: Maybe<Array<MaskedMeeting>>;
  organization: Organization;
  pbsaValue?: Maybe<Scalars['Float']['output']>;
  peerGroup?: Maybe<Scalars['ObjectID']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  priority: ActionItemPriority;
  profitPotentialCurrency?: Maybe<Scalars['String']['output']>;
  profitPotentialIdentified?: Maybe<Scalars['Float']['output']>;
  profitPotentialRealized?: Maybe<Scalars['Float']['output']>;
  questionnaire?: Maybe<FilledInQuestionnaire>;
  questionnaires?: Maybe<Array<FilledInQuestionnaire>>;
  responsible: Person;
  source?: Maybe<Source>;
  status: ActionItemStatus;
  strategyImpact?: Maybe<StrategyImpact>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  widget?: Maybe<ActionItemWidget>;
  widgets?: Maybe<Array<ActionItemWidget>>;
};


export type ActionItemChangeHistoryArgs = {
  granularity?: InputMaybe<ChangeHistoryGranularity>;
};


export type ActionItemChangelogArgs = {
  filter?: InputMaybe<ChangelogFilter>;
};


export type ActionItemFilledInAuditArgs = {
  widgetId: Scalars['ObjectID']['input'];
};


export type ActionItemQuestionnaireArgs = {
  widgetId: Scalars['ObjectID']['input'];
};


export type ActionItemWidgetArgs = {
  widgetId: Scalars['ObjectID']['input'];
};

export type ActionItemChangeHistory = {
  __typename?: 'ActionItemChangeHistory';
  diffs: Array<ActionItemChangeHistoryDiff>;
  person: Person;
  timestamp: Scalars['DateTime']['output'];
};

export type ActionItemChangeHistoryDiff = ActionItemChangeHistoryDiffAny | ActionItemChangeHistoryDiffArray;

export type ActionItemChangeHistoryDiffAny = {
  __typename?: 'ActionItemChangeHistoryDiffAny';
  next?: Maybe<Scalars['JSON']['output']>;
  path: Array<Scalars['PathElement']['output']>;
  prev?: Maybe<Scalars['JSON']['output']>;
};

export type ActionItemChangeHistoryDiffArray = {
  __typename?: 'ActionItemChangeHistoryDiffArray';
  moved: Array<Scalars['JSON']['output']>;
  next?: Maybe<Array<Scalars['JSON']['output']>>;
  path: Array<Scalars['PathElement']['output']>;
  prev?: Maybe<Array<Scalars['JSON']['output']>>;
  pulled: Array<Scalars['JSON']['output']>;
  pushed: Array<Scalars['JSON']['output']>;
};

export type ActionItemCountByCategory = {
  __typename?: 'ActionItemCountByCategory';
  key: Scalars['ObjectID']['output'];
  value: Scalars['Int']['output'];
};

export type ActionItemCountByStatus = {
  __typename?: 'ActionItemCountByStatus';
  key: ActionItemStatus;
  value: Scalars['Int']['output'];
};

export type ActionItemFilter = {
  _and?: InputMaybe<Array<InputMaybe<ActionItemFilter>>>;
  _id?: InputMaybe<ObjectIdFilter>;
  _or?: InputMaybe<Array<InputMaybe<ActionItemFilter>>>;
  author_personId?: InputMaybe<BigIntFilter>;
  categories_categoryId?: InputMaybe<ObjectIdFilter>;
  changelog?: InputMaybe<ChangelogFilter>;
  coachingModules_coachingModuleId?: InputMaybe<ObjectIdFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdByResource_actionItemId?: InputMaybe<ObjectIdFilter>;
  createdByResource_apex__contextKey?: InputMaybe<ApexActionItemContextKeyFilter>;
  createdByResource_apex__resultId?: InputMaybe<ObjectIdFilter>;
  createdByResource_auditId?: InputMaybe<ObjectIdFilter>;
  createdByResource_questionGroupId?: InputMaybe<BigIntFilter>;
  createdByResource_questionId?: InputMaybe<ObjectIdFilter>;
  createdByResource_questionnaireId?: InputMaybe<ObjectIdFilter>;
  createdByResource_widgetId?: InputMaybe<ObjectIdFilter>;
  dueDate?: InputMaybe<DateTimeFilter>;
  isConfidential?: InputMaybe<BooleanFilter>;
  isFollowUp?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<ActionItemKindFilter>;
  kpiUnitCategory?: InputMaybe<ObjectIdFilter>;
  organization_geography_region?: InputMaybe<StringFilter>;
  organization_organizationId?: InputMaybe<BigIntFilter>;
  priority?: InputMaybe<ActionItemPriorityFilter>;
  profitPotentialIdentified?: InputMaybe<BigIntFilter>;
  profitPotentialRealized?: InputMaybe<BigIntFilter>;
  responsible_personId?: InputMaybe<BigIntFilter>;
  rootOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
  source?: InputMaybe<ActionItemSourceFilter>;
  status?: InputMaybe<ActionItemStatusFilter>;
  strategyImpactId?: InputMaybe<ObjectIdFilter>;
  tags?: InputMaybe<StringArrayFilter>;
  title?: InputMaybe<StringFilter>;
  widgets_questionnaireOrAuditId?: InputMaybe<ObjectIdFilter>;
};

export type ActionItemInput = {
  actionItemId?: InputMaybe<Scalars['ObjectID']['input']>;
  agendaItems?: InputMaybe<Array<AgendaReferenceInput>>;
  attachments?: InputMaybe<Array<InputMaybe<AttachmentInput>>>;
  attachmentsToCopy?: InputMaybe<CopyActionItemAttachmentsInput>;
  author?: InputMaybe<PersonReferenceInput>;
  categories?: InputMaybe<Array<CategoryReferenceInput>>;
  coachingModules?: InputMaybe<Array<CoachingModuleReferenceInput>>;
  confidentialExceptForPersons?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdByResource?: InputMaybe<ResourcesInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  isConfidential?: InputMaybe<Scalars['Boolean']['input']>;
  isCreatedAsStandalone?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<ActionItemKind>;
  kpiActualValue?: InputMaybe<Scalars['Float']['input']>;
  kpiInitialValue?: InputMaybe<Scalars['Float']['input']>;
  kpiTargetValue?: InputMaybe<Scalars['Float']['input']>;
  kpiUnit?: InputMaybe<Scalars['String']['input']>;
  kpiUnitCategoryId?: InputMaybe<Scalars['ObjectID']['input']>;
  kpiUnitId?: InputMaybe<Scalars['ObjectID']['input']>;
  organization: OrganizationReferenceInput;
  pbsaValue?: InputMaybe<Scalars['Float']['input']>;
  peerGroup?: InputMaybe<Scalars['ObjectID']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  priority: ActionItemPriority;
  profitPotentialCurrency?: InputMaybe<Scalars['String']['input']>;
  profitPotentialIdentified?: InputMaybe<Scalars['Float']['input']>;
  profitPotentialRealized?: InputMaybe<Scalars['Float']['input']>;
  responsible: PersonReferenceInput;
  source?: InputMaybe<Source>;
  status: ActionItemStatus;
  strategyImpact?: InputMaybe<StrategyImpactReferenceInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
  widgets?: InputMaybe<ModifyActionItemWidgetsInput>;
};

export enum ActionItemKind {
  Dealer = 'DEALER',
  Mpi = 'MPI',
  Pbe = 'PBE',
  Plt = 'PLT',
  Standard = 'STANDARD'
}

export type ActionItemKindFilter = {
  _eq?: InputMaybe<ActionItemKind>;
  _in?: InputMaybe<Array<InputMaybe<ActionItemKind>>>;
};

export enum ActionItemPriority {
  High = 'HIGH',
  Normal = 'NORMAL'
}

export type ActionItemPriorityFilter = {
  _in?: InputMaybe<Array<InputMaybe<ActionItemPriority>>>;
};

export type ActionItemRecipient = {
  __typename?: 'ActionItemRecipient';
  organization: OrganizationReference;
  responsible: PersonReference;
};

export type ActionItemRecipientInput = {
  organization: OrganizationReferenceInput;
  responsible: PersonReferenceInput;
};

export type ActionItemSort = {
  author_name?: InputMaybe<SortOrder>;
  categories?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dueDate?: InputMaybe<SortOrder>;
  kind?: InputMaybe<SortOrder>;
  organization_name?: InputMaybe<SortOrder>;
  priority?: InputMaybe<SortOrder>;
  responsible_name?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  strategyImpact?: InputMaybe<SortOrder>;
  tags?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ActionItemSourceFilter = {
  _eq?: InputMaybe<Source>;
  _exists?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<InputMaybe<Source>>>;
  _ne?: InputMaybe<Source>;
  _nin?: InputMaybe<Array<InputMaybe<Source>>>;
};

export type ActionItemStatistic = {
  __typename?: 'ActionItemStatistic';
  count: Scalars['Int']['output'];
  date: Scalars['DateTime']['output'];
};

export type ActionItemStatisticInput = {
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
  granularity: StatisticGranularity;
  organizationId: Scalars['BigInt']['input'];
};

export enum ActionItemStatus {
  '1Assigned' = '_1_ASSIGNED',
  '2InProgress' = '_2_IN_PROGRESS',
  '3NotPossible' = '_3_NOT_POSSIBLE',
  '4Done' = '_4_DONE',
  '5Finished' = '_5_FINISHED'
}

export type ActionItemStatusFilter = {
  _in?: InputMaybe<Array<InputMaybe<ActionItemStatus>>>;
  _nin?: InputMaybe<Array<InputMaybe<ActionItemStatus>>>;
};

export type ActionItemTemplate = {
  __typename?: 'ActionItemTemplate';
  attachments?: Maybe<Array<Maybe<Attachment>>>;
  author?: Maybe<Person>;
  categories?: Maybe<Array<CategoryReference>>;
  coachingModules?: Maybe<Array<CoachingModule>>;
  confidentialExceptForPersons?: Maybe<Array<Person>>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  /** ffmAlias: actionItemTemplateId */
  id: Scalars['ObjectID']['output'];
  isBroadcasting?: Maybe<Scalars['Boolean']['output']>;
  isConfidential?: Maybe<Scalars['Boolean']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  kind?: Maybe<ActionItemKind>;
  kpiActualValue?: Maybe<Scalars['Float']['output']>;
  kpiInitialValue?: Maybe<Scalars['Float']['output']>;
  kpiTargetValue?: Maybe<Scalars['Float']['output']>;
  kpiUnit?: Maybe<Scalars['String']['output']>;
  kpiUnitCategory?: Maybe<KpiUnitCategory>;
  kpiUnitId?: Maybe<Scalars['ObjectID']['output']>;
  organization?: Maybe<OrganizationReference>;
  peerGroup?: Maybe<Scalars['ObjectID']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<ActionItemPriority>;
  profitPotentialCurrency?: Maybe<Scalars['String']['output']>;
  profitPotentialIdentified?: Maybe<Scalars['Float']['output']>;
  profitPotentialRealized?: Maybe<Scalars['Float']['output']>;
  recipients?: Maybe<Array<ActionItemRecipient>>;
  responsible?: Maybe<PersonReference>;
  status?: Maybe<ActionItemStatus>;
  strategyImpact?: Maybe<StrategyImpact>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ActionItemTemplateInput = {
  attachments?: InputMaybe<Array<InputMaybe<AttachmentInput>>>;
  categories?: InputMaybe<Array<CategoryReferenceInput>>;
  coachingModules?: InputMaybe<Array<CoachingModuleReferenceInput>>;
  confidentialExceptForPersons?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  isBroadcasting?: InputMaybe<Scalars['Boolean']['input']>;
  isConfidential?: InputMaybe<Scalars['Boolean']['input']>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<ActionItemKind>;
  kpiActualValue?: InputMaybe<Scalars['Float']['input']>;
  kpiInitialValue?: InputMaybe<Scalars['Float']['input']>;
  kpiTargetValue?: InputMaybe<Scalars['Float']['input']>;
  kpiUnit?: InputMaybe<Scalars['String']['input']>;
  kpiUnitCategoryId?: InputMaybe<Scalars['ObjectID']['input']>;
  kpiUnitId?: InputMaybe<Scalars['ObjectID']['input']>;
  organization?: InputMaybe<OrganizationReferenceInput>;
  peerGroup?: InputMaybe<Scalars['ObjectID']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<ActionItemPriority>;
  profitPotentialCurrency?: InputMaybe<Scalars['String']['input']>;
  profitPotentialIdentified?: InputMaybe<Scalars['Float']['input']>;
  profitPotentialRealized?: InputMaybe<Scalars['Float']['input']>;
  recipients?: InputMaybe<Array<ActionItemRecipientInput>>;
  responsible?: InputMaybe<PersonReferenceInput>;
  status?: InputMaybe<ActionItemStatus>;
  strategyImpact?: InputMaybe<StrategyImpactReferenceInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
};

export type ActionItemWidget = {
  isRemoved?: Maybe<Scalars['Boolean']['output']>;
  kind: WidgetKind;
  widgetId: Scalars['ObjectID']['output'];
};

export type ActionItemsByCategory = {
  __typename?: 'ActionItemsByCategory';
  categories: Array<ActionItemCountByCategory>;
  organizations: Array<Scalars['BigInt']['output']>;
};

export type AgendaActionItem = ActionItem | MaskedActionItem;

export type AgendaItem = {
  __typename?: 'AgendaItem';
  actionItems?: Maybe<Array<AgendaActionItem>>;
  attachments?: Maybe<Array<Attachment>>;
  attendees?: Maybe<Array<PersonReference>>;
  categories?: Maybe<Array<Category>>;
  description?: Maybe<Scalars['String']['output']>;
  externals?: Maybe<Array<Scalars['String']['output']>>;
  itemId: Scalars['Int']['output'];
  meeting: Meeting;
  order?: Maybe<Scalars['Int']['output']>;
  scheduledTimeEnd?: Maybe<Scalars['DateTime']['output']>;
  scheduledTimeStart?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
};

export type AgendaItemInput = {
  actionItems?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  attachments?: InputMaybe<Array<InputMaybe<AttachmentInput>>>;
  attachmentsToCopy?: InputMaybe<CopyAgendaItemAttachmentsInput>;
  attendees?: InputMaybe<Array<PersonReferenceInput>>;
  categories?: InputMaybe<Array<CategoryReferenceInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  externals?: InputMaybe<Array<Scalars['String']['input']>>;
  itemId: Scalars['Int']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  scheduledTimeEnd?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledTimeStart?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AgendaReferenceInput = {
  itemId: Scalars['Int']['input'];
  meeting: MeetingReferenceInput;
};

export type Analytics = {
  __typename?: 'Analytics';
  eventCount: Scalars['Int']['output'];
  eventDate: Scalars['Date']['output'];
  organization?: Maybe<Organization>;
  role?: Maybe<Scalars['String']['output']>;
};

export enum AnalyticsEvent {
  Login = 'LOGIN',
  OfflineMode = 'OFFLINE_MODE',
  OpenChangeHistory = 'OPEN_CHANGE_HISTORY'
}

export enum AnalyticsGranularity {
  Day = 'DAY',
  Month = 'MONTH',
  Year = 'YEAR'
}

export enum AnalyticsGroupBy {
  MarketRole = 'MARKET_ROLE',
  Role = 'ROLE'
}

export type AnalyticsInput = {
  app: Scalars['String']['input'];
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
  event: AnalyticsEvent;
  granularity: AnalyticsGranularity;
  groupBy?: AnalyticsGroupBy;
  organizationId?: InputMaybe<Scalars['BigInt']['input']>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Announcement = {
  __typename?: 'Announcement';
  from?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ObjectID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isUserFeedbackActive?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['Date']['output']>;
  userFeedbackUrl?: Maybe<Scalars['URL']['output']>;
};

export type AnonymousPerson = {
  __typename?: 'AnonymousPerson';
  ability: Ability;
  id: Scalars['ID']['output'];
};

export type AnswerSurveyDateQuestionInput = {
  attachments?: InputMaybe<ModifyAttachmentsInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  isNotApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['Date']['input']>;
};

export type AnswerSurveyLikertScaleQuestionInput = {
  attachments?: InputMaybe<ModifyAttachmentsInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  isNotApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['LikertScaleValue']['input']>;
};

export type AnswerSurveyMultipleChoiceQuestionInput = {
  attachments?: InputMaybe<ModifyAttachmentsInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  isNotApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  otherText?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
};

export type AnswerSurveyMultipleEntryQuestionInput = {
  attachments?: InputMaybe<ModifyAttachmentsInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  isNotApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<AnswerSurveyMultipleEntryQuestionInputModifyValue>;
};

export type AnswerSurveyMultipleEntryQuestionInputEntry = {
  entryId: Scalars['ObjectID']['input'];
  value: Scalars['Int']['input'];
};

export type AnswerSurveyMultipleEntryQuestionInputModifyValue = {
  _pull?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  _push?: InputMaybe<Array<AnswerSurveyMultipleEntryQuestionInputEntry>>;
  _update?: InputMaybe<Array<AnswerSurveyMultipleEntryQuestionInputUpdateEntry>>;
};

export type AnswerSurveyMultipleEntryQuestionInputUpdateEntry = {
  entryId: Scalars['ObjectID']['input'];
  id: Scalars['ObjectID']['input'];
  value: Scalars['Int']['input'];
};

export type AnswerSurveyNumericQuestionInput = {
  attachments?: InputMaybe<ModifyAttachmentsInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  isNotApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type AnswerSurveyQuestionInput = {
  actionItemIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  answerDate?: InputMaybe<AnswerSurveyDateQuestionInput>;
  answerLikertScale?: InputMaybe<AnswerSurveyLikertScaleQuestionInput>;
  answerMultipleChoice?: InputMaybe<AnswerSurveyMultipleChoiceQuestionInput>;
  answerMultipleEntry?: InputMaybe<AnswerSurveyMultipleEntryQuestionInput>;
  answerNumeric?: InputMaybe<AnswerSurveyNumericQuestionInput>;
  answerText?: InputMaybe<AnswerSurveyTextQuestionInput>;
  answerUpload?: InputMaybe<AnswerSurveyUploadQuestionInput>;
  answerYesNo?: InputMaybe<AnswerSurveyYesNoQuestionInput>;
  answeredFor: Scalars['SurveyAnsweredFor']['input'];
  itemId: Scalars['ObjectID']['input'];
  period?: InputMaybe<Scalars['Date']['input']>;
  surveyId: Scalars['ObjectID']['input'];
};

export type AnswerSurveyTextQuestionInput = {
  attachments?: InputMaybe<ModifyAttachmentsInput>;
  isNotApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type AnswerSurveyUploadQuestionInput = {
  attachments?: InputMaybe<ModifyAttachmentsInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  isNotApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<ModifyAttachmentsInput>;
};

export type AnswerSurveyYesNoQuestionInput = {
  attachments?: InputMaybe<ModifyAttachmentsInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  isNotApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<SurveyYesNoAnswerValue>;
};

export enum AnswerType {
  QuestionnaireCurrencyAnswer = 'QuestionnaireCurrencyAnswer',
  QuestionnaireMultipleChoiceAnswer = 'QuestionnaireMultipleChoiceAnswer',
  QuestionnaireTextAnswer = 'QuestionnaireTextAnswer',
  QuestionnaireYesNoAnswer = 'QuestionnaireYesNoAnswer'
}

export type Answerable = Organization | Person | SurveyAnonymousUser;

export enum AnswerableType {
  Anonymous = 'anonymous',
  Organization = 'organization',
  Person = 'person'
}

export type AnswersAllowedByPerOrganization = {
  __typename?: 'AnswersAllowedByPerOrganization';
  organization: Organization;
  persons: Array<Person>;
};

export type AnswersAllowedByPerOrganizationInput = {
  organizationId: Scalars['BigInt']['input'];
  personIds: Array<Scalars['BigInt']['input']>;
};

export enum ApexActionItemContextKey {
  Challenges = 'CHALLENGES',
  SafeKpiNoAppointmentInvitationReceived = 'SAFE_KPI_NO_APPOINTMENT_INVITATION_RECEIVED',
  SafeKpiNoContactDataCollected = 'SAFE_KPI_NO_CONTACT_DATA_COLLECTED',
  SafeKpiNoFollowUpReceived = 'SAFE_KPI_NO_FOLLOW_UP_RECEIVED',
  SafeKpiNoOfferReceived = 'SAFE_KPI_NO_OFFER_RECEIVED',
  SafeKpiNoTestDriveOffered = 'SAFE_KPI_NO_TEST_DRIVE_OFFERED',
  Strengths = 'STRENGTHS'
}

export type ApexActionItemContextKeyFilter = {
  _eq?: InputMaybe<ApexActionItemContextKey>;
  _in?: InputMaybe<Array<InputMaybe<ApexActionItemContextKey>>>;
};

export type ApexEmailNotification = {
  __typename?: 'ApexEmailNotification';
  adhoc?: Maybe<Scalars['Boolean']['output']>;
  cron?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  person: Person;
  topic: ApexEmailNotificationTopic;
};

export enum ApexEmailNotificationTopic {
  ApexImportDataCreation = 'APEX_IMPORT_DATA_CREATION'
}

export type ApexImportSchedule = {
  __typename?: 'ApexImportSchedule';
  cron: Scalars['String']['output'];
};

export type ApexImportState = {
  __typename?: 'ApexImportState';
  addedRecords?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectID']['output'];
  isRunning: Scalars['Boolean']['output'];
  startedAt: Scalars['DateTime']['output'];
  unresolvedOrganizations?: Maybe<Array<ApexImportUnresolvedOrganization>>;
  updatedRecords?: Maybe<Scalars['Int']['output']>;
};

export type ApexImportUnresolvedOrganization = {
  __typename?: 'ApexImportUnresolvedOrganization';
  organizations: Array<Organization>;
  partnerNumber?: Maybe<Scalars['String']['output']>;
  storeName: Scalars['String']['output'];
};

export type ApexQuestionnaire = {
  __typename?: 'ApexQuestionnaire';
  id: Scalars['ObjectID']['output'];
  kind: ApexQuestionnaireKind;
  name: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export enum ApexQuestionnaireKind {
  OffSite = 'OFF_SITE',
  OnSite = 'ON_SITE'
}

export type ApexResult = {
  __typename?: 'ApexResult';
  id: Scalars['ObjectID']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
  questionnaire: ApexQuestionnaire;
  sampleSize: Scalars['Int']['output'];
  scores: Array<ApexResultScore>;
  year: Scalars['Int']['output'];
};

export enum ApexResultAggregationLevel {
  Importer = 'IMPORTER',
  Market = 'MARKET',
  Pag = 'PAG',
  PorscheCenter = 'PORSCHE_CENTER'
}

export type ApexResultFilterInput = {
  _and?: InputMaybe<Array<ApexResultFilterInput>>;
  _or?: InputMaybe<Array<ApexResultFilterInput>>;
  aggregationLevel?: InputMaybe<ApexResultAggregationLevel>;
  organization?: InputMaybe<BigIntFilter>;
  questionnaire?: InputMaybe<ObjectIdFilter>;
};

export type ApexResultScore = {
  __typename?: 'ApexResultScore';
  distribution: Array<ApexResultScoreDistribution>;
  kind: ApexResultScoreKind;
  sampleSize: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type ApexResultScoreDistribution = {
  __typename?: 'ApexResultScoreDistribution';
  kind: ApexResultScoreDistributionKind;
  value?: Maybe<Scalars['Float']['output']>;
};

export enum ApexResultScoreDistributionKind {
  Advocates = 'ADVOCATES',
  Ambassadors = 'AMBASSADORS',
  Definitely = 'DEFINITELY',
  DefinitelyNot = 'DEFINITELY_NOT',
  Disappointed = 'DISAPPOINTED',
  IllMouthers = 'ILL_MOUTHERS',
  No = 'NO',
  Probably = 'PROBABLY',
  ProbablyNot = 'PROBABLY_NOT',
  Uncertain = 'UNCERTAIN',
  Unimpressed = 'UNIMPRESSED',
  Yes = 'YES'
}

export enum ApexResultScoreKind {
  Advocacy = 'ADVOCACY',
  AppointmentInvitation = 'APPOINTMENT_INVITATION',
  ContactDetails = 'CONTACT_DETAILS',
  FollowUp = 'FOLLOW_UP',
  ProactiveOffer = 'PROACTIVE_OFFER',
  Purchase = 'PURCHASE',
  TestDrive = 'TEST_DRIVE'
}

export enum AssignmentType {
  PorscheCenter = 'PORSCHE_CENTER',
  PorscheImporter = 'PORSCHE_IMPORTER'
}

export type Attachment = {
  __typename?: 'Attachment';
  createdAt: Scalars['DateTime']['output'];
  filePrefix?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  uploader?: Maybe<Person>;
};

export type AttachmentInput = {
  /** @deprecated Field no longer supported */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  filePrefix?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ObjectID']['input'];
  name: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

export type Audit = {
  __typename?: 'Audit';
  additionalPersons?: Maybe<Array<Person>>;
  allowMultipleAssignments?: Maybe<Scalars['Boolean']['output']>;
  author: PersonReference;
  children: Array<AuditItem>;
  copiedFrom?: Maybe<Scalars['ObjectID']['output']>;
  copyAnswersActionItemId?: Maybe<Scalars['ObjectID']['output']>;
  /** ffmAlias: auditId */
  id: Scalars['ObjectID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isAssigned?: Maybe<Scalars['Boolean']['output']>;
  languages: Array<Scalars['String']['output']>;
  name: Scalars['JSON']['output'];
  organizations: Array<Organization>;
};


export type AuditCopyAnswersActionItemIdArgs = {
  actionItemId: Scalars['ObjectID']['input'];
};

export type AuditAnswer = {
  item: AuditItem;
  questionGroupId?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

export type AuditAnswerInput = {
  itemId: Scalars['ObjectID']['input'];
  questionGroupId?: InputMaybe<Scalars['Int']['input']>;
  yesNoAnswer?: InputMaybe<AuditYesNoAnswerInput>;
};

export type AuditFilter = {
  _and?: InputMaybe<Array<InputMaybe<AuditFilter>>>;
  _or?: InputMaybe<Array<InputMaybe<AuditFilter>>>;
  author_personId?: InputMaybe<BigIntFilter>;
  isActive?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<TranslationFilter>;
  organizations_organizationId?: InputMaybe<BigIntFilter>;
};

export type AuditInput = {
  additionalPersons?: InputMaybe<Array<PersonReferenceInput>>;
  allowMultipleAssignments?: InputMaybe<Scalars['Boolean']['input']>;
  children?: InputMaybe<Array<AuditItemInput>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['JSON']['input']>;
  organizations?: InputMaybe<Array<OrganizationReferenceInput>>;
};

export type AuditItem = {
  /** ffmAlias: itemId */
  id: Scalars['ObjectID']['output'];
  kind: AuditItemKind;
  score?: Maybe<Scalars['Float']['output']>;
};

export type AuditItemInput = {
  allowComment?: InputMaybe<Scalars['Boolean']['input']>;
  allowFollowUp?: InputMaybe<Scalars['Boolean']['input']>;
  allowNotApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  allowUpload?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  dynamicMax?: InputMaybe<Scalars['Int']['input']>;
  dynamicMin?: InputMaybe<Scalars['Int']['input']>;
  dynamicTitle?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ObjectID']['input'];
  isCopied?: InputMaybe<Scalars['Boolean']['input']>;
  isDynamic?: InputMaybe<Scalars['Boolean']['input']>;
  kind: AuditItemKind;
  level?: InputMaybe<Scalars['Int']['input']>;
  question?: InputMaybe<Scalars['JSON']['input']>;
  requireComment?: InputMaybe<Scalars['Boolean']['input']>;
  requireUpload?: InputMaybe<Scalars['Boolean']['input']>;
  score?: InputMaybe<Scalars['Float']['input']>;
  scoreCountValue?: InputMaybe<YesNoScoreValue>;
  title?: InputMaybe<Scalars['JSON']['input']>;
};

export enum AuditItemKind {
  AuditSection = 'AuditSection',
  AuditYesNoQuestion = 'AuditYesNoQuestion'
}

export type AuditSection = AuditItem & {
  __typename?: 'AuditSection';
  dynamicMax?: Maybe<Scalars['Int']['output']>;
  dynamicMin?: Maybe<Scalars['Int']['output']>;
  dynamicTitle?: Maybe<Scalars['JSON']['output']>;
  /** ffmAlias: itemId */
  id: Scalars['ObjectID']['output'];
  isDynamic?: Maybe<Scalars['Boolean']['output']>;
  kind: AuditItemKind;
  level: Scalars['Int']['output'];
  score?: Maybe<Scalars['Float']['output']>;
  title: Scalars['JSON']['output'];
};

export type AuditSort = {
  author_name?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type AuditYesNoAnswer = AuditAnswer & {
  __typename?: 'AuditYesNoAnswer';
  answer?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  followUp?: Maybe<Scalars['Boolean']['output']>;
  item: AuditItem;
  questionGroupId?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  uploads?: Maybe<Array<Attachment>>;
};

export type AuditYesNoAnswerInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  followUp?: InputMaybe<Scalars['Boolean']['input']>;
  score?: InputMaybe<Scalars['Float']['input']>;
  uploads?: InputMaybe<Array<AttachmentInput>>;
};

export type AuditYesNoQuestion = AuditItem & {
  __typename?: 'AuditYesNoQuestion';
  allowComment?: Maybe<Scalars['Boolean']['output']>;
  allowFollowUp?: Maybe<Scalars['Boolean']['output']>;
  allowNotApplicable?: Maybe<Scalars['Boolean']['output']>;
  allowUpload?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['JSON']['output']>;
  /** ffmAlias: itemId */
  id: Scalars['ObjectID']['output'];
  isCopied?: Maybe<Scalars['Boolean']['output']>;
  kind: AuditItemKind;
  question: Scalars['JSON']['output'];
  requireComment?: Maybe<Scalars['Boolean']['output']>;
  requireUpload?: Maybe<Scalars['Boolean']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  scoreCountValue?: Maybe<YesNoScoreValue>;
};

export type BigIntFilter = {
  _eq?: InputMaybe<Scalars['BigInt']['input']>;
  _exists?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['BigInt']['input']>;
  _gte?: InputMaybe<Scalars['BigInt']['input']>;
  _in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
  _lt?: InputMaybe<Scalars['BigInt']['input']>;
  _lte?: InputMaybe<Scalars['BigInt']['input']>;
  _ne?: InputMaybe<Scalars['BigInt']['input']>;
  _nin?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
  _size?: InputMaybe<Scalars['Int']['input']>;
};

export type BooleanFilter = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _exists?: InputMaybe<Scalars['Boolean']['input']>;
  _ne?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BooleanQuery = {
  __typename?: 'BooleanQuery';
  _eq?: Maybe<Scalars['Boolean']['output']>;
};

export type BroadcastActionItemInput = {
  actionItem: ActionItemInput;
  agenda?: InputMaybe<MeetingAgendaInput>;
  recipients: Array<ActionItemRecipientInput>;
};

export type CalculateSurveyResultInput = {
  answeredFor: Scalars['SurveyAnsweredFor']['input'];
  surveyId: Scalars['ObjectID']['input'];
};

export type CalculateSurveyResultsInput = {
  answeredFors: Array<Scalars['SurveyAnsweredFor']['input']>;
  surveyId: Scalars['ObjectID']['input'];
};

export type Category = {
  __typename?: 'Category';
  groups?: Maybe<Array<GroupReference>>;
  /** ffmAlias: categoryId */
  id: Scalars['ObjectID']['output'];
  name: Scalars['String']['output'];
  persons?: Maybe<Array<PersonReference>>;
  translations?: Maybe<Scalars['JSON']['output']>;
};

export type CategoryCreationInput = {
  groups?: InputMaybe<Array<GroupReferenceInput>>;
  name: Scalars['String']['input'];
  persons?: InputMaybe<Array<PersonReferenceInput>>;
  translations?: InputMaybe<Scalars['JSON']['input']>;
};

export type CategoryReference = {
  __typename?: 'CategoryReference';
  categoryId: Scalars['ObjectID']['output'];
  name: Scalars['String']['output'];
};

export type CategoryReferenceInput = {
  categoryId: Scalars['ObjectID']['input'];
  name: Scalars['String']['input'];
};

export type CategoryUpdateInput = {
  groups?: InputMaybe<Array<GroupReferenceInput>>;
  name: Scalars['String']['input'];
  persons?: InputMaybe<Array<PersonReferenceInput>>;
  translations?: InputMaybe<Scalars['JSON']['input']>;
};

export enum ChangeHistoryGranularity {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type Changelog = {
  __typename?: 'Changelog';
  _id?: Maybe<Scalars['ObjectID']['output']>;
  patch?: Maybe<Scalars['JSON']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type ChangelogFilter = {
  _and?: InputMaybe<Array<InputMaybe<ChangelogFilter>>>;
  _elemMatch?: InputMaybe<ChangelogFilter>;
  _or?: InputMaybe<Array<InputMaybe<ChangelogFilter>>>;
  date?: InputMaybe<DateTimeFilter>;
  ops?: InputMaybe<PatchFilter>;
  /** @deprecated Use ops field instead */
  patch?: InputMaybe<PatchFilter>;
  /** @deprecated Use date field instead */
  timestamp?: InputMaybe<DateTimeFilter>;
};

export enum ChartEntity {
  ActionItem = 'ActionItem',
  Meeting = 'Meeting'
}

export type ChartFilter = {
  ActionItem?: InputMaybe<ActionItemFilter>;
  Meeting?: InputMaybe<MeetingFilter>;
};

export enum ChartGroupProperty {
  ApproverPersonId = 'approver_personId',
  AttendeesPersonId = 'attendees_personId',
  AuthorPersonId = 'author_personId',
  CategoriesCategoryId = 'categories_categoryId',
  CoachingModulesCoachingModuleId = 'coachingModules_coachingModuleId',
  ConsultingMeetingTypeConsultingMeetingTypeId = 'consultingMeetingType_consultingMeetingTypeId',
  KpiUnit = 'kpiUnit',
  OrganizationOrganizationId = 'organization_organizationId',
  Priority = 'priority',
  ProfitPotentialCurrency = 'profitPotentialCurrency',
  ResponsiblePersonId = 'responsible_personId',
  Status = 'status',
  StrategyImpactId = 'strategyImpactId',
  Tags = 'tags',
  Type = 'type'
}

export type ChartProperties = {
  groupProperty?: InputMaybe<Array<InputMaybe<ChartGroupProperty>>>;
  valueAggregation?: InputMaybe<ChartValueAggregation>;
  valueProperty?: InputMaybe<Array<InputMaybe<ChartValueProperty>>>;
};

export enum ChartType {
  BarsHorizontal = 'BarsHorizontal',
  BarsVertical = 'BarsVertical',
  Sunburst = 'Sunburst'
}

export enum ChartValueAggregation {
  Hierarchy = 'hierarchy',
  StackedSum = 'stackedSum',
  Sum = 'sum'
}

export enum ChartValueProperty {
  AggregateCount = 'aggregate_count',
  CoachingDays = 'coachingDays',
  KpiActualValue = 'kpiActualValue',
  KpiInitialValue = 'kpiInitialValue',
  KpiTargetValue = 'kpiTargetValue',
  ProfitPotentialIdentified = 'profitPotentialIdentified',
  ProfitPotentialRealized = 'profitPotentialRealized'
}

export type Choice = {
  __typename?: 'Choice';
  choice?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ObjectID']['output'];
};

export type ChoiceInput = {
  choice: Scalars['JSON']['input'];
  id: Scalars['ObjectID']['input'];
};

export enum ChoiceType {
  Multiple = 'Multiple',
  Single = 'Single'
}

export type CoachingModule = {
  __typename?: 'CoachingModule';
  categoryIds?: Maybe<Array<Scalars['ObjectID']['output']>>;
  consultingMeetingTypeIds?: Maybe<Array<Scalars['ObjectID']['output']>>;
  /** ffmAlias: coachingModuleId */
  id: Scalars['ObjectID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  meetingKind: MeetingKind;
  name: Scalars['String']['output'];
  organizationIds?: Maybe<Array<Scalars['BigInt']['output']>>;
  organizations?: Maybe<Array<Organization>>;
  translations?: Maybe<Scalars['JSON']['output']>;
};

export type CoachingModuleCreateInput = {
  categoryIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  consultingMeetingTypeIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  meetingKind: MeetingKind;
  name: Scalars['String']['input'];
  organizationIds?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  translations?: InputMaybe<Scalars['JSON']['input']>;
};

export type CoachingModuleReferenceInput = {
  coachingModuleId: Scalars['ObjectID']['input'];
  name: Scalars['String']['input'];
};

export type CoachingModuleUpdateInput = {
  categoryIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  consultingMeetingTypeIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  meetingKind: MeetingKind;
  name: Scalars['String']['input'];
  organizationIds?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  translations?: InputMaybe<Scalars['JSON']['input']>;
};

export type CoachingModulesFilter = {
  _and?: InputMaybe<Array<CoachingModulesFilter>>;
  _id?: InputMaybe<ObjectIdFilter>;
  _or?: InputMaybe<Array<CoachingModulesFilter>>;
  meetingKind?: InputMaybe<MeetingKindFilter>;
  name?: InputMaybe<StringFilter>;
  organizationIds?: InputMaybe<BigIntFilter>;
  organizationIds_0?: InputMaybe<BigIntFilter>;
};

export type CoachingModulesInput = {
  filter?: InputMaybe<CoachingModulesFilter>;
};

export type Comment = {
  __typename?: 'Comment';
  attachments?: Maybe<Array<Attachment>>;
  author: PersonReference;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ObjectID']['output'];
  text: Scalars['String']['output'];
};

export type CommentInput = {
  attachments?: InputMaybe<Array<InputMaybe<AttachmentInput>>>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  text: Scalars['String']['input'];
};

export type CommentUpdateInput = {
  id: Scalars['ObjectID']['input'];
  text: Scalars['String']['input'];
};

export type ConsultingMeetingType = {
  __typename?: 'ConsultingMeetingType';
  /** ffmAlias: consultingMeetingTypeId */
  id: Scalars['ObjectID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  meetingKind: MeetingKind;
  name: Scalars['String']['output'];
  organizationIds?: Maybe<Array<Scalars['BigInt']['output']>>;
  organizations?: Maybe<Array<Organization>>;
  requiresCoachingModules?: Maybe<Scalars['Boolean']['output']>;
  translations?: Maybe<Scalars['JSON']['output']>;
};

export type ConsultingMeetingTypeCreateInput = {
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  meetingKind: MeetingKind;
  name: Scalars['String']['input'];
  organizationIds?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  requiresCoachingModules?: InputMaybe<Scalars['Boolean']['input']>;
  translations?: InputMaybe<Scalars['JSON']['input']>;
};

export type ConsultingMeetingTypeReferenceInput = {
  consultingMeetingTypeId: Scalars['ObjectID']['input'];
  name: Scalars['String']['input'];
};

export type ConsultingMeetingTypeUpdateInput = {
  meetingKind: MeetingKind;
  name: Scalars['String']['input'];
  organizationIds?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  requiresCoachingModules?: InputMaybe<Scalars['Boolean']['input']>;
  translations?: InputMaybe<Scalars['JSON']['input']>;
};

export type CopyActionItemAttachmentsInput = {
  actionItemId: Scalars['ObjectID']['input'];
};

export type CopyAgendaItemAttachmentsInput = {
  agendaItemId: Scalars['Int']['input'];
  meetingId: Scalars['ObjectID']['input'];
};

export type CopyMeetingAttachmentsInput = {
  meetingId: Scalars['ObjectID']['input'];
};

export type CopySurveyInput = {
  asVersion?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ObjectID']['input'];
  nameLocalizations?: InputMaybe<Array<LocalizedStringInput>>;
};

export type CopySurveyTemplateInput = {
  asVersion?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ObjectID']['input'];
  nameLocalizations?: InputMaybe<Array<LocalizedStringInput>>;
};

export type CopyUploadInput = {
  id: Scalars['ObjectID']['input'];
  sourceReference: UploadReference;
  targetReference: UploadReference;
  type: UploadType;
};

export type CopyUploadsInput = {
  uploads: Array<CopyUploadInput>;
};

export type CountryFilter = {
  ancestors?: InputMaybe<BigIntFilter>;
  market?: InputMaybe<Scalars['String']['input']>;
};

export type CreateActionItemWidgetInput = {
  copyAnswersId?: InputMaybe<Scalars['ObjectID']['input']>;
  id: Scalars['ObjectID']['input'];
  kind: WidgetKind;
};

export type CreateApexEmailNotificationInput = {
  adhoc?: InputMaybe<Scalars['Boolean']['input']>;
  cron?: InputMaybe<Scalars['String']['input']>;
  topic: ApexEmailNotificationTopic;
};

export type CreateDashboardEmailNotificationInput = {
  adhoc?: InputMaybe<Scalars['Boolean']['input']>;
  cron?: InputMaybe<Scalars['String']['input']>;
  topic: DashboardEmailNotificationTopic;
};

export type CreateFeatureArticleInput = {
  apps?: InputMaybe<Array<Scalars['String']['input']>>;
  article: Scalars['String']['input'];
  author?: InputMaybe<Scalars['BigInt']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  organizations?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  publishedAt?: InputMaybe<Scalars['Date']['input']>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
};

export type CreateFieldForceManagementEmailNotificationInput = {
  adhoc?: InputMaybe<Scalars['Boolean']['input']>;
  cron?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<FieldForceManagementEmailNotificationOptionInput>;
  topic: FieldForceManagementEmailNotificationTopic;
};

export type CreateFieldForceManagementFilterPresetInput = {
  filter: FieldForceManagementFilterInput;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type CreateHelpArticleInput = {
  article?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<AttachmentInput>>;
  id: Scalars['ObjectID']['input'];
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  publishDate?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
  type: HelpArticleType;
  visibleToRoles?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateKpiUnitCategoryInput = {
  /** @deprecated Use actionItemKinds instead */
  actionItemKind?: InputMaybe<ActionItemKind>;
  actionItemKinds?: InputMaybe<Array<ActionItemKind>>;
  kpiUnitIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  nameLocalizations: Array<LocalizedStringInput>;
  organizationIds?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type CreateKpiUnitInput = {
  /** @deprecated Use actionItemKinds instead */
  actionItemKind?: InputMaybe<ActionItemKind>;
  actionItemKinds?: InputMaybe<Array<ActionItemKind>>;
  irisKey?: InputMaybe<Scalars['String']['input']>;
  nameLocalizations: Array<LocalizedStringInput>;
  organizationIds?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type CreateMultisensoryExperienceAreaInput = {
  format: MultisensoryExperienceFormat;
  name: Scalars['String']['input'];
};

export type CreateMultisensoryExperienceBundleInput = {
  areaIds: Array<Scalars['ObjectID']['input']>;
  isActive: Scalars['Boolean']['input'];
  itemIds: Array<Scalars['ObjectID']['input']>;
  name: Scalars['String']['input'];
};

export type CreateMultisensoryExperienceEmailNotificationInput = {
  adhoc?: InputMaybe<Scalars['Boolean']['input']>;
  cron?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<MultisensoryExperienceEmailNotificationOptionInput>;
  topic: MultisensoryExperienceEmailNotificationTopic;
};

export type CreateMultisensoryExperienceFilterPresetInput = {
  filter?: InputMaybe<MultisensoryExperienceFilterPresetConfigInput>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type CreateMultisensoryExperienceInput = {
  attachments?: InputMaybe<Array<MultisensoryExperienceAttachmentInput>>;
  budgetIsAvailable: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  format: MultisensoryExperienceFormat;
  includesDestinationPorscheFurniture: Scalars['Boolean']['input'];
  organizationId: Scalars['BigInt']['input'];
  plannedCompletion?: InputMaybe<Scalars['Date']['input']>;
  projectCompletionWithinStartYear: Scalars['Boolean']['input'];
  relatedMeasures?: InputMaybe<Array<MultisensoryExperienceRelatedMeasureInput>>;
  start?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<MultisensoryExperienceStatus>;
  title: Scalars['String']['input'];
};

export type CreateMultisensoryExperienceItemInput = {
  areaIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  category?: InputMaybe<MultisensoryExperienceItemCategory>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AttachmentInput>;
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  referenceId?: InputMaybe<Scalars['String']['input']>;
  supplier: Scalars['String']['input'];
  url?: InputMaybe<Scalars['URL']['input']>;
};

export type CreateMultisensoryExperienceMeasureInput = {
  areaId: Scalars['ObjectID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  experienceId: Scalars['ObjectID']['input'];
  implementationImages?: InputMaybe<Array<InputMaybe<AttachmentInput>>>;
  media?: InputMaybe<Array<InputMaybe<AttachmentInput>>>;
  status: MultisensoryExperienceMeasureStatus;
};

export type CreateMultisensoryExperienceMeasureTaskInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  bundleId?: InputMaybe<Scalars['ObjectID']['input']>;
  description: Scalars['String']['input'];
  itemId?: InputMaybe<Scalars['ObjectID']['input']>;
  measureId: Scalars['ObjectID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MultisensoryExperienceMeasureTaskStatus>;
};

export type CreateNetworkPlanningEmailNotificationInput = {
  adhoc?: InputMaybe<Scalars['Boolean']['input']>;
  cron?: InputMaybe<Scalars['String']['input']>;
  topic: NetworkPlanningEmailNotificationTopic;
};

export type CreateNetworkPlanningOrganizationInput = {
  category?: InputMaybe<NetworkPlanningOrganizationCategory>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  marketId: Scalars['BigInt']['input'];
  name: Scalars['String']['input'];
  opening: Scalars['DateMonth']['input'];
  type: NetworkPlanningOrganizationType;
};

export type CreateOccasionRelatedApprovalInput = {
  adHocResponsibleId?: InputMaybe<Scalars['BigInt']['input']>;
  applicantIds: Array<Scalars['BigInt']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<AttachmentInput>>>;
  comment: Scalars['String']['input'];
  date: Scalars['Date']['input'];
  externalApplicants: Array<Scalars['String']['input']>;
  reason: Reason;
  reports: Array<Scalars['String']['input']>;
};

export type CreatePcRoadmapActionItemInput = {
  attachments?: InputMaybe<Array<AttachmentInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  okr: Scalars['String']['input'];
  organizationId: Scalars['BigInt']['input'];
  responsibleId: Scalars['BigInt']['input'];
  status: PcRoadmapActionItemStatus;
  title: Scalars['String']['input'];
  workPackages?: InputMaybe<Array<PcRoadmapActionItemWorkPackageInput>>;
};

export type CreatePcRoadmapAdditionalAgreementInput = {
  descriptionByStage?: InputMaybe<Array<PcRoadmapValueByStageInput>>;
  kind?: InputMaybe<PcRoadmapAdditionalAgreementKind>;
  name: Scalars['String']['input'];
  orderByStage?: InputMaybe<Array<PcRoadmapOrderByStageInput>>;
  organizationId: Scalars['BigInt']['input'];
  parentId?: InputMaybe<Scalars['ObjectID']['input']>;
  stageIds: Array<Scalars['ObjectID']['input']>;
  templateVariablesByStage?: InputMaybe<Array<PcRoadmapTemplateVariablesByStageInput>>;
};

export type CreatePcRoadmapApplicableDocumentInput = {
  attachment: AttachmentInput;
  name: Scalars['String']['input'];
  organizationIds?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stageIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  strategyKpiId: Scalars['ObjectID']['input'];
};

export type CreatePcRoadmapCommitmentInput = {
  mission?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['BigInt']['input'];
  stageId: Scalars['ObjectID']['input'];
  status: PcRoadmapCommitmentStatus;
  visibleForDealer?: InputMaybe<Scalars['Boolean']['input']>;
  vision?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePcRoadmapFurtherDetailInput = {
  description: Scalars['String']['input'];
  stageIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  strategyKpiId: Scalars['ObjectID']['input'];
};

export type CreatePcRoadmapStageInput = {
  visibleForDealer: Scalars['Date']['input'];
  visibleForManager: Scalars['Date']['input'];
  year: Scalars['Int']['input'];
};

export type CreatePcRoadmapStrategyFieldInput = {
  colorByStage?: InputMaybe<Array<PcRoadmapValueByStageInput>>;
  iconByStage?: InputMaybe<Array<PcRoadmapValueByStageInput>>;
  name: Scalars['String']['input'];
  orderByStage?: InputMaybe<Array<PcRoadmapOrderByStageInput>>;
  organizationId: Scalars['BigInt']['input'];
  stageIds: Array<Scalars['ObjectID']['input']>;
};

export type CreatePcRoadmapStrategyKpiCategoryInput = {
  additionalDescriptionByStage?: InputMaybe<Array<PcRoadmapValueByStageInput>>;
  decimalPrecision?: InputMaybe<Scalars['Int']['input']>;
  descriptionByStage?: InputMaybe<Array<PcRoadmapValueByStageInput>>;
  name: Scalars['String']['input'];
  orderByStage?: InputMaybe<Array<PcRoadmapOrderByStageInput>>;
  reportingDescriptionByStage?: InputMaybe<Array<PcRoadmapValueByStageInput>>;
  reportingDescriptionSourceByStage?: InputMaybe<Array<PcRoadmapValueByStageInput>>;
  stageIds: Array<Scalars['ObjectID']['input']>;
  strategyKpiId: Scalars['ObjectID']['input'];
};

export type CreatePcRoadmapStrategyKpiInput = {
  additionalDescriptionByStage?: InputMaybe<Array<PcRoadmapValueByStageInput>>;
  decimalPrecision?: InputMaybe<Scalars['Int']['input']>;
  descriptionByStage?: InputMaybe<Array<PcRoadmapValueByStageInput>>;
  name: Scalars['String']['input'];
  orderByStage?: InputMaybe<Array<PcRoadmapOrderByStageInput>>;
  reportingDescriptionByStage?: InputMaybe<Array<PcRoadmapValueByStageInput>>;
  reportingDescriptionSourceByStage?: InputMaybe<Array<PcRoadmapValueByStageInput>>;
  stageIds: Array<Scalars['ObjectID']['input']>;
  strategyFieldId: Scalars['ObjectID']['input'];
};

export type CreatePorscheImportAgreementsChangeRequestApprovalInput = {
  department?: InputMaybe<PorscheImportAgreementsChangeRequestApprovalDepartment>;
  personId?: InputMaybe<Scalars['BigInt']['input']>;
};

export type CreatePorscheImportAgreementsChangeRequestInput = {
  adjustmentAt: Scalars['Date']['input'];
  adjustmentType: PorscheImportAgreementsChangeRequestAdjustmentType;
  organization: Scalars['BigInt']['input'];
  switchoverAt: Scalars['Date']['input'];
};

export type CreatePorscheImportAgreementsEmailNotificationInput = {
  adhoc?: InputMaybe<Scalars['Boolean']['input']>;
  cron?: InputMaybe<Scalars['String']['input']>;
  topic: PorscheImportAgreementsEmailNotificationTopic;
};

export type CreatePorscheImportAgreementsIncotermInput = {
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type CreatePorscheImportAgreementsPaymentTermInput = {
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type CreatePorscheStrategy2030EmailNotificationInput = {
  adhoc?: InputMaybe<Scalars['Boolean']['input']>;
  cron?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<PorscheStrategy2030EmailNotificationOptionInput>;
  topic: PorscheStrategy2030EmailNotificationTopic;
};

export type CreateRealEstatePropertyInput = {
  annualRent?: InputMaybe<Scalars['SafeInt']['input']>;
  bookValue?: InputMaybe<Scalars['SafeInt']['input']>;
  buildingSizeInM2?: InputMaybe<Scalars['Int']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  earliestTermination?: InputMaybe<Scalars['DateTime']['input']>;
  headcount?: InputMaybe<Scalars['Float']['input']>;
  integratedFunctions?: InputMaybe<Scalars['String']['input']>;
  landlord?: InputMaybe<Scalars['String']['input']>;
  lastRenovation?: InputMaybe<Scalars['Int']['input']>;
  leaseEnd?: InputMaybe<Scalars['DateTime']['input']>;
  leaseStart?: InputMaybe<Scalars['DateTime']['input']>;
  marketId: Scalars['BigInt']['input'];
  numberOfParking?: InputMaybe<Scalars['Int']['input']>;
  occupation?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['BigInt']['input']>;
  ownership?: InputMaybe<RealEstatePropertyOwnership>;
  postalCode: Scalars['String']['input'];
  prolongation?: InputMaybe<Scalars['Boolean']['input']>;
  sharedWithOr?: InputMaybe<Scalars['Boolean']['input']>;
  siteLandplotSizeInM2?: InputMaybe<Scalars['Int']['input']>;
  street: Scalars['String']['input'];
  subsidiaryId: Scalars['BigInt']['input'];
  type: RealEstatePropertyType;
  usage?: InputMaybe<RealEstatePropertyUsageInput>;
  use?: InputMaybe<RealEstatePropertyUse>;
  yearOfConstruction?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateRetailDesignDocumentInput = {
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  mandatoryForStatus: Array<RetailDesignProjectStatus>;
  mandatoryOnlyForFormatIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  name: Scalars['String']['input'];
  translations?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateRetailDesignEmailNotificationInput = {
  adhoc?: InputMaybe<Scalars['Boolean']['input']>;
  cron?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<RetailDesignEmailNotificationOptionInput>;
  topic: RetailDesignEmailNotificationTopic;
};

export type CreateRetailDesignFilterPresetInput = {
  filter?: InputMaybe<RetailDesignFilterPresetConfigInput>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type CreateRetailDesignFormatInput = {
  /** @deprecated Use hasNoWorkshopThroughput instead */
  hasNoAftersalesThroughput?: InputMaybe<Scalars['Boolean']['input']>;
  hasNoBodyAndPaintThroughput?: InputMaybe<Scalars['Boolean']['input']>;
  hasNoNCSalesVolume?: InputMaybe<Scalars['Boolean']['input']>;
  hasNoWorkshopThroughput?: InputMaybe<Scalars['Boolean']['input']>;
  hasRelatedOrganization?: InputMaybe<RetailDesignFormatRelatedOrganizationInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  needsAftersalesApproval?: InputMaybe<Scalars['Boolean']['input']>;
  needsApprovalProcessType?: InputMaybe<RetailDesignFormatApprovalProcessType>;
  needsBrandManagementApproval?: InputMaybe<RetailDesignFormatBrandManagementApprovalInput>;
  translations?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateRetailDesignProjectInput = {
  construction?: InputMaybe<RetailDesignProjectConstructionInput>;
  formatApproval?: InputMaybe<RetailDesignProjectFormatApprovalInput>;
};

export type CreateRetailDesignProjectTypeInput = {
  name: Scalars['String']['input'];
  translations?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateStrategyActionItemInput = {
  attachments: Array<StrategyAttachmentInput>;
  authorId?: InputMaybe<Scalars['BigInt']['input']>;
  createdByResource?: InputMaybe<StrategyActionItemResourceInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  kpiCategoryId?: InputMaybe<Scalars['ObjectID']['input']>;
  kpiId: Scalars['ObjectID']['input'];
  okr: Scalars['String']['input'];
  organizationId: Scalars['BigInt']['input'];
  responsibleId: Scalars['BigInt']['input'];
  status: StrategyActionItemStatus;
  title: Scalars['String']['input'];
  workPackages: Array<StrategyActionItemWorkPackageInput>;
  year: Scalars['Int']['input'];
};

export type CreateStrategyFieldInput = {
  color: Scalars['String']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organization: Scalars['BigInt']['input'];
  stage: Scalars['Int']['input'];
};

export type CreateStrategyKpiCategoryInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  organization: Scalars['BigInt']['input'];
  stage: Scalars['Int']['input'];
  strategyKpi: Scalars['ObjectID']['input'];
};

export type CreateStrategyKpiInput = {
  organization: Scalars['BigInt']['input'];
  stage: Scalars['Int']['input'];
  strategyField: Scalars['ObjectID']['input'];
  title: Scalars['String']['input'];
};

export type CreateStrategyStageInput = {
  visibleForDealer: Scalars['Date']['input'];
  visibleForManager: Scalars['Date']['input'];
  year: Scalars['Int']['input'];
};

export type CreateSupportRequestInput = {
  application: Scalars['String']['input'];
  attachments?: InputMaybe<Array<AttachmentInput>>;
  description: Scalars['String']['input'];
  details?: InputMaybe<SupportRequestDetailsInput>;
  organizationId: Scalars['BigInt']['input'];
  referencePersonId?: InputMaybe<Scalars['BigInt']['input']>;
  title: Scalars['String']['input'];
};

export type CreateSurveyEmailNotificationInput = {
  adhoc?: InputMaybe<Scalars['Boolean']['input']>;
  cron?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<SurveyEmailNotificationOptionInput>;
  topic: SurveyEmailNotificationTopic;
};

export type CreateSurveyEntryValueUnitInput = {
  id: Scalars['ObjectID']['input'];
  nameLocalizations: Array<LocalizedStringInput>;
  type: SurveyEntryValueUnitType;
};

export type CreateSurveyInput = {
  ancestorVersionId?: InputMaybe<Scalars['ObjectID']['input']>;
  anonymousAnswers?: InputMaybe<Scalars['Boolean']['input']>;
  answersAllowedByIds?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  answersAllowedByPerOrganization?: InputMaybe<Array<AnswersAllowedByPerOrganizationInput>>;
  canCreateActionItems: Scalars['Boolean']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  effectiveFrom: Scalars['Date']['input'];
  effectiveTo?: InputMaybe<Scalars['Date']['input']>;
  entryPeriodMode?: InputMaybe<SurveyEntryPeriodMode>;
  equalQuestionWeighting?: InputMaybe<Scalars['Boolean']['input']>;
  frequency?: InputMaybe<SurveyFrequency>;
  hasDefaultWeights?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  items: Array<CreateSurveyItemInput>;
  languages: Array<Scalars['String']['input']>;
  nameLocalizations: Array<LocalizedStringInput>;
  organizationIds?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  personIds?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  templateId?: InputMaybe<Scalars['ObjectID']['input']>;
  typeId: Scalars['ObjectID']['input'];
  version: Scalars['Int']['input'];
  weight: Scalars['Int']['input'];
};

export type CreateSurveyItemDateQuestionInput = {
  allowComment?: InputMaybe<Scalars['Boolean']['input']>;
  allowNotApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  allowUpload?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentsLocalizations?: InputMaybe<Array<LocalizedAttachmentsInput>>;
  commentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  datePrecision?: InputMaybe<DatePrecision>;
  descriptionLocalizations?: InputMaybe<Array<LocalizedStringInput>>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  uploadRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateSurveyItemInput = {
  dateQuestion?: InputMaybe<CreateSurveyItemDateQuestionInput>;
  dependencies?: InputMaybe<SurveyItemDependenciesInput>;
  depth: Scalars['Int']['input'];
  id: Scalars['ObjectID']['input'];
  itemReference?: InputMaybe<CreateSurveyItemItemReferenceInput>;
  kind: SurveyItemKind;
  likertScaleQuestion?: InputMaybe<CreateSurveyItemLikertScaleQuestionInput>;
  multipleChoiceQuestion?: InputMaybe<CreateSurveyItemMultipleChoiceQuestionInput>;
  multipleEntryQuestion?: InputMaybe<CreateSurveyItemMultipleEntryQuestionInput>;
  nameLocalizations: Array<LocalizedStringInput>;
  numericQuestion?: InputMaybe<CreateSurveyItemNumericQuestionInput>;
  section?: InputMaybe<CreateSurveyItemSectionInput>;
  staticPage?: InputMaybe<CreateSurveyItemStaticPageInput>;
  templateOptions?: InputMaybe<SurveyItemTemplateOptionsInput>;
  textQuestion?: InputMaybe<CreateSurveyItemTextQuestionInput>;
  uploadQuestion?: InputMaybe<CreateSurveyItemUploadQuestionInput>;
  yesNoQuestion?: InputMaybe<CreateSurveyItemYesNoQuestionInput>;
};

export type CreateSurveyItemItemReferenceInput = {
  attachmentsLocalizations?: InputMaybe<Array<LocalizedAttachmentsInput>>;
  descriptionLocalizations?: InputMaybe<Array<LocalizedStringInput>>;
  itemId?: InputMaybe<Scalars['ObjectID']['input']>;
  multipleChoiceLocalizationsOptions?: InputMaybe<Array<SurveyLocalizationItemInput>>;
  multipleEntryLocalizationsEntries?: InputMaybe<Array<SurveyLocalizationItemInput>>;
  templateId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type CreateSurveyItemLikertScaleQuestionInput = {
  allowComment?: InputMaybe<Scalars['Boolean']['input']>;
  allowNotApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  allowUpload?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentsLocalizations?: InputMaybe<Array<LocalizedAttachmentsInput>>;
  commentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLocalizations?: InputMaybe<Array<LocalizedStringInput>>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  uploadRequired?: InputMaybe<Scalars['Boolean']['input']>;
  weightRange: Array<Scalars['Int']['input']>;
};

export type CreateSurveyItemMultipleChoiceQuestionInput = {
  allowComment?: InputMaybe<Scalars['Boolean']['input']>;
  allowMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  allowNotApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  allowUpload?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentsLocalizations?: InputMaybe<Array<LocalizedAttachmentsInput>>;
  commentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLocalizations?: InputMaybe<Array<LocalizedStringInput>>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  options: Array<CreateSurveyMultipleChoiceQuestionOptionInput>;
  uploadRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateSurveyItemMultipleEntryQuestionInput = {
  allowComment?: InputMaybe<Scalars['Boolean']['input']>;
  allowNotApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  allowUpload?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentsLocalizations?: InputMaybe<Array<LocalizedAttachmentsInput>>;
  commentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLocalizations?: InputMaybe<Array<LocalizedStringInput>>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  entries: Array<CreateSurveyMultipleEntryQuestionEntryInput>;
  entryValueUnit?: InputMaybe<CreateSurveyEntryValueUnitInput>;
  uploadRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateSurveyItemNumericQuestionInput = {
  allowComment?: InputMaybe<Scalars['Boolean']['input']>;
  allowNotApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  allowUpload?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentsLocalizations?: InputMaybe<Array<LocalizedAttachmentsInput>>;
  commentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLocalizations?: InputMaybe<Array<LocalizedStringInput>>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  uploadRequired?: InputMaybe<Scalars['Boolean']['input']>;
  valueUnit?: InputMaybe<CreateSurveyValueUnitInput>;
};

export type CreateSurveyItemSectionInput = {
  weight: Scalars['Int']['input'];
};

export type CreateSurveyItemStaticPageInput = {
  descriptionLocalizations?: InputMaybe<Array<LocalizedStringInput>>;
};

export type CreateSurveyItemTextQuestionInput = {
  allowComment?: InputMaybe<Scalars['Boolean']['input']>;
  allowNotApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  allowUpload?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentsLocalizations?: InputMaybe<Array<LocalizedAttachmentsInput>>;
  descriptionLocalizations?: InputMaybe<Array<LocalizedStringInput>>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  uploadRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateSurveyItemUploadQuestionInput = {
  allowComment?: InputMaybe<Scalars['Boolean']['input']>;
  allowNotApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  allowUpload?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentsLocalizations?: InputMaybe<Array<LocalizedAttachmentsInput>>;
  commentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLocalizations?: InputMaybe<Array<LocalizedStringInput>>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  minimumCount: Scalars['Int']['input'];
};

export type CreateSurveyItemYesNoQuestionInput = {
  allowComment?: InputMaybe<Scalars['Boolean']['input']>;
  allowNotApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  allowUpload?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentsLocalizations?: InputMaybe<Array<LocalizedAttachmentsInput>>;
  commentRequired?: InputMaybe<SurveyYesNoQuestionRequiredFieldInput>;
  descriptionLocalizations?: InputMaybe<Array<LocalizedStringInput>>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  uploadRequired?: InputMaybe<SurveyYesNoQuestionRequiredFieldInput>;
  weightNo: Scalars['Int']['input'];
  weightYes: Scalars['Int']['input'];
};

export type CreateSurveyMultipleChoiceQuestionOptionInput = {
  id: Scalars['ObjectID']['input'];
  isOther?: InputMaybe<Scalars['Boolean']['input']>;
  nameLocalizations: Array<LocalizedStringInput>;
  weight: Scalars['Int']['input'];
};

export type CreateSurveyMultipleEntryQuestionEntryInput = {
  id: Scalars['ObjectID']['input'];
  nameLocalizations: Array<LocalizedStringInput>;
};

export type CreateSurveyPredefinedItemInput = {
  config: CreateSurveyItemInput;
  languages: Array<Scalars['String']['input']>;
  organizationIds: Array<Scalars['BigInt']['input']>;
};

export type CreateSurveyReportConfigChartInput = {
  aggregationLevel?: InputMaybe<SurveyReportAggregationLevel>;
  answerValueType?: InputMaybe<SurveyReportChartAnswerValueType>;
  cutoffDate?: InputMaybe<Scalars['Date']['input']>;
  onlyIncludeOrganizationsWithAnswers?: InputMaybe<Scalars['Boolean']['input']>;
  organizationIds: Array<Scalars['BigInt']['input']>;
  surveyIds: Array<Scalars['ObjectID']['input']>;
  surveyItemIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  template?: InputMaybe<SurveyReportChartTemplate>;
  title: Scalars['String']['input'];
  type: SurveyReportChartType;
  visualizationBars?: InputMaybe<SurveyReportChartVisualizationBarsInput>;
  visualizationList?: InputMaybe<SurveyReportChartVisualizationListInput>;
  visualizationSpider?: InputMaybe<SurveyReportChartVisualizationSpiderInput>;
  visualizationTimeline?: InputMaybe<SurveyReportChartVisualizationTimelineInput>;
};

export type CreateSurveyReportConfigInput = {
  name: Scalars['String']['input'];
  sections?: InputMaybe<Array<CreateSurveyReportConfigSectionInput>>;
  type: SurveyReportType;
};

export type CreateSurveyReportConfigSectionInput = {
  charts: Array<CreateSurveyReportConfigChartInput>;
  width: Scalars['Int']['input'];
};

export type CreateSurveyTableConfigInput = {
  table: SurveyTable;
  visibleColumns: Array<Scalars['String']['input']>;
};

export type CreateSurveyTemplateInput = {
  ancestorVersionId?: InputMaybe<Scalars['ObjectID']['input']>;
  anonymousAnswers?: InputMaybe<Scalars['Boolean']['input']>;
  equalQuestionWeighting?: InputMaybe<Scalars['Boolean']['input']>;
  hasDefaultWeights?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  items: Array<CreateSurveyItemInput>;
  languages: Array<Scalars['String']['input']>;
  nameLocalizations: Array<LocalizedStringInput>;
  organizationIds?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  templateId?: InputMaybe<Scalars['ObjectID']['input']>;
  typeId: Scalars['ObjectID']['input'];
  version: Scalars['Int']['input'];
  weight: Scalars['Int']['input'];
};

export type CreateSurveyTypeInput = {
  nameLocalizations: Array<LocalizedStringInput>;
};

export type CreateSurveyValueUnitInput = {
  id: Scalars['ObjectID']['input'];
  nameLocalizations: Array<LocalizedStringInput>;
};

export type CreateUserFeedbackInput = {
  comment: Scalars['String']['input'];
  rating: Scalars['Int']['input'];
};

export type CreateUserManagementItemInput = {
  additionalOrganizationIds: Array<Scalars['BigInt']['input']>;
  application: Scalars['String']['input'];
  personId: Scalars['BigInt']['input'];
};

export enum Currency {
  Aud = 'AUD',
  Brl = 'BRL',
  Cad = 'CAD',
  Chf = 'CHF',
  Cny = 'CNY',
  Dkk = 'DKK',
  Eur = 'EUR',
  Gbp = 'GBP',
  Jpy = 'JPY',
  Krw = 'KRW',
  Nok = 'NOK',
  Ntd = 'NTD',
  Pln = 'PLN',
  Rub = 'RUB',
  Sek = 'SEK',
  Usd = 'USD'
}

export type CustomReportingData = {
  __typename?: 'CustomReportingData';
  keyNames: Array<Scalars['String']['output']>;
  keys: Array<Scalars['String']['output']>;
  meta?: Maybe<Scalars['JSON']['output']>;
  stackedKeyNames?: Maybe<Scalars['JSON']['output']>;
  stackedKeys?: Maybe<Array<Scalars['String']['output']>>;
  stackedValues?: Maybe<Scalars['JSON']['output']>;
  /** @deprecated Field no longer supported */
  value: Array<Scalars['Float']['output']>;
  values: Array<Scalars['Float']['output']>;
};

export type DashboardEmailNotification = {
  __typename?: 'DashboardEmailNotification';
  adhoc?: Maybe<Scalars['Boolean']['output']>;
  cron?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  person: Person;
  topic: DashboardEmailNotificationTopic;
};

export enum DashboardEmailNotificationTopic {
  DashboardFeatureArticlePublished = 'DASHBOARD_FEATURE_ARTICLE_PUBLISHED',
  DashboardSupportRequestUpdate = 'DASHBOARD_SUPPORT_REQUEST_UPDATE'
}

export type DateMonthFilter = {
  _eq?: InputMaybe<Scalars['DateMonth']['input']>;
  _exists?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['DateMonth']['input']>;
  _gte?: InputMaybe<Scalars['DateMonth']['input']>;
  _lt?: InputMaybe<Scalars['DateMonth']['input']>;
  _lte?: InputMaybe<Scalars['DateMonth']['input']>;
};

export enum DatePrecision {
  DayMonthYear = 'DAY_MONTH_YEAR',
  MonthYear = 'MONTH_YEAR',
  Year = 'YEAR'
}

export type DateTimeFilter = {
  _eq?: InputMaybe<Scalars['DateTime']['input']>;
  _exists?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['DateTime']['input']>;
  _gte?: InputMaybe<Scalars['DateTime']['input']>;
  _lt?: InputMaybe<Scalars['DateTime']['input']>;
  _lte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeleteStrategyActionItemInput = {
  id: Scalars['ObjectID']['input'];
};

export type DeleteStrategyFieldInput = {
  id: Scalars['ObjectID']['input'];
};

export type DeleteStrategyKpiCategoryInput = {
  id: Scalars['ObjectID']['input'];
};

export type DeleteStrategyKpiInput = {
  id: Scalars['ObjectID']['input'];
};

export type DeleteStrategyStageInput = {
  id: Scalars['ObjectID']['input'];
};

export enum DownloadReference {
  Dashboard = 'Dashboard',
  FieldForceManagement = 'FieldForceManagement',
  Greenland = 'Greenland',
  MultisensoryExperience = 'MultisensoryExperience',
  PcRoadmap = 'PcRoadmap',
  PorscheImportAgreements = 'PorscheImportAgreements',
  PorscheStrategy2030 = 'PorscheStrategy2030',
  RetailDesign = 'RetailDesign',
  Survey = 'Survey'
}

export enum DownloadType {
  Attachment = 'Attachment',
  Image = 'Image',
  Pdf = 'Pdf',
  Video = 'Video'
}

export enum DownloadUrlScanResult {
  NoThreatsFound = 'NoThreatsFound',
  NotScanned = 'NotScanned',
  ThreatsFound = 'ThreatsFound'
}

export type ExchangeRate = {
  __typename?: 'ExchangeRate';
  id: Scalars['ObjectID']['output'];
  rates: Scalars['ExchangeRates']['output'];
  year: Scalars['Int']['output'];
};

export type ExchangeRateInput = {
  rates: Scalars['ExchangeRates']['input'];
  year: Scalars['Int']['input'];
};

export type FeatureArticle = {
  __typename?: 'FeatureArticle';
  apps: Array<Scalars['String']['output']>;
  article: Scalars['String']['output'];
  author: Person;
  id: Scalars['ObjectID']['output'];
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  organizations: Array<Organization>;
  publishedAt?: Maybe<Scalars['Date']['output']>;
  roles: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type FieldForceManagementAbility = {
  __typename?: 'FieldForceManagementAbility';
  checkMeeting: FieldForceManagementAbilityCheckMeetingResult;
  rules: Array<Scalars['AbilityRule']['output']>;
};


export type FieldForceManagementAbilityCheckMeetingArgs = {
  id: Scalars['ObjectID']['input'];
  includeActionItems?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FieldForceManagementAbilityCheckActionItemResult = {
  __typename?: 'FieldForceManagementAbilityCheckActionItemResult';
  delete: AbilityCheckResult;
  read: AbilityCheckResult;
  subject: Scalars['String']['output'];
  update: AbilityCheckResult;
};

export type FieldForceManagementAbilityCheckMeetingResult = {
  __typename?: 'FieldForceManagementAbilityCheckMeetingResult';
  actionItems?: Maybe<Array<FieldForceManagementAbilityCheckActionItemResult>>;
  delete: AbilityCheckResult;
  read: AbilityCheckResult;
  subject: Scalars['String']['output'];
  update: AbilityCheckResult;
};

export type FieldForceManagementActionItemFilter = FieldForceManagementFilter & {
  __typename?: 'FieldForceManagementActionItemFilter';
  author_personId?: Maybe<Array<Scalars['BigInt']['output']>>;
  categories_categoryId?: Maybe<Array<Scalars['String']['output']>>;
  createdAtMaximum?: Maybe<Scalars['DateTime']['output']>;
  createdAtMinimum?: Maybe<Scalars['DateTime']['output']>;
  dueDateMaximum?: Maybe<Scalars['DateTime']['output']>;
  dueDateMinimum?: Maybe<Scalars['DateTime']['output']>;
  filterKind: FieldForceManagementFilterKind;
  isConfidential?: Maybe<Scalars['Boolean']['output']>;
  isFollowUp?: Maybe<Scalars['Boolean']['output']>;
  kind?: Maybe<Array<ActionItemKind>>;
  kpiUnitCategory?: Maybe<Array<Scalars['String']['output']>>;
  offlineOnly?: Maybe<Scalars['Boolean']['output']>;
  organization_organizationId?: Maybe<Array<Scalars['BigInt']['output']>>;
  priority?: Maybe<Array<ActionItemPriority>>;
  reportingPeriodFrom?: Maybe<Scalars['DateTime']['output']>;
  reportingPeriodTo?: Maybe<Scalars['DateTime']['output']>;
  responsible_personId?: Maybe<Array<Scalars['BigInt']['output']>>;
  rootOrganizationIds?: Maybe<Array<Scalars['BigInt']['output']>>;
  source?: Maybe<Array<Source>>;
  status?: Maybe<Array<ActionItemStatus>>;
  strategyImpactId?: Maybe<Array<Scalars['String']['output']>>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
  widgets_questionnaireOrAuditId?: Maybe<Array<Scalars['String']['output']>>;
};

export type FieldForceManagementCalendarExport = {
  __typename?: 'FieldForceManagementCalendarExport';
  id: Scalars['ObjectID']['output'];
  owner: Person;
  path: Scalars['String']['output'];
};

export type FieldForceManagementDashboardWidget = {
  __typename?: 'FieldForceManagementDashboardWidget';
  id: Scalars['ObjectID']['output'];
  settings: FieldForceManagementDashboardWidgetSettings;
  type: FieldForceManagementDashboardWidgetType;
};

export type FieldForceManagementDashboardWidgetPbeGrossProfitPotentialIdentifiedSettings = {
  __typename?: 'FieldForceManagementDashboardWidgetPbeGrossProfitPotentialIdentifiedSettings';
  endDate: Scalars['DateTime']['output'];
  organizationIds: Array<Scalars['BigInt']['output']>;
  startDate: Scalars['DateTime']['output'];
};

export type FieldForceManagementDashboardWidgetPbeGrossProfitPotentialIdentifiedSettingsInput = {
  endDate: Scalars['DateTime']['input'];
  organizationIds: Array<Scalars['BigInt']['input']>;
  startDate: Scalars['DateTime']['input'];
};

export type FieldForceManagementDashboardWidgetPbeStatusOverviewSettings = {
  __typename?: 'FieldForceManagementDashboardWidgetPbeStatusOverviewSettings';
  actionItemStatus: Array<ActionItemStatus>;
  organizationIds: Array<Scalars['BigInt']['output']>;
};

export type FieldForceManagementDashboardWidgetPbeStatusOverviewSettingsInput = {
  actionItemStatus: Array<ActionItemStatus>;
  organizationIds: Array<Scalars['BigInt']['input']>;
};

export type FieldForceManagementDashboardWidgetSettings = FieldForceManagementDashboardWidgetPbeGrossProfitPotentialIdentifiedSettings | FieldForceManagementDashboardWidgetPbeStatusOverviewSettings;

export type FieldForceManagementDashboardWidgetSettingsInput = {
  pbeGrossProfitPotentialIdentified?: InputMaybe<FieldForceManagementDashboardWidgetPbeGrossProfitPotentialIdentifiedSettingsInput>;
  pbeStatusOverview?: InputMaybe<FieldForceManagementDashboardWidgetPbeStatusOverviewSettingsInput>;
};

export enum FieldForceManagementDashboardWidgetType {
  PbeGrossProfitPotentialIdentified = 'PBE_GROSS_PROFIT_POTENTIAL_IDENTIFIED',
  PbeStatusOverview = 'PBE_STATUS_OVERVIEW'
}

export type FieldForceManagementEmailNotification = {
  __typename?: 'FieldForceManagementEmailNotification';
  adhoc?: Maybe<Scalars['Boolean']['output']>;
  cron?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  options?: Maybe<FieldForceManagementEmailNotificationOption>;
  person: Person;
  topic: FieldForceManagementEmailNotificationTopic;
};

export type FieldForceManagementEmailNotificationOption = {
  __typename?: 'FieldForceManagementEmailNotificationOption';
  actionItemAssignedAsResponsible?: Maybe<Scalars['Boolean']['output']>;
  actionItemCommentedOn?: Maybe<Scalars['Boolean']['output']>;
  actionItemCreated?: Maybe<Scalars['Boolean']['output']>;
  actionItemDone?: Maybe<Scalars['Boolean']['output']>;
  actionItemDueDateChanged?: Maybe<Scalars['Boolean']['output']>;
  actionItemFinished?: Maybe<Scalars['Boolean']['output']>;
  includeMyChanges?: Maybe<Scalars['Boolean']['output']>;
  meetingAddedAsAttendee?: Maybe<Scalars['Boolean']['output']>;
  meetingApprovalRejected?: Maybe<Scalars['Boolean']['output']>;
  meetingCommentedOn?: Maybe<Scalars['Boolean']['output']>;
  meetingCreated?: Maybe<Scalars['Boolean']['output']>;
  meetingFinished?: Maybe<Scalars['Boolean']['output']>;
  meetingRescheduled?: Maybe<Scalars['Boolean']['output']>;
  meetingSentForApproval?: Maybe<Scalars['Boolean']['output']>;
  notifyDaysBeforeDue?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Filter-based events will be migrated to events */
  organizationIds?: Maybe<Array<Scalars['BigInt']['output']>>;
  /** @deprecated Filter-based events will be migrated to events */
  personIds?: Maybe<Array<Scalars['BigInt']['output']>>;
  /** @deprecated Source-based events will be migrated to events */
  source?: Maybe<Array<Source>>;
};

export type FieldForceManagementEmailNotificationOptionInput = {
  actionItemAssignedAsResponsible?: InputMaybe<Scalars['Boolean']['input']>;
  actionItemCommentedOn?: InputMaybe<Scalars['Boolean']['input']>;
  actionItemCreated?: InputMaybe<Scalars['Boolean']['input']>;
  actionItemDone?: InputMaybe<Scalars['Boolean']['input']>;
  actionItemDueDateChanged?: InputMaybe<Scalars['Boolean']['input']>;
  actionItemFinished?: InputMaybe<Scalars['Boolean']['input']>;
  includeMyChanges?: InputMaybe<Scalars['Boolean']['input']>;
  meetingAddedAsAttendee?: InputMaybe<Scalars['Boolean']['input']>;
  meetingApprovalRejected?: InputMaybe<Scalars['Boolean']['input']>;
  meetingCommentedOn?: InputMaybe<Scalars['Boolean']['input']>;
  meetingCreated?: InputMaybe<Scalars['Boolean']['input']>;
  meetingFinished?: InputMaybe<Scalars['Boolean']['input']>;
  meetingRescheduled?: InputMaybe<Scalars['Boolean']['input']>;
  meetingSentForApproval?: InputMaybe<Scalars['Boolean']['input']>;
  notifyDaysBeforeDue?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Filter-based events will be migrated to events */
  organizationIds?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  /** @deprecated Filter-based events will be migrated to events */
  personIds?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  /** @deprecated Source-based events will be migrated to events */
  source?: InputMaybe<Array<Source>>;
};

export enum FieldForceManagementEmailNotificationTopic {
  FieldForceManagementActionItemNearingDue = 'FIELD_FORCE_MANAGEMENT_ACTION_ITEM_NEARING_DUE',
  FieldForceManagementEvents = 'FIELD_FORCE_MANAGEMENT_EVENTS',
  /** @deprecated Filter-based events will be migrated to events */
  FieldForceManagementFilterBasedEvents = 'FIELD_FORCE_MANAGEMENT_FILTER_BASED_EVENTS',
  FieldForceManagementReminders = 'FIELD_FORCE_MANAGEMENT_REMINDERS',
  /** @deprecated Source-based events will be migrated to events */
  FieldForceManagementSourceBasedEvents = 'FIELD_FORCE_MANAGEMENT_SOURCE_BASED_EVENTS',
  FieldForceManagementSummary = 'FIELD_FORCE_MANAGEMENT_SUMMARY'
}

export type FieldForceManagementFeatureFlag = {
  __typename?: 'FieldForceManagementFeatureFlag';
  id: Scalars['ObjectID']['output'];
  name: FieldForceManagementFeatureFlagName;
  organizations: Array<Organization>;
  persons: Array<Person>;
};

export enum FieldForceManagementFeatureFlagName {
  ActionItemsHaveNoDoneStatus = 'ACTION_ITEMS_HAVE_NO_DONE_STATUS',
  ApprovalProcess = 'APPROVAL_PROCESS',
  ApprovalProcessWithSelfApproval = 'APPROVAL_PROCESS_WITH_SELF_APPROVAL',
  Audit = 'AUDIT',
  CalendarExport = 'CALENDAR_EXPORT',
  ConvertCurrency = 'CONVERT_CURRENCY',
  DealerCanCreateActionItemsAndMeetings = 'DEALER_CAN_CREATE_ACTION_ITEMS_AND_MEETINGS',
  DealerCanFinishActionItems = 'DEALER_CAN_FINISH_ACTION_ITEMS',
  EmailNotifications = 'EMAIL_NOTIFICATIONS',
  FilterBasedNotifications = 'FILTER_BASED_NOTIFICATIONS',
  IrisDashboard = 'IRIS_DASHBOARD',
  LegacyMeetings = 'LEGACY_MEETINGS',
  ManageQuestionnaires = 'MANAGE_QUESTIONNAIRES',
  PbeReportsWithConfidentials = 'PBE_REPORTS_WITH_CONFIDENTIALS',
  RoadToXReports = 'ROAD_TO_X_REPORTS',
  ShowRoadToXReporting = 'SHOW_ROAD_TO_X_REPORTING',
  SourceBasedNotifications = 'SOURCE_BASED_NOTIFICATIONS'
}

export type FieldForceManagementFilter = {
  filterKind: FieldForceManagementFilterKind;
};

export type FieldForceManagementFilterInput = {
  approver_personId?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  author_personId?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  categories_categoryId?: InputMaybe<Array<Scalars['String']['input']>>;
  coachingModules_coachingModuleId?: InputMaybe<Array<Scalars['String']['input']>>;
  consultingMeetingType_consultingMeetingTypeId?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAtMaximum?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtMinimum?: InputMaybe<Scalars['DateTime']['input']>;
  distinctBy?: InputMaybe<Scalars['String']['input']>;
  dueDateMaximum?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateMinimum?: InputMaybe<Scalars['DateTime']['input']>;
  filterKind: FieldForceManagementFilterKind;
  hasConsultants?: InputMaybe<Scalars['Boolean']['input']>;
  isConfidential?: InputMaybe<Scalars['Boolean']['input']>;
  isFollowUp?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Array<Scalars['String']['input']>>;
  kpiUnitCategory?: InputMaybe<Array<Scalars['String']['input']>>;
  offlineOnly?: InputMaybe<Scalars['Boolean']['input']>;
  onlyIamApprover?: InputMaybe<Scalars['Boolean']['input']>;
  organization_organizationId?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  priority?: InputMaybe<Array<ActionItemPriority>>;
  reportingPeriodFrom?: InputMaybe<Scalars['DateTime']['input']>;
  reportingPeriodTo?: InputMaybe<Scalars['DateTime']['input']>;
  responsible_personId?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  rootOrganizationIds?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  scheduledTimeMaximum?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledTimeMinimum?: InputMaybe<Scalars['DateTime']['input']>;
  source?: InputMaybe<Array<Source>>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  strategyImpactId?: InputMaybe<Array<Scalars['String']['input']>>;
  subject?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<MeetingType>>;
  widgets_questionnaireOrAuditId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum FieldForceManagementFilterKind {
  ActionItem = 'ACTION_ITEM',
  Meeting = 'MEETING'
}

export type FieldForceManagementFilterPreset = {
  __typename?: 'FieldForceManagementFilterPreset';
  filter: FieldForceManagementFilter;
  id: Scalars['ObjectID']['output'];
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type FieldForceManagementFilterPresetsFilter = {
  filter_filterKind?: InputMaybe<FieldForceManagementFilterKind>;
};

export type FieldForceManagementMeetingConnection = {
  __typename?: 'FieldForceManagementMeetingConnection';
  edges: Array<FieldForceManagementMeetingEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FieldForceManagementMeetingEdge = {
  __typename?: 'FieldForceManagementMeetingEdge';
  cursor: Scalars['Cursor']['output'];
  node: Meeting;
};

export type FieldForceManagementMeetingFilter = FieldForceManagementFilter & {
  __typename?: 'FieldForceManagementMeetingFilter';
  approver_personId?: Maybe<Array<Scalars['BigInt']['output']>>;
  author_personId?: Maybe<Array<Scalars['BigInt']['output']>>;
  categories_categoryId?: Maybe<Array<Scalars['String']['output']>>;
  coachingModules_coachingModuleId?: Maybe<Array<Scalars['String']['output']>>;
  consultingMeetingType_consultingMeetingTypeId?: Maybe<Array<Scalars['String']['output']>>;
  createdAtMaximum?: Maybe<Scalars['DateTime']['output']>;
  createdAtMinimum?: Maybe<Scalars['DateTime']['output']>;
  distinctBy?: Maybe<Scalars['String']['output']>;
  filterKind: FieldForceManagementFilterKind;
  hasConsultants?: Maybe<Scalars['Boolean']['output']>;
  isConfidential?: Maybe<Scalars['Boolean']['output']>;
  kind?: Maybe<Array<MeetingKind>>;
  offlineOnly?: Maybe<Scalars['Boolean']['output']>;
  onlyIamApprover?: Maybe<Scalars['Boolean']['output']>;
  organization_organizationId?: Maybe<Array<Scalars['BigInt']['output']>>;
  rootOrganizationIds?: Maybe<Array<Scalars['BigInt']['output']>>;
  scheduledTimeMaximum?: Maybe<Scalars['DateTime']['output']>;
  scheduledTimeMinimum?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Array<Scalars['String']['output']>>;
  subject?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  type?: Maybe<Array<MeetingType>>;
};

export type FilledInAudit = ActionItemWidget & {
  __typename?: 'FilledInAudit';
  actionItem: ActionItem;
  answers: Array<AuditAnswer>;
  audit: Audit;
  isRemoved?: Maybe<Scalars['Boolean']['output']>;
  kind: WidgetKind;
  updatedAt: Scalars['DateTime']['output'];
  widgetId: Scalars['ObjectID']['output'];
};

export type FilledInQuestionnaire = ActionItemWidget & {
  __typename?: 'FilledInQuestionnaire';
  actionItem: ActionItem;
  answers: Array<QuestionnaireAnswer>;
  changeHistory: Array<FilledInQuestionnaireChangeHistory>;
  isRemoved?: Maybe<Scalars['Boolean']['output']>;
  kind: WidgetKind;
  questionnaire: Questionnaire;
  updatedAt: Scalars['DateTime']['output'];
  widgetId: Scalars['ObjectID']['output'];
};


export type FilledInQuestionnaireChangeHistoryArgs = {
  granularity?: InputMaybe<ChangeHistoryGranularity>;
};

export type FilledInQuestionnaireChangeHistory = {
  __typename?: 'FilledInQuestionnaireChangeHistory';
  diffs: Array<FilledInQuestionnaireChangeHistoryDiff>;
  person: Person;
  timestamp: Scalars['DateTime']['output'];
};

export type FilledInQuestionnaireChangeHistoryDiff = FilledInQuestionnaireChangeHistoryDiffAny | FilledInQuestionnaireChangeHistoryDiffArray;

export type FilledInQuestionnaireChangeHistoryDiffAny = {
  __typename?: 'FilledInQuestionnaireChangeHistoryDiffAny';
  next?: Maybe<Scalars['JSON']['output']>;
  path: Array<Scalars['PathElement']['output']>;
  prev?: Maybe<Scalars['JSON']['output']>;
};

export type FilledInQuestionnaireChangeHistoryDiffArray = {
  __typename?: 'FilledInQuestionnaireChangeHistoryDiffArray';
  moved: Array<Scalars['JSON']['output']>;
  next?: Maybe<Array<Scalars['JSON']['output']>>;
  path: Array<Scalars['PathElement']['output']>;
  prev?: Maybe<Array<Scalars['JSON']['output']>>;
  pulled: Array<Scalars['JSON']['output']>;
  pushed: Array<Scalars['JSON']['output']>;
};

export type FilledInSurvey = ActionItemWidget & {
  __typename?: 'FilledInSurvey';
  isRemoved?: Maybe<Scalars['Boolean']['output']>;
  kind: WidgetKind;
  surveyId: Scalars['ObjectID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  widgetId: Scalars['ObjectID']['output'];
};

export type FloatValueWithYear = {
  __typename?: 'FloatValueWithYear';
  value?: Maybe<Scalars['Float']['output']>;
  year: Scalars['Int']['output'];
};

export type GeoRegionFilter = {
  ancestors?: InputMaybe<BigIntFilter>;
};

export type Group = {
  __typename?: 'Group';
  /** ffmAlias: groupId */
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  visibleGroups?: Maybe<Array<GroupReference>>;
};

export type GroupReference = {
  __typename?: 'GroupReference';
  groupId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type GroupReferenceInput = {
  groupId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type HelpArticle = {
  __typename?: 'HelpArticle';
  article?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<Array<Attachment>>;
  author?: Maybe<Person>;
  /** ffmAlias: helpArticleId */
  id: Scalars['ObjectID']['output'];
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  publishDate?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  type: HelpArticleType;
  visibleToRoles?: Maybe<Array<Scalars['String']['output']>>;
};

export type HelpArticleSort = {
  isPublished?: InputMaybe<SortOrder>;
  publishDate?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export enum HelpArticleType {
  Faq = 'FAQ',
  QuickStartGuide = 'QUICK_START_GUIDE'
}

export type IdFilter = {
  _eq?: InputMaybe<Scalars['ID']['input']>;
  _in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  _nin?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ImportPcRoadmapKpiValueSetValueInput = {
  kind?: InputMaybe<PcRoadmapKpiValueKind>;
  name: Scalars['String']['input'];
  style?: InputMaybe<NumberStyle>;
  value?: InputMaybe<Scalars['Float']['input']>;
  variant?: InputMaybe<PcRoadmapKpiValueVariant>;
};

export type ImportPcRoadmapReportInput = {
  actualValue?: InputMaybe<Scalars['Float']['input']>;
  deviationAbsolute?: InputMaybe<Scalars['Float']['input']>;
  deviationRelative?: InputMaybe<Scalars['Float']['input']>;
  organizationId: Scalars['BigInt']['input'];
  previousYearValue?: InputMaybe<Scalars['Float']['input']>;
  strategyFieldId: Scalars['ObjectID']['input'];
  strategyKpiCategoryId?: InputMaybe<Scalars['ObjectID']['input']>;
  strategyKpiId: Scalars['ObjectID']['input'];
  style?: InputMaybe<NumberStyle>;
  targetNextValue?: InputMaybe<Scalars['Float']['input']>;
  targetValue?: InputMaybe<Scalars['Float']['input']>;
  valueSet: Array<ImportPcRoadmapReportValueInput>;
};

export type ImportPcRoadmapReportValueInput = {
  name: Scalars['String']['input'];
  style?: InputMaybe<NumberStyle>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type IntFilter = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _exists?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _ne?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type IntValueWithYear = {
  __typename?: 'IntValueWithYear';
  value?: Maybe<Scalars['Int']['output']>;
  year: Scalars['Int']['output'];
};

export type KpiUnit = {
  __typename?: 'KpiUnit';
  /** @deprecated Use actionItemKinds instead */
  actionItemKind: ActionItemKind;
  actionItemKinds: Array<ActionItemKind>;
  id: Scalars['ObjectID']['output'];
  irisKey?: Maybe<Scalars['String']['output']>;
  kpiUnitCategory?: Maybe<KpiUnitCategory>;
  /** Localized field for nameLocalizations */
  name: Scalars['String']['output'];
  nameLocalizations: Array<LocalizedString>;
  organizations: Array<Organization>;
};

export type KpiUnitCategoriesFilter = {
  _and?: InputMaybe<Array<KpiUnitCategoriesFilter>>;
  _id?: InputMaybe<ObjectIdFilter>;
  _or?: InputMaybe<Array<KpiUnitCategoriesFilter>>;
  actionItemKind?: InputMaybe<ActionItemKindFilter>;
  actionItemKinds?: InputMaybe<ActionItemKindFilter>;
  nameLocalized?: InputMaybe<StringFilter>;
  organizations?: InputMaybe<BigIntFilter>;
};

export type KpiUnitCategoriesInput = {
  filter?: InputMaybe<KpiUnitCategoriesFilter>;
};

export type KpiUnitCategory = {
  __typename?: 'KpiUnitCategory';
  /** @deprecated Use actionItemKinds instead */
  actionItemKind: ActionItemKind;
  actionItemKinds: Array<ActionItemKind>;
  id: Scalars['ObjectID']['output'];
  kpiUnits: Array<KpiUnit>;
  /** Localized field for nameLocalizations */
  name: Scalars['String']['output'];
  nameLocalizations: Array<LocalizedString>;
  organizations: Array<Organization>;
};

export type LocalizedAttachments = {
  __typename?: 'LocalizedAttachments';
  locale: Scalars['String']['output'];
  value?: Maybe<Array<Attachment>>;
};

export type LocalizedAttachmentsInput = {
  locale: Scalars['String']['input'];
  value?: InputMaybe<Array<AttachmentInput>>;
};

export type LocalizedString = {
  __typename?: 'LocalizedString';
  locale: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type LocalizedStringInput = {
  locale: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type Login = AnonymousPerson | Person;

export type MarketFilter = {
  region?: InputMaybe<Scalars['String']['input']>;
};

export type MaskedActionItem = {
  __typename?: 'MaskedActionItem';
  agendaItems?: Maybe<Array<AgendaItem>>;
  /** ffmAlias: actionItemId */
  id: Scalars['ObjectID']['output'];
  status: ActionItemStatus;
};

export type MaskedMeeting = {
  __typename?: 'MaskedMeeting';
  /** ffmAlias: meetingId */
  id: Scalars['ObjectID']['output'];
};

export type Meeting = {
  __typename?: 'Meeting';
  agenda?: Maybe<Array<AgendaItem>>;
  approver?: Maybe<PersonReference>;
  attachments?: Maybe<Array<Attachment>>;
  attendees?: Maybe<Array<Person>>;
  author: Person;
  categories?: Maybe<Array<Category>>;
  changeHistory: Array<MeetingChangeHistory>;
  coachingModules?: Maybe<Array<CoachingModule>>;
  comments: Array<Comment>;
  consultants?: Maybe<Array<Person>>;
  consultingMeetingType?: Maybe<Array<ConsultingMeetingType>>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  externals?: Maybe<Array<Scalars['String']['output']>>;
  hasVisibleAgendaActionItem?: Maybe<Scalars['Boolean']['output']>;
  /** ffmAlias: meetingId */
  id: Scalars['ObjectID']['output'];
  isConfidential?: Maybe<Scalars['Boolean']['output']>;
  kind?: Maybe<MeetingKind>;
  organization: Organization;
  pbeIrisLink?: Maybe<Scalars['String']['output']>;
  peerGroup?: Maybe<Scalars['ObjectID']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  scheduledTimeEnd: Scalars['DateTime']['output'];
  scheduledTimeStart: Scalars['DateTime']['output'];
  status: MeetingStatus;
  statusChanges?: Maybe<Array<StatusChange>>;
  subject: Scalars['String']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  type: MeetingType;
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['Int']['output'];
};


export type MeetingChangeHistoryArgs = {
  granularity?: InputMaybe<ChangeHistoryGranularity>;
};

export type MeetingAgendaInput = {
  itemId: Scalars['Int']['input'];
  meetingId: Scalars['ObjectID']['input'];
};

export type MeetingChangeHistory = {
  __typename?: 'MeetingChangeHistory';
  diffs: Array<MeetingChangeHistoryDiff>;
  person: Person;
  timestamp: Scalars['DateTime']['output'];
};

export type MeetingChangeHistoryDiff = MeetingChangeHistoryDiffAny | MeetingChangeHistoryDiffArray;

export type MeetingChangeHistoryDiffAny = {
  __typename?: 'MeetingChangeHistoryDiffAny';
  next?: Maybe<Scalars['JSON']['output']>;
  path: Array<Scalars['PathElement']['output']>;
  prev?: Maybe<Scalars['JSON']['output']>;
};

export type MeetingChangeHistoryDiffArray = {
  __typename?: 'MeetingChangeHistoryDiffArray';
  moved: Array<Scalars['JSON']['output']>;
  next?: Maybe<Array<Scalars['JSON']['output']>>;
  path: Array<Scalars['PathElement']['output']>;
  prev?: Maybe<Array<Scalars['JSON']['output']>>;
  pulled: Array<Scalars['JSON']['output']>;
  pushed: Array<Scalars['JSON']['output']>;
};

export enum MeetingDistinctBy {
  Organization = 'organization'
}

export type MeetingFilter = {
  _and?: InputMaybe<Array<InputMaybe<MeetingFilter>>>;
  _id?: InputMaybe<IdFilter>;
  _or?: InputMaybe<Array<InputMaybe<MeetingFilter>>>;
  approver_personId?: InputMaybe<BigIntFilter>;
  attendees_personId?: InputMaybe<BigIntFilter>;
  author_personId?: InputMaybe<BigIntFilter>;
  categories_categoryId?: InputMaybe<ObjectIdFilter>;
  coachingModules_coachingModuleId?: InputMaybe<ObjectIdFilter>;
  consultants_personId?: InputMaybe<BigIntFilter>;
  consultingMeetingType_consultingMeetingTypeId?: InputMaybe<ObjectIdFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  isConfidential?: InputMaybe<BooleanFilter>;
  kind?: InputMaybe<MeetingKindFilter>;
  organization_geography_region?: InputMaybe<StringFilter>;
  organization_organizationId?: InputMaybe<BigIntFilter>;
  rootOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
  scheduledTimeEnd?: InputMaybe<DateTimeFilter>;
  scheduledTimeStart?: InputMaybe<DateTimeFilter>;
  status?: InputMaybe<MeetingStatusFilter>;
  subject?: InputMaybe<StringFilter>;
  tags?: InputMaybe<StringArrayFilter>;
  type?: InputMaybe<MeetingTypeFilter>;
};

export enum MeetingKind {
  Dealer = 'DEALER',
  Pbe = 'PBE',
  Plt = 'PLT',
  Standard = 'STANDARD'
}

export type MeetingKindFilter = {
  _eq?: InputMaybe<MeetingKind>;
  _in?: InputMaybe<Array<InputMaybe<MeetingKind>>>;
};

export enum MeetingOrderBy {
  AuthorName = 'author_name',
  Categories = 'categories',
  ConsultingMeetingType = 'consultingMeetingType',
  Kind = 'kind',
  OrganizationName = 'organization_name',
  ScheduledTimeStart = 'scheduledTimeStart',
  Status = 'status',
  Subject = 'subject',
  Tags = 'tags',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type MeetingReferenceInput = {
  meetingId: Scalars['ObjectID']['input'];
};

export type MeetingSort = {
  author_name?: InputMaybe<SortOrder>;
  categories?: InputMaybe<SortOrder>;
  consultingMeetingType?: InputMaybe<SortOrder>;
  kind?: InputMaybe<SortOrder>;
  organization_name?: InputMaybe<SortOrder>;
  scheduledTimeStart?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subject?: InputMaybe<SortOrder>;
  tags?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type MeetingStatistic = {
  __typename?: 'MeetingStatistic';
  count: Scalars['Int']['output'];
  date: Scalars['DateTime']['output'];
};

export type MeetingStatisticInput = {
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
  granularity: StatisticGranularity;
  organizationId: Scalars['BigInt']['input'];
};

export enum MeetingStatus {
  Finished = 'FINISHED',
  Open = 'OPEN',
  PendingApproval = 'PENDING_APPROVAL'
}

export type MeetingStatusFilter = {
  _eq?: InputMaybe<MeetingStatus>;
  _in?: InputMaybe<Array<InputMaybe<MeetingStatus>>>;
  _nin?: InputMaybe<Array<InputMaybe<MeetingStatus>>>;
};

export enum MeetingType {
  Other = 'Other',
  Phone = 'Phone',
  VirtualVisit = 'VirtualVisit',
  Visit = 'Visit'
}

export type MeetingTypeFilter = {
  _eq?: InputMaybe<MeetingType>;
  _in?: InputMaybe<Array<InputMaybe<MeetingType>>>;
};

export type ModifyActionItemWidgetsInput = {
  _pull?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  _push?: InputMaybe<Array<CreateActionItemWidgetInput>>;
};

export type ModifyAttachmentsInput = {
  _pull?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  _push?: InputMaybe<Array<AttachmentInput>>;
  _update?: InputMaybe<Array<UpdateAttachmentInput>>;
};

export type ModifyCommentsInput = {
  _pull?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  _push?: InputMaybe<Array<CommentInput>>;
  _update?: InputMaybe<Array<UpdateCommentInput>>;
};

export type ModifyImplementationImagesInput = {
  _move?: InputMaybe<Array<MoveArrayElementInput>>;
  _pull?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  _push?: InputMaybe<Array<AttachmentInput>>;
  _update?: InputMaybe<Array<UpdateAttachmentInput>>;
};

export type ModifyMediaInput = {
  _move?: InputMaybe<Array<MoveArrayElementInput>>;
  _pull?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  _push?: InputMaybe<Array<AttachmentInput>>;
  _update?: InputMaybe<Array<UpdateAttachmentInput>>;
};

export type ModifyMultisensoryExperienceAttachmentInput = {
  _pull?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  _push?: InputMaybe<Array<MultisensoryExperienceAttachmentInput>>;
  _update?: InputMaybe<Array<UpdateMultisensoryExperienceAttachmentInput>>;
};

export type ModifyMultisensoryExperienceMeasureTaskPlacementsInput = {
  _pull?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  _push?: InputMaybe<Array<MultisensoryExperienceMeasureTaskPlacementInput>>;
  _update?: InputMaybe<Array<MultisensoryExperienceMeasureTaskPlacementInput>>;
};

export type ModifyNetworkPlanningOrganizationActionItemsInput = {
  _pull?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  _push?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
};

export type ModifyPcRoadmapAdditionalAgreementValueInput = {
  _update?: InputMaybe<Array<UpdatePcRoadmapAdditionalAgreementValueInput>>;
};

export type ModifyPcRoadmapWorkPackagesInput = {
  _pull?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  _push?: InputMaybe<Array<PcRoadmapActionItemWorkPackageInput>>;
  _update?: InputMaybe<Array<UpdatePcRoadmapActionItemWorkPackageInput>>;
};

export type ModifyPorscheImportAgreementsChangeRequestApprovalsInput = {
  _pull?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  _push?: InputMaybe<Array<CreatePorscheImportAgreementsChangeRequestApprovalInput>>;
  _update?: InputMaybe<Array<UpdatePorscheImportAgreementsChangeRequestApprovalInput>>;
};

export type ModifyRealEstatePropertyCommentsInput = {
  _push?: InputMaybe<Array<RealEstatePropertyCommentInput>>;
  _update?: InputMaybe<Array<UpdateRealEstatePropertyCommentInput>>;
};

export type ModifyRetailDesignProjectAttachmentInput = {
  _pull?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  _push?: InputMaybe<Array<RetailDesignProjectAttachmentInput>>;
  _update?: InputMaybe<Array<UpdateRetailDesignProjectAttachmentInput>>;
};

export type ModifySurveyReportConfigChartInput = {
  _move?: InputMaybe<Array<MoveSurveyReportConfigChartInput>>;
  _pull?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  _push?: InputMaybe<Array<CreateSurveyReportConfigChartInput>>;
  _update?: InputMaybe<Array<UpdateSurveyReportConfigChartInput>>;
};

export type ModifySurveyReportConfigSectionInput = {
  _move?: InputMaybe<Array<MoveSurveyReportConfigSectionInput>>;
  _pull?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  _push?: InputMaybe<Array<CreateSurveyReportConfigSectionInput>>;
  _update?: InputMaybe<Array<UpdateSurveyReportConfigSectionInput>>;
};

export type ModifyUserManagementItemOrganizationIdsInput = {
  _pull?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  _push?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type ModifyWorkPackagesInput = {
  _pull?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  _push?: InputMaybe<Array<StrategyActionItemWorkPackageInput>>;
  _update?: InputMaybe<Array<UpdateStrategyActionItemWorkPackageInput>>;
};

export type MoveArrayElementInput = {
  fromIndex: Scalars['Int']['input'];
  toIndex: Scalars['Int']['input'];
};

export type MoveSurveyReportConfigChartInput = {
  fromIndex: Scalars['Int']['input'];
  toIndex: Scalars['Int']['input'];
};

export type MoveSurveyReportConfigSectionInput = {
  fromIndex: Scalars['Int']['input'];
  toIndex: Scalars['Int']['input'];
};

export type MultisensoryExperience = {
  __typename?: 'MultisensoryExperience';
  attachment?: Maybe<MultisensoryExperienceAttachment>;
  attachments: Array<MultisensoryExperienceAttachment>;
  author: Person;
  budgetIsAvailable?: Maybe<Scalars['Boolean']['output']>;
  changeHistory: Array<MultisensoryExperienceChangeHistory>;
  comments: Array<Comment>;
  description?: Maybe<Scalars['String']['output']>;
  format: MultisensoryExperienceFormat;
  id: Scalars['ObjectID']['output'];
  includesDestinationPorscheFurniture?: Maybe<Scalars['Boolean']['output']>;
  market: Organization;
  measures: Array<MultisensoryExperienceMeasure>;
  organization: Organization;
  plannedCompletion?: Maybe<Scalars['Date']['output']>;
  previousStatus?: Maybe<MultisensoryExperienceStatus>;
  projectCompletionWithinStartYear?: Maybe<Scalars['Boolean']['output']>;
  relatedMeasures: Array<MultisensoryExperienceRelatedMeasure>;
  start?: Maybe<Scalars['Date']['output']>;
  status: MultisensoryExperienceStatus;
  taskCount: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};


export type MultisensoryExperienceAttachmentArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MultisensoryExperienceChangeHistoryArgs = {
  granularity?: InputMaybe<ChangeHistoryGranularity>;
};


export type MultisensoryExperienceTaskCountArgs = {
  filter?: InputMaybe<TaskCountFilter>;
};

export type MultisensoryExperienceArea = {
  __typename?: 'MultisensoryExperienceArea';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  format: MultisensoryExperienceFormat;
  id: Scalars['ObjectID']['output'];
  isInUse: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type MultisensoryExperienceAreaFilter = {
  _and?: InputMaybe<Array<MultisensoryExperienceAreaFilter>>;
  _or?: InputMaybe<Array<MultisensoryExperienceAreaFilter>>;
  format?: InputMaybe<MultisensoryExperienceFormatFilter>;
  name?: InputMaybe<StringFilter>;
};

export type MultisensoryExperienceAreasInput = {
  filter?: InputMaybe<MultisensoryExperienceAreaFilter>;
};

export type MultisensoryExperienceAttachment = {
  __typename?: 'MultisensoryExperienceAttachment';
  comments: Array<Comment>;
  createdAt: Scalars['DateTime']['output'];
  filePrefix?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  uploader?: Maybe<Person>;
  visibility: MultisensoryExperienceAttachmentVisibility;
};

export type MultisensoryExperienceAttachmentInput = {
  filePrefix?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ObjectID']['input'];
  name: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  type: Scalars['String']['input'];
  visibility?: InputMaybe<MultisensoryExperienceAttachmentVisibility>;
};

export enum MultisensoryExperienceAttachmentVisibility {
  Internal = 'INTERNAL',
  Public = 'PUBLIC'
}

export type MultisensoryExperienceBundle = {
  __typename?: 'MultisensoryExperienceBundle';
  areas: Array<MultisensoryExperienceArea>;
  id: Scalars['ObjectID']['output'];
  isActive: Scalars['Boolean']['output'];
  isInUse: Scalars['Boolean']['output'];
  items: Array<MultisensoryExperienceItem>;
  name: Scalars['String']['output'];
};

export type MultisensoryExperienceBundleEmbedded = {
  __typename?: 'MultisensoryExperienceBundleEmbedded';
  id: Scalars['ObjectID']['output'];
  items: Array<MultisensoryExperienceItemEmbedded>;
  name: Scalars['String']['output'];
};

export type MultisensoryExperienceBundleFilter = {
  _and?: InputMaybe<Array<MultisensoryExperienceBundleFilter>>;
  _or?: InputMaybe<Array<MultisensoryExperienceBundleFilter>>;
  areas?: InputMaybe<ObjectIdFilter>;
  isActive?: InputMaybe<BooleanFilter>;
  items?: InputMaybe<ObjectIdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type MultisensoryExperienceBundlesInput = {
  filter?: InputMaybe<MultisensoryExperienceBundleFilter>;
};

export type MultisensoryExperienceChangeHistory = {
  __typename?: 'MultisensoryExperienceChangeHistory';
  diffs: Array<MultisensoryExperienceChangeHistoryDiff>;
  person: Person;
  timestamp: Scalars['DateTime']['output'];
};

export type MultisensoryExperienceChangeHistoryDiff = MultisensoryExperienceChangeHistoryDiffAny | MultisensoryExperienceChangeHistoryDiffArray;

export type MultisensoryExperienceChangeHistoryDiffAny = {
  __typename?: 'MultisensoryExperienceChangeHistoryDiffAny';
  next?: Maybe<Scalars['JSON']['output']>;
  path: Array<Scalars['PathElement']['output']>;
  prev?: Maybe<Scalars['JSON']['output']>;
};

export type MultisensoryExperienceChangeHistoryDiffArray = {
  __typename?: 'MultisensoryExperienceChangeHistoryDiffArray';
  moved: Array<Scalars['JSON']['output']>;
  next?: Maybe<Array<Scalars['JSON']['output']>>;
  path: Array<Scalars['PathElement']['output']>;
  prev?: Maybe<Array<Scalars['JSON']['output']>>;
  pulled: Array<Scalars['JSON']['output']>;
  pushed: Array<Scalars['JSON']['output']>;
};

export type MultisensoryExperienceEmailNotification = {
  __typename?: 'MultisensoryExperienceEmailNotification';
  adhoc?: Maybe<Scalars['Boolean']['output']>;
  cron?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  options?: Maybe<MultisensoryExperienceEmailNotificationOption>;
  person: Person;
  topic: MultisensoryExperienceEmailNotificationTopic;
};

export type MultisensoryExperienceEmailNotificationOption = {
  __typename?: 'MultisensoryExperienceEmailNotificationOption';
  notifyDaysBeforeCompletion?: Maybe<Scalars['Int']['output']>;
};

export type MultisensoryExperienceEmailNotificationOptionInput = {
  notifyDaysBeforeCompletion?: InputMaybe<Scalars['Int']['input']>;
};

export enum MultisensoryExperienceEmailNotificationTopic {
  MultisensoryExperienceDocumentUpload = 'MULTISENSORY_EXPERIENCE_DOCUMENT_UPLOAD',
  MultisensoryExperienceNearingCompletion = 'MULTISENSORY_EXPERIENCE_NEARING_COMPLETION',
  MultisensoryExperienceStatusChange = 'MULTISENSORY_EXPERIENCE_STATUS_CHANGE'
}

export type MultisensoryExperienceFilter = {
  _and?: InputMaybe<Array<MultisensoryExperienceFilter>>;
  _or?: InputMaybe<Array<MultisensoryExperienceFilter>>;
  author?: InputMaybe<BigIntFilter>;
  format?: InputMaybe<MultisensoryExperienceFormatFilter>;
  organization?: InputMaybe<BigIntFilter>;
  plannedCompletion?: InputMaybe<DateTimeFilter>;
  start?: InputMaybe<DateTimeFilter>;
  status?: InputMaybe<MultisensoryExperienceStatusFilter>;
  title?: InputMaybe<StringFilter>;
};

export type MultisensoryExperienceFilterPreset = {
  __typename?: 'MultisensoryExperienceFilterPreset';
  filter: MultisensoryExperienceFilterPresetConfig;
  id: Scalars['ObjectID']['output'];
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type MultisensoryExperienceFilterPresetConfig = {
  __typename?: 'MultisensoryExperienceFilterPresetConfig';
  author?: Maybe<Array<Scalars['BigInt']['output']>>;
  format?: Maybe<Array<MultisensoryExperienceFormat>>;
  onlyCreated?: Maybe<Scalars['Boolean']['output']>;
  organization?: Maybe<Array<Scalars['BigInt']['output']>>;
  plannedCompletionFrom?: Maybe<Scalars['DateTime']['output']>;
  plannedCompletionTo?: Maybe<Scalars['DateTime']['output']>;
  startFrom?: Maybe<Scalars['DateTime']['output']>;
  startTo?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Array<MultisensoryExperienceStatus>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type MultisensoryExperienceFilterPresetConfigInput = {
  author?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  format?: InputMaybe<Array<MultisensoryExperienceFormat>>;
  onlyCreated?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  plannedCompletionFrom?: InputMaybe<Scalars['DateTime']['input']>;
  plannedCompletionTo?: InputMaybe<Scalars['DateTime']['input']>;
  startFrom?: InputMaybe<Scalars['DateTime']['input']>;
  startTo?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Array<MultisensoryExperienceStatus>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum MultisensoryExperienceFormat {
  PorscheApprovedAndServiceCenter = 'PORSCHE_APPROVED_AND_SERVICE_CENTER',
  PorscheApprovedCenter = 'PORSCHE_APPROVED_CENTER',
  PorscheCenterCa2000 = 'PORSCHE_CENTER_CA2000',
  PorscheCenterDestinationPorsche = 'PORSCHE_CENTER_DESTINATION_PORSCHE',
  PorscheClassicCenter = 'PORSCHE_CLASSIC_CENTER',
  PorscheExperienceCenter = 'PORSCHE_EXPERIENCE_CENTER',
  PorscheExpressCityServiceCenter = 'PORSCHE_EXPRESS_CITY_SERVICE_CENTER',
  PorschePreOwnedCarCenter = 'PORSCHE_PRE_OWNED_CAR_CENTER',
  PorscheSalesPopUp = 'PORSCHE_SALES_POP_UP',
  PorscheServiceCenter = 'PORSCHE_SERVICE_CENTER',
  PorscheServiceFactory = 'PORSCHE_SERVICE_FACTORY',
  PorscheShowroom = 'PORSCHE_SHOWROOM',
  PorscheStore = 'PORSCHE_STORE',
  PorscheStudio = 'PORSCHE_STUDIO',
  SatellitePorscheCenter = 'SATELLITE_PORSCHE_CENTER'
}

export type MultisensoryExperienceFormatFilter = {
  _eq?: InputMaybe<MultisensoryExperienceFormat>;
  _in?: InputMaybe<Array<InputMaybe<MultisensoryExperienceFormat>>>;
};

export type MultisensoryExperienceItem = {
  __typename?: 'MultisensoryExperienceItem';
  areas: Array<MultisensoryExperienceArea>;
  category?: Maybe<MultisensoryExperienceItemCategory>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  image?: Maybe<Attachment>;
  isActive: Scalars['Boolean']['output'];
  isInUse: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  referenceId?: Maybe<Scalars['String']['output']>;
  supplier: Scalars['String']['output'];
  url?: Maybe<Scalars['URL']['output']>;
};

export enum MultisensoryExperienceItemCategory {
  CoffeeEssentials = 'COFFEE_ESSENTIALS',
  CommunicationMaterials = 'COMMUNICATION_MATERIALS',
  Decoration = 'DECORATION',
  Divers = 'DIVERS',
  Furniture = 'FURNITURE',
  KitchenEssentials = 'KITCHEN_ESSENTIALS',
  Literature = 'LITERATURE',
  PlantsAndPlantpots = 'PLANTS_AND_PLANTPOTS',
  PlaytimeEssentials = 'PLAYTIME_ESSENTIALS',
  Scent = 'SCENT',
  Sound = 'SOUND',
  ToiletryHygieneEssentials = 'TOILETRY_HYGIENE_ESSENTIALS',
  WallDecoration = 'WALL_DECORATION'
}

export type MultisensoryExperienceItemCategoryFilter = {
  _eq?: InputMaybe<MultisensoryExperienceItemCategory>;
  _in?: InputMaybe<Array<InputMaybe<MultisensoryExperienceItemCategory>>>;
};

export type MultisensoryExperienceItemEmbedded = {
  __typename?: 'MultisensoryExperienceItemEmbedded';
  category?: Maybe<MultisensoryExperienceItemCategory>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  image?: Maybe<Attachment>;
  name: Scalars['String']['output'];
  referenceId?: Maybe<Scalars['String']['output']>;
  supplier: Scalars['String']['output'];
  url?: Maybe<Scalars['URL']['output']>;
};

export type MultisensoryExperienceItemFilter = {
  _and?: InputMaybe<Array<MultisensoryExperienceItemFilter>>;
  _or?: InputMaybe<Array<MultisensoryExperienceItemFilter>>;
  areas?: InputMaybe<ObjectIdFilter>;
  category?: InputMaybe<MultisensoryExperienceItemCategoryFilter>;
  isActive?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  supplier?: InputMaybe<StringFilter>;
};

export type MultisensoryExperienceItemsInput = {
  filter?: InputMaybe<MultisensoryExperienceItemFilter>;
};

export type MultisensoryExperienceMeasure = {
  __typename?: 'MultisensoryExperienceMeasure';
  area: MultisensoryExperienceArea;
  author: Person;
  changeHistory: Array<MultisensoryExperienceMeasureChangeHistory>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  experience: MultisensoryExperience;
  id: Scalars['ObjectID']['output'];
  implementationImages: Array<Attachment>;
  media: Array<Attachment>;
  status: MultisensoryExperienceMeasureStatus;
  tasks: Array<MultisensoryExperienceMeasureTask>;
};


export type MultisensoryExperienceMeasureChangeHistoryArgs = {
  granularity?: InputMaybe<ChangeHistoryGranularity>;
};

export type MultisensoryExperienceMeasureChangeHistory = {
  __typename?: 'MultisensoryExperienceMeasureChangeHistory';
  diffs: Array<MultisensoryExperienceMeasureChangeHistoryDiff>;
  person: Person;
  timestamp: Scalars['DateTime']['output'];
};

export type MultisensoryExperienceMeasureChangeHistoryDiff = MultisensoryExperienceMeasureChangeHistoryDiffAny | MultisensoryExperienceMeasureChangeHistoryDiffArray;

export type MultisensoryExperienceMeasureChangeHistoryDiffAny = {
  __typename?: 'MultisensoryExperienceMeasureChangeHistoryDiffAny';
  next?: Maybe<Scalars['JSON']['output']>;
  path: Array<Scalars['PathElement']['output']>;
  prev?: Maybe<Scalars['JSON']['output']>;
};

export type MultisensoryExperienceMeasureChangeHistoryDiffArray = {
  __typename?: 'MultisensoryExperienceMeasureChangeHistoryDiffArray';
  moved: Array<Scalars['JSON']['output']>;
  next?: Maybe<Array<Scalars['JSON']['output']>>;
  path: Array<Scalars['PathElement']['output']>;
  prev?: Maybe<Array<Scalars['JSON']['output']>>;
  pulled: Array<Scalars['JSON']['output']>;
  pushed: Array<Scalars['JSON']['output']>;
};

export type MultisensoryExperienceMeasureFilter = {
  _and?: InputMaybe<Array<MultisensoryExperienceMeasureFilter>>;
  _or?: InputMaybe<Array<MultisensoryExperienceMeasureFilter>>;
  area?: InputMaybe<ObjectIdFilter>;
  author?: InputMaybe<BigIntFilter>;
  experience?: InputMaybe<ObjectIdFilter>;
};

export enum MultisensoryExperienceMeasureStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  ItemsOrdered = 'ITEMS_ORDERED',
  Open = 'OPEN'
}

export type MultisensoryExperienceMeasureTask = {
  __typename?: 'MultisensoryExperienceMeasureTask';
  amount?: Maybe<Scalars['Int']['output']>;
  changeHistory: Array<MultisensoryExperienceMeasureTaskChangeHistory>;
  comments: Array<Comment>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  measure: MultisensoryExperienceMeasure;
  name: Scalars['String']['output'];
  placements: Array<MultisensoryExperienceMeasureTaskPlacement>;
  status: MultisensoryExperienceMeasureTaskStatus;
  subject?: Maybe<MultisensoryExperienceTaskSubject>;
};


export type MultisensoryExperienceMeasureTaskChangeHistoryArgs = {
  granularity?: InputMaybe<ChangeHistoryGranularity>;
};

export type MultisensoryExperienceMeasureTaskChangeHistory = {
  __typename?: 'MultisensoryExperienceMeasureTaskChangeHistory';
  diffs: Array<MultisensoryExperienceMeasureTaskChangeHistoryDiff>;
  person: Person;
  timestamp: Scalars['DateTime']['output'];
};

export type MultisensoryExperienceMeasureTaskChangeHistoryDiff = MultisensoryExperienceMeasureTaskChangeHistoryDiffAny | MultisensoryExperienceMeasureTaskChangeHistoryDiffArray;

export type MultisensoryExperienceMeasureTaskChangeHistoryDiffAny = {
  __typename?: 'MultisensoryExperienceMeasureTaskChangeHistoryDiffAny';
  next?: Maybe<Scalars['JSON']['output']>;
  path: Array<Scalars['PathElement']['output']>;
  prev?: Maybe<Scalars['JSON']['output']>;
};

export type MultisensoryExperienceMeasureTaskChangeHistoryDiffArray = {
  __typename?: 'MultisensoryExperienceMeasureTaskChangeHistoryDiffArray';
  moved: Array<Scalars['JSON']['output']>;
  next?: Maybe<Array<Scalars['JSON']['output']>>;
  path: Array<Scalars['PathElement']['output']>;
  prev?: Maybe<Array<Scalars['JSON']['output']>>;
  pulled: Array<Scalars['JSON']['output']>;
  pushed: Array<Scalars['JSON']['output']>;
};

export type MultisensoryExperienceMeasureTaskFilter = {
  _and?: InputMaybe<Array<MultisensoryExperienceMeasureTaskFilter>>;
  _or?: InputMaybe<Array<MultisensoryExperienceMeasureTaskFilter>>;
  bundle_id?: InputMaybe<ObjectIdFilter>;
  item_id?: InputMaybe<ObjectIdFilter>;
  measure?: InputMaybe<ObjectIdFilter>;
};

export type MultisensoryExperienceMeasureTaskPlacement = {
  __typename?: 'MultisensoryExperienceMeasureTaskPlacement';
  id: Scalars['ObjectID']['output'];
  mediaId: Scalars['ObjectID']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type MultisensoryExperienceMeasureTaskPlacementInput = {
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  mediaId: Scalars['ObjectID']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export enum MultisensoryExperienceMeasureTaskStatus {
  Delivered = 'DELIVERED',
  Implemented = 'IMPLEMENTED',
  Open = 'OPEN',
  Ordered = 'ORDERED'
}

export type MultisensoryExperienceMeasureTaskStatusFilter = {
  _eq?: InputMaybe<MultisensoryExperienceMeasureTaskStatus>;
};

export type MultisensoryExperienceMeasureTasksInput = {
  filter?: InputMaybe<MultisensoryExperienceMeasureTaskFilter>;
};

export type MultisensoryExperienceMeasuresInput = {
  filter?: InputMaybe<MultisensoryExperienceMeasureFilter>;
};

export type MultisensoryExperienceRelatedMeasure = {
  __typename?: 'MultisensoryExperienceRelatedMeasure';
  status: MultisensoryExperienceRelatedMeasureStatus;
  type: MultisensoryExperienceRelatedMeasureType;
};

export type MultisensoryExperienceRelatedMeasureInput = {
  status: MultisensoryExperienceRelatedMeasureStatus;
  type: MultisensoryExperienceRelatedMeasureType;
};

export enum MultisensoryExperienceRelatedMeasureStatus {
  Implemented = 'IMPLEMENTED',
  NotImplemented = 'NOT_IMPLEMENTED'
}

export enum MultisensoryExperienceRelatedMeasureType {
  Music = 'MUSIC',
  Scent = 'SCENT',
  Taste = 'TASTE'
}

export enum MultisensoryExperienceStatus {
  AcceptedForActionPlan = 'ACCEPTED_FOR_ACTION_PLAN',
  AcceptedForLocationCheck = 'ACCEPTED_FOR_LOCATION_CHECK',
  ActionPlanPerformed = 'ACTION_PLAN_PERFORMED',
  Draft = 'DRAFT',
  Implemented = 'IMPLEMENTED',
  InReview = 'IN_REVIEW',
  LocationCheckPerformed = 'LOCATION_CHECK_PERFORMED',
  NeedsRevision = 'NEEDS_REVISION',
  OnHold = 'ON_HOLD'
}

export type MultisensoryExperienceStatusFilter = {
  _eq?: InputMaybe<MultisensoryExperienceStatus>;
  _in?: InputMaybe<Array<InputMaybe<MultisensoryExperienceStatus>>>;
  _ne?: InputMaybe<MultisensoryExperienceStatus>;
};

export type MultisensoryExperienceTaskSubject = MultisensoryExperienceBundleEmbedded | MultisensoryExperienceItemEmbedded;

export type MultisensoryExperiencesInput = {
  filter?: InputMaybe<MultisensoryExperienceFilter>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acknowledgePcRoadmapCommitmentJointAgreement: PcRoadmapCommitment;
  addMeetingPbeIrisLink?: Maybe<Meeting>;
  addPbeOnlyOrg?: Maybe<Array<Person>>;
  addPeerGroupToPersons: Array<Person>;
  answerAudit: FilledInAudit;
  answerQuestionnaire: FilledInQuestionnaire;
  answerSurveyQuestion: SurveyAnswer;
  assignGroups?: Maybe<Array<Group>>;
  broadcastActionItem?: Maybe<Array<Maybe<ActionItem>>>;
  calculateSurveyResult?: Maybe<SurveyResult>;
  calculateSurveyResults: Array<SurveyResult>;
  commentOnActionItem: Comment;
  commentOnMeeting: Comment;
  copyAudit: Audit;
  copyQuestionnaire: Questionnaire;
  copySurvey: Survey;
  copySurveyTemplate: SurveyTemplate;
  copyUploads: Array<Scalars['ObjectID']['output']>;
  createActionItem?: Maybe<ActionItem>;
  createActionItemTemplate: ActionItemTemplate;
  createAnonymousLoginForSurveyAnswers: SurveyAnonymousToken;
  createApexEmailNotification: ApexEmailNotification;
  createApexImport: ApexImportState;
  createAudit: Audit;
  createCategory?: Maybe<Category>;
  createCoachingModule?: Maybe<CoachingModule>;
  createConsultingMeetingType?: Maybe<ConsultingMeetingType>;
  createDashboardEmailNotification: DashboardEmailNotification;
  createDownloadUrl: Scalars['String']['output'];
  createExchangeRate: ExchangeRate;
  createFeatureArticle: FeatureArticle;
  createFieldForceManagementCalendarExport: FieldForceManagementCalendarExport;
  createFieldForceManagementEmailNotification: FieldForceManagementEmailNotification;
  createFieldForceManagementFilterPreset?: Maybe<FieldForceManagementFilterPreset>;
  createHelpArticle: HelpArticle;
  createKpiUnit: KpiUnit;
  createKpiUnitCategory: KpiUnitCategory;
  createMeeting?: Maybe<Meeting>;
  createMultisensoryExperience: MultisensoryExperience;
  createMultisensoryExperienceArea: MultisensoryExperienceArea;
  createMultisensoryExperienceAreas: Array<MultisensoryExperienceArea>;
  createMultisensoryExperienceBundle: MultisensoryExperienceBundle;
  createMultisensoryExperienceEmailNotification: MultisensoryExperienceEmailNotification;
  createMultisensoryExperienceFilterPreset: MultisensoryExperienceFilterPreset;
  createMultisensoryExperienceItem: MultisensoryExperienceItem;
  createMultisensoryExperienceMeasure: MultisensoryExperienceMeasure;
  createMultisensoryExperienceMeasureTask: MultisensoryExperienceMeasureTask;
  createNetworkPlanningEmailNotification: NetworkPlanningEmailNotification;
  createNetworkPlanningOrganization: NetworkPlanningOrganization;
  createOccasionRelatedApproval: OccasionRelatedApproval;
  createPbeIrisKpi?: Maybe<PbeIrisKpi>;
  createPcRoadmapActionItem: PcRoadmapActionItem;
  createPcRoadmapAdditionalAgreement: PcRoadmapAdditionalAgreementElement;
  createPcRoadmapApplicableDocument: PcRoadmapApplicableDocument;
  createPcRoadmapCommitment: PcRoadmapCommitment;
  createPcRoadmapFurtherDetail: PcRoadmapFurtherDetail;
  createPcRoadmapStage: PcRoadmapStage;
  createPcRoadmapStrategyField: PcRoadmapStrategyField;
  createPcRoadmapStrategyKpi: PcRoadmapStrategyKpi;
  createPcRoadmapStrategyKpiCategory: PcRoadmapStrategyKpiCategory;
  createPeerGroup: PeerGroup;
  createPorscheImportAgreementsChangeRequest: PorscheImportAgreementsChangeRequest;
  createPorscheImportAgreementsEmailNotification: PorscheImportAgreementsEmailNotification;
  createPorscheImportAgreementsIncoterm: PorscheImportAgreementsIncoterm;
  createPorscheImportAgreementsPaymentTerm: PorscheImportAgreementsPaymentTerm;
  createPorscheStrategy2030EmailNotification: PorscheStrategy2030EmailNotification;
  createPresignedUploadUrls: Array<PresignedUpload>;
  createQuestionnaire: Questionnaire;
  createQuestionnaireTypeConfig?: Maybe<QuestionnaireTypeConfig>;
  createRealEstateProperty: RealEstateProperty;
  createRetailDesignDocument: RetailDesignDocument;
  createRetailDesignEmailNotification: RetailDesignEmailNotification;
  createRetailDesignFilterPreset: RetailDesignFilterPreset;
  createRetailDesignFormat: RetailDesignFormat;
  createRetailDesignProject: RetailDesignProject;
  createRetailDesignProjectType: RetailDesignProjectType;
  createStrategyActionItem: StrategyActionItem;
  createStrategyField?: Maybe<StrategyField>;
  createStrategyImpact?: Maybe<StrategyImpact>;
  createStrategyKpi?: Maybe<StrategyKpi>;
  createStrategyKpiCategory?: Maybe<StrategyKpiCategory>;
  createStrategyStage?: Maybe<StrategyStage>;
  createSupportRequest: SupportRequest;
  createSurvey: Survey;
  createSurveyEmailNotification: SurveyEmailNotification;
  createSurveyPredefinedItem: SurveyPredefinedItem;
  createSurveyReportConfig: SurveyReportConfig;
  createSurveyTableConfig: SurveyTableConfig;
  createSurveyTemplate: SurveyTemplate;
  createSurveyType: SurveyType;
  createUserFeedback: UserFeedback;
  createUserManagementItem: UserManagementItem;
  deleteActionItem?: Maybe<ActionItem>;
  deleteActionItemTemplate: ActionItemTemplate;
  deleteApexEmailNotification: ApexEmailNotification;
  deleteCoachingModule?: Maybe<Scalars['Boolean']['output']>;
  deleteConsultingMeetingType?: Maybe<Scalars['Boolean']['output']>;
  deleteDashboardEmailNotification: DashboardEmailNotification;
  deleteExchangeRate: ExchangeRate;
  deleteFeatureArticle: FeatureArticle;
  deleteFieldForceManagementCalendarExport: FieldForceManagementCalendarExport;
  deleteFieldForceManagementEmailNotification: FieldForceManagementEmailNotification;
  deleteFieldForceManagementFilterPreset?: Maybe<FieldForceManagementFilterPreset>;
  deleteGroupAssignment: Group;
  deleteHelpArticle: HelpArticle;
  deleteKpiUnit: KpiUnit;
  deleteKpiUnitCategory: KpiUnitCategory;
  deleteMeeting?: Maybe<Meeting>;
  deleteMultisensoryExperience: MultisensoryExperience;
  deleteMultisensoryExperienceArea: MultisensoryExperienceArea;
  deleteMultisensoryExperienceBundle?: Maybe<MultisensoryExperienceBundle>;
  deleteMultisensoryExperienceEmailNotification: MultisensoryExperienceEmailNotification;
  deleteMultisensoryExperienceFilterPreset: MultisensoryExperienceFilterPreset;
  deleteMultisensoryExperienceItem: MultisensoryExperienceItem;
  deleteMultisensoryExperienceMeasure: MultisensoryExperienceMeasure;
  deleteMultisensoryExperienceMeasureTask: MultisensoryExperienceMeasureTask;
  deleteNetworkPlanningEmailNotification: NetworkPlanningEmailNotification;
  deleteNetworkPlanningOrganizations: Array<Maybe<NetworkPlanningOrganization>>;
  deletePbeIrisKpi?: Maybe<PbeIrisKpi>;
  deletePbeOnlyOrg: Person;
  deletePcRoadmapActionItem?: Maybe<PcRoadmapActionItem>;
  deletePcRoadmapAdditionalAgreement: PcRoadmapAdditionalAgreementElement;
  deletePcRoadmapApplicableDocument: PcRoadmapApplicableDocument;
  deletePcRoadmapCommitment: PcRoadmapCommitment;
  deletePcRoadmapFurtherDetail: PcRoadmapFurtherDetail;
  deletePcRoadmapStage: PcRoadmapStage;
  deletePcRoadmapStrategyField: PcRoadmapStrategyField;
  deletePcRoadmapStrategyKpi: PcRoadmapStrategyKpi;
  deletePcRoadmapStrategyKpiCategory: PcRoadmapStrategyKpiCategory;
  deletePeerGroup: PeerGroup;
  deletePeerGroupFromPerson: Person;
  deletePorscheImportAgreementsEmailNotification: PorscheImportAgreementsEmailNotification;
  deletePorscheImportAgreementsIncoterm: PorscheImportAgreementsIncoterm;
  deletePorscheImportAgreementsPaymentTerm: PorscheImportAgreementsPaymentTerm;
  deletePorscheStrategy2030EmailNotification: PorscheStrategy2030EmailNotification;
  deleteQuestionnaire: Questionnaire;
  deleteRealEstateProperty: RealEstateProperty;
  deleteRetailDesignDocument: RetailDesignDocument;
  deleteRetailDesignEmailNotification: RetailDesignEmailNotification;
  deleteRetailDesignFilterPreset: RetailDesignFilterPreset;
  deleteRetailDesignFormat: RetailDesignFormat;
  deleteRetailDesignProject: RetailDesignProject;
  deleteRetailDesignProjectType: RetailDesignProjectType;
  deleteStrategyActionItem?: Maybe<StrategyActionItem>;
  deleteStrategyField?: Maybe<StrategyField>;
  deleteStrategyKpi?: Maybe<StrategyKpi>;
  deleteStrategyKpiCategory?: Maybe<StrategyKpiCategory>;
  deleteStrategyStage?: Maybe<StrategyStage>;
  deleteSupportRequest: SupportRequest;
  deleteSurvey: Survey;
  deleteSurveyEmailNotification: SurveyEmailNotification;
  deleteSurveyPredefinedItem: SurveyPredefinedItem;
  deleteSurveyReportConfig: SurveyReportConfig;
  deleteSurveyTableConfig: SurveyTableConfig;
  deleteSurveyTemplate: SurveyTemplate;
  deleteSurveyType: SurveyType;
  deleteUserFeedback: UserFeedback;
  deleteUserManagementItem: UserManagementItem;
  importPcRoadmapKpi: PcRoadmapCommitment;
  importPcRoadmapReportData: PcRoadmapReportImportResult;
  removeAttachmentFromActionItemComment?: Maybe<ActionItem>;
  removeAttachmentFromMeetingComment?: Maybe<Meeting>;
  removeMeetingPbeIrisLink?: Maybe<Meeting>;
  removeReport?: Maybe<Scalars['Boolean']['output']>;
  removeReportTab?: Maybe<ReportTab>;
  resendPorscheImportAgreementsChangeRequestApprovalEmail: PorscheImportAgreementsChangeRequest;
  resetSurveyAnswer: SurveyAnswer;
  revokeAnonymousLoginForSurveyAnswers: Scalars['Boolean']['output'];
  sendPorscheImportAgreementsChangeRequestApprovalEmails: PorscheImportAgreementsChangeRequest;
  setPcRoadmapCommitmentKpi?: Maybe<PcRoadmapCommitment>;
  setPcRoadmapCommitmentValue?: Maybe<PcRoadmapCommitment>;
  startPpnMasterdataImport: PpnMasterdataImportStatus;
  translateSurvey: SurveyTranslation;
  triggerPcRoadmapCommitmentCompletedNotification: PcRoadmapCommitment;
  updateActionItem?: Maybe<ActionItem>;
  updateActionItemComment: Comment;
  updateActionItemStatus?: Maybe<ActionItem>;
  updateActionItemTemplate: ActionItemTemplate;
  updateAnnouncement: Announcement;
  updateApexEmailNotification: ApexEmailNotification;
  updateApexImportSchedule: ApexImportSchedule;
  updateAudit: Audit;
  updateCategory?: Maybe<Category>;
  updateCoachingModule?: Maybe<CoachingModule>;
  updateConsultingMeetingType?: Maybe<ConsultingMeetingType>;
  updateDashboardEmailNotification: DashboardEmailNotification;
  updateExchangeRate: ExchangeRate;
  updateFeatureArticle: FeatureArticle;
  updateFieldForceManagementCalendarExport: FieldForceManagementCalendarExport;
  updateFieldForceManagementDashboardWidget: FieldForceManagementDashboardWidget;
  updateFieldForceManagementEmailNotification: FieldForceManagementEmailNotification;
  updateFieldForceManagementFeatureFlag: FieldForceManagementFeatureFlag;
  updateFieldForceManagementFilterPreset?: Maybe<FieldForceManagementFilterPreset>;
  updateHelpArticle: HelpArticle;
  updateKpiUnit: KpiUnit;
  updateKpiUnitCategory: KpiUnitCategory;
  updateMeeting?: Maybe<Meeting>;
  updateMeetingComment: Comment;
  updateMeetingStatus?: Maybe<Meeting>;
  updateMultisensoryExperience: MultisensoryExperience;
  updateMultisensoryExperienceArea: MultisensoryExperienceArea;
  updateMultisensoryExperienceBundle: MultisensoryExperienceBundle;
  updateMultisensoryExperienceEmailNotification: MultisensoryExperienceEmailNotification;
  updateMultisensoryExperienceFilterPreset: MultisensoryExperienceFilterPreset;
  updateMultisensoryExperienceItem: MultisensoryExperienceItem;
  updateMultisensoryExperienceMeasure: MultisensoryExperienceMeasure;
  updateMultisensoryExperienceMeasureTask: MultisensoryExperienceMeasureTask;
  updateNetworkPlanningEmailNotification: NetworkPlanningEmailNotification;
  updateNetworkPlanningFeatureFlag: NetworkPlanningFeatureFlag;
  updateNetworkPlanningOrganization: NetworkPlanningOrganization;
  updateOccasionRelatedApproval: OccasionRelatedApproval;
  updateOccasionRelatedApprovalActionItem: OccasionRelatedApproval;
  updateOccasionRelatedApprovalReview: OccasionRelatedApproval;
  updatePbeIrisKpi?: Maybe<PbeIrisKpi>;
  updatePcRoadmapActionItem: PcRoadmapActionItem;
  updatePcRoadmapAdditionalAgreement: PcRoadmapAdditionalAgreementElement;
  updatePcRoadmapApplicableDocument: PcRoadmapApplicableDocument;
  updatePcRoadmapCommitment: PcRoadmapCommitment;
  updatePcRoadmapFurtherDetail: PcRoadmapFurtherDetail;
  updatePcRoadmapStage: PcRoadmapStage;
  updatePcRoadmapStrategyField: PcRoadmapStrategyField;
  updatePcRoadmapStrategyKpi: PcRoadmapStrategyKpi;
  updatePcRoadmapStrategyKpiCategory: PcRoadmapStrategyKpiCategory;
  updatePeerGroup: PeerGroup;
  updatePerson: Person;
  updatePersonSettings: Person;
  updatePorscheImportAgreementsChangeRequest: PorscheImportAgreementsChangeRequest;
  updatePorscheImportAgreementsEmailNotification: PorscheImportAgreementsEmailNotification;
  updatePorscheImportAgreementsIncoterm: PorscheImportAgreementsIncoterm;
  updatePorscheImportAgreementsPaymentTerm: PorscheImportAgreementsPaymentTerm;
  updatePorscheStrategy2030EmailNotification: PorscheStrategy2030EmailNotification;
  updateQuestionnaire: Questionnaire;
  updateQuestionnaireTypeConfig?: Maybe<QuestionnaireTypeConfig>;
  updateRealEstateProperty: RealEstateProperty;
  updateReport?: Maybe<ReportItem>;
  updateReportTab?: Maybe<ReportTab>;
  updateRetailDesignAbsenceNote: RetailDesignAbsenceNote;
  updateRetailDesignDocument: RetailDesignDocument;
  updateRetailDesignEmailNotification: RetailDesignEmailNotification;
  updateRetailDesignFilterPreset: RetailDesignFilterPreset;
  updateRetailDesignFormat: RetailDesignFormat;
  updateRetailDesignProject: RetailDesignProject;
  updateRetailDesignProjectType: RetailDesignProjectType;
  updateStrategyActionItem: StrategyActionItem;
  updateStrategyField?: Maybe<StrategyField>;
  updateStrategyFields?: Maybe<Array<Maybe<StrategyField>>>;
  updateStrategyImpact?: Maybe<StrategyImpact>;
  updateStrategyKpi?: Maybe<StrategyKpi>;
  updateStrategyKpiCategory?: Maybe<StrategyKpiCategory>;
  updateStrategyStage?: Maybe<StrategyStage>;
  updateSupportRequest: SupportRequest;
  updateSurvey: Survey;
  updateSurveyEmailNotification: SurveyEmailNotification;
  updateSurveyPredefinedItem: SurveyPredefinedItem;
  updateSurveyReportConfig: SurveyReportConfig;
  updateSurveyTableConfig: SurveyTableConfig;
  updateSurveyTemplate: SurveyTemplate;
  updateSurveyType: SurveyType;
  updateUserManagementItem: UserManagementItem;
};


export type MutationAcknowledgePcRoadmapCommitmentJointAgreementArgs = {
  input: AcknowledgePcRoadmapCommitmentJointAgreementInput;
};


export type MutationAddMeetingPbeIrisLinkArgs = {
  id: Scalars['ObjectID']['input'];
  pbeIrisLink: Scalars['String']['input'];
};


export type MutationAddPbeOnlyOrgArgs = {
  pbeOnlyOrganizations: Array<OrganizationReferenceInput>;
  personIds: Array<Scalars['BigInt']['input']>;
};


export type MutationAddPeerGroupToPersonsArgs = {
  id: Scalars['ObjectID']['input'];
  personIds: Array<Scalars['BigInt']['input']>;
};


export type MutationAnswerAuditArgs = {
  input: Array<AuditAnswerInput>;
  widgetId: Scalars['ObjectID']['input'];
};


export type MutationAnswerQuestionnaireArgs = {
  input: Array<QuestionnaireAnswerInput>;
  widgetId: Scalars['ObjectID']['input'];
};


export type MutationAnswerSurveyQuestionArgs = {
  input: AnswerSurveyQuestionInput;
};


export type MutationAssignGroupsArgs = {
  ids: Array<Scalars['String']['input']>;
  visibleGroups?: InputMaybe<Array<GroupReferenceInput>>;
};


export type MutationBroadcastActionItemArgs = {
  input: BroadcastActionItemInput;
};


export type MutationCalculateSurveyResultArgs = {
  input: CalculateSurveyResultInput;
};


export type MutationCalculateSurveyResultsArgs = {
  input: CalculateSurveyResultsInput;
};


export type MutationCommentOnActionItemArgs = {
  actionItemId: Scalars['ObjectID']['input'];
  comment: CommentInput;
};


export type MutationCommentOnMeetingArgs = {
  comment: CommentInput;
  meetingId: Scalars['ObjectID']['input'];
};


export type MutationCopyAuditArgs = {
  allowCopyAnswers: Scalars['Boolean']['input'];
  id: Scalars['ObjectID']['input'];
};


export type MutationCopyQuestionnaireArgs = {
  allowCopyAnswers: Scalars['Boolean']['input'];
  id: Scalars['ObjectID']['input'];
};


export type MutationCopySurveyArgs = {
  input: CopySurveyInput;
};


export type MutationCopySurveyTemplateArgs = {
  input: CopySurveyTemplateInput;
};


export type MutationCopyUploadsArgs = {
  input: CopyUploadsInput;
};


export type MutationCreateActionItemArgs = {
  input: ActionItemInput;
};


export type MutationCreateActionItemTemplateArgs = {
  actionItemTemplate: ActionItemTemplateInput;
};


export type MutationCreateAnonymousLoginForSurveyAnswersArgs = {
  expireAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationId: Scalars['BigInt']['input'];
  surveyId: Scalars['ObjectID']['input'];
};


export type MutationCreateApexEmailNotificationArgs = {
  input: CreateApexEmailNotificationInput;
};


export type MutationCreateAuditArgs = {
  input: NewAuditInput;
};


export type MutationCreateCategoryArgs = {
  category: CategoryCreationInput;
};


export type MutationCreateCoachingModuleArgs = {
  coachingModule: CoachingModuleCreateInput;
};


export type MutationCreateConsultingMeetingTypeArgs = {
  consultingMeetingType: ConsultingMeetingTypeCreateInput;
};


export type MutationCreateDashboardEmailNotificationArgs = {
  input: CreateDashboardEmailNotificationInput;
};


export type MutationCreateDownloadUrlArgs = {
  filePrefix?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  key?: InputMaybe<Scalars['ID']['input']>;
  reference: DownloadReference;
  type: DownloadType;
};


export type MutationCreateExchangeRateArgs = {
  input: ExchangeRateInput;
};


export type MutationCreateFeatureArticleArgs = {
  featureArticle: CreateFeatureArticleInput;
};


export type MutationCreateFieldForceManagementEmailNotificationArgs = {
  input: CreateFieldForceManagementEmailNotificationInput;
};


export type MutationCreateFieldForceManagementFilterPresetArgs = {
  input: CreateFieldForceManagementFilterPresetInput;
};


export type MutationCreateHelpArticleArgs = {
  helpArticle: CreateHelpArticleInput;
};


export type MutationCreateKpiUnitArgs = {
  input: CreateKpiUnitInput;
};


export type MutationCreateKpiUnitCategoryArgs = {
  input: CreateKpiUnitCategoryInput;
};


export type MutationCreateMeetingArgs = {
  meeting: NewMeetingInput;
};


export type MutationCreateMultisensoryExperienceArgs = {
  input: CreateMultisensoryExperienceInput;
};


export type MutationCreateMultisensoryExperienceAreaArgs = {
  input: CreateMultisensoryExperienceAreaInput;
};


export type MutationCreateMultisensoryExperienceAreasArgs = {
  input: Array<CreateMultisensoryExperienceAreaInput>;
};


export type MutationCreateMultisensoryExperienceBundleArgs = {
  input: CreateMultisensoryExperienceBundleInput;
};


export type MutationCreateMultisensoryExperienceEmailNotificationArgs = {
  input: CreateMultisensoryExperienceEmailNotificationInput;
};


export type MutationCreateMultisensoryExperienceFilterPresetArgs = {
  input: CreateMultisensoryExperienceFilterPresetInput;
};


export type MutationCreateMultisensoryExperienceItemArgs = {
  input: CreateMultisensoryExperienceItemInput;
};


export type MutationCreateMultisensoryExperienceMeasureArgs = {
  input: CreateMultisensoryExperienceMeasureInput;
};


export type MutationCreateMultisensoryExperienceMeasureTaskArgs = {
  input: CreateMultisensoryExperienceMeasureTaskInput;
};


export type MutationCreateNetworkPlanningEmailNotificationArgs = {
  input: CreateNetworkPlanningEmailNotificationInput;
};


export type MutationCreateNetworkPlanningOrganizationArgs = {
  input: CreateNetworkPlanningOrganizationInput;
};


export type MutationCreateOccasionRelatedApprovalArgs = {
  input: CreateOccasionRelatedApprovalInput;
};


export type MutationCreatePbeIrisKpiArgs = {
  pbeIrisKpi: PbeIrisKpiInput;
};


export type MutationCreatePcRoadmapActionItemArgs = {
  input: CreatePcRoadmapActionItemInput;
};


export type MutationCreatePcRoadmapAdditionalAgreementArgs = {
  input: CreatePcRoadmapAdditionalAgreementInput;
};


export type MutationCreatePcRoadmapApplicableDocumentArgs = {
  input: CreatePcRoadmapApplicableDocumentInput;
};


export type MutationCreatePcRoadmapCommitmentArgs = {
  input: CreatePcRoadmapCommitmentInput;
};


export type MutationCreatePcRoadmapFurtherDetailArgs = {
  input: CreatePcRoadmapFurtherDetailInput;
};


export type MutationCreatePcRoadmapStageArgs = {
  input: CreatePcRoadmapStageInput;
};


export type MutationCreatePcRoadmapStrategyFieldArgs = {
  input: CreatePcRoadmapStrategyFieldInput;
};


export type MutationCreatePcRoadmapStrategyKpiArgs = {
  input: CreatePcRoadmapStrategyKpiInput;
};


export type MutationCreatePcRoadmapStrategyKpiCategoryArgs = {
  input: CreatePcRoadmapStrategyKpiCategoryInput;
};


export type MutationCreatePeerGroupArgs = {
  peerGroup: PeerGroupInput;
};


export type MutationCreatePorscheImportAgreementsChangeRequestArgs = {
  input: CreatePorscheImportAgreementsChangeRequestInput;
};


export type MutationCreatePorscheImportAgreementsEmailNotificationArgs = {
  input: CreatePorscheImportAgreementsEmailNotificationInput;
};


export type MutationCreatePorscheImportAgreementsIncotermArgs = {
  input: CreatePorscheImportAgreementsIncotermInput;
};


export type MutationCreatePorscheImportAgreementsPaymentTermArgs = {
  input: CreatePorscheImportAgreementsPaymentTermInput;
};


export type MutationCreatePorscheStrategy2030EmailNotificationArgs = {
  input: CreatePorscheStrategy2030EmailNotificationInput;
};


export type MutationCreatePresignedUploadUrlsArgs = {
  files: Array<UploadFileInput>;
  reference: UploadReference;
  type: UploadType;
};


export type MutationCreateQuestionnaireArgs = {
  input: NewQuestionnaireInput;
};


export type MutationCreateQuestionnaireTypeConfigArgs = {
  input: QuestionnaireTypeConfigCreationInput;
};


export type MutationCreateRealEstatePropertyArgs = {
  input: CreateRealEstatePropertyInput;
};


export type MutationCreateRetailDesignDocumentArgs = {
  input: CreateRetailDesignDocumentInput;
};


export type MutationCreateRetailDesignEmailNotificationArgs = {
  input: CreateRetailDesignEmailNotificationInput;
};


export type MutationCreateRetailDesignFilterPresetArgs = {
  input: CreateRetailDesignFilterPresetInput;
};


export type MutationCreateRetailDesignFormatArgs = {
  input: CreateRetailDesignFormatInput;
};


export type MutationCreateRetailDesignProjectArgs = {
  input: CreateRetailDesignProjectInput;
};


export type MutationCreateRetailDesignProjectTypeArgs = {
  input: CreateRetailDesignProjectTypeInput;
};


export type MutationCreateStrategyActionItemArgs = {
  input: CreateStrategyActionItemInput;
};


export type MutationCreateStrategyFieldArgs = {
  input: CreateStrategyFieldInput;
};


export type MutationCreateStrategyImpactArgs = {
  strategyImpact: StrategyImpactCreationInput;
};


export type MutationCreateStrategyKpiArgs = {
  input: CreateStrategyKpiInput;
};


export type MutationCreateStrategyKpiCategoryArgs = {
  input: CreateStrategyKpiCategoryInput;
};


export type MutationCreateStrategyStageArgs = {
  input: CreateStrategyStageInput;
};


export type MutationCreateSupportRequestArgs = {
  input: CreateSupportRequestInput;
};


export type MutationCreateSurveyArgs = {
  input: CreateSurveyInput;
};


export type MutationCreateSurveyEmailNotificationArgs = {
  input: CreateSurveyEmailNotificationInput;
};


export type MutationCreateSurveyPredefinedItemArgs = {
  input: CreateSurveyPredefinedItemInput;
};


export type MutationCreateSurveyReportConfigArgs = {
  input: CreateSurveyReportConfigInput;
};


export type MutationCreateSurveyTableConfigArgs = {
  input: CreateSurveyTableConfigInput;
};


export type MutationCreateSurveyTemplateArgs = {
  input: CreateSurveyTemplateInput;
};


export type MutationCreateSurveyTypeArgs = {
  input: CreateSurveyTypeInput;
};


export type MutationCreateUserFeedbackArgs = {
  input: CreateUserFeedbackInput;
};


export type MutationCreateUserManagementItemArgs = {
  input: CreateUserManagementItemInput;
};


export type MutationDeleteActionItemArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteActionItemTemplateArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteApexEmailNotificationArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteCoachingModuleArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteConsultingMeetingTypeArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteDashboardEmailNotificationArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteExchangeRateArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteFeatureArticleArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteFieldForceManagementEmailNotificationArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteFieldForceManagementFilterPresetArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteGroupAssignmentArgs = {
  id: Scalars['String']['input'];
  visibleGroupId: Scalars['String']['input'];
};


export type MutationDeleteHelpArticleArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteKpiUnitArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteKpiUnitCategoryArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteMeetingArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteMultisensoryExperienceArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteMultisensoryExperienceAreaArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteMultisensoryExperienceBundleArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteMultisensoryExperienceEmailNotificationArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteMultisensoryExperienceFilterPresetArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteMultisensoryExperienceItemArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteMultisensoryExperienceMeasureArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteMultisensoryExperienceMeasureTaskArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteNetworkPlanningEmailNotificationArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteNetworkPlanningOrganizationsArgs = {
  ids: Array<NetworkPlanningNetworkPlanningIdInput>;
};


export type MutationDeletePbeIrisKpiArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeletePbeOnlyOrgArgs = {
  orgIdToDelete: Scalars['BigInt']['input'];
  personId: Scalars['BigInt']['input'];
};


export type MutationDeletePcRoadmapActionItemArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeletePcRoadmapAdditionalAgreementArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeletePcRoadmapApplicableDocumentArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeletePcRoadmapCommitmentArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeletePcRoadmapFurtherDetailArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeletePcRoadmapStageArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeletePcRoadmapStrategyFieldArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeletePcRoadmapStrategyKpiArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeletePcRoadmapStrategyKpiCategoryArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeletePeerGroupArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeletePeerGroupFromPersonArgs = {
  id: Scalars['ObjectID']['input'];
  personId: Scalars['BigInt']['input'];
};


export type MutationDeletePorscheImportAgreementsEmailNotificationArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeletePorscheImportAgreementsIncotermArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeletePorscheImportAgreementsPaymentTermArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeletePorscheStrategy2030EmailNotificationArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteQuestionnaireArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteRealEstatePropertyArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteRetailDesignDocumentArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteRetailDesignEmailNotificationArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteRetailDesignFilterPresetArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteRetailDesignFormatArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteRetailDesignProjectArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteRetailDesignProjectTypeArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteStrategyActionItemArgs = {
  input: DeleteStrategyActionItemInput;
};


export type MutationDeleteStrategyFieldArgs = {
  input: DeleteStrategyFieldInput;
};


export type MutationDeleteStrategyKpiArgs = {
  input: DeleteStrategyKpiInput;
};


export type MutationDeleteStrategyKpiCategoryArgs = {
  input: DeleteStrategyKpiCategoryInput;
};


export type MutationDeleteStrategyStageArgs = {
  input: DeleteStrategyStageInput;
};


export type MutationDeleteSupportRequestArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteSurveyArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteSurveyEmailNotificationArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteSurveyPredefinedItemArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteSurveyReportConfigArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteSurveyTableConfigArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteSurveyTemplateArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteSurveyTypeArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteUserFeedbackArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteUserManagementItemArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationImportPcRoadmapKpiArgs = {
  input: PcRoadmapKpiImportInput;
};


export type MutationImportPcRoadmapReportDataArgs = {
  input: PcRoadmapReportDataImportInput;
};


export type MutationRemoveAttachmentFromActionItemCommentArgs = {
  actionItemId: Scalars['ObjectID']['input'];
  attachmentId: Scalars['ObjectID']['input'];
  commentId: Scalars['ObjectID']['input'];
};


export type MutationRemoveAttachmentFromMeetingCommentArgs = {
  attachmentId: Scalars['ObjectID']['input'];
  commentId: Scalars['ObjectID']['input'];
  meetingId: Scalars['ObjectID']['input'];
};


export type MutationRemoveMeetingPbeIrisLinkArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationRemoveReportArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationRemoveReportTabArgs = {
  key: Scalars['ObjectID']['input'];
};


export type MutationResendPorscheImportAgreementsChangeRequestApprovalEmailArgs = {
  input: ResendPorscheImportAgreementsChangeRequestApprovalEmailInput;
};


export type MutationResetSurveyAnswerArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationRevokeAnonymousLoginForSurveyAnswersArgs = {
  surveyId: Scalars['ObjectID']['input'];
  tokenId: Scalars['ObjectID']['input'];
};


export type MutationSendPorscheImportAgreementsChangeRequestApprovalEmailsArgs = {
  input: SendPorscheImportAgreementsChangeRequestApprovalEmailsInput;
};


export type MutationSetPcRoadmapCommitmentKpiArgs = {
  input: SetCommitmentKpiInput;
};


export type MutationSetPcRoadmapCommitmentValueArgs = {
  input: SetPcRoadmapCommitmentValueInput;
};


export type MutationTranslateSurveyArgs = {
  input: TranslateSurveyInput;
};


export type MutationTriggerPcRoadmapCommitmentCompletedNotificationArgs = {
  input: TriggerPcRoadmapCommitmentCompletedNotificationInput;
};


export type MutationUpdateActionItemArgs = {
  actionItem: ActionItemInput;
  id: Scalars['ObjectID']['input'];
};


export type MutationUpdateActionItemCommentArgs = {
  actionItemId: Scalars['ObjectID']['input'];
  comment: CommentUpdateInput;
};


export type MutationUpdateActionItemStatusArgs = {
  id: Scalars['ObjectID']['input'];
  input: UpdateActionItemStatusInput;
};


export type MutationUpdateActionItemTemplateArgs = {
  actionItemTemplate: ActionItemTemplateInput;
  id: Scalars['ObjectID']['input'];
};


export type MutationUpdateAnnouncementArgs = {
  input: UpdateAnnouncementInput;
};


export type MutationUpdateApexEmailNotificationArgs = {
  input: UpdateApexEmailNotificationInput;
};


export type MutationUpdateApexImportScheduleArgs = {
  input: SetApexImportScheduleInput;
};


export type MutationUpdateAuditArgs = {
  id: Scalars['ObjectID']['input'];
  input: AuditInput;
};


export type MutationUpdateCategoryArgs = {
  category: CategoryUpdateInput;
  id: Scalars['ObjectID']['input'];
};


export type MutationUpdateCoachingModuleArgs = {
  coachingModule: CoachingModuleUpdateInput;
  id: Scalars['ObjectID']['input'];
};


export type MutationUpdateConsultingMeetingTypeArgs = {
  consultingMeetingType: ConsultingMeetingTypeUpdateInput;
  id: Scalars['ObjectID']['input'];
};


export type MutationUpdateDashboardEmailNotificationArgs = {
  input: UpdateDashboardEmailNotificationInput;
};


export type MutationUpdateExchangeRateArgs = {
  id: Scalars['ObjectID']['input'];
  input: ExchangeRateInput;
};


export type MutationUpdateFeatureArticleArgs = {
  featureArticle: UpdateFeatureArticleInput;
};


export type MutationUpdateFieldForceManagementDashboardWidgetArgs = {
  input: UpdateFieldForceManagementDashboardWidgetInput;
};


export type MutationUpdateFieldForceManagementEmailNotificationArgs = {
  input: UpdateFieldForceManagementEmailNotificationInput;
};


export type MutationUpdateFieldForceManagementFeatureFlagArgs = {
  input: UpdateFieldForceManagementFeatureFlagInput;
};


export type MutationUpdateFieldForceManagementFilterPresetArgs = {
  input: UpdateFieldForceManagementFilterPresetInput;
};


export type MutationUpdateHelpArticleArgs = {
  helpArticle: UpdateHelpArticleInput;
  id: Scalars['ObjectID']['input'];
};


export type MutationUpdateKpiUnitArgs = {
  input: UpdateKpiUnitInput;
};


export type MutationUpdateKpiUnitCategoryArgs = {
  input: UpdateKpiUnitCategoryInput;
};


export type MutationUpdateMeetingArgs = {
  id: Scalars['ObjectID']['input'];
  meeting: UpdateMeetingInput;
};


export type MutationUpdateMeetingCommentArgs = {
  comment: CommentUpdateInput;
  meetingId: Scalars['ObjectID']['input'];
};


export type MutationUpdateMeetingStatusArgs = {
  id: Scalars['ObjectID']['input'];
  input: UpdateMeetingStatusInput;
};


export type MutationUpdateMultisensoryExperienceArgs = {
  input: UpdateMultisensoryExperienceInput;
};


export type MutationUpdateMultisensoryExperienceAreaArgs = {
  input: UpdateMultisensoryExperienceAreaInput;
};


export type MutationUpdateMultisensoryExperienceBundleArgs = {
  input: UpdateMultisensoryExperienceBundleInput;
};


export type MutationUpdateMultisensoryExperienceEmailNotificationArgs = {
  input: UpdateMultisensoryExperienceEmailNotificationInput;
};


export type MutationUpdateMultisensoryExperienceFilterPresetArgs = {
  input: UpdateMultisensoryExperienceFilterPresetInput;
};


export type MutationUpdateMultisensoryExperienceItemArgs = {
  input: UpdateMultisensoryExperienceItemInput;
};


export type MutationUpdateMultisensoryExperienceMeasureArgs = {
  input: UpdateMultisensoryExperienceMeasureInput;
};


export type MutationUpdateMultisensoryExperienceMeasureTaskArgs = {
  input: UpdateMultisensoryExperienceMeasureTaskInput;
};


export type MutationUpdateNetworkPlanningEmailNotificationArgs = {
  input: UpdateNetworkPlanningEmailNotificationInput;
};


export type MutationUpdateNetworkPlanningFeatureFlagArgs = {
  input: UpdateNetworkPlanningFeatureFlagInput;
};


export type MutationUpdateNetworkPlanningOrganizationArgs = {
  input: UpdateNetworkPlanningOrganizationInput;
  organizationId: Scalars['BigInt']['input'];
};


export type MutationUpdateOccasionRelatedApprovalArgs = {
  input: UpdateOccasionRelatedApprovalInput;
};


export type MutationUpdateOccasionRelatedApprovalActionItemArgs = {
  input: UpdateOccasionRelatedApprovalActionItemInput;
};


export type MutationUpdateOccasionRelatedApprovalReviewArgs = {
  input: UpdateOccasionRelatedApprovalReviewInput;
};


export type MutationUpdatePbeIrisKpiArgs = {
  id: Scalars['ObjectID']['input'];
  pbeIrisKpi: PbeIrisKpiInput;
};


export type MutationUpdatePcRoadmapActionItemArgs = {
  input: UpdatePcRoadmapActionItemInput;
};


export type MutationUpdatePcRoadmapAdditionalAgreementArgs = {
  input: UpdatePcRoadmapAdditionalAgreementInput;
};


export type MutationUpdatePcRoadmapApplicableDocumentArgs = {
  input: UpdatePcRoadmapApplicableDocumentInput;
};


export type MutationUpdatePcRoadmapCommitmentArgs = {
  input: UpdatePcRoadmapCommitmentInput;
};


export type MutationUpdatePcRoadmapFurtherDetailArgs = {
  input: UpdatePcRoadmapFurtherDetailInput;
};


export type MutationUpdatePcRoadmapStageArgs = {
  input: UpdatePcRoadmapStageInput;
};


export type MutationUpdatePcRoadmapStrategyFieldArgs = {
  input: UpdatePcRoadmapStrategyFieldInput;
};


export type MutationUpdatePcRoadmapStrategyKpiArgs = {
  input: UpdatePcRoadmapStrategyKpiInput;
};


export type MutationUpdatePcRoadmapStrategyKpiCategoryArgs = {
  input: UpdatePcRoadmapStrategyKpiCategoryInput;
};


export type MutationUpdatePeerGroupArgs = {
  id: Scalars['ObjectID']['input'];
  peerGroup: PeerGroupInput;
};


export type MutationUpdatePersonArgs = {
  input: UpdatePersonInput;
};


export type MutationUpdatePersonSettingsArgs = {
  input: UpdatePersonSettingsInput;
};


export type MutationUpdatePorscheImportAgreementsChangeRequestArgs = {
  input: UpdatePorscheImportAgreementsChangeRequestInput;
};


export type MutationUpdatePorscheImportAgreementsEmailNotificationArgs = {
  input: UpdatePorscheImportAgreementsEmailNotificationInput;
};


export type MutationUpdatePorscheImportAgreementsIncotermArgs = {
  input: UpdatePorscheImportAgreementsIncotermInput;
};


export type MutationUpdatePorscheImportAgreementsPaymentTermArgs = {
  input: UpdatePorscheImportAgreementsPaymentTermInput;
};


export type MutationUpdatePorscheStrategy2030EmailNotificationArgs = {
  input: UpdatePorscheStrategy2030EmailNotificationInput;
};


export type MutationUpdateQuestionnaireArgs = {
  id: Scalars['ObjectID']['input'];
  input: QuestionnaireInput;
};


export type MutationUpdateQuestionnaireTypeConfigArgs = {
  id: Scalars['ObjectID']['input'];
  input: QuestionnaireTypeConfigEditInput;
};


export type MutationUpdateRealEstatePropertyArgs = {
  input: UpdateRealEstatePropertyInput;
};


export type MutationUpdateReportArgs = {
  input: ReportItemInput;
};


export type MutationUpdateReportTabArgs = {
  input: ReportTabInput;
};


export type MutationUpdateRetailDesignAbsenceNoteArgs = {
  input: UpdateRetailDesignAbsenceNoteInput;
};


export type MutationUpdateRetailDesignDocumentArgs = {
  input: UpdateRetailDesignDocumentInput;
};


export type MutationUpdateRetailDesignEmailNotificationArgs = {
  input: UpdateRetailDesignEmailNotificationInput;
};


export type MutationUpdateRetailDesignFilterPresetArgs = {
  input: UpdateRetailDesignFilterPresetInput;
};


export type MutationUpdateRetailDesignFormatArgs = {
  input: UpdateRetailDesignFormatInput;
};


export type MutationUpdateRetailDesignProjectArgs = {
  input: UpdateRetailDesignProjectInput;
};


export type MutationUpdateRetailDesignProjectTypeArgs = {
  input: UpdateRetailDesignProjectTypeInput;
};


export type MutationUpdateStrategyActionItemArgs = {
  input: UpdateStrategyActionItemInput;
};


export type MutationUpdateStrategyFieldArgs = {
  input: UpdateStrategyFieldInput;
};


export type MutationUpdateStrategyFieldsArgs = {
  input: Array<UpdateStrategyFieldInput>;
};


export type MutationUpdateStrategyImpactArgs = {
  id: Scalars['ObjectID']['input'];
  strategyImpact: StrategyImpactUpdateInput;
};


export type MutationUpdateStrategyKpiArgs = {
  input: UpdateStrategyKpiInput;
};


export type MutationUpdateStrategyKpiCategoryArgs = {
  input: UpdateStrategyKpiCategoryInput;
};


export type MutationUpdateStrategyStageArgs = {
  input: UpdateStrategyStageInput;
};


export type MutationUpdateSupportRequestArgs = {
  input: UpdateSupportRequestInput;
};


export type MutationUpdateSurveyArgs = {
  input: UpdateSurveyInput;
};


export type MutationUpdateSurveyEmailNotificationArgs = {
  input: UpdateSurveyEmailNotificationInput;
};


export type MutationUpdateSurveyPredefinedItemArgs = {
  input: UpdateSurveyPredefinedItemInput;
};


export type MutationUpdateSurveyReportConfigArgs = {
  input: UpdateSurveyReportConfigInput;
};


export type MutationUpdateSurveyTableConfigArgs = {
  input: UpdateSurveyTableConfigInput;
};


export type MutationUpdateSurveyTemplateArgs = {
  input: UpdateSurveyTemplateInput;
};


export type MutationUpdateSurveyTypeArgs = {
  input: UpdateSurveyTypeInput;
};


export type MutationUpdateUserManagementItemArgs = {
  input: UpdateUserManagementItemInput;
};

export type NetworkPlanningAcCharger = {
  __typename?: 'NetworkPlanningAcCharger';
  maxPower?: Maybe<Scalars['Int']['output']>;
  numberOfChargers?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<NetworkPlanningChargerStatus>;
  type?: Maybe<NetworkPlanningAcChargerType>;
  vendor?: Maybe<Scalars['String']['output']>;
};

export type NetworkPlanningAcChargerInput = {
  maxPower?: InputMaybe<Scalars['Int']['input']>;
  numberOfChargers?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<NetworkPlanningChargerStatus>;
  type?: InputMaybe<NetworkPlanningAcChargerType>;
  vendor?: InputMaybe<Scalars['String']['input']>;
};

export enum NetworkPlanningAcChargerType {
  PorscheMobileCharger = 'PORSCHE_MOBILE_CHARGER',
  PorscheWallbox = 'PORSCHE_WALLBOX',
  ThirdParty = 'THIRD_PARTY'
}

export enum NetworkPlanningChargerStatus {
  FreeCharging = 'FREE_CHARGING',
  InInstallation = 'IN_INSTALLATION',
  NonFunctioning = 'NON_FUNCTIONING',
  Planned = 'PLANNED',
  PublicCharging = 'PUBLIC_CHARGING',
  RfidCharging = 'RFID_CHARGING'
}

export type NetworkPlanningDcCharger = {
  __typename?: 'NetworkPlanningDcCharger';
  creditCardTerminal?: Maybe<Scalars['Boolean']['output']>;
  maxPower?: Maybe<Scalars['Int']['output']>;
  numberOfChargers?: Maybe<Scalars['Int']['output']>;
  numberOfOutlets?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<NetworkPlanningChargerStatus>;
  type?: Maybe<NetworkPlanningDcChargerType>;
  vendor?: Maybe<Scalars['String']['output']>;
};

export type NetworkPlanningDcChargerInput = {
  creditCardTerminal?: InputMaybe<Scalars['Boolean']['input']>;
  maxPower?: InputMaybe<Scalars['Int']['input']>;
  numberOfChargers?: InputMaybe<Scalars['Int']['input']>;
  numberOfOutlets?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<NetworkPlanningChargerStatus>;
  type?: InputMaybe<NetworkPlanningDcChargerType>;
  vendor?: InputMaybe<Scalars['String']['input']>;
};

export enum NetworkPlanningDcChargerType {
  Alpitronic = 'ALPITRONIC',
  Cbx = 'CBX',
  Premium = 'PREMIUM',
  ThirdParty = 'THIRD_PARTY'
}

export type NetworkPlanningEmailNotification = {
  __typename?: 'NetworkPlanningEmailNotification';
  adhoc?: Maybe<Scalars['Boolean']['output']>;
  cron?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  person: Person;
  topic: NetworkPlanningEmailNotificationTopic;
};

export enum NetworkPlanningEmailNotificationTopic {
  NetworkPlanningEntriesWithIssues = 'NETWORK_PLANNING_ENTRIES_WITH_ISSUES'
}

export type NetworkPlanningFeatureFlag = {
  __typename?: 'NetworkPlanningFeatureFlag';
  id: Scalars['ObjectID']['output'];
  name: NetworkPlanningFeatureFlagName;
  organizations: Array<Organization>;
  persons: Array<Person>;
};

export enum NetworkPlanningFeatureFlagName {
  ShowEperformanceTabs = 'SHOW_EPERFORMANCE_TABS',
  ShowForecastkpiTab = 'SHOW_FORECASTKPI_TAB'
}

export type NetworkPlanningId = NetworkPlanningNetworkPlanningId | NetworkPlanningOrganizationId;

export type NetworkPlanningNetworkPlanningId = {
  __typename?: 'NetworkPlanningNetworkPlanningID';
  networkPlanningId: Scalars['ObjectID']['output'];
  organizationId: Scalars['BigInt']['output'];
};

export type NetworkPlanningNetworkPlanningIdInput = {
  networkPlanningId: Scalars['ObjectID']['input'];
};

export type NetworkPlanningOrganization = {
  __typename?: 'NetworkPlanningOrganization';
  actionItemsCount: Scalars['Int']['output'];
  actualInvestor?: Maybe<Scalars['String']['output']>;
  actualWorkbays?: Maybe<Scalars['Int']['output']>;
  aftersalesAcCharger?: Maybe<NetworkPlanningAcCharger>;
  aftersalesDcCharger?: Maybe<NetworkPlanningDcCharger>;
  category?: Maybe<NetworkPlanningOrganizationCategory>;
  chargingBackendName?: Maybe<Scalars['String']['output']>;
  chargingBackendVendor?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Array<Comment>>;
  connectedInvestor?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  customerAreaAcCharger?: Maybe<NetworkPlanningAcCharger>;
  customerAreaDcCharger?: Maybe<NetworkPlanningDcCharger>;
  dpCompletionExterieur?: Maybe<Scalars['DateMonth']['output']>;
  dpCompletionInterieur?: Maybe<Scalars['DateMonth']['output']>;
  dpUpgradeCompleted?: Maybe<Scalars['Boolean']['output']>;
  formatDevelopmentDate?: Maybe<Scalars['String']['output']>;
  formatDevelopmentTarget?: Maybe<NetworkPlanningOrganizationFormatDevelopmentTarget>;
  id: NetworkPlanningId;
  importer?: Maybe<Scalars['String']['output']>;
  isCustom: Scalars['Boolean']['output'];
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  lastChange?: Maybe<Scalars['DateTime']['output']>;
  lastCiUpdate?: Maybe<Scalars['Int']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  loadManagementPresent?: Maybe<Scalars['Boolean']['output']>;
  loadManagementVendor?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  market?: Maybe<Scalars['String']['output']>;
  multiBrand?: Maybe<NetworkPlanningOrganizationBrand>;
  name: Scalars['String']['output'];
  ncSales?: Maybe<Scalars['FloatPerYear']['output']>;
  numberOfWirelessChargers?: Maybe<Scalars['Int']['output']>;
  opening?: Maybe<Scalars['DateMonth']['output']>;
  partner?: Maybe<NetworkPlanningOrganizationPartner>;
  partnerNumber?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  relatedOrganization?: Maybe<Organization>;
  relations?: Maybe<OrganizationRelations>;
  sqm?: Maybe<Scalars['FloatPerYear']['output']>;
  status?: Maybe<OrganizationStatus>;
  street?: Maybe<Scalars['String']['output']>;
  subregion?: Maybe<NetworkPlanningOrganizationSubregion>;
  termination?: Maybe<Scalars['DateMonth']['output']>;
  type?: Maybe<NetworkPlanningOrganizationType>;
  uio?: Maybe<Scalars['FloatPerYear']['output']>;
  upgradeType?: Maybe<NetworkPlanningOrganizationUpgradeType>;
  validation: NetworkPlanningOrganizationValidation;
  wirelessChargerVendor?: Maybe<Scalars['String']['output']>;
  workbays?: Maybe<Scalars['IntPerYear']['output']>;
};

export enum NetworkPlanningOrganizationBrand {
  Exclusive = 'EXCLUSIVE',
  Multibrand = 'MULTIBRAND'
}

export enum NetworkPlanningOrganizationCategory {
  Between_200And_300 = 'BETWEEN_200_AND_300',
  Between_300And_500 = 'BETWEEN_300_AND_500',
  LessThan_200 = 'LESS_THAN_200',
  MoreThan_500 = 'MORE_THAN_500'
}

export type NetworkPlanningOrganizationFilterInput = {
  isCustom?: InputMaybe<Scalars['Boolean']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NetworkPlanningOrganizationType>;
};

export enum NetworkPlanningOrganizationFormatDevelopmentTarget {
  ClosingInFuture = 'CLOSING_IN_FUTURE',
  PorscheApprovedAndServiceCenter = 'PORSCHE_APPROVED_AND_SERVICE_CENTER',
  PorscheApprovedCenter = 'PORSCHE_APPROVED_CENTER',
  PorscheCenter = 'PORSCHE_CENTER',
  PorscheClassicCenter = 'PORSCHE_CLASSIC_CENTER',
  PorscheExpressCityServiceCenter = 'PORSCHE_EXPRESS_CITY_SERVICE_CENTER',
  PorscheNow = 'PORSCHE_NOW',
  PorschePreOwnedCarCenter = 'PORSCHE_PRE_OWNED_CAR_CENTER',
  PorscheServiceCenter = 'PORSCHE_SERVICE_CENTER',
  PorscheServiceFactory = 'PORSCHE_SERVICE_FACTORY',
  PorscheShowroom = 'PORSCHE_SHOWROOM',
  PorscheStore = 'PORSCHE_STORE',
  PorscheStudio = 'PORSCHE_STUDIO',
  PorscheWorkshop = 'PORSCHE_WORKSHOP',
  SatellitePorscheCenter = 'SATELLITE_PORSCHE_CENTER'
}

export type NetworkPlanningOrganizationId = {
  __typename?: 'NetworkPlanningOrganizationID';
  organizationId: Scalars['BigInt']['output'];
};

export type NetworkPlanningOrganizationInvestorFilter = {
  investor?: InputMaybe<StringFilter>;
};

export enum NetworkPlanningOrganizationPartner {
  ClassicExclusivePartner = 'CLASSIC_EXCLUSIVE_PARTNER',
  ClassicPartner = 'CLASSIC_PARTNER',
  ExclusivePartner = 'EXCLUSIVE_PARTNER'
}

export enum NetworkPlanningOrganizationSubregion {
  V1 = 'V1',
  V2 = 'V2',
  V3 = 'V3',
  V41 = 'V41',
  V42 = 'V42',
  V43 = 'V43',
  V51 = 'V51',
  V52 = 'V52',
  V53 = 'V53'
}

export enum NetworkPlanningOrganizationType {
  PorscheApprovedAndServiceCenter = 'PORSCHE_APPROVED_AND_SERVICE_CENTER',
  PorscheApprovedCenter = 'PORSCHE_APPROVED_CENTER',
  PorscheCenter = 'PORSCHE_CENTER',
  PorscheClassicCenter = 'PORSCHE_CLASSIC_CENTER',
  PorscheExpressCityServiceCenter = 'PORSCHE_EXPRESS_CITY_SERVICE_CENTER',
  PorscheNow = 'PORSCHE_NOW',
  PorschePreOwnedCarCenter = 'PORSCHE_PRE_OWNED_CAR_CENTER',
  PorscheServiceCenter = 'PORSCHE_SERVICE_CENTER',
  PorscheServiceFactory = 'PORSCHE_SERVICE_FACTORY',
  PorscheShowroom = 'PORSCHE_SHOWROOM',
  PorscheStore = 'PORSCHE_STORE',
  PorscheStudio = 'PORSCHE_STUDIO',
  PorscheWorkshop = 'PORSCHE_WORKSHOP',
  SatellitePorscheCenter = 'SATELLITE_PORSCHE_CENTER'
}

export enum NetworkPlanningOrganizationUpgradeType {
  FitoutProject = 'FITOUT_PROJECT',
  NewBuilding = 'NEW_BUILDING',
  RefurbishmentProject = 'REFURBISHMENT_PROJECT'
}

export type NetworkPlanningOrganizationValidation = {
  __typename?: 'NetworkPlanningOrganizationValidation';
  issues: Array<NetworkPlanningOrganizationValidationIssue>;
};

export type NetworkPlanningOrganizationValidationIssue = {
  __typename?: 'NetworkPlanningOrganizationValidationIssue';
  message: Scalars['TranslationKey']['output'];
  path: Array<Scalars['PathKey']['output']>;
};

export type NewAuditInput = {
  additionalPersons?: InputMaybe<Array<PersonReferenceInput>>;
  allowMultipleAssignments: Scalars['Boolean']['input'];
  auditId?: InputMaybe<Scalars['ObjectID']['input']>;
  children: Array<AuditItemInput>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  languages: Array<Scalars['String']['input']>;
  name: Scalars['JSON']['input'];
  organizations: Array<OrganizationReferenceInput>;
};

export type NewMeetingInput = {
  agenda?: InputMaybe<Array<InputMaybe<AgendaItemInput>>>;
  approver?: InputMaybe<PersonReferenceInput>;
  attachments?: InputMaybe<Array<InputMaybe<AttachmentInput>>>;
  attachmentsToCopy?: InputMaybe<CopyMeetingAttachmentsInput>;
  attendees?: InputMaybe<Array<InputMaybe<PersonReferenceInput>>>;
  categories?: InputMaybe<Array<InputMaybe<CategoryReferenceInput>>>;
  coachingModules?: InputMaybe<Array<CoachingModuleReferenceInput>>;
  consultants?: InputMaybe<Array<InputMaybe<PersonReferenceInput>>>;
  consultingMeetingType?: InputMaybe<Array<InputMaybe<ConsultingMeetingTypeReferenceInput>>>;
  /** This field is only available in test environments */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externals?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  isConfidential?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<MeetingKind>;
  meetingId?: InputMaybe<Scalars['ObjectID']['input']>;
  organization: OrganizationReferenceInput;
  pbeIrisLink?: InputMaybe<Scalars['String']['input']>;
  peerGroup?: InputMaybe<Scalars['ObjectID']['input']>;
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  scheduledTimeEnd: Scalars['DateTime']['input'];
  scheduledTimeStart: Scalars['DateTime']['input'];
  status?: InputMaybe<MeetingStatus>;
  subject: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<MeetingType>;
};

export type NewQuestionnaireInput = {
  additionalPersons?: InputMaybe<Array<PersonReferenceInput>>;
  allowMultipleAssignments: Scalars['Boolean']['input'];
  allowMultipleAssignmentsForPerson?: InputMaybe<Scalars['Boolean']['input']>;
  children: Array<QuestionnaireItemInput>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  languages: Array<Scalars['String']['input']>;
  name: Scalars['JSON']['input'];
  organizations: Array<OrganizationReferenceInput>;
  questionnaireId?: InputMaybe<Scalars['ObjectID']['input']>;
  type: QuestionnaireType;
};

export enum NumberStyle {
  Currency = 'CURRENCY',
  Percent = 'PERCENT'
}

export type ObjectIdQuery = {
  __typename?: 'ObjectIDQuery';
  _eq?: Maybe<Scalars['ObjectID']['output']>;
};

export type ObjectIdFilter = {
  _eq?: InputMaybe<Scalars['ObjectID']['input']>;
  _exists?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  _nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
};

export type OccasionRelatedApproval = {
  __typename?: 'OccasionRelatedApproval';
  actionItemIds?: Maybe<Array<Scalars['ObjectID']['output']>>;
  adHocResponsible?: Maybe<Person>;
  applicants: Array<Person>;
  attachments?: Maybe<Array<Attachment>>;
  author: Person;
  changeHistory: Array<OccasionRelatedApprovalChangeHistory>;
  comment: Scalars['String']['output'];
  comments: Array<Comment>;
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['Date']['output'];
  externalApplicants: Array<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  reason: Reason;
  reports: Array<Scalars['String']['output']>;
  review: Review;
};


export type OccasionRelatedApprovalChangeHistoryArgs = {
  granularity?: InputMaybe<ChangeHistoryGranularity>;
};

export type OccasionRelatedApprovalChangeHistory = {
  __typename?: 'OccasionRelatedApprovalChangeHistory';
  diffs: Array<OccasionRelatedApprovalChangeHistoryDiff>;
  person: Person;
  timestamp: Scalars['DateTime']['output'];
};

export type OccasionRelatedApprovalChangeHistoryDiff = OccasionRelatedApprovalChangeHistoryDiffAny | OccasionRelatedApprovalChangeHistoryDiffArray;

export type OccasionRelatedApprovalChangeHistoryDiffAny = {
  __typename?: 'OccasionRelatedApprovalChangeHistoryDiffAny';
  next?: Maybe<Scalars['JSON']['output']>;
  path: Array<Scalars['PathElement']['output']>;
  prev?: Maybe<Scalars['JSON']['output']>;
};

export type OccasionRelatedApprovalChangeHistoryDiffArray = {
  __typename?: 'OccasionRelatedApprovalChangeHistoryDiffArray';
  moved: Array<Scalars['JSON']['output']>;
  next?: Maybe<Array<Scalars['JSON']['output']>>;
  path: Array<Scalars['PathElement']['output']>;
  prev?: Maybe<Array<Scalars['JSON']['output']>>;
  pulled: Array<Scalars['JSON']['output']>;
  pushed: Array<Scalars['JSON']['output']>;
};

export type Organization = {
  __typename?: 'Organization';
  ancestors?: Maybe<Array<Organization>>;
  businessType?: Maybe<OrganizationBusinessType>;
  children?: Maybe<Array<Organization>>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  facilityType?: Maybe<OrganizationFacilityType>;
  filledInAudits?: Maybe<Array<FilledInAudit>>;
  filledInQuestionnaires?: Maybe<Array<FilledInQuestionnaire>>;
  geography?: Maybe<OrganizationGeography>;
  hasChildren?: Maybe<Scalars['Boolean']['output']>;
  /** ffmAlias: organizationId */
  id: Scalars['BigInt']['output'];
  importer?: Maybe<OrganizationReference>;
  isImporterOfRegionalOffice?: Maybe<Scalars['Boolean']['output']>;
  isManagedByKADO: Scalars['Boolean']['output'];
  isRegionalOffice?: Maybe<Scalars['Boolean']['output']>;
  isVRegion?: Maybe<Scalars['Boolean']['output']>;
  localization?: Maybe<OrganizationLocalization>;
  marketAcronym?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  parent?: Maybe<Organization>;
  parentId?: Maybe<Scalars['BigInt']['output']>;
  parentMarket?: Maybe<Organization>;
  partnerNumber?: Maybe<Scalars['String']['output']>;
  postalcode?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Organization>;
  profitPotentialIdentified?: Maybe<Scalars['Float']['output']>;
  relations?: Maybe<OrganizationRelations>;
  status?: Maybe<OrganizationStatus>;
  strategyFields?: Maybe<Array<Maybe<StrategyField>>>;
  strategyKpis?: Maybe<Array<Maybe<StrategyKpi>>>;
  street?: Maybe<Scalars['String']['output']>;
  type: OrganizationType;
  vRegion?: Maybe<OrganizationReference>;
};


export type OrganizationChildrenArgs = {
  direct?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrganizationFilledInAuditsArgs = {
  auditId?: InputMaybe<Scalars['ObjectID']['input']>;
};


export type OrganizationFilledInQuestionnairesArgs = {
  questionnaireId?: InputMaybe<Scalars['ObjectID']['input']>;
  type?: InputMaybe<QuestionnaireType>;
};


export type OrganizationParentMarketArgs = {
  topLevel?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrganizationProfitPotentialIdentifiedArgs = {
  currency: Currency;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type OrganizationStrategyFieldsArgs = {
  input?: InputMaybe<StrategyFieldsFilterInput>;
};


export type OrganizationStrategyKpisArgs = {
  input?: InputMaybe<StrategyKpisInput>;
};

export enum OrganizationBusinessType {
  Contractor = 'CONTRACTOR',
  External = 'EXTERNAL',
  PorscheAg = 'PORSCHE_AG',
  PorscheDealer = 'PORSCHE_DEALER',
  PorscheImporter = 'PORSCHE_IMPORTER',
  PorscheSubsidiary = 'PORSCHE_SUBSIDIARY'
}

export type OrganizationBusinessTypeFilter = {
  _in?: InputMaybe<Array<InputMaybe<OrganizationBusinessType>>>;
};

export enum OrganizationFacilityType {
  ContactCenter = 'CONTACT_CENTER',
  ExternalDealer = 'EXTERNAL_DEALER',
  ExternalVendor = 'EXTERNAL_VENDOR',
  ExternalWorkshop = 'EXTERNAL_WORKSHOP',
  IndependentImporter = 'INDEPENDENT_IMPORTER',
  IndependentOperator = 'INDEPENDENT_OPERATOR',
  IndependentRegionalOffice = 'INDEPENDENT_REGIONAL_OFFICE',
  InternalDealerImporter = 'INTERNAL_DEALER_IMPORTER',
  InternalDealerPag = 'INTERNAL_DEALER_PAG',
  InternalDealerSubsidiary = 'INTERNAL_DEALER_SUBSIDIARY',
  InternalPdiCentreSubsidiary = 'INTERNAL_PDI_CENTRE_SUBSIDIARY',
  Nsc = 'NSC',
  PorscheAg = 'PORSCHE_AG',
  PorscheApprovedAndServiceCenter = 'PORSCHE_APPROVED_AND_SERVICE_CENTER',
  PorscheApprovedCenter = 'PORSCHE_APPROVED_CENTER',
  PorscheCenter = 'PORSCHE_CENTER',
  PorscheCenterGroup = 'PORSCHE_CENTER_GROUP',
  PorscheClassicCenter = 'PORSCHE_CLASSIC_CENTER',
  PorscheCustomerInteractionCenter = 'PORSCHE_CUSTOMER_INTERACTION_CENTER',
  PorscheExperienceCenter = 'PORSCHE_EXPERIENCE_CENTER',
  PorscheExperienceCenterTemp = 'PORSCHE_EXPERIENCE_CENTER_TEMP',
  PorscheExpressCityServiceCenter = 'PORSCHE_EXPRESS_CITY_SERVICE_CENTER',
  PorscheNow = 'PORSCHE_NOW',
  PorscheOwnedImporterSubsidiary = 'PORSCHE_OWNED_IMPORTER_SUBSIDIARY',
  PorscheOwnedSubsidiary = 'PORSCHE_OWNED_SUBSIDIARY',
  PorschePreDeliveryInspectionWorkshop = 'PORSCHE_PRE_DELIVERY_INSPECTION_WORKSHOP',
  PorschePreOwnedCarCenter = 'PORSCHE_PRE_OWNED_CAR_CENTER',
  PorscheRegionalOffice = 'PORSCHE_REGIONAL_OFFICE',
  PorscheSalesPopUp = 'PORSCHE_SALES_POP_UP',
  PorscheSe = 'PORSCHE_SE',
  PorscheServiceCenter = 'PORSCHE_SERVICE_CENTER',
  PorscheServiceFactory = 'PORSCHE_SERVICE_FACTORY',
  PorscheShowroom = 'PORSCHE_SHOWROOM',
  PorscheStore = 'PORSCHE_STORE',
  PorscheStudio = 'PORSCHE_STUDIO',
  PorscheTrainingCenter = 'PORSCHE_TRAINING_CENTER',
  PorscheWorkshop = 'PORSCHE_WORKSHOP',
  SatellitePorscheCenter = 'SATELLITE_PORSCHE_CENTER',
  Supplier = 'SUPPLIER'
}

export type OrganizationFacilityTypeFilter = {
  _in?: InputMaybe<Array<InputMaybe<OrganizationFacilityType>>>;
};

export type OrganizationFilter = {
  _and?: InputMaybe<Array<OrganizationFilter>>;
  _id?: InputMaybe<BigIntFilter>;
  _or?: InputMaybe<Array<OrganizationFilter>>;
  ancestors?: InputMaybe<BigIntFilter>;
  businessType?: InputMaybe<OrganizationBusinessTypeFilter>;
  children?: InputMaybe<BigIntFilter>;
  deletedAt?: InputMaybe<DateTimeFilter>;
  facilityType?: InputMaybe<OrganizationFacilityTypeFilter>;
  isVRegion?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  organizationType?: InputMaybe<OrganizationTypeFilter>;
  parent?: InputMaybe<OrganizationFilter>;
  parentId?: InputMaybe<BigIntFilter>;
  partnerNumber?: InputMaybe<StringFilter>;
  previousId?: InputMaybe<BigIntFilter>;
  relations_market?: InputMaybe<BigIntFilter>;
  status?: InputMaybe<OrganizationStatusFilter>;
  street?: InputMaybe<StringFilter>;
  /** @deprecated Use organizationType instead */
  type?: InputMaybe<OrganizationType>;
};

export type OrganizationGeography = {
  __typename?: 'OrganizationGeography';
  area?: Maybe<Scalars['String']['output']>;
  market?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type OrganizationLocalization = {
  __typename?: 'OrganizationLocalization';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

export type OrganizationReference = {
  __typename?: 'OrganizationReference';
  name: Scalars['String']['output'];
  organizationId: Scalars['BigInt']['output'];
};

export type OrganizationReferenceInput = {
  name: Scalars['String']['input'];
  organizationId: Scalars['BigInt']['input'];
};

export type OrganizationRelations = {
  __typename?: 'OrganizationRelations';
  market?: Maybe<Organization>;
  vRegion?: Maybe<Organization>;
};

export enum OrganizationStatus {
  Archived = 'ARCHIVED',
  Closed = 'CLOSED',
  Operative = 'OPERATIVE',
  Planned = 'PLANNED',
  RampUp = 'RAMP_UP',
  WhiteSpot = 'WHITE_SPOT'
}

export type OrganizationStatusFilter = {
  _eq?: InputMaybe<OrganizationStatus>;
  _in?: InputMaybe<Array<InputMaybe<OrganizationStatus>>>;
};

export enum OrganizationType {
  Market = 'MARKET',
  Organization = 'ORGANIZATION',
  OrganizationalUnit = 'ORGANIZATIONAL_UNIT',
  OrganizationUnit = 'ORGANIZATION_UNIT'
}

export type OrganizationTypeFilter = {
  _eq?: InputMaybe<OrganizationType>;
  _in?: InputMaybe<Array<InputMaybe<OrganizationType>>>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['Cursor']['output']>;
};

export type PaginatedActionItems = {
  __typename?: 'PaginatedActionItems';
  docs: Array<ActionItem>;
  total: Scalars['Int']['output'];
};

export type PaginatedAudits = {
  __typename?: 'PaginatedAudits';
  docs: Array<Audit>;
  total: Scalars['Int']['output'];
};

export type PaginatedHelpArticles = {
  __typename?: 'PaginatedHelpArticles';
  docs: Array<HelpArticle>;
  total: Scalars['Int']['output'];
};

export type PaginatedMeetings = {
  __typename?: 'PaginatedMeetings';
  docs: Array<Meeting>;
  total: Scalars['Int']['output'];
};

export type PaginatedOrganizations = {
  __typename?: 'PaginatedOrganizations';
  docs: Array<Organization>;
  total: Scalars['Int']['output'];
};

export type PaginatedPersons = {
  __typename?: 'PaginatedPersons';
  docs: Array<Person>;
  total: Scalars['Int']['output'];
};

export type PaginatedQuestionnaireTypeConfig = {
  __typename?: 'PaginatedQuestionnaireTypeConfig';
  docs: Array<QuestionnaireTypeConfig>;
  total: Scalars['Int']['output'];
};

export type PaginatedQuestionnaires = {
  __typename?: 'PaginatedQuestionnaires';
  docs: Array<Questionnaire>;
  total: Scalars['Int']['output'];
};

export type Patch = {
  date: Scalars['DateTime']['output'];
  id: Scalars['ObjectID']['output'];
  ops: Scalars['JSON']['output'];
  person: Person;
  ref: Scalars['ObjectID']['output'];
};


export type PatchOpsArgs = {
  input?: InputMaybe<PatchOpsInput>;
};

export type PatchFilter = {
  _elemMatch?: InputMaybe<PatchFilter>;
  op?: InputMaybe<StringFilter>;
  path?: InputMaybe<StringFilter>;
  value?: InputMaybe<StringFilter>;
};

export type PatchOpsFilter = {
  path?: InputMaybe<StringFilter>;
};

export type PatchOpsInput = {
  filter?: InputMaybe<PatchOpsFilter>;
};

export type PbeIrisFilter = {
  _or?: InputMaybe<Array<InputMaybe<PbeIrisFilter>>>;
  coachingModuleIds?: InputMaybe<ObjectIdFilter>;
  type?: InputMaybe<PbeIrisKpiTypeFilter>;
};

export type PbeIrisKpi = {
  __typename?: 'PbeIrisKpi';
  coachingModuleIds?: Maybe<Array<Scalars['ObjectID']['output']>>;
  /** ffmAlias: pbeIrisKpiId */
  id: Scalars['ObjectID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  translations?: Maybe<Scalars['JSON']['output']>;
  type: PbeIrisKpiType;
};

export type PbeIrisKpiInput = {
  coachingModuleIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
  translations?: InputMaybe<Scalars['JSON']['input']>;
  type: PbeIrisKpiType;
};

export enum PbeIrisKpiType {
  CoachingModules = 'COACHING_MODULES',
  Optional = 'OPTIONAL',
  Required = 'REQUIRED'
}

export type PbeIrisKpiTypeFilter = {
  _eq?: InputMaybe<PbeIrisKpiType>;
  _in?: InputMaybe<Array<InputMaybe<PbeIrisKpiType>>>;
  _nin?: InputMaybe<Array<InputMaybe<PbeIrisKpiType>>>;
};

export type PcRoadmapActionItem = {
  __typename?: 'PcRoadmapActionItem';
  attachments: Array<Attachment>;
  author: Person;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  okr: Scalars['String']['output'];
  organization: Organization;
  porscheStrategy2030ActionItemId?: Maybe<Scalars['ObjectID']['output']>;
  responsible: Person;
  status: PcRoadmapActionItemStatus;
  title: Scalars['String']['output'];
  workPackages: Array<PcRoadmapActionItemWorkPackage>;
};

export enum PcRoadmapActionItemStatus {
  Done = 'DONE',
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN'
}

export type PcRoadmapActionItemWorkPackage = {
  __typename?: 'PcRoadmapActionItemWorkPackage';
  id: Scalars['ObjectID']['output'];
  status: PcRoadmapActionItemWorkPackageStatus;
  targetMonth: Scalars['DateMonth']['output'];
  title: Scalars['String']['output'];
};

export type PcRoadmapActionItemWorkPackageInput = {
  status: PcRoadmapActionItemWorkPackageStatus;
  targetMonth: Scalars['DateMonth']['input'];
  title: Scalars['String']['input'];
};

export enum PcRoadmapActionItemWorkPackageStatus {
  Done = 'DONE',
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN'
}

export type PcRoadmapAdditionalAgreement = {
  __typename?: 'PcRoadmapAdditionalAgreement';
  id: Scalars['ObjectID']['output'];
  isAssigned: Scalars['Boolean']['output'];
  kind: PcRoadmapAdditionalAgreementKind;
  name: Scalars['String']['output'];
  organization: Organization;
  parent?: Maybe<PcRoadmapAdditionalAgreementCollection>;
  stages: Array<PcRoadmapStage>;
};

export type PcRoadmapAdditionalAgreementCollection = {
  __typename?: 'PcRoadmapAdditionalAgreementCollection';
  id: Scalars['ObjectID']['output'];
  isAssigned: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
  stages: Array<PcRoadmapStage>;
  subs: Array<PcRoadmapAdditionalAgreement>;
};

export type PcRoadmapAdditionalAgreementCollectionForStage = {
  __typename?: 'PcRoadmapAdditionalAgreementCollectionForStage';
  additionalAgreementCollection: PcRoadmapAdditionalAgreementCollection;
  description?: Maybe<Scalars['String']['output']>;
  stage: PcRoadmapStage;
  subs: Array<PcRoadmapAdditionalAgreementForStage>;
  templateVariables?: Maybe<Array<PcRoadmapTemplateVariable>>;
};

export type PcRoadmapAdditionalAgreementElement = PcRoadmapAdditionalAgreement | PcRoadmapAdditionalAgreementCollection;

export type PcRoadmapAdditionalAgreementElementForStage = PcRoadmapAdditionalAgreementCollectionForStage | PcRoadmapAdditionalAgreementForStage;

export type PcRoadmapAdditionalAgreementFilter = {
  _and?: InputMaybe<Array<PcRoadmapStrategyFieldFilter>>;
  _id?: InputMaybe<ObjectIdFilter>;
  _or?: InputMaybe<Array<PcRoadmapStrategyFieldFilter>>;
  kind?: InputMaybe<PcRoadmapAdditionalAgreementKindFilter>;
  organization?: InputMaybe<BigIntFilter>;
  stages?: InputMaybe<ObjectIdFilter>;
};

export type PcRoadmapAdditionalAgreementForStage = {
  __typename?: 'PcRoadmapAdditionalAgreementForStage';
  additionalAgreement: PcRoadmapAdditionalAgreement;
  description?: Maybe<Scalars['String']['output']>;
  stage: PcRoadmapStage;
  templateVariables?: Maybe<Array<PcRoadmapTemplateVariable>>;
};

export enum PcRoadmapAdditionalAgreementKind {
  Miscellaneous = 'MISCELLANEOUS',
  OverviewCoachingModules = 'OVERVIEW_COACHING_MODULES',
  PdaRewardsProgram = 'PDA_REWARDS_PROGRAM',
  PdaRewardsProgramCounterBusiness = 'PDA_REWARDS_PROGRAM_COUNTER_BUSINESS',
  PfsBonusplan = 'PFS_BONUSPLAN',
  PorscheDestination = 'PORSCHE_DESTINATION',
  Signatures = 'SIGNATURES',
  Sustainability = 'SUSTAINABILITY'
}

export type PcRoadmapAdditionalAgreementKindFilter = {
  _exists?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<InputMaybe<PcRoadmapAdditionalAgreementKind>>>;
};

export type PcRoadmapAdditionalAgreementValue = {
  additionalAgreement: PcRoadmapAdditionalAgreement;
  id: Scalars['ObjectID']['output'];
  kind: PcRoadmapAdditionalAgreementKind;
};

export type PcRoadmapAdditionalAgreementValueBonusplan = PcRoadmapAdditionalAgreementValue & {
  __typename?: 'PcRoadmapAdditionalAgreementValueBonusplan';
  additionalAgreement: PcRoadmapAdditionalAgreement;
  attachments?: Maybe<Array<Attachment>>;
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  kind: PcRoadmapAdditionalAgreementKind;
};

export type PcRoadmapAdditionalAgreementValueMiscellaneous = PcRoadmapAdditionalAgreementValue & {
  __typename?: 'PcRoadmapAdditionalAgreementValueMiscellaneous';
  additionalAgreement: PcRoadmapAdditionalAgreement;
  comment?: Maybe<Scalars['String']['output']>;
  complianceConfirmation?: Maybe<Scalars['Boolean']['output']>;
  equityRatioAllowance?: Maybe<Scalars['Boolean']['output']>;
  equityRatioStatementAcknowledged?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ObjectID']['output'];
  kind: PcRoadmapAdditionalAgreementKind;
};

export type PcRoadmapAdditionalAgreementValueOverviewCoachingModules = PcRoadmapAdditionalAgreementValue & {
  __typename?: 'PcRoadmapAdditionalAgreementValueOverviewCoachingModules';
  additionalAgreement: PcRoadmapAdditionalAgreement;
  coachingModules?: Maybe<Array<CoachingModule>>;
  id: Scalars['ObjectID']['output'];
  kind: PcRoadmapAdditionalAgreementKind;
};

export type PcRoadmapAdditionalAgreementValuePdaRewardsProgram = PcRoadmapAdditionalAgreementValue & {
  __typename?: 'PcRoadmapAdditionalAgreementValuePdaRewardsProgram';
  additionalAgreement: PcRoadmapAdditionalAgreement;
  attachments?: Maybe<Array<Attachment>>;
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  kind: PcRoadmapAdditionalAgreementKind;
};

export type PcRoadmapAdditionalAgreementValuePdaRewardsProgramCounterBusiness = PcRoadmapAdditionalAgreementValue & {
  __typename?: 'PcRoadmapAdditionalAgreementValuePdaRewardsProgramCounterBusiness';
  additionalAgreement: PcRoadmapAdditionalAgreement;
  attachments?: Maybe<Array<Attachment>>;
  comment?: Maybe<Scalars['String']['output']>;
  dutyOfCareResaleAndSanctionsObserved?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ObjectID']['output'];
  kind: PcRoadmapAdditionalAgreementKind;
};

export type PcRoadmapAdditionalAgreementValuePorscheDestination = PcRoadmapAdditionalAgreementValue & {
  __typename?: 'PcRoadmapAdditionalAgreementValuePorscheDestination';
  additionalAgreement: PcRoadmapAdditionalAgreement;
  changeOptions?: Maybe<Array<PcRoadmapAdditionalAgreementValuePorscheDestinationChangeOption>>;
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  kind: PcRoadmapAdditionalAgreementKind;
  plannedAdditionalLocationPorscheApprovedAndServiceCenterYear?: Maybe<Scalars['Int']['output']>;
  plannedAdditionalLocationPorscheCenterYear?: Maybe<Scalars['Int']['output']>;
  plannedAdditionalLocationPorscheServiceFactoryYear?: Maybe<Scalars['Int']['output']>;
  plannedAdditionalLocationSatellitePorscheCenterYear?: Maybe<Scalars['Int']['output']>;
};

export enum PcRoadmapAdditionalAgreementValuePorscheDestinationChangeOption {
  NewBuild = 'NEW_BUILD',
  Relocation = 'RELOCATION',
  RepairExtension = 'REPAIR_EXTENSION',
  Transformation = 'TRANSFORMATION'
}

export type PcRoadmapAdditionalAgreementValueSignature = {
  __typename?: 'PcRoadmapAdditionalAgreementValueSignature';
  acknowledged?: Maybe<Scalars['Boolean']['output']>;
  emailSentAt?: Maybe<Scalars['DateTime']['output']>;
  person: Person;
};

export type PcRoadmapAdditionalAgreementValueSignatures = PcRoadmapAdditionalAgreementValue & {
  __typename?: 'PcRoadmapAdditionalAgreementValueSignatures';
  additionalAgreement: PcRoadmapAdditionalAgreement;
  afterSalesFieldForce?: Maybe<PcRoadmapAdditionalAgreementValueSignature>;
  headOfSales?: Maybe<PcRoadmapAdditionalAgreementValueSignature>;
  id: Scalars['ObjectID']['output'];
  kind: PcRoadmapAdditionalAgreementKind;
  managingDirector?: Maybe<PcRoadmapAdditionalAgreementValueSignature>;
  pfsFieldForce?: Maybe<PcRoadmapAdditionalAgreementValueSignature>;
  salesFieldForce?: Maybe<PcRoadmapAdditionalAgreementValueSignature>;
};

export type PcRoadmapAdditionalAgreementValueSustainability = PcRoadmapAdditionalAgreementValue & {
  __typename?: 'PcRoadmapAdditionalAgreementValueSustainability';
  additionalAgreement: PcRoadmapAdditionalAgreement;
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  isoCertification?: Maybe<PcRoadmapAdditionalAgreementValueSustainabilityIsoCertification>;
  kind: PcRoadmapAdditionalAgreementKind;
};

export enum PcRoadmapAdditionalAgreementValueSustainabilityIsoCertification {
  Done = 'DONE',
  PlannedLater = 'PLANNED_LATER',
  PlannedNextStage = 'PLANNED_NEXT_STAGE',
  PlannedThisStage = 'PLANNED_THIS_STAGE'
}

export type PcRoadmapAdditionalAgreementsInput = {
  filter?: InputMaybe<PcRoadmapAdditionalAgreementFilter>;
};

export type PcRoadmapApplicableDocument = {
  __typename?: 'PcRoadmapApplicableDocument';
  attachment: Attachment;
  id: Scalars['ObjectID']['output'];
  name: Scalars['String']['output'];
  organizations: Array<Organization>;
  stages: Array<PcRoadmapStage>;
  strategyKpi: PcRoadmapStrategyKpi;
};

export type PcRoadmapApplicableDocumentFilter = {
  organizationId?: InputMaybe<Scalars['BigInt']['input']>;
};

export type PcRoadmapCommitment = {
  __typename?: 'PcRoadmapCommitment';
  actionItemRelations?: Maybe<Array<PcRoadmapCommitmentActionItemRelation>>;
  additionalAgreementValues?: Maybe<Array<PcRoadmapAdditionalAgreementValue>>;
  additionalAgreements?: Maybe<Array<PcRoadmapAdditionalAgreementElementForStage>>;
  applicableDocuments?: Maybe<Array<PcRoadmapApplicableDocument>>;
  changeHistory: Array<PcRoadmapCommitmentChangeHistory>;
  coachingModuleRelations?: Maybe<Array<PcRoadmapCommitmentCoachingModuleRelationRelation>>;
  completedAt?: Maybe<Scalars['Date']['output']>;
  focusKpiCount: Scalars['Int']['output'];
  furtherDetail?: Maybe<PcRoadmapFurtherDetail>;
  hasActionItemsTransmittedToPorscheStrategy: Scalars['Boolean']['output'];
  id: Scalars['ObjectID']['output'];
  isFocusKpi?: Maybe<Scalars['Boolean']['output']>;
  kpiComment?: Maybe<Scalars['String']['output']>;
  kpiValueSets: Array<PcRoadmapCommitmentKpiValueSet>;
  kpis: Array<PcRoadmapCommitmentKpi>;
  mission?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  previousCommitment?: Maybe<PcRoadmapCommitment>;
  stage: PcRoadmapStage;
  status: PcRoadmapCommitmentStatus;
  strategyFields: Array<PcRoadmapStrategyFieldForStage>;
  visibleForDealer: Scalars['Boolean']['output'];
  vision?: Maybe<Scalars['String']['output']>;
};


export type PcRoadmapCommitmentApplicableDocumentsArgs = {
  strategyKpiId: Scalars['ObjectID']['input'];
};


export type PcRoadmapCommitmentChangeHistoryArgs = {
  granularity?: InputMaybe<ChangeHistoryGranularity>;
};


export type PcRoadmapCommitmentFurtherDetailArgs = {
  strategyKpiId: Scalars['ObjectID']['input'];
};


export type PcRoadmapCommitmentIsFocusKpiArgs = {
  strategyFieldId: Scalars['ObjectID']['input'];
  strategyKpiCategoryId?: InputMaybe<Scalars['ObjectID']['input']>;
  strategyKpiId: Scalars['ObjectID']['input'];
};


export type PcRoadmapCommitmentKpiCommentArgs = {
  strategyFieldId: Scalars['ObjectID']['input'];
  strategyKpiCategoryId?: InputMaybe<Scalars['ObjectID']['input']>;
  strategyKpiId: Scalars['ObjectID']['input'];
};


export type PcRoadmapCommitmentKpiValueSetsArgs = {
  strategyFieldId: Scalars['ObjectID']['input'];
  strategyKpiCategoryId?: InputMaybe<Scalars['ObjectID']['input']>;
  strategyKpiId: Scalars['ObjectID']['input'];
};

export type PcRoadmapCommitmentActionItemRelation = {
  __typename?: 'PcRoadmapCommitmentActionItemRelation';
  actionItems: Array<PcRoadmapActionItem>;
  kind: PcRoadmapKpiValueKind;
  strategyField: PcRoadmapStrategyFieldForStage;
  strategyKpi: PcRoadmapStrategyKpiForStage;
  strategyKpiCategory?: Maybe<PcRoadmapStrategyKpiCategoryForStage>;
  valueSet?: Maybe<PcRoadmapCommitmentKpiValueSet>;
};

export type PcRoadmapCommitmentChangeHistory = {
  __typename?: 'PcRoadmapCommitmentChangeHistory';
  diffs: Array<PcRoadmapCommitmentChangeHistoryDiff>;
  person: Person;
  timestamp: Scalars['DateTime']['output'];
};

export type PcRoadmapCommitmentChangeHistoryDiff = PcRoadmapCommitmentChangeHistoryDiffAny | PcRoadmapCommitmentChangeHistoryDiffArray;

export type PcRoadmapCommitmentChangeHistoryDiffAny = {
  __typename?: 'PcRoadmapCommitmentChangeHistoryDiffAny';
  next?: Maybe<Scalars['JSON']['output']>;
  path: Array<Scalars['PathElement']['output']>;
  prev?: Maybe<Scalars['JSON']['output']>;
};

export type PcRoadmapCommitmentChangeHistoryDiffArray = {
  __typename?: 'PcRoadmapCommitmentChangeHistoryDiffArray';
  moved: Array<Scalars['JSON']['output']>;
  next?: Maybe<Array<Scalars['JSON']['output']>>;
  path: Array<Scalars['PathElement']['output']>;
  prev?: Maybe<Array<Scalars['JSON']['output']>>;
  pulled: Array<Scalars['JSON']['output']>;
  pushed: Array<Scalars['JSON']['output']>;
};

export type PcRoadmapCommitmentCoachingModuleRelationRelation = {
  __typename?: 'PcRoadmapCommitmentCoachingModuleRelationRelation';
  coachingModules: Array<CoachingModule>;
  kind: PcRoadmapKpiValueKind;
  strategyField: PcRoadmapStrategyFieldForStage;
  strategyKpi: PcRoadmapStrategyKpiForStage;
  strategyKpiCategory?: Maybe<PcRoadmapStrategyKpiCategoryForStage>;
};

export type PcRoadmapCommitmentFilter = {
  organization?: InputMaybe<BigIntFilter>;
  rootOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
  stage?: InputMaybe<ObjectIdFilter>;
  status?: InputMaybe<PcRoadmapCommitmentStatusFilter>;
};

export type PcRoadmapCommitmentKpi = {
  __typename?: 'PcRoadmapCommitmentKpi';
  strategyField: PcRoadmapStrategyFieldForStage;
  strategyKpi: PcRoadmapStrategyKpiForStage;
  strategyKpiCategory?: Maybe<PcRoadmapStrategyKpiCategoryForStage>;
  valueSets: Array<PcRoadmapCommitmentKpiValueSet>;
};

export type PcRoadmapCommitmentKpiValueSet = {
  __typename?: 'PcRoadmapCommitmentKpiValueSet';
  actionItems: Array<PcRoadmapActionItem>;
  coachingModules: Array<CoachingModule>;
  kind?: Maybe<PcRoadmapKpiValueKind>;
  type?: Maybe<PcRoadmapKpiType>;
  values: Array<PcRoadmapCommitmentKpiValueSetValue>;
};

export type PcRoadmapCommitmentKpiValueSetValue = {
  __typename?: 'PcRoadmapCommitmentKpiValueSetValue';
  name: Scalars['String']['output'];
  originalValue?: Maybe<Scalars['Float']['output']>;
  style?: Maybe<NumberStyle>;
  value?: Maybe<Scalars['Float']['output']>;
  variant?: Maybe<PcRoadmapKpiValueVariant>;
};

export enum PcRoadmapCommitmentStatus {
  Completed = 'COMPLETED',
  InPlanning = 'IN_PLANNING',
  InProgress = 'IN_PROGRESS'
}

export type PcRoadmapCommitmentStatusFilter = {
  _eq?: InputMaybe<PcRoadmapCommitmentStatus>;
};

export type PcRoadmapCommitmentsInput = {
  filter?: InputMaybe<PcRoadmapCommitmentFilter>;
};

export type PcRoadmapFurtherDetail = {
  __typename?: 'PcRoadmapFurtherDetail';
  description: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  stages: Array<PcRoadmapStage>;
  strategyKpi: PcRoadmapStrategyKpi;
};

export type PcRoadmapKpiImportInput = {
  organizationId: Scalars['BigInt']['input'];
  stageId: Scalars['ObjectID']['input'];
  strategyFieldId: Scalars['ObjectID']['input'];
  strategyKpiCategoryId?: InputMaybe<Scalars['ObjectID']['input']>;
  strategyKpiId: Scalars['ObjectID']['input'];
  type: PcRoadmapKpiType;
  valueSet: Array<ImportPcRoadmapKpiValueSetValueInput>;
};

export enum PcRoadmapKpiType {
  Jzv = 'JZV',
  PreOwnedCars = 'PRE_OWNED_CARS',
  Standard = 'STANDARD'
}

export enum PcRoadmapKpiValueKind {
  Operative = 'OPERATIVE',
  Strategically = 'STRATEGICALLY',
  Vision = 'VISION'
}

export enum PcRoadmapKpiValueVariant {
  AdditionalPotential = 'ADDITIONAL_POTENTIAL',
  BasePotential = 'BASE_POTENTIAL',
  ElectrificationLevel = 'ELECTRIFICATION_LEVEL',
  MarketingRate = 'MARKETING_RATE',
  Model_718 = 'MODEL_718',
  Model_911 = 'MODEL_911',
  ModelCayenne = 'MODEL_CAYENNE',
  ModelCayenneE3 = 'MODEL_CAYENNE_E3',
  ModelCayenneE4 = 'MODEL_CAYENNE_E4',
  ModelMacan = 'MODEL_MACAN',
  ModelPanamera = 'MODEL_PANAMERA',
  ModelTaycan = 'MODEL_TAYCAN',
  SportsCar = 'SPORTS_CAR'
}

export type PcRoadmapOrderByStageInput = {
  id: Scalars['ObjectID']['input'];
  order: Scalars['Int']['input'];
};

export type PcRoadmapReport = {
  __typename?: 'PcRoadmapReport';
  actualValue?: Maybe<Scalars['Float']['output']>;
  deviationAbsolute?: Maybe<Scalars['Float']['output']>;
  deviationRelative?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ObjectID']['output'];
  importBatchId: Scalars['String']['output'];
  organization: Organization;
  previousYearValue?: Maybe<Scalars['Float']['output']>;
  stage: PcRoadmapStage;
  strategyField: PcRoadmapStrategyFieldForStage;
  strategyKpi: PcRoadmapStrategyKpiForStage;
  strategyKpiCategory?: Maybe<PcRoadmapStrategyKpiCategoryForStage>;
  style?: Maybe<NumberStyle>;
  targetNextValue?: Maybe<Scalars['Float']['output']>;
  targetValue?: Maybe<Scalars['Float']['output']>;
  uploadedAt: Scalars['Date']['output'];
  valueSet: Array<PcRoadmapReportValue>;
};

export type PcRoadmapReportDataImportInput = {
  importBatchId?: InputMaybe<Scalars['String']['input']>;
  reports: Array<ImportPcRoadmapReportInput>;
  stageId: Scalars['ObjectID']['input'];
};

export type PcRoadmapReportFilter = {
  _and?: InputMaybe<Array<PcRoadmapReportFilter>>;
  _or?: InputMaybe<Array<PcRoadmapReportFilter>>;
  importBatchId?: InputMaybe<StringFilter>;
  organization?: InputMaybe<BigIntFilter>;
  stage?: InputMaybe<ObjectIdFilter>;
  strategyField?: InputMaybe<ObjectIdFilter>;
  strategyKpi?: InputMaybe<ObjectIdFilter>;
  strategyKpiCategory?: InputMaybe<ObjectIdFilter>;
};

export type PcRoadmapReportImportResult = {
  __typename?: 'PcRoadmapReportImportResult';
  count: Scalars['Int']['output'];
  importBatchId: Scalars['String']['output'];
};

export type PcRoadmapReportValue = {
  __typename?: 'PcRoadmapReportValue';
  name: Scalars['String']['output'];
  style?: Maybe<NumberStyle>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type PcRoadmapReportsInput = {
  filter?: InputMaybe<PcRoadmapReportFilter>;
};

export type PcRoadmapStage = {
  __typename?: 'PcRoadmapStage';
  additionalAgreements: Array<PcRoadmapAdditionalAgreementElementForStage>;
  id: Scalars['ObjectID']['output'];
  isAssigned: Scalars['Boolean']['output'];
  strategyFields: Array<PcRoadmapStrategyFieldForStage>;
  visibleForDealer: Scalars['Date']['output'];
  visibleForManager: Scalars['Date']['output'];
  year: Scalars['Int']['output'];
};

export type PcRoadmapStageFilter = {
  _and?: InputMaybe<Array<PcRoadmapStageFilter>>;
  _id?: InputMaybe<ObjectIdFilter>;
  _or?: InputMaybe<Array<PcRoadmapStageFilter>>;
  year?: InputMaybe<IntFilter>;
};

export type PcRoadmapStagesInput = {
  filter?: InputMaybe<PcRoadmapStageFilter>;
};

export type PcRoadmapStrategyField = {
  __typename?: 'PcRoadmapStrategyField';
  id: Scalars['ObjectID']['output'];
  isAssigned: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
  stages: Array<PcRoadmapStage>;
  strategyKpis: Array<PcRoadmapStrategyKpi>;
};

export type PcRoadmapStrategyFieldFilter = {
  _and?: InputMaybe<Array<PcRoadmapStrategyFieldFilter>>;
  _id?: InputMaybe<ObjectIdFilter>;
  _or?: InputMaybe<Array<PcRoadmapStrategyFieldFilter>>;
  name?: InputMaybe<StringFilter>;
  organization?: InputMaybe<BigIntFilter>;
  stages?: InputMaybe<ObjectIdFilter>;
};

export type PcRoadmapStrategyFieldForStage = {
  __typename?: 'PcRoadmapStrategyFieldForStage';
  color: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  stage: PcRoadmapStage;
  strategyField: PcRoadmapStrategyField;
  strategyKpis: Array<PcRoadmapStrategyKpiForStage>;
};

export type PcRoadmapStrategyFieldsInput = {
  filter?: InputMaybe<PcRoadmapStrategyFieldFilter>;
};

export type PcRoadmapStrategyKpi = {
  __typename?: 'PcRoadmapStrategyKpi';
  applicableDocuments?: Maybe<Array<PcRoadmapApplicableDocument>>;
  commitmentComment?: Maybe<Scalars['String']['output']>;
  commitmentValueSets: Array<PcRoadmapCommitmentKpiValueSet>;
  decimalPrecision?: Maybe<Scalars['Int']['output']>;
  furtherDetail?: Maybe<PcRoadmapFurtherDetail>;
  id: Scalars['ObjectID']['output'];
  isAssigned: Scalars['Boolean']['output'];
  isCommitmentFocusKpi: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  stages: Array<PcRoadmapStage>;
  strategyField: PcRoadmapStrategyField;
  strategyKpiCategories: Array<PcRoadmapStrategyKpiCategory>;
};


export type PcRoadmapStrategyKpiApplicableDocumentsArgs = {
  filter?: InputMaybe<PcRoadmapApplicableDocumentFilter>;
};


export type PcRoadmapStrategyKpiCommitmentCommentArgs = {
  commitmentId: Scalars['ObjectID']['input'];
};


export type PcRoadmapStrategyKpiCommitmentValueSetsArgs = {
  commitmentId: Scalars['ObjectID']['input'];
};


export type PcRoadmapStrategyKpiIsCommitmentFocusKpiArgs = {
  commitmentId: Scalars['ObjectID']['input'];
};

export type PcRoadmapStrategyKpiCategoriesInput = {
  filter?: InputMaybe<PcRoadmapStrategyKpiCategoryFilter>;
};

export type PcRoadmapStrategyKpiCategory = {
  __typename?: 'PcRoadmapStrategyKpiCategory';
  commitmentComment?: Maybe<Scalars['String']['output']>;
  commitmentValueSets: Array<PcRoadmapCommitmentKpiValueSet>;
  decimalPrecision?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ObjectID']['output'];
  isAssigned: Scalars['Boolean']['output'];
  isCommitmentFocusKpi: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  stages: Array<PcRoadmapStage>;
  strategyKpi: PcRoadmapStrategyKpi;
};


export type PcRoadmapStrategyKpiCategoryCommitmentCommentArgs = {
  commitmentId: Scalars['ObjectID']['input'];
};


export type PcRoadmapStrategyKpiCategoryCommitmentValueSetsArgs = {
  commitmentId: Scalars['ObjectID']['input'];
};


export type PcRoadmapStrategyKpiCategoryIsCommitmentFocusKpiArgs = {
  commitmentId: Scalars['ObjectID']['input'];
};

export type PcRoadmapStrategyKpiCategoryFilter = {
  _and?: InputMaybe<Array<PcRoadmapStrategyKpiCategoryFilter>>;
  _id?: InputMaybe<ObjectIdFilter>;
  _or?: InputMaybe<Array<PcRoadmapStrategyKpiCategoryFilter>>;
  name?: InputMaybe<StringFilter>;
  stages?: InputMaybe<ObjectIdFilter>;
  strategyKpi?: InputMaybe<ObjectIdFilter>;
};

export type PcRoadmapStrategyKpiCategoryForStage = {
  __typename?: 'PcRoadmapStrategyKpiCategoryForStage';
  additionalDescription?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  reportingDescription?: Maybe<Scalars['String']['output']>;
  reportingDescriptionSource?: Maybe<Scalars['String']['output']>;
  stage: PcRoadmapStage;
  strategyKpiCategory: PcRoadmapStrategyKpiCategory;
};

export type PcRoadmapStrategyKpiFilter = {
  _and?: InputMaybe<Array<PcRoadmapStrategyKpiFilter>>;
  _id?: InputMaybe<ObjectIdFilter>;
  _or?: InputMaybe<Array<PcRoadmapStrategyKpiFilter>>;
  name?: InputMaybe<StringFilter>;
  stages?: InputMaybe<ObjectIdFilter>;
  strategyField?: InputMaybe<ObjectIdFilter>;
};

export type PcRoadmapStrategyKpiForStage = {
  __typename?: 'PcRoadmapStrategyKpiForStage';
  additionalDescription?: Maybe<Scalars['String']['output']>;
  applicableDocuments?: Maybe<Array<PcRoadmapApplicableDocument>>;
  description?: Maybe<Scalars['String']['output']>;
  furtherDetail?: Maybe<PcRoadmapFurtherDetail>;
  reportingDescription?: Maybe<Scalars['String']['output']>;
  reportingDescriptionSource?: Maybe<Scalars['String']['output']>;
  stage: PcRoadmapStage;
  strategyKpi: PcRoadmapStrategyKpi;
  strategyKpiCategories: Array<PcRoadmapStrategyKpiCategoryForStage>;
};


export type PcRoadmapStrategyKpiForStageApplicableDocumentsArgs = {
  filter?: InputMaybe<PcRoadmapApplicableDocumentFilter>;
};

export type PcRoadmapStrategyKpisInput = {
  filter?: InputMaybe<PcRoadmapStrategyKpiFilter>;
};

export type PcRoadmapTemplateVariable = {
  __typename?: 'PcRoadmapTemplateVariable';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PcRoadmapTemplateVariableInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type PcRoadmapTemplateVariablesByStageInput = {
  id: Scalars['ObjectID']['input'];
  variables: Array<PcRoadmapTemplateVariableInput>;
};

export type PcRoadmapValueByStageInput = {
  id: Scalars['ObjectID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PeerGroup = {
  __typename?: 'PeerGroup';
  /** ffmAlias: peerGroupId */
  id: Scalars['ObjectID']['output'];
  name: Scalars['String']['output'];
};

export type PeerGroupInput = {
  name: Scalars['String']['input'];
};

export type PeerGroupSort = {
  name?: InputMaybe<SortOrder>;
};

export type Person = {
  __typename?: 'Person';
  ability: Ability;
  acknowledgements?: Maybe<PersonAcknowledgements>;
  /** @deprecated Use userManagement instead. */
  additionalOrganizations?: Maybe<Array<OrganizationReference>>;
  /** @deprecated Field no longer supported */
  consents?: Maybe<PersonConsents>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Group>>;
  /** ffmAlias: personId */
  id: Scalars['BigInt']['output'];
  mail: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
  pagCurrentAccountStatus?: Maybe<Scalars['String']['output']>;
  pbeOnlyOrganizations?: Maybe<Array<OrganizationReference>>;
  peerGroups?: Maybe<Array<PeerGroup>>;
  ppnuid: Scalars['String']['output'];
  pseudonymized?: Maybe<Scalars['Boolean']['output']>;
  reportTabs?: Maybe<Array<ReportTab>>;
  roles: Array<Scalars['String']['output']>;
  settings?: Maybe<PersonSettings>;
  visibleCategories?: Maybe<Array<Category>>;
  visibleGroups?: Maybe<Array<Group>>;
  visibleOrganizations?: Maybe<Array<Organization>>;
};

export type PersonAcknowledgements = {
  __typename?: 'PersonAcknowledgements';
  emailNotificationsHint?: Maybe<PersonAcknowledgementsEmailNotificationsHint>;
  userDeletionConsent?: Maybe<Scalars['DateTime']['output']>;
};

export type PersonAcknowledgementsEmailNotificationsHint = {
  __typename?: 'PersonAcknowledgementsEmailNotificationsHint';
  APEX?: Maybe<Scalars['DateTime']['output']>;
  DASHBOARD?: Maybe<Scalars['DateTime']['output']>;
  FIELD_FORCE_MANAGEMENT?: Maybe<Scalars['DateTime']['output']>;
  GREENLAND?: Maybe<Scalars['DateTime']['output']>;
  MULTISENSORY_EXPERIENCE?: Maybe<Scalars['DateTime']['output']>;
  NETWORK_PLANNING?: Maybe<Scalars['DateTime']['output']>;
  PC_ROADMAP?: Maybe<Scalars['DateTime']['output']>;
  PORSCHE_STRATEGY_2030?: Maybe<Scalars['DateTime']['output']>;
  REAL_ESTATE?: Maybe<Scalars['DateTime']['output']>;
  RETAIL_DESIGN?: Maybe<Scalars['DateTime']['output']>;
  SURVEY?: Maybe<Scalars['DateTime']['output']>;
};

export type PersonAcknowledgementsEmailNotificationsHintInput = {
  APEX?: InputMaybe<Scalars['DateTime']['input']>;
  DASHBOARD?: InputMaybe<Scalars['DateTime']['input']>;
  FIELD_FORCE_MANAGEMENT?: InputMaybe<Scalars['DateTime']['input']>;
  GREENLAND?: InputMaybe<Scalars['DateTime']['input']>;
  MULTISENSORY_EXPERIENCE?: InputMaybe<Scalars['DateTime']['input']>;
  NETWORK_PLANNING?: InputMaybe<Scalars['DateTime']['input']>;
  PC_ROADMAP?: InputMaybe<Scalars['DateTime']['input']>;
  PORSCHE_STRATEGY_2030?: InputMaybe<Scalars['DateTime']['input']>;
  REAL_ESTATE?: InputMaybe<Scalars['DateTime']['input']>;
  RETAIL_DESIGN?: InputMaybe<Scalars['DateTime']['input']>;
  SURVEY?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PersonAcknowledgementsInput = {
  emailNotificationsHint?: InputMaybe<PersonAcknowledgementsEmailNotificationsHintInput>;
  userDeletionConsent?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PersonConsents = {
  __typename?: 'PersonConsents';
  userDeletion?: Maybe<Scalars['DateTime']['output']>;
};

export type PersonConsentsInput = {
  userDeletion?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PersonFilter = {
  _and?: InputMaybe<Array<InputMaybe<PersonFilter>>>;
  _id?: InputMaybe<BigIntFilter>;
  _or?: InputMaybe<Array<InputMaybe<PersonFilter>>>;
  deletedAt?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  organization_organizationId?: InputMaybe<BigIntFilter>;
  personId?: InputMaybe<BigIntFilter>;
  pseudonymized?: InputMaybe<BooleanFilter>;
  roles?: InputMaybe<StringArrayFilter>;
};

export type PersonReference = {
  __typename?: 'PersonReference';
  name: Scalars['String']['output'];
  organization?: Maybe<OrganizationReference>;
  personId: Scalars['BigInt']['output'];
};

export type PersonReferenceInput = {
  name: Scalars['String']['input'];
  organization?: InputMaybe<OrganizationReferenceInput>;
  personId: Scalars['BigInt']['input'];
};

export type PersonSettings = {
  __typename?: 'PersonSettings';
  /** @deprecated Gateway access only */
  _personId: Scalars['BigInt']['output'];
  actionItemListColumns: Array<Scalars['String']['output']>;
  dateFormat?: Maybe<Scalars['String']['output']>;
  defaultApprover?: Maybe<PersonReference>;
  defaultCurrency?: Maybe<Scalars['String']['output']>;
  emailReportTimezone?: Maybe<Scalars['String']['output']>;
  exportMode?: Maybe<Scalars['String']['output']>;
  is24HourFormat?: Maybe<Scalars['Boolean']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  meetingListColumns: Array<Scalars['String']['output']>;
  printMode?: Maybe<PrintMode>;
};

export type PersonSettingsInput = {
  dateFormat?: InputMaybe<Scalars['String']['input']>;
  defaultCurrency?: InputMaybe<Scalars['String']['input']>;
  emailReportTimezone?: InputMaybe<Scalars['String']['input']>;
  exportMode?: InputMaybe<Scalars['String']['input']>;
  is24HourFormat?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  printMode?: InputMaybe<PrintMode>;
};

export type PorscheImportAgreementsChangeRequest = {
  __typename?: 'PorscheImportAgreementsChangeRequest';
  adjustmentAt: Scalars['Date']['output'];
  adjustmentType: PorscheImportAgreementsChangeRequestAdjustmentType;
  approvals: Array<PorscheImportAgreementsChangeRequestApproval>;
  author: Person;
  deliveryTermsPartsDetails?: Maybe<PorscheImportAgreementsChangeRequestDeliveryTermsPartsDetails>;
  deliveryTermsVehiclesDetails?: Maybe<PorscheImportAgreementsChangeRequestDeliveryTermsVehiclesDetails>;
  emailsSentAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectID']['output'];
  managingDirectorDetails?: Maybe<PorscheImportAgreementsChangeRequestManagingDirectorDetails>;
  masterDataDetails?: Maybe<PorscheImportAgreementsChangeRequestMasterDataDetails>;
  organization: Organization;
  paymentTermsPartsDetails?: Maybe<PorscheImportAgreementsChangeRequestPaymentTermsPartsDetails>;
  paymentTermsVehiclesDetails?: Maybe<PorscheImportAgreementsChangeRequestPaymentTermsVehiclesDetails>;
  processNumber: Scalars['String']['output'];
  status: PorscheImportAgreementsChangeRequestStatus;
  switchoverAt: Scalars['Date']['output'];
  transferOfRiskVehiclesDetails?: Maybe<PorscheImportAgreementsChangeRequestTransferOfRiskVehiclesDetails>;
};

export enum PorscheImportAgreementsChangeRequestAdjustmentType {
  DeliveryTermsParts = 'DELIVERY_TERMS_PARTS',
  DeliveryTermsVehicles = 'DELIVERY_TERMS_VEHICLES',
  ManagingDirector = 'MANAGING_DIRECTOR',
  MasterData = 'MASTER_DATA',
  PaymentTermsParts = 'PAYMENT_TERMS_PARTS',
  PaymentTermsVehicles = 'PAYMENT_TERMS_VEHICLES',
  TransferOfRiskVehicles = 'TRANSFER_OF_RISK_VEHICLES'
}

export type PorscheImportAgreementsChangeRequestApproval = {
  __typename?: 'PorscheImportAgreementsChangeRequestApproval';
  comment?: Maybe<Scalars['String']['output']>;
  department?: Maybe<PorscheImportAgreementsChangeRequestApprovalDepartment>;
  emailSentAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectID']['output'];
  person?: Maybe<Person>;
  status: PorscheImportAgreementsChangeRequestApprovalStatus;
};

export enum PorscheImportAgreementsChangeRequestApprovalDepartment {
  Accounting = 'ACCOUNTING',
  AfterSales = 'AFTER_SALES',
  CreditCommittee = 'CREDIT_COMMITTEE',
  Insurance = 'INSURANCE',
  Logistics = 'LOGISTICS',
  PartnerRegistration = 'PARTNER_REGISTRATION',
  PartsLogistics = 'PARTS_LOGISTICS',
  RegionalOffice = 'REGIONAL_OFFICE',
  Sales = 'SALES',
  SalesControlling = 'SALES_CONTROLLING',
  SubsidiaryContact = 'SUBSIDIARY_CONTACT'
}

export enum PorscheImportAgreementsChangeRequestApprovalStatus {
  Approved = 'APPROVED',
  Open = 'OPEN',
  Rejected = 'REJECTED'
}

export type PorscheImportAgreementsChangeRequestDeliveryTermsPartsDetails = {
  __typename?: 'PorscheImportAgreementsChangeRequestDeliveryTermsPartsDetails';
  attachments: Array<Attachment>;
  comment?: Maybe<Scalars['String']['output']>;
  destinationCurrent: Scalars['String']['output'];
  destinationTarget: Scalars['String']['output'];
  incotermCurrent: PorscheImportAgreementsIncoterm;
  incotermTarget: PorscheImportAgreementsIncoterm;
};

export type PorscheImportAgreementsChangeRequestDeliveryTermsVehiclesDetails = {
  __typename?: 'PorscheImportAgreementsChangeRequestDeliveryTermsVehiclesDetails';
  attachments: Array<Attachment>;
  comment?: Maybe<Scalars['String']['output']>;
  destinationCurrent: Scalars['String']['output'];
  destinationTarget: Scalars['String']['output'];
  incotermCurrent: PorscheImportAgreementsIncoterm;
  incotermTarget: PorscheImportAgreementsIncoterm;
};

export type PorscheImportAgreementsChangeRequestManagingDirectorDetails = {
  __typename?: 'PorscheImportAgreementsChangeRequestManagingDirectorDetails';
  attachments: Array<Attachment>;
  externalPersonCurrent?: Maybe<Scalars['String']['output']>;
  externalPersonTarget?: Maybe<Scalars['String']['output']>;
  integritySearch: Scalars['Boolean']['output'];
  integritySearchHits?: Maybe<Scalars['Boolean']['output']>;
  personCurrent?: Maybe<Person>;
  personTarget?: Maybe<Person>;
};

export type PorscheImportAgreementsChangeRequestMasterDataDetails = {
  __typename?: 'PorscheImportAgreementsChangeRequestMasterDataDetails';
  businessCity?: Maybe<Scalars['String']['output']>;
  businessCompanyName?: Maybe<Scalars['String']['output']>;
  businessPostalCode?: Maybe<Scalars['String']['output']>;
  businessStreet?: Maybe<Scalars['String']['output']>;
  commercialRegister: Scalars['String']['output'];
  companyLegalName: Scalars['String']['output'];
  isBusinessAddressIdentical: Scalars['Boolean']['output'];
  registerCourt: Scalars['String']['output'];
  registeredCity: Scalars['String']['output'];
  registeredCompanyName: Scalars['String']['output'];
  registeredPostalCode: Scalars['String']['output'];
  registeredStreet: Scalars['String']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type PorscheImportAgreementsChangeRequestPaymentTermsPartsDetails = {
  __typename?: 'PorscheImportAgreementsChangeRequestPaymentTermsPartsDetails';
  attachments: Array<Attachment>;
  comment?: Maybe<Scalars['String']['output']>;
  paymentTermCurrent: PorscheImportAgreementsPaymentTerm;
  paymentTermTarget: PorscheImportAgreementsPaymentTerm;
};

export type PorscheImportAgreementsChangeRequestPaymentTermsVehiclesDetails = {
  __typename?: 'PorscheImportAgreementsChangeRequestPaymentTermsVehiclesDetails';
  attachments: Array<Attachment>;
  comment?: Maybe<Scalars['String']['output']>;
  paymentTermCurrent: PorscheImportAgreementsPaymentTerm;
  paymentTermTarget: PorscheImportAgreementsPaymentTerm;
};

export enum PorscheImportAgreementsChangeRequestStatus {
  Approved = 'APPROVED',
  PendingApproval = 'PENDING_APPROVAL',
  Rejected = 'REJECTED',
  Specification = 'SPECIFICATION'
}

export type PorscheImportAgreementsChangeRequestTransferOfRiskVehiclesDetails = {
  __typename?: 'PorscheImportAgreementsChangeRequestTransferOfRiskVehiclesDetails';
  attachments: Array<Attachment>;
  comment?: Maybe<Scalars['String']['output']>;
};

export type PorscheImportAgreementsEmailNotification = {
  __typename?: 'PorscheImportAgreementsEmailNotification';
  adhoc?: Maybe<Scalars['Boolean']['output']>;
  cron?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  person: Person;
  topic: PorscheImportAgreementsEmailNotificationTopic;
};

export enum PorscheImportAgreementsEmailNotificationTopic {
  PorscheImportAgreementsApproverAssigned = 'PORSCHE_IMPORT_AGREEMENTS_APPROVER_ASSIGNED'
}

export type PorscheImportAgreementsIncoterm = {
  __typename?: 'PorscheImportAgreementsIncoterm';
  id: Scalars['ObjectID']['output'];
  isActive: Scalars['Boolean']['output'];
  isAssigned: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type PorscheImportAgreementsIncotermFilter = {
  _and?: InputMaybe<Array<PorscheImportAgreementsIncotermFilter>>;
  _or?: InputMaybe<Array<PorscheImportAgreementsIncotermFilter>>;
  isActive?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
};

export type PorscheImportAgreementsIncotermsInput = {
  filter?: InputMaybe<PorscheImportAgreementsIncotermFilter>;
};

export type PorscheImportAgreementsPaymentTerm = {
  __typename?: 'PorscheImportAgreementsPaymentTerm';
  id: Scalars['ObjectID']['output'];
  isActive: Scalars['Boolean']['output'];
  isAssigned: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type PorscheImportAgreementsPaymentTermFilter = {
  _and?: InputMaybe<Array<PorscheImportAgreementsPaymentTermFilter>>;
  _or?: InputMaybe<Array<PorscheImportAgreementsPaymentTermFilter>>;
  isActive?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
};

export type PorscheImportAgreementsPaymentTermsInput = {
  filter?: InputMaybe<PorscheImportAgreementsPaymentTermFilter>;
};

export type PorscheStrategy2030EmailNotification = {
  __typename?: 'PorscheStrategy2030EmailNotification';
  adhoc?: Maybe<Scalars['Boolean']['output']>;
  cron?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  options?: Maybe<PorscheStrategy2030EmailNotificationOption>;
  person: Person;
  topic: PorscheStrategy2030EmailNotificationTopic;
};

export type PorscheStrategy2030EmailNotificationOption = {
  __typename?: 'PorscheStrategy2030EmailNotificationOption';
  includeMyChanges?: Maybe<Scalars['Boolean']['output']>;
  strategyActionItemAssignedAsResponsible?: Maybe<Scalars['Boolean']['output']>;
  strategyActionItemCommentedOn?: Maybe<Scalars['Boolean']['output']>;
  strategyActionItemFinished?: Maybe<Scalars['Boolean']['output']>;
};

export type PorscheStrategy2030EmailNotificationOptionInput = {
  includeMyChanges?: InputMaybe<Scalars['Boolean']['input']>;
  strategyActionItemAssignedAsResponsible?: InputMaybe<Scalars['Boolean']['input']>;
  strategyActionItemCommentedOn?: InputMaybe<Scalars['Boolean']['input']>;
  strategyActionItemFinished?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PorscheStrategy2030EmailNotificationTopic {
  PorscheStrategy_2030StrategyActionItemEvents = 'PORSCHE_STRATEGY_2030_STRATEGY_ACTION_ITEM_EVENTS'
}

export type PpnMasterdataImportStatus = {
  __typename?: 'PpnMasterdataImportStatus';
  error?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  groupsFinishedAt?: Maybe<Scalars['DateTime']['output']>;
  isRunning: Scalars['Boolean']['output'];
  organizationsFinishedAt?: Maybe<Scalars['DateTime']['output']>;
  personsFinishedAt?: Maybe<Scalars['DateTime']['output']>;
  startedAt: Scalars['DateTime']['output'];
};

export type PresignedUpload = {
  __typename?: 'PresignedUpload';
  fields: Scalars['JSON']['output'];
  id: Scalars['ObjectID']['output'];
  url: Scalars['String']['output'];
};

export enum PrintMode {
  Full = 'full',
  Minimal = 'minimal'
}

export type ProfitPotential = {
  __typename?: 'ProfitPotential';
  organization: OrganizationReference;
  profitPotentialCurrency?: Maybe<Scalars['String']['output']>;
  profitPotentialIdentified: Scalars['Float']['output'];
  profitPotentialNotPossible: Scalars['Float']['output'];
  profitPotentialRealized: Scalars['Float']['output'];
};

export type ProfitPotentialRaw = {
  __typename?: 'ProfitPotentialRaw';
  identified: Array<Maybe<ActionItem>>;
  notPossible: Array<Maybe<ActionItem>>;
  realized: Array<Maybe<ActionItem>>;
};

export type Query = {
  __typename?: 'Query';
  _ability: Ability;
  _coachingModules: Array<Maybe<CoachingModule>>;
  _organizations: Array<Maybe<Organization>>;
  _personSettings: PersonSettings;
  _persons: Array<Maybe<Person>>;
  actionItem?: Maybe<ActionItem>;
  actionItemStatistic: Array<Maybe<ActionItemStatistic>>;
  actionItemSunburst?: Maybe<Sunburst>;
  actionItems: PaginatedActionItems;
  actionItemsByCategory: ActionItemsByCategory;
  actionItemsByStatus: Array<ActionItemCountByStatus>;
  /** @deprecated Use meetingsPaginated instead */
  allMeetings: PaginatedMeetings;
  analytics?: Maybe<Array<Analytics>>;
  announcements: Array<Announcement>;
  apexEmailNotifications: Array<ApexEmailNotification>;
  apexImportSchedule?: Maybe<ApexImportSchedule>;
  apexImportState?: Maybe<ApexImportState>;
  apexQuestionnaire?: Maybe<ApexQuestionnaire>;
  apexQuestionnaires: Array<ApexQuestionnaire>;
  apexResult?: Maybe<ApexResult>;
  apexResults: Array<ApexResult>;
  audit?: Maybe<Audit>;
  audits: PaginatedAudits;
  auditsForActionItem: PaginatedAudits;
  categories?: Maybe<Array<Category>>;
  category?: Maybe<Category>;
  cities: Array<Scalars['String']['output']>;
  coachingModule?: Maybe<CoachingModule>;
  coachingModules: Array<CoachingModule>;
  countries: Array<Scalars['String']['output']>;
  customReporting?: Maybe<Array<CustomReportingData>>;
  dashboardEmailNotifications: Array<DashboardEmailNotification>;
  exchangeRate?: Maybe<ExchangeRate>;
  exchangeRates?: Maybe<Array<ExchangeRate>>;
  featureArticle?: Maybe<FeatureArticle>;
  featureArticles: Array<FeatureArticle>;
  fieldForceManagementCalendarExport?: Maybe<FieldForceManagementCalendarExport>;
  fieldForceManagementDashboardWidgets: Array<FieldForceManagementDashboardWidget>;
  fieldForceManagementEmailNotifications: Array<FieldForceManagementEmailNotification>;
  fieldForceManagementFeatureFlag?: Maybe<FieldForceManagementFeatureFlag>;
  fieldForceManagementFeatureFlags: Array<FieldForceManagementFeatureFlag>;
  fieldForceManagementFilterPresets?: Maybe<Array<FieldForceManagementFilterPreset>>;
  /** @deprecated Field no longer supported */
  findOrganizations: Array<Organization>;
  geoRegions: Array<Scalars['String']['output']>;
  getActionItemTemplate?: Maybe<ActionItemTemplate>;
  getActionItemTemplates: Array<ActionItemTemplate>;
  getAllGroups?: Maybe<Array<Group>>;
  getAllGroupsWithVisibleGroups?: Maybe<Array<Group>>;
  getAllHelpArticles: PaginatedHelpArticles;
  getAllHelpArticlesForUser: PaginatedHelpArticles;
  getConsultingMeetingType?: Maybe<ConsultingMeetingType>;
  getConsultingMeetingTypes?: Maybe<Array<ConsultingMeetingType>>;
  /** @deprecated Use exchangeRate instead. */
  getExchangeRate?: Maybe<ExchangeRate>;
  /** @deprecated Use exchangeRates instead. */
  getExchangeRates?: Maybe<Array<ExchangeRate>>;
  getHelpArticle?: Maybe<HelpArticle>;
  /** @deprecated Use meeting instead */
  getMeeting?: Maybe<Meeting>;
  /** @deprecated Field no longer supported */
  getOrganization?: Maybe<Organization>;
  getOrganizationsCount: Scalars['Int']['output'];
  /** @deprecated Field no longer supported */
  getOrganizationsForUser?: Maybe<PaginatedOrganizations>;
  getPbeIrisKpi?: Maybe<PbeIrisKpi>;
  getPbeIrisKpis?: Maybe<Array<PbeIrisKpi>>;
  getPeerGroups: Array<PeerGroup>;
  /** @deprecated Use person instead */
  getPerson?: Maybe<Person>;
  getPersonsCountForOfflineSync: Scalars['Int']['output'];
  /** @deprecated Use persons query instead */
  getPersonsForOfflineSync?: Maybe<Array<Person>>;
  getPersonsWithPbeOnlyOrgs?: Maybe<Array<Person>>;
  getPersonsWithPeerGroups: Array<Maybe<Person>>;
  kpiUnit?: Maybe<KpiUnit>;
  kpiUnitCategories?: Maybe<Array<KpiUnitCategory>>;
  kpiUnitCategory?: Maybe<KpiUnitCategory>;
  kpiUnits?: Maybe<Array<KpiUnit>>;
  markets: Array<Scalars['String']['output']>;
  me: Login;
  meeting?: Maybe<Meeting>;
  meetingStatistic: Array<Maybe<MeetingStatistic>>;
  meetingSunburst?: Maybe<Sunburst>;
  meetingsPaginated: FieldForceManagementMeetingConnection;
  multisensoryExperience?: Maybe<MultisensoryExperience>;
  multisensoryExperienceArea?: Maybe<MultisensoryExperienceArea>;
  multisensoryExperienceAreas: Array<MultisensoryExperienceArea>;
  multisensoryExperienceBundle?: Maybe<MultisensoryExperienceBundle>;
  multisensoryExperienceBundles: Array<MultisensoryExperienceBundle>;
  multisensoryExperienceEmailNotifications: Array<MultisensoryExperienceEmailNotification>;
  multisensoryExperienceFilterPresets?: Maybe<Array<MultisensoryExperienceFilterPreset>>;
  multisensoryExperienceItem?: Maybe<MultisensoryExperienceItem>;
  multisensoryExperienceItems: Array<MultisensoryExperienceItem>;
  multisensoryExperienceMeasure?: Maybe<MultisensoryExperienceMeasure>;
  multisensoryExperienceMeasureTask?: Maybe<MultisensoryExperienceMeasureTask>;
  multisensoryExperienceMeasureTasks: Array<MultisensoryExperienceMeasureTask>;
  multisensoryExperienceMeasures: Array<MultisensoryExperienceMeasure>;
  multisensoryExperiences: Array<MultisensoryExperience>;
  networkPlanningEmailNotifications: Array<NetworkPlanningEmailNotification>;
  networkPlanningFeatureFlag?: Maybe<NetworkPlanningFeatureFlag>;
  networkPlanningFeatureFlags: Array<NetworkPlanningFeatureFlag>;
  networkPlanningInvestors: Array<Scalars['String']['output']>;
  networkPlanningOrganizations: Array<Maybe<NetworkPlanningOrganization>>;
  occasionRelatedApproval?: Maybe<OccasionRelatedApproval>;
  occasionRelatedApprovalReports: Array<Maybe<Scalars['String']['output']>>;
  occasionRelatedApprovals: Array<OccasionRelatedApproval>;
  organization?: Maybe<Organization>;
  organizations: PaginatedOrganizations;
  pcRoadmapActionItem?: Maybe<PcRoadmapActionItem>;
  pcRoadmapAdditionalAgreement?: Maybe<PcRoadmapAdditionalAgreementElement>;
  pcRoadmapAdditionalAgreements: Array<PcRoadmapAdditionalAgreementElement>;
  pcRoadmapApplicableDocument?: Maybe<PcRoadmapApplicableDocument>;
  pcRoadmapApplicableDocuments: Array<PcRoadmapApplicableDocument>;
  pcRoadmapCommitment?: Maybe<PcRoadmapCommitment>;
  pcRoadmapCommitments: Array<PcRoadmapCommitment>;
  pcRoadmapFurtherDetail?: Maybe<PcRoadmapFurtherDetail>;
  pcRoadmapFurtherDetails: Array<PcRoadmapFurtherDetail>;
  pcRoadmapReportingDescriptionSources: Array<Scalars['String']['output']>;
  pcRoadmapReports: Array<PcRoadmapReport>;
  pcRoadmapStage?: Maybe<PcRoadmapStage>;
  pcRoadmapStages: Array<PcRoadmapStage>;
  pcRoadmapStrategyField?: Maybe<PcRoadmapStrategyField>;
  pcRoadmapStrategyFields: Array<PcRoadmapStrategyField>;
  pcRoadmapStrategyKpi?: Maybe<PcRoadmapStrategyKpi>;
  pcRoadmapStrategyKpiCategories: Array<PcRoadmapStrategyKpiCategory>;
  pcRoadmapStrategyKpiCategory?: Maybe<PcRoadmapStrategyKpiCategory>;
  pcRoadmapStrategyKpis: Array<PcRoadmapStrategyKpi>;
  person?: Maybe<Person>;
  persons: PaginatedPersons;
  porscheImportAgreementsChangeRequest?: Maybe<PorscheImportAgreementsChangeRequest>;
  porscheImportAgreementsChangeRequests: Array<PorscheImportAgreementsChangeRequest>;
  porscheImportAgreementsEmailNotifications: Array<PorscheImportAgreementsEmailNotification>;
  porscheImportAgreementsIncoterm?: Maybe<PorscheImportAgreementsIncoterm>;
  porscheImportAgreementsIncoterms: Array<PorscheImportAgreementsIncoterm>;
  porscheImportAgreementsPaymentTerm?: Maybe<PorscheImportAgreementsPaymentTerm>;
  porscheImportAgreementsPaymentTerms: Array<PorscheImportAgreementsPaymentTerm>;
  porscheStrategy2030EmailNotifications: Array<PorscheStrategy2030EmailNotification>;
  ppnMasterdataImportStatus?: Maybe<PpnMasterdataImportStatus>;
  profitPotential: Array<ProfitPotential>;
  profitPotentialRaw: ProfitPotentialRaw;
  questionnaire?: Maybe<Questionnaire>;
  questionnaireForAdminArea?: Maybe<Questionnaire>;
  questionnaireRoadToXReport: QuestionnaireRoadToXReport;
  questionnaireTypeConfig?: Maybe<QuestionnaireTypeConfig>;
  questionnaireTypeConfigs: PaginatedQuestionnaireTypeConfig;
  questionnaires: PaginatedQuestionnaires;
  questionnairesForActionItem: PaginatedQuestionnaires;
  questionnairesForAdminArea: PaginatedQuestionnaires;
  realEstateProperties: Array<RealEstateProperty>;
  realEstatePropertiesPaginated: RealEstatePropertiesPaginated;
  realEstateProperty?: Maybe<RealEstateProperty>;
  regions: Array<Scalars['String']['output']>;
  retailDesignAbsenceNotes: Array<RetailDesignAbsenceNote>;
  retailDesignCities: Array<Scalars['String']['output']>;
  retailDesignDocument?: Maybe<RetailDesignDocument>;
  retailDesignDocuments: Array<RetailDesignDocument>;
  retailDesignEmailNotifications: Array<RetailDesignEmailNotification>;
  retailDesignFilterPresets?: Maybe<Array<RetailDesignFilterPreset>>;
  retailDesignFormat?: Maybe<RetailDesignFormat>;
  retailDesignFormats: Array<RetailDesignFormat>;
  retailDesignInvestors: Array<Scalars['String']['output']>;
  retailDesignProject?: Maybe<RetailDesignProject>;
  retailDesignProjectType?: Maybe<RetailDesignProjectType>;
  retailDesignProjectTypes: Array<RetailDesignProjectType>;
  retailDesignProjects: Array<RetailDesignProject>;
  strategyActionItem?: Maybe<StrategyActionItem>;
  strategyActionItems?: Maybe<Array<Maybe<StrategyActionItem>>>;
  strategyField?: Maybe<StrategyField>;
  strategyFields: Array<StrategyField>;
  strategyImpact?: Maybe<StrategyImpact>;
  strategyImpacts?: Maybe<Array<StrategyImpact>>;
  strategyKpi?: Maybe<StrategyKpi>;
  strategyKpiCategories: Array<StrategyKpiCategory>;
  strategyKpiCategory?: Maybe<StrategyKpiCategory>;
  strategyKpis: Array<StrategyKpi>;
  strategyStage?: Maybe<StrategyStage>;
  strategyStages: Array<StrategyStage>;
  supportRequest?: Maybe<SupportRequest>;
  supportRequests: Array<SupportRequest>;
  survey?: Maybe<Survey>;
  surveyAnswer: SurveyAnswer;
  surveyEmailNotifications: Array<SurveyEmailNotification>;
  surveyInstances: SurveyInstanceConnection;
  surveyPredefinedItem?: Maybe<SurveyPredefinedItem>;
  surveyPredefinedItems: Array<SurveyPredefinedItem>;
  surveyReportConfig?: Maybe<SurveyReportConfig>;
  surveyReportConfigs: Array<SurveyReportConfig>;
  surveyResult?: Maybe<SurveyResult>;
  surveyResults: Array<SurveyResult>;
  surveyResultsByItem: SurveyResultsByItemConnection;
  surveyResultsByItemOverTime: Array<SurveyResultsByItemOverTimeNode>;
  surveyResultsByOrganization: SurveyResultsByOrganizationConnection;
  surveyResultsByOrganizationOverTime: Array<SurveyResultsByOrganizationOverTimeNode>;
  surveyTableConfig?: Maybe<SurveyTableConfig>;
  surveyTemplate?: Maybe<SurveyTemplate>;
  surveyTemplates: Array<SurveyTemplate>;
  surveyType?: Maybe<SurveyType>;
  surveyTypes: Array<SurveyType>;
  surveys: Array<Survey>;
  tags: Array<Scalars['String']['output']>;
  topLevelOrganizations: Array<Organization>;
  userFeedbacks: Array<UserFeedback>;
  userManagementItem?: Maybe<UserManagementItem>;
  userManagementItems: Array<UserManagementItem>;
};


export type Query_AbilityArgs = {
  key: Scalars['_Key']['input'];
};


export type Query_CoachingModulesArgs = {
  keys: Array<Scalars['_Key']['input']>;
};


export type Query_OrganizationsArgs = {
  keys: Array<Scalars['_Key']['input']>;
};


export type Query_PersonSettingsArgs = {
  key: Scalars['_Key']['input'];
};


export type Query_PersonsArgs = {
  keys: Array<Scalars['_Key']['input']>;
};


export type QueryActionItemArgs = {
  id: Scalars['ObjectID']['input'];
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
};


export type QueryActionItemStatisticArgs = {
  input: ActionItemStatisticInput;
};


export type QueryActionItemSunburstArgs = {
  filter?: InputMaybe<ActionItemFilter>;
  rootOrgaIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryActionItemsArgs = {
  filter?: InputMaybe<ActionItemFilter>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ActionItemSort>;
};


export type QueryActionItemsByCategoryArgs = {
  filter?: InputMaybe<ActionItemFilter>;
  rootOrgaIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryActionItemsByStatusArgs = {
  filter?: InputMaybe<ActionItemFilter>;
};


export type QueryAllMeetingsArgs = {
  distinct?: InputMaybe<MeetingDistinctBy>;
  filter?: InputMaybe<MeetingFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<MeetingSort>;
};


export type QueryAnalyticsArgs = {
  input: AnalyticsInput;
};


export type QueryApexQuestionnaireArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryApexResultArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryApexResultsArgs = {
  filter?: InputMaybe<ApexResultFilterInput>;
};


export type QueryAuditArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryAuditsArgs = {
  filter?: InputMaybe<AuditFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AuditSort>;
};


export type QueryAuditsForActionItemArgs = {
  actionItemId: Scalars['ObjectID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AuditSort>;
};


export type QueryCategoryArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryCoachingModuleArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryCoachingModulesArgs = {
  input?: InputMaybe<CoachingModulesInput>;
};


export type QueryCountriesArgs = {
  filter?: InputMaybe<CountryFilter>;
};


export type QueryCustomReportingArgs = {
  entity: ChartEntity;
  filter: ChartFilter;
  properties: ChartProperties;
  reportType?: InputMaybe<ReportType>;
  type: ChartType;
};


export type QueryDashboardEmailNotificationsArgs = {
  topic?: InputMaybe<DashboardEmailNotificationTopic>;
};


export type QueryExchangeRateArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryFeatureArticleArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryFieldForceManagementEmailNotificationsArgs = {
  topic?: InputMaybe<FieldForceManagementEmailNotificationTopic>;
};


export type QueryFieldForceManagementFeatureFlagArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryFieldForceManagementFilterPresetsArgs = {
  filter?: InputMaybe<FieldForceManagementFilterPresetsFilter>;
};


export type QueryFindOrganizationsArgs = {
  searchString: Scalars['String']['input'];
};


export type QueryGeoRegionsArgs = {
  filter?: InputMaybe<GeoRegionFilter>;
};


export type QueryGetActionItemTemplateArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryGetAllGroupsArgs = {
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllHelpArticlesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<HelpArticleSort>;
};


export type QueryGetAllHelpArticlesForUserArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<HelpArticleType>;
};


export type QueryGetConsultingMeetingTypeArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryGetExchangeRateArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryGetHelpArticleArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryGetMeetingArgs = {
  id: Scalars['ObjectID']['input'];
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
};


export type QueryGetOrganizationArgs = {
  id: Scalars['BigInt']['input'];
};


export type QueryGetOrganizationsForUserArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetPbeIrisKpiArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryGetPbeIrisKpisArgs = {
  filter?: InputMaybe<PbeIrisFilter>;
};


export type QueryGetPeerGroupsArgs = {
  sort?: InputMaybe<PeerGroupSort>;
};


export type QueryGetPersonArgs = {
  id: Scalars['BigInt']['input'];
};


export type QueryGetPersonsForOfflineSyncArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryKpiUnitArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryKpiUnitCategoriesArgs = {
  input?: InputMaybe<KpiUnitCategoriesInput>;
};


export type QueryKpiUnitCategoryArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryMarketsArgs = {
  filter?: InputMaybe<MarketFilter>;
};


export type QueryMeetingArgs = {
  id: Scalars['ObjectID']['input'];
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
};


export type QueryMeetingStatisticArgs = {
  input: MeetingStatisticInput;
};


export type QueryMeetingSunburstArgs = {
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MeetingFilter>;
  rootOrgaId?: InputMaybe<Scalars['Int']['input']>;
  rootOrgaIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryMeetingsPaginatedArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<MeetingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<SortOrder>;
  orderBy?: InputMaybe<MeetingOrderBy>;
};


export type QueryMultisensoryExperienceArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryMultisensoryExperienceAreaArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryMultisensoryExperienceAreasArgs = {
  input?: InputMaybe<MultisensoryExperienceAreasInput>;
};


export type QueryMultisensoryExperienceBundleArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryMultisensoryExperienceBundlesArgs = {
  input?: InputMaybe<MultisensoryExperienceBundlesInput>;
};


export type QueryMultisensoryExperienceItemArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryMultisensoryExperienceItemsArgs = {
  input?: InputMaybe<MultisensoryExperienceItemsInput>;
};


export type QueryMultisensoryExperienceMeasureArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryMultisensoryExperienceMeasureTaskArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryMultisensoryExperienceMeasureTasksArgs = {
  input?: InputMaybe<MultisensoryExperienceMeasureTasksInput>;
};


export type QueryMultisensoryExperienceMeasuresArgs = {
  input?: InputMaybe<MultisensoryExperienceMeasuresInput>;
};


export type QueryMultisensoryExperiencesArgs = {
  input?: InputMaybe<MultisensoryExperiencesInput>;
};


export type QueryNetworkPlanningFeatureFlagArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryNetworkPlanningInvestorsArgs = {
  filter?: InputMaybe<NetworkPlanningOrganizationInvestorFilter>;
};


export type QueryNetworkPlanningOrganizationsArgs = {
  filter?: InputMaybe<NetworkPlanningOrganizationFilterInput>;
};


export type QueryOccasionRelatedApprovalArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryOrganizationArgs = {
  id?: InputMaybe<Scalars['BigInt']['input']>;
};


export type QueryOrganizationsArgs = {
  filter?: InputMaybe<OrganizationFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPcRoadmapActionItemArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryPcRoadmapAdditionalAgreementArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryPcRoadmapAdditionalAgreementsArgs = {
  input?: InputMaybe<PcRoadmapAdditionalAgreementsInput>;
};


export type QueryPcRoadmapApplicableDocumentArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryPcRoadmapCommitmentArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryPcRoadmapCommitmentsArgs = {
  input?: InputMaybe<PcRoadmapCommitmentsInput>;
};


export type QueryPcRoadmapFurtherDetailArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryPcRoadmapReportsArgs = {
  input?: InputMaybe<PcRoadmapReportsInput>;
};


export type QueryPcRoadmapStageArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryPcRoadmapStagesArgs = {
  input?: InputMaybe<PcRoadmapStagesInput>;
};


export type QueryPcRoadmapStrategyFieldArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryPcRoadmapStrategyFieldsArgs = {
  input?: InputMaybe<PcRoadmapStrategyFieldsInput>;
};


export type QueryPcRoadmapStrategyKpiArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryPcRoadmapStrategyKpiCategoriesArgs = {
  input?: InputMaybe<PcRoadmapStrategyKpiCategoriesInput>;
};


export type QueryPcRoadmapStrategyKpiCategoryArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryPcRoadmapStrategyKpisArgs = {
  input?: InputMaybe<PcRoadmapStrategyKpisInput>;
};


export type QueryPersonArgs = {
  id?: InputMaybe<Scalars['BigInt']['input']>;
  ppnuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPersonsArgs = {
  filter?: InputMaybe<PersonFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPorscheImportAgreementsChangeRequestArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryPorscheImportAgreementsIncotermArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryPorscheImportAgreementsIncotermsArgs = {
  input?: InputMaybe<PorscheImportAgreementsIncotermsInput>;
};


export type QueryPorscheImportAgreementsPaymentTermArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryPorscheImportAgreementsPaymentTermsArgs = {
  input?: InputMaybe<PorscheImportAgreementsPaymentTermsInput>;
};


export type QueryPorscheStrategy2030EmailNotificationsArgs = {
  topic?: InputMaybe<PorscheStrategy2030EmailNotificationTopic>;
};


export type QueryProfitPotentialArgs = {
  currency?: InputMaybe<Currency>;
  endDate: Scalars['DateTime']['input'];
  kind?: InputMaybe<ActionItemKind>;
  organizationIds?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  startDate: Scalars['DateTime']['input'];
};


export type QueryProfitPotentialRawArgs = {
  currency?: InputMaybe<Currency>;
  endDate: Scalars['DateTime']['input'];
  kind?: InputMaybe<ActionItemKind>;
  organizationIds: Array<Scalars['BigInt']['input']>;
  startDate: Scalars['DateTime']['input'];
};


export type QueryQuestionnaireArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryQuestionnaireForAdminAreaArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryQuestionnaireRoadToXReportArgs = {
  organizationId: Scalars['BigInt']['input'];
};


export type QueryQuestionnaireTypeConfigArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryQuestionnaireTypeConfigsArgs = {
  filter?: InputMaybe<QuestionnaireTypeConfigFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<QuestionnaireTypeConfigSort>;
};


export type QueryQuestionnairesArgs = {
  filter?: InputMaybe<QuestionnaireFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<QuestionnaireSort>;
};


export type QueryQuestionnairesForActionItemArgs = {
  actionItemId: Scalars['ObjectID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<QuestionnaireSort>;
};


export type QueryQuestionnairesForAdminAreaArgs = {
  filter?: InputMaybe<QuestionnaireFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<QuestionnaireSort>;
};


export type QueryRealEstatePropertiesArgs = {
  filter?: InputMaybe<RealEstatePropertyFilterInput>;
};


export type QueryRealEstatePropertiesPaginatedArgs = {
  filter?: InputMaybe<RealEstatePropertyFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRealEstatePropertyArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryRetailDesignCitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRetailDesignDocumentArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryRetailDesignFormatArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryRetailDesignFormatsArgs = {
  input?: InputMaybe<RetailDesignFormatsInput>;
};


export type QueryRetailDesignProjectArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryRetailDesignProjectTypeArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryRetailDesignProjectsArgs = {
  input?: InputMaybe<RetailDesignProjectsInput>;
};


export type QueryStrategyActionItemArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryStrategyActionItemsArgs = {
  input?: InputMaybe<StrategyActionItemsInput>;
};


export type QueryStrategyFieldArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryStrategyFieldsArgs = {
  input?: InputMaybe<StrategyFieldsFilterInput>;
};


export type QueryStrategyImpactArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryStrategyImpactsArgs = {
  input?: InputMaybe<StrategyImpactsInput>;
};


export type QueryStrategyKpiArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryStrategyKpiCategoriesArgs = {
  input?: InputMaybe<StrategyKpiCategoriesInput>;
};


export type QueryStrategyKpiCategoryArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryStrategyKpisArgs = {
  input?: InputMaybe<StrategyKpisInput>;
};


export type QueryStrategyStageArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryStrategyStagesArgs = {
  input?: InputMaybe<StrategyStagesFilterInput>;
};


export type QuerySupportRequestArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QuerySurveyArgs = {
  id: Scalars['ObjectID']['input'];
  period?: InputMaybe<Scalars['Date']['input']>;
};


export type QuerySurveyAnswerArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QuerySurveyInstancesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<SurveyInstanceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<SortOrder>;
  orderBy?: InputMaybe<SurveyInstanceOrderBy>;
};


export type QuerySurveyPredefinedItemArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QuerySurveyPredefinedItemsArgs = {
  filter?: InputMaybe<SurveyPredefinedItemFilterInput>;
};


export type QuerySurveyReportConfigArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QuerySurveyResultArgs = {
  answeredFor: Scalars['SurveyAnsweredFor']['input'];
  period?: InputMaybe<Scalars['Date']['input']>;
  surveyId: Scalars['ObjectID']['input'];
};


export type QuerySurveyResultsArgs = {
  surveyId: Scalars['ObjectID']['input'];
};


export type QuerySurveyResultsByItemArgs = {
  input: SurveyResultsByItemInput;
};


export type QuerySurveyResultsByItemOverTimeArgs = {
  input: SurveyResultsByItemOverTimeInput;
};


export type QuerySurveyResultsByOrganizationArgs = {
  input: SurveyResultsByOrganizationInput;
};


export type QuerySurveyResultsByOrganizationOverTimeArgs = {
  input: SurveyResultsByOrganizationOverTimeInput;
};


export type QuerySurveyTableConfigArgs = {
  table: SurveyTable;
};


export type QuerySurveyTemplateArgs = {
  id: Scalars['ObjectID']['input'];
  options?: InputMaybe<SurveyTemplateOptionsInput>;
};


export type QuerySurveyTypeArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QuerySurveysArgs = {
  filter?: InputMaybe<SurveyFilter>;
};


export type QueryTagsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserManagementItemArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryUserManagementItemsArgs = {
  input?: InputMaybe<UserManagementItemsInput>;
};

export type Questionnaire = {
  __typename?: 'Questionnaire';
  additionalPersons?: Maybe<Array<Person>>;
  allowMultipleAssignments?: Maybe<Scalars['Boolean']['output']>;
  allowMultipleAssignmentsForPerson?: Maybe<Scalars['Boolean']['output']>;
  author: PersonReference;
  children: Array<QuestionnaireItem>;
  copiedFrom?: Maybe<Scalars['ObjectID']['output']>;
  copyAnswersActionItemId?: Maybe<Scalars['ObjectID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** ffmAlias: questionnaireId */
  id: Scalars['ObjectID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isAssigned?: Maybe<Scalars['Boolean']['output']>;
  languages: Array<Scalars['String']['output']>;
  name: Scalars['JSON']['output'];
  organizations: Array<Organization>;
  type: QuestionnaireType;
};


export type QuestionnaireCopyAnswersActionItemIdArgs = {
  actionItemId: Scalars['ObjectID']['input'];
};

export type QuestionnaireAnswer = {
  item: QuestionnaireItem;
};

export type QuestionnaireAnswerInput = {
  currencyAnswer?: InputMaybe<QuestionnaireCurrencyAnswerInput>;
  itemId: Scalars['ObjectID']['input'];
  kind: AnswerType;
  multipleChoiceAnswer?: InputMaybe<QuestionnaireMultipleChoiceAnswerInput>;
  notApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  textAnswer?: InputMaybe<QuestionnaireTextAnswerInput>;
  yesNoAnswer?: InputMaybe<QuestionnaireYesNoAnswerInput>;
};

export type QuestionnaireCurrencyAnswer = QuestionnaireAnswer & {
  __typename?: 'QuestionnaireCurrencyAnswer';
  answer?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  followUp?: Maybe<Scalars['Boolean']['output']>;
  item: QuestionnaireItem;
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  uploads?: Maybe<Array<Attachment>>;
};

export type QuestionnaireCurrencyAnswerInput = {
  answer?: InputMaybe<Scalars['Float']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  followUp?: InputMaybe<Scalars['Boolean']['input']>;
  notApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  uploads?: InputMaybe<Array<AttachmentInput>>;
};

export type QuestionnaireCurrencyQuestion = QuestionnaireItem & {
  __typename?: 'QuestionnaireCurrencyQuestion';
  allowComment?: Maybe<Scalars['Boolean']['output']>;
  allowFollowUp?: Maybe<Scalars['Boolean']['output']>;
  allowNotApplicable?: Maybe<Scalars['Boolean']['output']>;
  allowUpload?: Maybe<Scalars['Boolean']['output']>;
  attachments?: Maybe<Scalars['JSON']['output']>;
  currency: Currency;
  description?: Maybe<Scalars['JSON']['output']>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  /** ffmAlias: itemId */
  id: Scalars['ObjectID']['output'];
  isCopied?: Maybe<Scalars['Boolean']['output']>;
  kind: QuestionnaireItemKind;
  question: Scalars['JSON']['output'];
};

export type QuestionnaireFilter = {
  _and?: InputMaybe<Array<InputMaybe<QuestionnaireFilter>>>;
  _or?: InputMaybe<Array<InputMaybe<QuestionnaireFilter>>>;
  author_personId?: InputMaybe<BigIntFilter>;
  isActive?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<TranslationFilter>;
  organizations_organizationId?: InputMaybe<BigIntFilter>;
  type?: InputMaybe<QuestionnaireTypeFilter>;
};

export type QuestionnaireInput = {
  additionalPersons?: InputMaybe<Array<PersonReferenceInput>>;
  allowMultipleAssignments?: InputMaybe<Scalars['Boolean']['input']>;
  allowMultipleAssignmentsForPerson?: InputMaybe<Scalars['Boolean']['input']>;
  children?: InputMaybe<Array<QuestionnaireItemInput>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['JSON']['input']>;
  organizations?: InputMaybe<Array<OrganizationReferenceInput>>;
  type?: InputMaybe<QuestionnaireType>;
};

export type QuestionnaireItem = {
  /** ffmAlias: itemId */
  id: Scalars['ObjectID']['output'];
  kind: QuestionnaireItemKind;
};

export type QuestionnaireItemInput = {
  allowComment?: InputMaybe<Scalars['Boolean']['input']>;
  allowFollowUp?: InputMaybe<Scalars['Boolean']['input']>;
  allowNotApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  allowUpload?: InputMaybe<Scalars['Boolean']['input']>;
  attachments?: InputMaybe<Scalars['JSON']['input']>;
  choiceType?: InputMaybe<ChoiceType>;
  choices?: InputMaybe<Array<ChoiceInput>>;
  currency?: InputMaybe<Currency>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ObjectID']['input'];
  isCopied?: InputMaybe<Scalars['Boolean']['input']>;
  kind: QuestionnaireItemKind;
  level?: InputMaybe<Scalars['Int']['input']>;
  question?: InputMaybe<Scalars['JSON']['input']>;
  requireComment?: InputMaybe<Scalars['Boolean']['input']>;
  requireCommentForYes?: InputMaybe<Scalars['Boolean']['input']>;
  requireUpload?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['JSON']['input']>;
};

export enum QuestionnaireItemKind {
  QuestionnaireCurrencyQuestion = 'QuestionnaireCurrencyQuestion',
  QuestionnaireMultipleChoiceQuestion = 'QuestionnaireMultipleChoiceQuestion',
  QuestionnaireSection = 'QuestionnaireSection',
  QuestionnaireTextQuestion = 'QuestionnaireTextQuestion',
  QuestionnaireYesNoQuestion = 'QuestionnaireYesNoQuestion'
}

export type QuestionnaireMultipleChoiceAnswer = QuestionnaireAnswer & {
  __typename?: 'QuestionnaireMultipleChoiceAnswer';
  answers?: Maybe<Array<Choice>>;
  comment?: Maybe<Scalars['String']['output']>;
  followUp?: Maybe<Scalars['Boolean']['output']>;
  item: QuestionnaireItem;
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  uploads?: Maybe<Array<Attachment>>;
};

export type QuestionnaireMultipleChoiceAnswerInput = {
  choiceIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  followUp?: InputMaybe<Scalars['Boolean']['input']>;
  notApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  uploads?: InputMaybe<Array<AttachmentInput>>;
};

export type QuestionnaireMultipleChoiceQuestion = QuestionnaireItem & {
  __typename?: 'QuestionnaireMultipleChoiceQuestion';
  allowComment?: Maybe<Scalars['Boolean']['output']>;
  allowFollowUp?: Maybe<Scalars['Boolean']['output']>;
  allowNotApplicable?: Maybe<Scalars['Boolean']['output']>;
  allowUpload?: Maybe<Scalars['Boolean']['output']>;
  attachments?: Maybe<Scalars['JSON']['output']>;
  choiceType?: Maybe<ChoiceType>;
  choices?: Maybe<Array<Choice>>;
  description?: Maybe<Scalars['JSON']['output']>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  /** ffmAlias: itemId */
  id: Scalars['ObjectID']['output'];
  isCopied?: Maybe<Scalars['Boolean']['output']>;
  kind: QuestionnaireItemKind;
  question: Scalars['JSON']['output'];
};

export type QuestionnaireRoadToX = {
  __typename?: 'QuestionnaireRoadToX';
  answers?: Maybe<Array<QuestionnaireRoadToXAnswer>>;
  label: Scalars['String']['output'];
  level: Scalars['Int']['output'];
  readiness?: Maybe<Array<QuestionnaireRoadToXReadiness>>;
  worldReadiness?: Maybe<Scalars['Float']['output']>;
};

export type QuestionnaireRoadToXAnswer = {
  __typename?: 'QuestionnaireRoadToXAnswer';
  organizationId: Scalars['BigInt']['output'];
  value: Scalars['String']['output'];
};

export type QuestionnaireRoadToXOrganization = {
  __typename?: 'QuestionnaireRoadToXOrganization';
  isImporterOfRegionalOffice: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['BigInt']['output'];
  readiness: Scalars['Float']['output'];
};

export type QuestionnaireRoadToXReadiness = {
  __typename?: 'QuestionnaireRoadToXReadiness';
  organizationId: Scalars['BigInt']['output'];
  value: Scalars['Float']['output'];
};

export type QuestionnaireRoadToXReport = {
  __typename?: 'QuestionnaireRoadToXReport';
  organizations?: Maybe<Array<QuestionnaireRoadToXOrganization>>;
  questionnaire?: Maybe<Array<QuestionnaireRoadToX>>;
  worldReadiness: Scalars['Float']['output'];
};

export type QuestionnaireSection = QuestionnaireItem & {
  __typename?: 'QuestionnaireSection';
  /** ffmAlias: itemId */
  id: Scalars['ObjectID']['output'];
  kind: QuestionnaireItemKind;
  level: Scalars['Int']['output'];
  title: Scalars['JSON']['output'];
};

export type QuestionnaireSort = {
  author_name?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type QuestionnaireTextAnswer = QuestionnaireAnswer & {
  __typename?: 'QuestionnaireTextAnswer';
  answer?: Maybe<Scalars['String']['output']>;
  followUp?: Maybe<Scalars['Boolean']['output']>;
  item: QuestionnaireItem;
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  uploads?: Maybe<Array<Attachment>>;
};

export type QuestionnaireTextAnswerInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  followUp?: InputMaybe<Scalars['Boolean']['input']>;
  notApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  uploads?: InputMaybe<Array<AttachmentInput>>;
};

export type QuestionnaireTextQuestion = QuestionnaireItem & {
  __typename?: 'QuestionnaireTextQuestion';
  allowFollowUp?: Maybe<Scalars['Boolean']['output']>;
  allowNotApplicable?: Maybe<Scalars['Boolean']['output']>;
  allowUpload?: Maybe<Scalars['Boolean']['output']>;
  attachments?: Maybe<Scalars['JSON']['output']>;
  description?: Maybe<Scalars['JSON']['output']>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  /** ffmAlias: itemId */
  id: Scalars['ObjectID']['output'];
  isCopied?: Maybe<Scalars['Boolean']['output']>;
  kind: QuestionnaireItemKind;
  question: Scalars['JSON']['output'];
};

export enum QuestionnaireType {
  AccidentServiceManagement = 'ACCIDENT_SERVICE_MANAGEMENT',
  EperformanceRoadToXDealer = 'EPERFORMANCE_ROAD_TO_X_DEALER',
  EperformanceRoadToXImporter = 'EPERFORMANCE_ROAD_TO_X_IMPORTER',
  EperformanceTaycanReadiness = 'EPERFORMANCE_TAYCAN_READINESS',
  Greenland = 'GREENLAND',
  Pdsr = 'PDSR',
  PorscheApproved = 'PORSCHE_APPROVED',
  Qst = 'QST',
  Standard = 'STANDARD',
  SustainabilityDealership = 'SUSTAINABILITY_DEALERSHIP',
  Test = 'TEST'
}

export type QuestionnaireTypeConfig = {
  __typename?: 'QuestionnaireTypeConfig';
  /** ffmAlias: questionnaireTypeConfigId */
  id: Scalars['ObjectID']['output'];
  organization: Organization;
  planningRound?: Maybe<Scalars['String']['output']>;
  type: QuestionnaireType;
  weightsPerYear?: Maybe<Scalars['QuestionnaireTypeWeightsPerYear']['output']>;
};

export type QuestionnaireTypeConfigCreationInput = {
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  organizationId: Scalars['BigInt']['input'];
  planningRound?: InputMaybe<Scalars['String']['input']>;
  type: QuestionnaireType;
  weightsPerYear?: InputMaybe<Scalars['QuestionnaireTypeWeightsPerYear']['input']>;
};

export type QuestionnaireTypeConfigEditInput = {
  organizationId: Scalars['BigInt']['input'];
  planningRound?: InputMaybe<Scalars['String']['input']>;
  type: QuestionnaireType;
  weightsPerYear?: InputMaybe<Scalars['QuestionnaireTypeWeightsPerYear']['input']>;
};

export type QuestionnaireTypeConfigFilter = {
  organizationId?: InputMaybe<BigIntFilter>;
  type?: InputMaybe<QuestionnaireTypeFilter>;
};

export type QuestionnaireTypeConfigSort = {
  type?: InputMaybe<SortOrder>;
};

export type QuestionnaireTypeFilter = {
  _eq?: InputMaybe<QuestionnaireType>;
  _in?: InputMaybe<Array<InputMaybe<QuestionnaireType>>>;
  _nin?: InputMaybe<Array<InputMaybe<QuestionnaireType>>>;
};

export type QuestionnaireYesNoAnswer = QuestionnaireAnswer & {
  __typename?: 'QuestionnaireYesNoAnswer';
  answer?: Maybe<YesNoAnswer>;
  comment?: Maybe<Scalars['String']['output']>;
  followUp?: Maybe<Scalars['Boolean']['output']>;
  item: QuestionnaireItem;
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  uploads?: Maybe<Array<Attachment>>;
};

export type QuestionnaireYesNoAnswerInput = {
  answer?: InputMaybe<YesNoAnswer>;
  comment?: InputMaybe<Scalars['String']['input']>;
  followUp?: InputMaybe<Scalars['Boolean']['input']>;
  notApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  uploads?: InputMaybe<Array<AttachmentInput>>;
};

export type QuestionnaireYesNoQuestion = QuestionnaireItem & {
  __typename?: 'QuestionnaireYesNoQuestion';
  allowComment?: Maybe<Scalars['Boolean']['output']>;
  allowFollowUp?: Maybe<Scalars['Boolean']['output']>;
  allowNotApplicable?: Maybe<Scalars['Boolean']['output']>;
  allowUpload?: Maybe<Scalars['Boolean']['output']>;
  attachments?: Maybe<Scalars['JSON']['output']>;
  description?: Maybe<Scalars['JSON']['output']>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  /** ffmAlias: itemId */
  id: Scalars['ObjectID']['output'];
  isCopied?: Maybe<Scalars['Boolean']['output']>;
  kind: QuestionnaireItemKind;
  question: Scalars['JSON']['output'];
  /** If true, a comment is required if the answer is no. */
  requireComment?: Maybe<Scalars['Boolean']['output']>;
  requireCommentForYes?: Maybe<Scalars['Boolean']['output']>;
  requireUpload?: Maybe<Scalars['Boolean']['output']>;
};

export type RealEstatePropertiesPaginated = {
  __typename?: 'RealEstatePropertiesPaginated';
  docs: Array<RealEstateProperty>;
  total: Scalars['Int']['output'];
};

export type RealEstateProperty = {
  __typename?: 'RealEstateProperty';
  annualRent?: Maybe<Scalars['SafeInt']['output']>;
  bookValue?: Maybe<Scalars['SafeInt']['output']>;
  buildingSizeInM2?: Maybe<Scalars['Int']['output']>;
  city: Scalars['String']['output'];
  comments: Array<Comment>;
  country: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  earliestTermination?: Maybe<Scalars['DateTime']['output']>;
  headcount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ObjectID']['output'];
  integratedFunctions?: Maybe<Scalars['String']['output']>;
  landlord?: Maybe<Scalars['String']['output']>;
  lastRenovation?: Maybe<Scalars['Int']['output']>;
  leaseEnd?: Maybe<Scalars['DateTime']['output']>;
  leaseStart?: Maybe<Scalars['DateTime']['output']>;
  market: Organization;
  numberOfParking?: Maybe<Scalars['Int']['output']>;
  occupation?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  ownership?: Maybe<RealEstatePropertyOwnership>;
  postalCode: Scalars['String']['output'];
  prolongation?: Maybe<Scalars['Boolean']['output']>;
  sharedWithOr?: Maybe<Scalars['Boolean']['output']>;
  siteLandplotSizeInM2?: Maybe<Scalars['Int']['output']>;
  street: Scalars['String']['output'];
  subsidiary: Organization;
  type: RealEstatePropertyType;
  usage?: Maybe<RealEstatePropertyUsage>;
  use?: Maybe<RealEstatePropertyUse>;
  yearOfConstruction?: Maybe<Scalars['Int']['output']>;
};

export type RealEstatePropertyCommentInput = {
  text: Scalars['String']['input'];
};

export type RealEstatePropertyFilterInput = {
  _and?: InputMaybe<Array<RealEstatePropertyFilterInput>>;
  _or?: InputMaybe<Array<RealEstatePropertyFilterInput>>;
  market?: InputMaybe<BigIntFilter>;
};

export type RealEstatePropertyHqUsage = {
  __typename?: 'RealEstatePropertyHqUsage';
  numberOfDesks?: Maybe<Scalars['Int']['output']>;
};

export type RealEstatePropertyHqUsageInput = {
  numberOfDesks?: InputMaybe<Scalars['Int']['input']>;
};

export type RealEstatePropertyOrUsage = {
  __typename?: 'RealEstatePropertyOrUsage';
  category?: Maybe<OrganizationFacilityType>;
  jobsPerDay?: Maybe<Scalars['Int']['output']>;
  numberOfWorkBays?: Maybe<Scalars['Int']['output']>;
};

export type RealEstatePropertyOrUsageInput = {
  category?: InputMaybe<OrganizationFacilityType>;
  jobsPerDay?: InputMaybe<Scalars['Int']['input']>;
  numberOfWorkBays?: InputMaybe<Scalars['Int']['input']>;
};

export enum RealEstatePropertyOwnership {
  Owned = 'OWNED',
  Rented = 'RENTED'
}

export type RealEstatePropertyPecUsage = {
  __typename?: 'RealEstatePropertyPecUsage';
  numberOfWorkBays?: Maybe<Scalars['Int']['output']>;
  offRoad?: Maybe<Scalars['Boolean']['output']>;
  trackDaysPerYear?: Maybe<Scalars['Int']['output']>;
  trackLengthInKm?: Maybe<Scalars['Float']['output']>;
};

export type RealEstatePropertyPecUsageInput = {
  numberOfWorkBays?: InputMaybe<Scalars['Int']['input']>;
  offRoad?: InputMaybe<Scalars['Boolean']['input']>;
  trackDaysPerYear?: InputMaybe<Scalars['Int']['input']>;
  trackLengthInKm?: InputMaybe<Scalars['Float']['input']>;
};

export type RealEstatePropertyTcUsage = {
  __typename?: 'RealEstatePropertyTcUsage';
  numberOfClassRooms?: Maybe<Scalars['Int']['output']>;
  numberOfWorkBays?: Maybe<Scalars['Int']['output']>;
  training?: Maybe<RealEstatePropertyTraining>;
  trainingDaysPerYear?: Maybe<Scalars['Int']['output']>;
};

export type RealEstatePropertyTcUsageInput = {
  numberOfClassRooms?: InputMaybe<Scalars['Int']['input']>;
  numberOfWorkBays?: InputMaybe<Scalars['Int']['input']>;
  training?: InputMaybe<RealEstatePropertyTraining>;
  trainingDaysPerYear?: InputMaybe<Scalars['Int']['input']>;
};

export enum RealEstatePropertyTraining {
  NonTechnical = 'NON_TECHNICAL',
  Technical = 'TECHNICAL'
}

export enum RealEstatePropertyType {
  Hq = 'HQ',
  Or = 'OR',
  Pdi = 'PDI',
  Pec = 'PEC',
  Tc = 'TC',
  Wh = 'WH'
}

export type RealEstatePropertyUsage = RealEstatePropertyHqUsage | RealEstatePropertyOrUsage | RealEstatePropertyPecUsage | RealEstatePropertyTcUsage;

/** Exactly one non-null branch matching the property type may be supplied. */
export type RealEstatePropertyUsageInput = {
  hq?: InputMaybe<RealEstatePropertyHqUsageInput>;
  or?: InputMaybe<RealEstatePropertyOrUsageInput>;
  pec?: InputMaybe<RealEstatePropertyPecUsageInput>;
  tc?: InputMaybe<RealEstatePropertyTcUsageInput>;
};

export enum RealEstatePropertyUse {
  Exclusive = 'EXCLUSIVE',
  Partially = 'PARTIALLY'
}

export enum Reason {
  ConsultancyProject = 'CONSULTANCY_PROJECT',
  DealerFinancingDealerSupport = 'DEALER_FINANCING_DEALER_SUPPORT',
  EvaluationOfTargetDeviation = 'EVALUATION_OF_TARGET_DEVIATION',
  InvestmentPlanning = 'INVESTMENT_PLANNING',
  PreparationOfInvestorMeeting = 'PREPARATION_OF_INVESTOR_MEETING',
  QuotaAllocation = 'QUOTA_ALLOCATION',
  ReviewHourlyRateWarranty = 'REVIEW_HOURLY_RATE_WARRANTY',
  ReviewOfBusinessPlan = 'REVIEW_OF_BUSINESS_PLAN',
  RiskAnalysis = 'RISK_ANALYSIS',
  RiskManagement = 'RISK_MANAGEMENT'
}

export type ReportColumn = {
  __typename?: 'ReportColumn';
  items: Array<Maybe<ReportItem>>;
  width: Scalars['Int']['output'];
};

export type ReportColumnInput = {
  items: Array<InputMaybe<ReportItemInput>>;
  width: Scalars['Int']['input'];
};

export type ReportItem = {
  __typename?: 'ReportItem';
  id: Scalars['ObjectID']['output'];
  name: Scalars['String']['output'];
  props?: Maybe<Scalars['JSON']['output']>;
  type: ReportType;
};

export type ReportItemInput = {
  id: Scalars['ObjectID']['input'];
  name: Scalars['String']['input'];
  props?: InputMaybe<Scalars['JSON']['input']>;
  type: ReportType;
};

export type ReportTab = {
  __typename?: 'ReportTab';
  columns: Array<ReportColumn>;
  key: Scalars['ObjectID']['output'];
  name: Scalars['String']['output'];
};

export type ReportTabInput = {
  columns: Array<ReportColumnInput>;
  key: Scalars['ObjectID']['input'];
  name: Scalars['String']['input'];
};

export enum ReportType {
  Custom = 'CUSTOM',
  PbeActionItemsImplemented = 'PBE_ACTION_ITEMS_IMPLEMENTED',
  PbeCoachingDays = 'PBE_COACHING_DAYS',
  PbeCoachingDaysByCoachingModule = 'PBE_COACHING_DAYS_BY_COACHING_MODULE',
  PbeCoachingModulesByCoachingDay = 'PBE_COACHING_MODULES_BY_COACHING_DAY',
  PbeFocusArea = 'PBE_FOCUS_AREA',
  PbeProfitPotential = 'PBE_PROFIT_POTENTIAL',
  PbeRolloutStatus = 'PBE_ROLLOUT_STATUS'
}

export type ResendPorscheImportAgreementsChangeRequestApprovalEmailInput = {
  approvalId: Scalars['ObjectID']['input'];
  changeRequestId: Scalars['ObjectID']['input'];
};

export type Resources = {
  __typename?: 'Resources';
  actionItemId?: Maybe<Scalars['ObjectID']['output']>;
  apex_contextKey?: Maybe<ApexActionItemContextKey>;
  apex_resultId?: Maybe<Scalars['ObjectID']['output']>;
  auditId?: Maybe<Scalars['ObjectID']['output']>;
  greenland_occasionRelatedApprovalId?: Maybe<Scalars['ObjectID']['output']>;
  mysteryShopping_criteriaId?: Maybe<Array<Maybe<Scalars['ObjectID']['output']>>>;
  questionGroupId?: Maybe<Scalars['Int']['output']>;
  questionId?: Maybe<Scalars['ObjectID']['output']>;
  questionnaireId?: Maybe<Scalars['ObjectID']['output']>;
  survey_surveyAnswerId?: Maybe<Scalars['ObjectID']['output']>;
  widgetId?: Maybe<Scalars['ObjectID']['output']>;
};

export type ResourcesInput = {
  actionItemId?: InputMaybe<Scalars['ObjectID']['input']>;
  apex_contextKey?: InputMaybe<ApexActionItemContextKey>;
  apex_resultId?: InputMaybe<Scalars['ObjectID']['input']>;
  auditId?: InputMaybe<Scalars['ObjectID']['input']>;
  greenland_occasionRelatedApprovalId?: InputMaybe<Scalars['ObjectID']['input']>;
  mysteryShopping_criteriaId?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  questionGroupId?: InputMaybe<Scalars['Int']['input']>;
  questionId?: InputMaybe<Scalars['ObjectID']['input']>;
  questionnaireId?: InputMaybe<Scalars['ObjectID']['input']>;
  survey_surveyAnswerId?: InputMaybe<Scalars['ObjectID']['input']>;
  widgetId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type RetailDesignAbsenceNote = {
  __typename?: 'RetailDesignAbsenceNote';
  description: Scalars['String']['output'];
  from?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ObjectID']['output'];
  isActive: Scalars['Boolean']['output'];
  to?: Maybe<Scalars['Date']['output']>;
};

export type RetailDesignDocument = {
  __typename?: 'RetailDesignDocument';
  id: Scalars['ObjectID']['output'];
  mandatory?: Maybe<Scalars['Boolean']['output']>;
  mandatoryForStatus: Array<RetailDesignProjectStatus>;
  mandatoryOnlyForFormatIds?: Maybe<Array<Scalars['ObjectID']['output']>>;
  name: Scalars['String']['output'];
  translations?: Maybe<Scalars['JSON']['output']>;
};

export type RetailDesignEmailNotification = {
  __typename?: 'RetailDesignEmailNotification';
  adhoc?: Maybe<Scalars['Boolean']['output']>;
  cron?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  options?: Maybe<RetailDesignEmailNotificationOption>;
  person: Person;
  topic: RetailDesignEmailNotificationTopic;
};

export type RetailDesignEmailNotificationOption = {
  __typename?: 'RetailDesignEmailNotificationOption';
  notifyDaysBeforeCompletion?: Maybe<Scalars['Int']['output']>;
};

export type RetailDesignEmailNotificationOptionInput = {
  notifyDaysBeforeCompletion?: InputMaybe<Scalars['Int']['input']>;
};

export enum RetailDesignEmailNotificationTopic {
  RetailDesignProjectCreation = 'RETAIL_DESIGN_PROJECT_CREATION',
  RetailDesignProjectDocumentUpload = 'RETAIL_DESIGN_PROJECT_DOCUMENT_UPLOAD',
  RetailDesignProjectNearingCompletion = 'RETAIL_DESIGN_PROJECT_NEARING_COMPLETION',
  RetailDesignProjectStatusChange = 'RETAIL_DESIGN_PROJECT_STATUS_CHANGE'
}

export type RetailDesignFilterPreset = {
  __typename?: 'RetailDesignFilterPreset';
  filter: RetailDesignFilterPresetConfig;
  id: Scalars['ObjectID']['output'];
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type RetailDesignFilterPresetConfig = {
  __typename?: 'RetailDesignFilterPresetConfig';
  author?: Maybe<Array<Scalars['BigInt']['output']>>;
  city?: Maybe<Array<Scalars['String']['output']>>;
  expectedSalesVolumePerYearFrom?: Maybe<Scalars['Int']['output']>;
  expectedSalesVolumePerYearTo?: Maybe<Scalars['Int']['output']>;
  expectedWorkshopThroughputPerDayFrom?: Maybe<Scalars['Int']['output']>;
  expectedWorkshopThroughputPerDayTo?: Maybe<Scalars['Int']['output']>;
  format?: Maybe<Array<Scalars['String']['output']>>;
  hasBookmark?: Maybe<Scalars['Boolean']['output']>;
  investor?: Maybe<Array<Scalars['String']['output']>>;
  kind?: Maybe<RetailDesignProjectKind>;
  onlyCreated?: Maybe<Scalars['Boolean']['output']>;
  organization?: Maybe<Array<Scalars['BigInt']['output']>>;
  plannedConstructionCompletionFrom?: Maybe<Scalars['DateMonth']['output']>;
  plannedConstructionCompletionTo?: Maybe<Scalars['DateMonth']['output']>;
  plannedConstructionStartFrom?: Maybe<Scalars['DateMonth']['output']>;
  plannedConstructionStartTo?: Maybe<Scalars['DateMonth']['output']>;
  status?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Array<Scalars['String']['output']>>;
};

export type RetailDesignFilterPresetConfigInput = {
  author?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  city?: InputMaybe<Array<Scalars['String']['input']>>;
  expectedSalesVolumePerYearFrom?: InputMaybe<Scalars['Int']['input']>;
  expectedSalesVolumePerYearTo?: InputMaybe<Scalars['Int']['input']>;
  expectedWorkshopThroughputPerDayFrom?: InputMaybe<Scalars['Int']['input']>;
  expectedWorkshopThroughputPerDayTo?: InputMaybe<Scalars['Int']['input']>;
  format?: InputMaybe<Array<Scalars['String']['input']>>;
  hasBookmark?: InputMaybe<Scalars['Boolean']['input']>;
  investor?: InputMaybe<Array<Scalars['String']['input']>>;
  kind?: InputMaybe<RetailDesignProjectKind>;
  onlyCreated?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  plannedConstructionCompletionFrom?: InputMaybe<Scalars['DateMonth']['input']>;
  plannedConstructionCompletionTo?: InputMaybe<Scalars['DateMonth']['input']>;
  plannedConstructionStartFrom?: InputMaybe<Scalars['DateMonth']['input']>;
  plannedConstructionStartTo?: InputMaybe<Scalars['DateMonth']['input']>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RetailDesignFormat = {
  __typename?: 'RetailDesignFormat';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  hasAssignedProjects?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use hasNoWorkshopThroughput instead */
  hasNoAftersalesThroughput?: Maybe<Scalars['Boolean']['output']>;
  hasNoBodyAndPaintThroughput?: Maybe<Scalars['Boolean']['output']>;
  hasNoNCSalesVolume?: Maybe<Scalars['Boolean']['output']>;
  hasNoWorkshopThroughput?: Maybe<Scalars['Boolean']['output']>;
  hasRelatedOrganization?: Maybe<RetailDesignFormatRelatedOrganization>;
  id: Scalars['ObjectID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  needsAftersalesApproval?: Maybe<Scalars['Boolean']['output']>;
  needsApprovalProcessType?: Maybe<RetailDesignFormatApprovalProcessType>;
  needsBrandManagementApproval?: Maybe<RetailDesignFormatBrandManagementApproval>;
  translations?: Maybe<Scalars['JSON']['output']>;
};

export enum RetailDesignFormatApprovalProcessType {
  Brand = 'BRAND',
  PorscheNow = 'PORSCHE_NOW',
  PorscheStore = 'PORSCHE_STORE',
  PorscheStudio = 'PORSCHE_STUDIO'
}

export type RetailDesignFormatApprovalProcessTypeFilter = {
  _eq?: InputMaybe<RetailDesignFormatApprovalProcessType>;
  _in?: InputMaybe<Array<InputMaybe<RetailDesignFormatApprovalProcessType>>>;
  _ne?: InputMaybe<RetailDesignFormatApprovalProcessType>;
  _nin?: InputMaybe<Array<InputMaybe<RetailDesignFormatApprovalProcessType>>>;
};

export type RetailDesignFormatBrandManagementApproval = {
  __typename?: 'RetailDesignFormatBrandManagementApproval';
  brandManagers?: Maybe<Array<Person>>;
  isRequired: Scalars['Boolean']['output'];
};

export type RetailDesignFormatBrandManagementApprovalInput = {
  brandManagerIds?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  isRequired: Scalars['Boolean']['input'];
};

export type RetailDesignFormatFilter = {
  _and?: InputMaybe<Array<RetailDesignFormatFilter>>;
  _id?: InputMaybe<ObjectIdFilter>;
  _or?: InputMaybe<Array<RetailDesignFormatFilter>>;
  isActive?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  needsApprovalProcessType?: InputMaybe<RetailDesignFormatApprovalProcessTypeFilter>;
};

export type RetailDesignFormatRelatedOrganization = {
  __typename?: 'RetailDesignFormatRelatedOrganization';
  isRequired: Scalars['Boolean']['output'];
};

export type RetailDesignFormatRelatedOrganizationInput = {
  isRequired: Scalars['Boolean']['input'];
};

export type RetailDesignFormatsInput = {
  filter?: InputMaybe<RetailDesignFormatFilter>;
};

export type RetailDesignProject = {
  attachment?: Maybe<RetailDesignProjectAttachment>;
  attachments: Array<RetailDesignProjectAttachment>;
  author: Person;
  city: Scalars['String']['output'];
  comments: Array<Comment>;
  description?: Maybe<Scalars['String']['output']>;
  format: RetailDesignFormat;
  hasBookmark?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ObjectID']['output'];
  iteration: Scalars['Int']['output'];
  kind: RetailDesignProjectKind;
  organization: Organization;
  patches: Array<RetailDesignProjectPatch>;
  status: RetailDesignProjectStatus;
  street?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};


export type RetailDesignProjectAttachmentArgs = {
  id: Scalars['ObjectID']['input'];
};


export type RetailDesignProjectPatchesArgs = {
  input?: InputMaybe<RetailDesignProjectPatchesInput>;
};

export type RetailDesignProjectAttachment = {
  __typename?: 'RetailDesignProjectAttachment';
  comments: Array<Comment>;
  createdAt: Scalars['DateTime']['output'];
  filePrefix?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  uploader?: Maybe<Person>;
  visibility: RetailDesignProjectAttachmentVisibility;
};

export type RetailDesignProjectAttachmentInput = {
  filePrefix?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ObjectID']['input'];
  name: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  type: Scalars['String']['input'];
  visibility?: InputMaybe<RetailDesignProjectAttachmentVisibility>;
};

export enum RetailDesignProjectAttachmentVisibility {
  PagInternal = 'PAG_INTERNAL',
  Public = 'PUBLIC',
  RegionalOfficeInternal = 'REGIONAL_OFFICE_INTERNAL'
}

export type RetailDesignProjectConstruction = RetailDesignProject & {
  __typename?: 'RetailDesignProjectConstruction';
  afterSalesApproved?: Maybe<Scalars['Boolean']['output']>;
  attachment?: Maybe<RetailDesignProjectAttachment>;
  attachments: Array<RetailDesignProjectAttachment>;
  author: Person;
  city: Scalars['String']['output'];
  comments: Array<Comment>;
  description?: Maybe<Scalars['String']['output']>;
  expectedBodyAndPaintThroughputPerDay: Array<FloatValueWithYear>;
  expectedSalesVolumePerYear: Array<IntValueWithYear>;
  expectedWorkshopThroughputPerDay: Array<FloatValueWithYear>;
  format: RetailDesignFormat;
  formatApproval?: Maybe<RetailDesignProjectFormatApproval>;
  hasBookmark?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ObjectID']['output'];
  internalDocumentsEditingStatus?: Maybe<RetailDesignProjectInternalDocumentsEditingStatus>;
  isInRegionalOfficeFlow: Scalars['Boolean']['output'];
  iteration: Scalars['Int']['output'];
  kind: RetailDesignProjectKind;
  organization: Organization;
  patches: Array<RetailDesignProjectPatch>;
  plannedConstructionCompletion?: Maybe<Scalars['DateMonth']['output']>;
  plannedConstructionStart?: Maybe<Scalars['DateMonth']['output']>;
  relatedOrganization?: Maybe<Organization>;
  relationType?: Maybe<RetailDesignProjectRelationType>;
  retailDesignApproved?: Maybe<Scalars['Boolean']['output']>;
  status: RetailDesignProjectStatus;
  street?: Maybe<Scalars['String']['output']>;
  sustainabilityRcp?: Maybe<RetailDesignProjectConstructionSustainabilityRcp>;
  title: Scalars['String']['output'];
  type?: Maybe<RetailDesignProjectType>;
};


export type RetailDesignProjectConstructionAttachmentArgs = {
  id: Scalars['ObjectID']['input'];
};


export type RetailDesignProjectConstructionPatchesArgs = {
  input?: InputMaybe<RetailDesignProjectPatchesInput>;
};

export type RetailDesignProjectConstructionInput = {
  attachments?: InputMaybe<Array<InputMaybe<RetailDesignProjectAttachmentInput>>>;
  city: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  expectedBodyAndPaintThroughputPerDay?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  expectedSalesVolumePerYear?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  expectedWorkshopThroughputPerDay?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  formatApprovalId?: InputMaybe<Scalars['ObjectID']['input']>;
  formatId: Scalars['ObjectID']['input'];
  internalDocumentsEditingStatus?: InputMaybe<RetailDesignProjectInternalDocumentsEditingStatus>;
  organizationId: Scalars['BigInt']['input'];
  plannedConstructionCompletion?: InputMaybe<Scalars['DateMonth']['input']>;
  plannedConstructionStart?: InputMaybe<Scalars['DateMonth']['input']>;
  relatedOrganizationId?: InputMaybe<Scalars['BigInt']['input']>;
  relationType?: InputMaybe<RetailDesignProjectRelationType>;
  status?: InputMaybe<RetailDesignProjectStatus>;
  street?: InputMaybe<Scalars['String']['input']>;
  sustainabilityRcp?: InputMaybe<RetailDesignProjectConstructionSustainabilityRcpInput>;
  title: Scalars['String']['input'];
  typeId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type RetailDesignProjectConstructionSustainabilityRcp = {
  __typename?: 'RetailDesignProjectConstructionSustainabilityRcp';
  desiredCertificate?: Maybe<RetailDesignProjectConstructionSustainabilityRcpDesiredCertificate>;
  details?: Maybe<Scalars['String']['output']>;
  otherDesiredCertificateInformation?: Maybe<Scalars['String']['output']>;
  performed?: Maybe<Scalars['Boolean']['output']>;
};

export enum RetailDesignProjectConstructionSustainabilityRcpDesiredCertificate {
  BreeamExcellent = 'BREEAM_EXCELLENT',
  BreeamGood = 'BREEAM_GOOD',
  BreeamOutstanding = 'BREEAM_OUTSTANDING',
  BreeamPass = 'BREEAM_PASS',
  BreeamVery = 'BREEAM_VERY',
  DgnbBronze = 'DGNB_BRONZE',
  DgnbGold = 'DGNB_GOLD',
  DgnbPlatin = 'DGNB_PLATIN',
  DgnbSilver = 'DGNB_SILVER',
  LeedCertified = 'LEED_CERTIFIED',
  LeedGold = 'LEED_GOLD',
  LeedPlatin = 'LEED_PLATIN',
  LeedSilver = 'LEED_SILVER',
  Others = 'OTHERS'
}

export type RetailDesignProjectConstructionSustainabilityRcpInput = {
  desiredCertificate?: InputMaybe<RetailDesignProjectConstructionSustainabilityRcpDesiredCertificate>;
  details?: InputMaybe<Scalars['String']['input']>;
  otherDesiredCertificateInformation?: InputMaybe<Scalars['String']['input']>;
  performed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RetailDesignProjectFilter = {
  _and?: InputMaybe<Array<InputMaybe<RetailDesignProjectFilter>>>;
  _or?: InputMaybe<Array<InputMaybe<RetailDesignProjectFilter>>>;
  author?: InputMaybe<BigIntFilter>;
  bookmarkedBy?: InputMaybe<BigIntFilter>;
  city?: InputMaybe<StringArrayFilter>;
  construction?: InputMaybe<ObjectIdFilter>;
  expectedBodyAndPaintThroughputPerDayAfterConstruction?: InputMaybe<IntFilter>;
  expectedSalesVolumePerYearAfterConstruction?: InputMaybe<IntFilter>;
  expectedWorkshopThroughputPerDayAfterConstruction?: InputMaybe<IntFilter>;
  format?: InputMaybe<ObjectIdFilter>;
  formatApproval?: InputMaybe<ObjectIdFilter>;
  investor?: InputMaybe<StringFilter>;
  kind?: InputMaybe<RetailDesignProjectKindFilter>;
  openingDate?: InputMaybe<DateMonthFilter>;
  organization?: InputMaybe<RetailDesignProjectOrganizationFilter>;
  plannedConstructionCompletion?: InputMaybe<DateMonthFilter>;
  plannedConstructionStart?: InputMaybe<DateMonthFilter>;
  status?: InputMaybe<RetailDesignProjectStatusFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<ObjectIdFilter>;
};

export type RetailDesignProjectFormatApproval = RetailDesignProject & {
  __typename?: 'RetailDesignProjectFormatApproval';
  attachment?: Maybe<RetailDesignProjectAttachment>;
  attachments: Array<RetailDesignProjectAttachment>;
  author: Person;
  brandFormatConfirmation?: Maybe<Scalars['DateTime']['output']>;
  brandManagementApproved?: Maybe<Scalars['Boolean']['output']>;
  brandType?: Maybe<RetailDesignProjectFormatApprovalBrandType>;
  brandTypeDescription?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  closingDate?: Maybe<Scalars['DateMonth']['output']>;
  collaborationWithOtherBrands?: Maybe<Scalars['Boolean']['output']>;
  collaborationWithOtherBrandsDescription?: Maybe<Scalars['String']['output']>;
  comments: Array<Comment>;
  construction?: Maybe<RetailDesignProjectConstruction>;
  contactPerson?: Maybe<Person>;
  country: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayOfNewVehicles?: Maybe<Scalars['Boolean']['output']>;
  foodAndBeverageIntegration?: Maybe<Scalars['Boolean']['output']>;
  foodAndBeverageIntegrationDescription?: Maybe<Scalars['String']['output']>;
  format: RetailDesignFormat;
  hasBookmark?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ObjectID']['output'];
  investor?: Maybe<Scalars['String']['output']>;
  iteration: Scalars['Int']['output'];
  kind: RetailDesignProjectKind;
  location?: Maybe<RetailDesignProjectFormatApprovalLocation>;
  locationDescription?: Maybe<Scalars['String']['output']>;
  merchandiseOrLifestyleProducts?: Maybe<Scalars['Boolean']['output']>;
  merchandiseOrLifestyleProductsDescription?: Maybe<Scalars['String']['output']>;
  openingDate?: Maybe<Scalars['DateMonth']['output']>;
  organization: Organization;
  patches: Array<RetailDesignProjectPatch>;
  plannedEvents?: Maybe<Scalars['Boolean']['output']>;
  plannedEventsDescription?: Maybe<Scalars['String']['output']>;
  primaryObjective?: Maybe<RetailDesignProjectFormatApprovalPrimaryObjective>;
  primaryObjectiveDescription?: Maybe<Scalars['String']['output']>;
  relatedOrganization?: Maybe<Organization>;
  retailDesignApproved?: Maybe<Scalars['Boolean']['output']>;
  returnOnMarketingInvest?: Maybe<Scalars['Float']['output']>;
  status: RetailDesignProjectStatus;
  street?: Maybe<Scalars['String']['output']>;
  testDrives?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
  validSpace?: Maybe<Scalars['Boolean']['output']>;
};


export type RetailDesignProjectFormatApprovalAttachmentArgs = {
  id: Scalars['ObjectID']['input'];
};


export type RetailDesignProjectFormatApprovalPatchesArgs = {
  input?: InputMaybe<RetailDesignProjectPatchesInput>;
};

export enum RetailDesignProjectFormatApprovalBrandType {
  Cafe = 'CAFE',
  Other = 'OTHER',
  PopUp = 'POP_UP'
}

export type RetailDesignProjectFormatApprovalInput = {
  attachments?: InputMaybe<Array<InputMaybe<RetailDesignProjectAttachmentInput>>>;
  brandFormatConfirmation?: InputMaybe<Scalars['DateTime']['input']>;
  brandType?: InputMaybe<RetailDesignProjectFormatApprovalBrandType>;
  brandTypeDescription?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  closingDate?: InputMaybe<Scalars['DateMonth']['input']>;
  collaborationWithOtherBrands?: InputMaybe<Scalars['Boolean']['input']>;
  collaborationWithOtherBrandsDescription?: InputMaybe<Scalars['String']['input']>;
  contactPersonId?: InputMaybe<Scalars['BigInt']['input']>;
  country: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  displayOfNewVehicles?: InputMaybe<Scalars['Boolean']['input']>;
  foodAndBeverageIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  foodAndBeverageIntegrationDescription?: InputMaybe<Scalars['String']['input']>;
  formatId: Scalars['ObjectID']['input'];
  investor?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<RetailDesignProjectFormatApprovalLocation>;
  locationDescription?: InputMaybe<Scalars['String']['input']>;
  merchandiseOrLifestyleProducts?: InputMaybe<Scalars['Boolean']['input']>;
  merchandiseOrLifestyleProductsDescription?: InputMaybe<Scalars['String']['input']>;
  openingDate?: InputMaybe<Scalars['DateMonth']['input']>;
  organizationId: Scalars['BigInt']['input'];
  plannedEvents?: InputMaybe<Scalars['Boolean']['input']>;
  plannedEventsDescription?: InputMaybe<Scalars['String']['input']>;
  primaryObjective?: InputMaybe<RetailDesignProjectFormatApprovalPrimaryObjective>;
  primaryObjectiveDescription?: InputMaybe<Scalars['String']['input']>;
  relatedOrganizationId?: InputMaybe<Scalars['BigInt']['input']>;
  returnOnMarketingInvest?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<RetailDesignProjectStatus>;
  street?: InputMaybe<Scalars['String']['input']>;
  testDrives?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  validSpace?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum RetailDesignProjectFormatApprovalLocation {
  City = 'CITY',
  CityCenter = 'CITY_CENTER',
  DowntownLocation = 'DOWNTOWN_LOCATION',
  Mall = 'MALL',
  Other = 'OTHER',
  Outdoor = 'OUTDOOR',
  ShoppingCenter = 'SHOPPING_CENTER',
  StreetLocation = 'STREET_LOCATION',
  Suburb = 'SUBURB'
}

export enum RetailDesignProjectFormatApprovalPrimaryObjective {
  BrandActivation = 'BRAND_ACTIVATION',
  CommunityAndEngagement = 'COMMUNITY_AND_ENGAGEMENT',
  Events = 'EVENTS',
  LeadGeneration = 'LEAD_GENERATION',
  Other = 'OTHER',
  ProductPresentation = 'PRODUCT_PRESENTATION'
}

export enum RetailDesignProjectInternalDocumentsEditingStatus {
  AfterSales = 'AFTER_SALES',
  RetailDesign = 'RETAIL_DESIGN'
}

export enum RetailDesignProjectKind {
  Construction = 'CONSTRUCTION',
  FormatApproval = 'FORMAT_APPROVAL'
}

export type RetailDesignProjectKindFilter = {
  _eq?: InputMaybe<RetailDesignProjectKind>;
};

export type RetailDesignProjectOrganizationFilter = {
  _eq?: InputMaybe<Scalars['BigInt']['input']>;
  _in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
};

export type RetailDesignProjectPatch = Patch & {
  __typename?: 'RetailDesignProjectPatch';
  date: Scalars['DateTime']['output'];
  id: Scalars['ObjectID']['output'];
  ops: Scalars['JSON']['output'];
  person: Person;
  ref: Scalars['ObjectID']['output'];
};


export type RetailDesignProjectPatchOpsArgs = {
  input?: InputMaybe<PatchOpsInput>;
};

export type RetailDesignProjectPatchFilter = {
  _and?: InputMaybe<Array<RetailDesignProjectPatchFilter>>;
  _or?: InputMaybe<Array<RetailDesignProjectPatchFilter>>;
  ops?: InputMaybe<RetailDesignProjectPatchOpFilter>;
  ops_op?: InputMaybe<StringFilter>;
  ops_path?: InputMaybe<StringFilter>;
};

export type RetailDesignProjectPatchOpFilter = {
  _elemMatch?: InputMaybe<RetailDesignProjectPatchOpObjectFilter>;
  op?: InputMaybe<StringFilter>;
  path?: InputMaybe<StringFilter>;
};

export type RetailDesignProjectPatchOpObjectFilter = {
  op?: InputMaybe<StringFilter>;
  path?: InputMaybe<StringFilter>;
};

export type RetailDesignProjectPatchesInput = {
  filter?: InputMaybe<RetailDesignProjectPatchFilter>;
};

export enum RetailDesignProjectRelationType {
  New = 'NEW',
  Replacement = 'REPLACEMENT'
}

export enum RetailDesignProjectStatus {
  Accepted = 'ACCEPTED',
  Draft = 'DRAFT',
  InOperation = 'IN_OPERATION',
  PagNeedsRevision = 'PAG_NEEDS_REVISION',
  PagOnHold = 'PAG_ON_HOLD',
  PagReview = 'PAG_REVIEW',
  RegionalOfficeNeedsRevision = 'REGIONAL_OFFICE_NEEDS_REVISION',
  RegionalOfficeOnHold = 'REGIONAL_OFFICE_ON_HOLD',
  RegionalOfficeReview = 'REGIONAL_OFFICE_REVIEW'
}

export type RetailDesignProjectStatusFilter = {
  _eq?: InputMaybe<RetailDesignProjectStatus>;
  _in?: InputMaybe<Array<InputMaybe<RetailDesignProjectStatus>>>;
  _ne?: InputMaybe<RetailDesignProjectStatus>;
};

export type RetailDesignProjectType = {
  __typename?: 'RetailDesignProjectType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  hasAssignedProjects?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ObjectID']['output'];
  name: Scalars['String']['output'];
  translations?: Maybe<Scalars['JSON']['output']>;
};

export type RetailDesignProjectsInput = {
  filter?: InputMaybe<RetailDesignProjectFilter>;
};

export enum Review {
  Flagged = 'FLAGGED',
  NotFlagged = 'NOT_FLAGGED',
  Resolved = 'RESOLVED'
}

export type SendPorscheImportAgreementsChangeRequestApprovalEmailsInput = {
  changeRequestId: Scalars['ObjectID']['input'];
};

export type SetApexImportScheduleInput = {
  cron: Scalars['String']['input'];
};

export type SetCommitmentKpiInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  commitmentId: Scalars['ObjectID']['input'];
  isFocusKpi?: InputMaybe<Scalars['Boolean']['input']>;
  strategyFieldId: Scalars['ObjectID']['input'];
  strategyKpiCategoryId?: InputMaybe<Scalars['ObjectID']['input']>;
  strategyKpiId: Scalars['ObjectID']['input'];
};

export type SetPcRoadmapCommitmentValueInput = {
  actionItemIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  coachingModuleIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  commitmentId: Scalars['ObjectID']['input'];
  kind: PcRoadmapKpiValueKind;
  strategyFieldId: Scalars['ObjectID']['input'];
  strategyKpiCategoryId?: InputMaybe<Scalars['ObjectID']['input']>;
  strategyKpiId: Scalars['ObjectID']['input'];
  value?: InputMaybe<Scalars['Float']['input']>;
  variant?: InputMaybe<PcRoadmapKpiValueVariant>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export enum Source {
  Apex = 'APEX',
  Greenland = 'GREENLAND',
  Mpi = 'MPI',
  MysteryShopping = 'MYSTERY_SHOPPING',
  NetworkPlanning = 'NETWORK_PLANNING',
  Pbsa = 'PBSA',
  Survey = 'SURVEY'
}

export enum StatisticGranularity {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type StatusChange = {
  __typename?: 'StatusChange';
  from: MeetingStatus;
  reason?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
  to: MeetingStatus;
  user: Person;
};

export type StrategyActionItem = {
  __typename?: 'StrategyActionItem';
  attachments: Array<Attachment>;
  author: PersonReference;
  comments: Array<Comment>;
  createdByResource?: Maybe<StrategyActionItemResource>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  kpi: StrategyKpi;
  kpiCategory?: Maybe<StrategyKpiCategory>;
  okr: Scalars['String']['output'];
  organization: Organization;
  responsible: PersonReference;
  status: StrategyActionItemStatus;
  title: Scalars['String']['output'];
  workPackages: Array<StrategyActionItemWorkPackage>;
  year: Scalars['Int']['output'];
};

export type StrategyActionItemFilter = {
  kpi?: InputMaybe<ObjectIdFilter>;
  kpiCategory?: InputMaybe<ObjectIdFilter>;
  kpi_stage?: InputMaybe<IntFilter>;
  organization_organizationId?: InputMaybe<BigIntFilter>;
  rootOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
  year?: InputMaybe<IntFilter>;
};

export type StrategyActionItemResource = {
  __typename?: 'StrategyActionItemResource';
  pcRoadmap_actionItemId?: Maybe<Scalars['ObjectID']['output']>;
};

export type StrategyActionItemResourceInput = {
  pcRoadmap_actionItemId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export enum StrategyActionItemStatus {
  Done = 'DONE',
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN'
}

export type StrategyActionItemWorkPackage = {
  __typename?: 'StrategyActionItemWorkPackage';
  id: Scalars['ObjectID']['output'];
  status: StrategyActionItemWorkPackageStatus;
  targetMonth: Scalars['DateMonth']['output'];
  title: Scalars['String']['output'];
};

export type StrategyActionItemWorkPackageInput = {
  status: StrategyActionItemWorkPackageStatus;
  targetMonth: Scalars['DateMonth']['input'];
  title: Scalars['String']['input'];
};

export enum StrategyActionItemWorkPackageStatus {
  Done = 'DONE',
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN'
}

export type StrategyActionItemsInput = {
  filter?: InputMaybe<StrategyActionItemFilter>;
};

export type StrategyAttachmentInput = {
  filePrefix?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ObjectID']['input'];
  name: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  type: Scalars['String']['input'];
  uploaderId?: InputMaybe<Scalars['BigInt']['input']>;
};

export type StrategyField = {
  __typename?: 'StrategyField';
  assignmentType: AssignmentType;
  color: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  isAssigned: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
  stage: Scalars['Int']['output'];
  strategyKpis: Array<StrategyKpi>;
};

export type StrategyFieldFilter = {
  _id?: InputMaybe<ObjectIdFilter>;
  assignmentType?: InputMaybe<AssignmentType>;
  organization?: InputMaybe<BigIntFilter>;
  stage?: InputMaybe<IntFilter>;
};

export type StrategyFieldsFilterInput = {
  filter?: InputMaybe<StrategyFieldFilter>;
};

export type StrategyImpact = {
  __typename?: 'StrategyImpact';
  author: PersonReference;
  /** ffmAlias: strategyImpactId */
  id: Scalars['ObjectID']['output'];
  name: Scalars['String']['output'];
  organization: OrganizationReference;
  translations?: Maybe<Scalars['JSON']['output']>;
};

export type StrategyImpactCreationInput = {
  author: PersonReferenceInput;
  name: Scalars['String']['input'];
  organization: OrganizationReferenceInput;
  translations?: InputMaybe<Scalars['JSON']['input']>;
};

export type StrategyImpactReferenceInput = {
  name: Scalars['String']['input'];
  strategyImpactId: Scalars['ObjectID']['input'];
};

export type StrategyImpactUpdateInput = {
  name: Scalars['String']['input'];
  organization: OrganizationReferenceInput;
  translations?: InputMaybe<Scalars['JSON']['input']>;
};

export type StrategyImpactsFilter = {
  _id?: InputMaybe<ObjectIdFilter>;
};

export type StrategyImpactsInput = {
  filter?: InputMaybe<StrategyImpactsFilter>;
};

export type StrategyKpi = {
  __typename?: 'StrategyKpi';
  id: Scalars['ObjectID']['output'];
  isAssigned: Scalars['Boolean']['output'];
  organization: Organization;
  stage: Scalars['Int']['output'];
  strategyField: StrategyField;
  strategyKpiCategories: Array<StrategyKpiCategory>;
  title: Scalars['String']['output'];
};

export type StrategyKpiCategoriesInput = {
  filter?: InputMaybe<StrategyKpiCategoryFilter>;
};

export type StrategyKpiCategory = {
  __typename?: 'StrategyKpiCategory';
  id: Scalars['ObjectID']['output'];
  isAssigned: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
  stage: Scalars['Int']['output'];
  strategyKpi: StrategyKpi;
};

export type StrategyKpiCategoryFilter = {
  _and?: InputMaybe<Array<InputMaybe<StrategyKpiCategoryFilter>>>;
  _or?: InputMaybe<Array<InputMaybe<StrategyKpiCategoryFilter>>>;
  organization?: InputMaybe<BigIntFilter>;
  stage?: InputMaybe<IntFilter>;
  strategyKpi?: InputMaybe<ObjectIdFilter>;
};

export type StrategyKpiFilter = {
  _or?: InputMaybe<Array<InputMaybe<StrategyKpiFilter>>>;
  organization?: InputMaybe<BigIntFilter>;
  stage?: InputMaybe<IntFilter>;
  strategyField?: InputMaybe<ObjectIdFilter>;
};

export type StrategyKpisInput = {
  filter?: InputMaybe<StrategyKpiFilter>;
};

export type StrategyStage = {
  __typename?: 'StrategyStage';
  id: Scalars['ObjectID']['output'];
  isAssigned: Scalars['Boolean']['output'];
  visibleForDealer: Scalars['Date']['output'];
  visibleForManager: Scalars['Date']['output'];
  year: Scalars['Int']['output'];
};

export type StrategyStageFilter = {
  _id?: InputMaybe<ObjectIdFilter>;
  year?: InputMaybe<IntFilter>;
};

export type StrategyStagesFilterInput = {
  filter?: InputMaybe<StrategyStageFilter>;
};

export type StringArrayFilter = {
  _in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StringFilter = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _exists?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  _nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  _options?: InputMaybe<Scalars['StringFilterRegexOptions']['input']>;
  _regex?: InputMaybe<Scalars['String']['input']>;
};

export type StringQuery = {
  __typename?: 'StringQuery';
  _eq?: Maybe<Scalars['String']['output']>;
};

export type Sunburst = {
  __typename?: 'Sunburst';
  d3Children?: Maybe<Scalars['JSON']['output']>;
  hasData?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orgId?: Maybe<Scalars['BigInt']['output']>;
  parentId?: Maybe<Scalars['BigInt']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type SupportRequest = {
  __typename?: 'SupportRequest';
  application: Scalars['String']['output'];
  attachments?: Maybe<Array<Attachment>>;
  author: Person;
  comments: Array<Comment>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  details?: Maybe<SupportRequestDetails>;
  hasNewActivity: Scalars['Boolean']['output'];
  id: Scalars['ObjectID']['output'];
  organization: Organization;
  referencePerson?: Maybe<Person>;
  status: SupportRequestStatus;
  title: Scalars['String']['output'];
};

export type SupportRequestDetails = {
  __typename?: 'SupportRequestDetails';
  browserWindowSize: SupportRequestSize;
  screenSize: SupportRequestSize;
  userAgent: Scalars['String']['output'];
};

export type SupportRequestDetailsInput = {
  browserWindowSize: SupportRequestSizeInput;
  screenSize: SupportRequestSizeInput;
  userAgent: Scalars['String']['input'];
};

export type SupportRequestSize = {
  __typename?: 'SupportRequestSize';
  height: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};

export type SupportRequestSizeInput = {
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

export enum SupportRequestStatus {
  Closed = 'CLOSED',
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN'
}

export type Survey = {
  __typename?: 'Survey';
  ancestorVersion?: Maybe<Survey>;
  anonymousAnswers?: Maybe<Scalars['Boolean']['output']>;
  anonymousTokens?: Maybe<Array<SurveyAnonymousToken>>;
  answerableFor: Array<Answerable>;
  answers: Array<SurveyAnswer>;
  answersAllowedBy?: Maybe<Array<Person>>;
  answersAllowedByPerOrganization?: Maybe<Array<AnswersAllowedByPerOrganization>>;
  author: Person;
  canCreateActionItems: Scalars['Boolean']['output'];
  color: Scalars['String']['output'];
  effectiveFrom: Scalars['Date']['output'];
  effectiveTo?: Maybe<Scalars['Date']['output']>;
  entryPeriodMode?: Maybe<SurveyEntryPeriodMode>;
  equalQuestionWeighting?: Maybe<Scalars['Boolean']['output']>;
  frequency?: Maybe<SurveyFrequency>;
  hasAssignedAnswers?: Maybe<Scalars['Boolean']['output']>;
  hasDefaultWeights?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ObjectID']['output'];
  instances: Array<SurveyInstance>;
  isActive: Scalars['Boolean']['output'];
  items: Array<SurveyItem>;
  languages: Array<Scalars['String']['output']>;
  /** Localized field for nameLocalizations */
  name: Scalars['String']['output'];
  nameLocalizations: Array<LocalizedString>;
  organizations?: Maybe<Array<Organization>>;
  persons?: Maybe<Array<Person>>;
  template?: Maybe<SurveyTemplate>;
  type: SurveyType;
  version: Scalars['Int']['output'];
  weight: Scalars['Int']['output'];
  weightsChangedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type SurveyAnswersArgs = {
  answeredFor?: InputMaybe<Array<Scalars['SurveyAnsweredFor']['input']>>;
  items?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  period?: InputMaybe<Scalars['Date']['input']>;
  periods?: InputMaybe<Array<Scalars['Date']['input']>>;
};


export type SurveyItemsArgs = {
  ids?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
};

export type SurveyAnonymousToken = {
  __typename?: 'SurveyAnonymousToken';
  createdAt: Scalars['DateTime']['output'];
  expireAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectID']['output'];
  organization: Organization;
  token: Scalars['String']['output'];
};

export type SurveyAnonymousUser = {
  __typename?: 'SurveyAnonymousUser';
  id: Scalars['ID']['output'];
  organization: Organization;
};

export type SurveyAnswer = {
  actionItemIds?: Maybe<Array<Scalars['ObjectID']['output']>>;
  answeredFor: Scalars['SurveyAnsweredFor']['output'];
  dependingAnswers?: Maybe<Array<SurveyAnswer>>;
  dependingItems?: Maybe<Array<SurveyItem>>;
  id: Scalars['ObjectID']['output'];
  isAnswered: Scalars['Boolean']['output'];
  itemId: Scalars['ObjectID']['output'];
  period?: Maybe<Scalars['Date']['output']>;
  survey: Survey;
};

export enum SurveyChartDataOutput {
  Item = 'ITEM',
  Organization = 'ORGANIZATION'
}

export type SurveyDateAnswer = SurveyAnswer & {
  __typename?: 'SurveyDateAnswer';
  actionItemIds?: Maybe<Array<Scalars['ObjectID']['output']>>;
  answeredFor: Scalars['SurveyAnsweredFor']['output'];
  attachments?: Maybe<Array<Attachment>>;
  comment?: Maybe<Scalars['String']['output']>;
  dependingAnswers?: Maybe<Array<SurveyAnswer>>;
  dependingItems?: Maybe<Array<SurveyItem>>;
  id: Scalars['ObjectID']['output'];
  isAnswered: Scalars['Boolean']['output'];
  isNotApplicable?: Maybe<Scalars['Boolean']['output']>;
  itemId: Scalars['ObjectID']['output'];
  period?: Maybe<Scalars['Date']['output']>;
  survey: Survey;
  value?: Maybe<Scalars['Date']['output']>;
};

export type SurveyDateQuestion = SurveyItem & {
  __typename?: 'SurveyDateQuestion';
  allowComment?: Maybe<Scalars['Boolean']['output']>;
  allowNotApplicable?: Maybe<Scalars['Boolean']['output']>;
  allowUpload?: Maybe<Scalars['Boolean']['output']>;
  answer?: Maybe<SurveyDateAnswer>;
  /** Localized field for attachmentsLocalizations */
  attachments?: Maybe<Array<Attachment>>;
  attachmentsLocalizations?: Maybe<Array<LocalizedAttachments>>;
  commentRequired?: Maybe<Scalars['Boolean']['output']>;
  datePrecision: DatePrecision;
  dependencies?: Maybe<SurveyItemDependencies>;
  depth: Scalars['Int']['output'];
  /** Localized field for descriptionLocalizations */
  description?: Maybe<Scalars['String']['output']>;
  descriptionLocalizations?: Maybe<Array<LocalizedString>>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ObjectID']['output'];
  isVisible: Scalars['Boolean']['output'];
  kind: SurveyItemKind;
  /** Localized field for nameLocalizations */
  name: Scalars['String']['output'];
  nameLocalizations: Array<LocalizedString>;
  templateOptions?: Maybe<SurveyItemTemplateOptions>;
  uploadRequired?: Maybe<Scalars['Boolean']['output']>;
};


export type SurveyDateQuestionAnswerArgs = {
  answeredFor: Scalars['SurveyAnsweredFor']['input'];
  period?: InputMaybe<Scalars['Date']['input']>;
};


export type SurveyDateQuestionIsVisibleArgs = {
  answeredFor: Scalars['SurveyAnsweredFor']['input'];
  period?: InputMaybe<Scalars['Date']['input']>;
};

export type SurveyEmailNotification = {
  __typename?: 'SurveyEmailNotification';
  adhoc?: Maybe<Scalars['Boolean']['output']>;
  cron?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  options?: Maybe<SurveyEmailNotificationOption>;
  person: Person;
  topic: SurveyEmailNotificationTopic;
};

export type SurveyEmailNotificationOption = {
  __typename?: 'SurveyEmailNotificationOption';
  surveyAssigned?: Maybe<Scalars['Boolean']['output']>;
  surveyCompleted?: Maybe<Scalars['Boolean']['output']>;
};

export type SurveyEmailNotificationOptionInput = {
  surveyAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  surveyCompleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SurveyEmailNotificationTopic {
  SurveyEvents = 'SURVEY_EVENTS',
  SurveyReminders = 'SURVEY_REMINDERS'
}

export enum SurveyEntryPeriodMode {
  Current = 'Current',
  Previous = 'Previous'
}

export type SurveyEntryValueUnit = {
  __typename?: 'SurveyEntryValueUnit';
  id: Scalars['ObjectID']['output'];
  /** Localized field for nameLocalizations */
  name: Scalars['String']['output'];
  nameLocalizations: Array<LocalizedString>;
  type: SurveyEntryValueUnitType;
};

export enum SurveyEntryValueUnitType {
  Number = 'NUMBER'
}

export type SurveyFilter = {
  _and?: InputMaybe<Array<SurveyFilter>>;
  _id?: InputMaybe<ObjectIdFilter>;
  _or?: InputMaybe<Array<SurveyFilter>>;
  isActive?: InputMaybe<BooleanFilter>;
  nameLocalized?: InputMaybe<StringFilter>;
  type?: InputMaybe<ObjectIdFilter>;
};

export enum SurveyFrequency {
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  Yearly = 'Yearly'
}

export type SurveyInstance = {
  __typename?: 'SurveyInstance';
  answeredFor: Answerable;
  answeredForType: AnswerableType;
  answeredPercentage: Scalars['Float']['output'];
  answersAllowedBy?: Maybe<Array<Person>>;
  answersAllowedByPerOrganization?: Maybe<Array<AnswersAllowedByPerOrganization>>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  latestAnswer?: Maybe<Scalars['DateTime']['output']>;
  /** Localized field for nameLocalizations */
  name: Scalars['String']['output'];
  nameLocalizations: Array<LocalizedString>;
  period?: Maybe<Scalars['Date']['output']>;
  result?: Maybe<SurveyResult>;
  survey: Survey;
  totalPercentage: Scalars['Float']['output'];
};


export type SurveyInstanceResultArgs = {
  cutoffDate?: InputMaybe<Scalars['Date']['input']>;
};

export type SurveyInstanceConnection = {
  __typename?: 'SurveyInstanceConnection';
  edges: Array<SurveyInstanceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SurveyInstanceEdge = {
  __typename?: 'SurveyInstanceEdge';
  cursor: Scalars['Cursor']['output'];
  node: SurveyInstance;
};

export type SurveyInstanceFilter = {
  _and?: InputMaybe<Array<SurveyInstanceFilter>>;
  _id?: InputMaybe<ObjectIdFilter>;
  _or?: InputMaybe<Array<SurveyInstanceFilter>>;
  answeredForType?: InputMaybe<StringFilter>;
  answeredFor_id?: InputMaybe<BigIntFilter>;
  answeredFor_organization_id?: InputMaybe<BigIntFilter>;
  answeredPercentage?: InputMaybe<IntFilter>;
  author_id?: InputMaybe<BigIntFilter>;
  author_name?: InputMaybe<StringFilter>;
  frequency?: InputMaybe<StringFilter>;
  nameLocalized?: InputMaybe<StringFilter>;
  organizationName?: InputMaybe<StringFilter>;
  totalPercentage?: InputMaybe<IntFilter>;
  type_id?: InputMaybe<ObjectIdFilter>;
  type_nameLocalized?: InputMaybe<StringFilter>;
};

export enum SurveyInstanceOrderBy {
  AnsweredPercentage = 'answeredPercentage',
  AuthorName = 'author_name',
  Frequency = 'frequency',
  LatestAnswer = 'latestAnswer',
  NameLocalized = 'nameLocalized',
  OrganizationName = 'organizationName',
  TotalPercentage = 'totalPercentage',
  TypeId = 'type_id',
  TypeNameLocalized = 'type_nameLocalized'
}

export type SurveyItem = {
  dependencies?: Maybe<SurveyItemDependencies>;
  depth: Scalars['Int']['output'];
  id: Scalars['ObjectID']['output'];
  isVisible: Scalars['Boolean']['output'];
  kind: SurveyItemKind;
  /** Localized field for nameLocalizations */
  name: Scalars['String']['output'];
  nameLocalizations: Array<LocalizedString>;
  templateOptions?: Maybe<SurveyItemTemplateOptions>;
};


export type SurveyItemIsVisibleArgs = {
  answeredFor: Scalars['SurveyAnsweredFor']['input'];
  period?: InputMaybe<Scalars['Date']['input']>;
};

export type SurveyItemDependencies = {
  __typename?: 'SurveyItemDependencies';
  query: SurveyItemDependencyQuery;
};

export type SurveyItemDependenciesInput = {
  query: Scalars['JSON']['input'];
};

export type SurveyItemDependencyAnswerQuery = {
  __typename?: 'SurveyItemDependencyAnswerQuery';
  isNotApplicable?: Maybe<BooleanQuery>;
  item?: Maybe<ObjectIdQuery>;
  value?: Maybe<Scalars['SurveyItemDependencyAnswerValue']['output']>;
};

export type SurveyItemDependencyAnswersQuery = {
  __typename?: 'SurveyItemDependencyAnswersQuery';
  _elemMatch?: Maybe<SurveyItemDependencyAnswerQuery>;
};

export type SurveyItemDependencyQuery = {
  __typename?: 'SurveyItemDependencyQuery';
  _and?: Maybe<Array<SurveyItemDependencyQuery>>;
  _or?: Maybe<Array<SurveyItemDependencyQuery>>;
  answers?: Maybe<SurveyItemDependencyAnswersQuery>;
  subject_geography_region?: Maybe<StringQuery>;
};

export type SurveyItemFilter = {
  _id?: InputMaybe<ObjectIdFilter>;
};

export enum SurveyItemKind {
  DateQuestion = 'DATE_QUESTION',
  ItemReference = 'ITEM_REFERENCE',
  LikertScaleQuestion = 'LIKERT_SCALE_QUESTION',
  MultipleChoiceQuestion = 'MULTIPLE_CHOICE_QUESTION',
  MultipleEntryQuestion = 'MULTIPLE_ENTRY_QUESTION',
  NumericQuestion = 'NUMERIC_QUESTION',
  Section = 'SECTION',
  StaticPage = 'STATIC_PAGE',
  TextQuestion = 'TEXT_QUESTION',
  UploadQuestion = 'UPLOAD_QUESTION',
  YesNoQuestion = 'YES_NO_QUESTION'
}

export type SurveyItemReference = SurveyItem & {
  __typename?: 'SurveyItemReference';
  attachmentsLocalizations?: Maybe<Array<LocalizedAttachments>>;
  dependencies?: Maybe<SurveyItemDependencies>;
  depth: Scalars['Int']['output'];
  descriptionLocalizations?: Maybe<Array<LocalizedString>>;
  id: Scalars['ObjectID']['output'];
  isVisible: Scalars['Boolean']['output'];
  kind: SurveyItemKind;
  multipleChoiceLocalizationsOptions?: Maybe<Array<SurveyLocalizationItem>>;
  multipleEntryLocalizationsEntries?: Maybe<Array<SurveyLocalizationItem>>;
  name: Scalars['String']['output'];
  nameLocalizations: Array<LocalizedString>;
  reference: SurveyTemplateItemReference;
  templateOptions?: Maybe<SurveyItemTemplateOptions>;
};


export type SurveyItemReferenceIsVisibleArgs = {
  answeredFor: Scalars['SurveyAnsweredFor']['input'];
  period?: InputMaybe<Scalars['Date']['input']>;
};

export type SurveyItemTemplateOptions = {
  __typename?: 'SurveyItemTemplateOptions';
  isLocked: Scalars['Boolean']['output'];
};

export type SurveyItemTemplateOptionsInput = {
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SurveyLikertScaleAnswer = SurveyAnswer & {
  __typename?: 'SurveyLikertScaleAnswer';
  actionItemIds?: Maybe<Array<Scalars['ObjectID']['output']>>;
  answeredFor: Scalars['SurveyAnsweredFor']['output'];
  attachments?: Maybe<Array<Attachment>>;
  comment?: Maybe<Scalars['String']['output']>;
  dependingAnswers?: Maybe<Array<SurveyAnswer>>;
  dependingItems?: Maybe<Array<SurveyItem>>;
  id: Scalars['ObjectID']['output'];
  isAnswered: Scalars['Boolean']['output'];
  isNotApplicable?: Maybe<Scalars['Boolean']['output']>;
  itemId: Scalars['ObjectID']['output'];
  period?: Maybe<Scalars['Date']['output']>;
  survey: Survey;
  value?: Maybe<Scalars['LikertScaleValue']['output']>;
};

export type SurveyLikertScaleQuestion = SurveyItem & {
  __typename?: 'SurveyLikertScaleQuestion';
  allowComment?: Maybe<Scalars['Boolean']['output']>;
  allowNotApplicable?: Maybe<Scalars['Boolean']['output']>;
  allowUpload?: Maybe<Scalars['Boolean']['output']>;
  answer?: Maybe<SurveyLikertScaleAnswer>;
  /** Localized field for attachmentsLocalizations */
  attachments?: Maybe<Array<Attachment>>;
  attachmentsLocalizations?: Maybe<Array<LocalizedAttachments>>;
  commentRequired?: Maybe<Scalars['Boolean']['output']>;
  dependencies?: Maybe<SurveyItemDependencies>;
  depth: Scalars['Int']['output'];
  /** Localized field for descriptionLocalizations */
  description?: Maybe<Scalars['String']['output']>;
  descriptionLocalizations?: Maybe<Array<LocalizedString>>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ObjectID']['output'];
  isVisible: Scalars['Boolean']['output'];
  kind: SurveyItemKind;
  /** Localized field for nameLocalizations */
  name: Scalars['String']['output'];
  nameLocalizations: Array<LocalizedString>;
  templateOptions?: Maybe<SurveyItemTemplateOptions>;
  uploadRequired?: Maybe<Scalars['Boolean']['output']>;
  weightRange: Array<Scalars['Int']['output']>;
};


export type SurveyLikertScaleQuestionAnswerArgs = {
  answeredFor: Scalars['SurveyAnsweredFor']['input'];
  period?: InputMaybe<Scalars['Date']['input']>;
};


export type SurveyLikertScaleQuestionIsVisibleArgs = {
  answeredFor: Scalars['SurveyAnsweredFor']['input'];
  period?: InputMaybe<Scalars['Date']['input']>;
};

export type SurveyLocalizationItem = {
  __typename?: 'SurveyLocalizationItem';
  id: Scalars['ObjectID']['output'];
  nameLocalizations?: Maybe<Array<LocalizedString>>;
};

export type SurveyLocalizationItemInput = {
  id: Scalars['ObjectID']['input'];
  nameLocalizations: Array<LocalizedStringInput>;
};

export type SurveyMultipleChoiceAnswer = SurveyAnswer & {
  __typename?: 'SurveyMultipleChoiceAnswer';
  actionItemIds?: Maybe<Array<Scalars['ObjectID']['output']>>;
  answeredFor: Scalars['SurveyAnsweredFor']['output'];
  attachments?: Maybe<Array<Attachment>>;
  comment?: Maybe<Scalars['String']['output']>;
  dependingAnswers?: Maybe<Array<SurveyAnswer>>;
  dependingItems?: Maybe<Array<SurveyItem>>;
  id: Scalars['ObjectID']['output'];
  isAnswered: Scalars['Boolean']['output'];
  isNotApplicable?: Maybe<Scalars['Boolean']['output']>;
  itemId: Scalars['ObjectID']['output'];
  otherText?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Scalars['Date']['output']>;
  survey: Survey;
  value?: Maybe<Array<Scalars['ObjectID']['output']>>;
};

export type SurveyMultipleChoiceQuestion = SurveyItem & {
  __typename?: 'SurveyMultipleChoiceQuestion';
  allowComment?: Maybe<Scalars['Boolean']['output']>;
  allowMultiple?: Maybe<Scalars['Boolean']['output']>;
  allowNotApplicable?: Maybe<Scalars['Boolean']['output']>;
  allowUpload?: Maybe<Scalars['Boolean']['output']>;
  answer?: Maybe<SurveyMultipleChoiceAnswer>;
  /** Localized field for attachmentsLocalizations */
  attachments?: Maybe<Array<Attachment>>;
  attachmentsLocalizations?: Maybe<Array<LocalizedAttachments>>;
  commentRequired?: Maybe<Scalars['Boolean']['output']>;
  dependencies?: Maybe<SurveyItemDependencies>;
  depth: Scalars['Int']['output'];
  /** Localized field for descriptionLocalizations */
  description?: Maybe<Scalars['String']['output']>;
  descriptionLocalizations?: Maybe<Array<LocalizedString>>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ObjectID']['output'];
  isVisible: Scalars['Boolean']['output'];
  kind: SurveyItemKind;
  /** Localized field for nameLocalizations */
  name: Scalars['String']['output'];
  nameLocalizations: Array<LocalizedString>;
  options: Array<SurveyMultipleChoiceQuestionOption>;
  templateOptions?: Maybe<SurveyItemTemplateOptions>;
  uploadRequired?: Maybe<Scalars['Boolean']['output']>;
};


export type SurveyMultipleChoiceQuestionAnswerArgs = {
  answeredFor: Scalars['SurveyAnsweredFor']['input'];
  period?: InputMaybe<Scalars['Date']['input']>;
};


export type SurveyMultipleChoiceQuestionIsVisibleArgs = {
  answeredFor: Scalars['SurveyAnsweredFor']['input'];
  period?: InputMaybe<Scalars['Date']['input']>;
};

export type SurveyMultipleChoiceQuestionOption = {
  __typename?: 'SurveyMultipleChoiceQuestionOption';
  id: Scalars['ObjectID']['output'];
  isOther?: Maybe<Scalars['Boolean']['output']>;
  /** Localized field for nameLocalizations */
  name?: Maybe<Scalars['String']['output']>;
  nameLocalizations?: Maybe<Array<LocalizedString>>;
  weight: Scalars['Int']['output'];
};

export type SurveyMultipleEntryAnswer = SurveyAnswer & {
  __typename?: 'SurveyMultipleEntryAnswer';
  actionItemIds?: Maybe<Array<Scalars['ObjectID']['output']>>;
  answeredFor: Scalars['SurveyAnsweredFor']['output'];
  attachments?: Maybe<Array<Attachment>>;
  comment?: Maybe<Scalars['String']['output']>;
  dependingAnswers?: Maybe<Array<SurveyAnswer>>;
  dependingItems?: Maybe<Array<SurveyItem>>;
  id: Scalars['ObjectID']['output'];
  isAnswered: Scalars['Boolean']['output'];
  isNotApplicable?: Maybe<Scalars['Boolean']['output']>;
  itemId: Scalars['ObjectID']['output'];
  period?: Maybe<Scalars['Date']['output']>;
  survey: Survey;
  value?: Maybe<Array<SurveyMultipleEntryAnswerEntry>>;
};

export type SurveyMultipleEntryAnswerEntry = {
  __typename?: 'SurveyMultipleEntryAnswerEntry';
  entryId: Scalars['ObjectID']['output'];
  id: Scalars['ObjectID']['output'];
  value: Scalars['Int']['output'];
};

export type SurveyMultipleEntryEntryAggregate = {
  __typename?: 'SurveyMultipleEntryEntryAggregate';
  avg?: Maybe<Scalars['Float']['output']>;
  count: Scalars['Int']['output'];
  entryId: Scalars['ObjectID']['output'];
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  sum?: Maybe<Scalars['Float']['output']>;
};

export type SurveyMultipleEntryQuestion = SurveyItem & {
  __typename?: 'SurveyMultipleEntryQuestion';
  /** Returns one aggregate per requested period. */
  aggregates: Array<SurveyMultipleEntryQuestionAggregate>;
  allowComment?: Maybe<Scalars['Boolean']['output']>;
  allowNotApplicable?: Maybe<Scalars['Boolean']['output']>;
  allowUpload?: Maybe<Scalars['Boolean']['output']>;
  answer?: Maybe<SurveyMultipleEntryAnswer>;
  /** Localized field for attachmentsLocalizations */
  attachments?: Maybe<Array<Attachment>>;
  attachmentsLocalizations?: Maybe<Array<LocalizedAttachments>>;
  /** Sums values across requested periods per organization, then aggregates those totals. */
  combinedAggregate?: Maybe<SurveyMultipleEntryQuestionCombinedAggregate>;
  commentRequired?: Maybe<Scalars['Boolean']['output']>;
  dependencies?: Maybe<SurveyItemDependencies>;
  depth: Scalars['Int']['output'];
  /** Localized field for descriptionLocalizations */
  description?: Maybe<Scalars['String']['output']>;
  descriptionLocalizations?: Maybe<Array<LocalizedString>>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  entries: Array<SurveyMultipleEntryQuestionEntry>;
  entryValueUnit?: Maybe<SurveyEntryValueUnit>;
  id: Scalars['ObjectID']['output'];
  isVisible: Scalars['Boolean']['output'];
  kind: SurveyItemKind;
  /** Localized field for nameLocalizations */
  name: Scalars['String']['output'];
  nameLocalizations: Array<LocalizedString>;
  templateOptions?: Maybe<SurveyItemTemplateOptions>;
  uploadRequired?: Maybe<Scalars['Boolean']['output']>;
};


export type SurveyMultipleEntryQuestionAggregatesArgs = {
  periods?: InputMaybe<Array<Scalars['Date']['input']>>;
};


export type SurveyMultipleEntryQuestionAnswerArgs = {
  answeredFor: Scalars['SurveyAnsweredFor']['input'];
  period?: InputMaybe<Scalars['Date']['input']>;
};


export type SurveyMultipleEntryQuestionCombinedAggregateArgs = {
  periods: Array<Scalars['Date']['input']>;
};


export type SurveyMultipleEntryQuestionIsVisibleArgs = {
  answeredFor: Scalars['SurveyAnsweredFor']['input'];
  period?: InputMaybe<Scalars['Date']['input']>;
};

export type SurveyMultipleEntryQuestionAggregate = {
  __typename?: 'SurveyMultipleEntryQuestionAggregate';
  count: Scalars['Int']['output'];
  entries: Array<SurveyMultipleEntryEntryAggregate>;
  period?: Maybe<Scalars['Date']['output']>;
};

export type SurveyMultipleEntryQuestionCombinedAggregate = {
  __typename?: 'SurveyMultipleEntryQuestionCombinedAggregate';
  avg?: Maybe<Scalars['Float']['output']>;
  count: Scalars['Int']['output'];
  entries: Array<SurveyMultipleEntryEntryAggregate>;
  sum?: Maybe<Scalars['Float']['output']>;
};

export type SurveyMultipleEntryQuestionEntry = {
  __typename?: 'SurveyMultipleEntryQuestionEntry';
  id: Scalars['ObjectID']['output'];
  /** Localized field for nameLocalizations */
  name: Scalars['String']['output'];
  nameLocalizations: Array<LocalizedString>;
};

export type SurveyNumericAnswer = SurveyAnswer & {
  __typename?: 'SurveyNumericAnswer';
  actionItemIds?: Maybe<Array<Scalars['ObjectID']['output']>>;
  answeredFor: Scalars['SurveyAnsweredFor']['output'];
  attachments?: Maybe<Array<Attachment>>;
  comment?: Maybe<Scalars['String']['output']>;
  dependingAnswers?: Maybe<Array<SurveyAnswer>>;
  dependingItems?: Maybe<Array<SurveyItem>>;
  id: Scalars['ObjectID']['output'];
  isAnswered: Scalars['Boolean']['output'];
  isNotApplicable?: Maybe<Scalars['Boolean']['output']>;
  itemId: Scalars['ObjectID']['output'];
  period?: Maybe<Scalars['Date']['output']>;
  survey: Survey;
  value?: Maybe<Scalars['Float']['output']>;
};

export type SurveyNumericQuestion = SurveyItem & {
  __typename?: 'SurveyNumericQuestion';
  /** Returns one aggregate per requested period. */
  aggregates: Array<SurveyNumericQuestionAggregate>;
  allowComment?: Maybe<Scalars['Boolean']['output']>;
  allowNotApplicable?: Maybe<Scalars['Boolean']['output']>;
  allowUpload?: Maybe<Scalars['Boolean']['output']>;
  answer?: Maybe<SurveyNumericAnswer>;
  /** Localized field for attachmentsLocalizations */
  attachments?: Maybe<Array<Attachment>>;
  attachmentsLocalizations?: Maybe<Array<LocalizedAttachments>>;
  /** Sums values across requested periods per organization, then aggregates those totals. */
  combinedAggregate?: Maybe<SurveyNumericQuestionCombinedAggregate>;
  commentRequired?: Maybe<Scalars['Boolean']['output']>;
  dependencies?: Maybe<SurveyItemDependencies>;
  depth: Scalars['Int']['output'];
  /** Localized field for descriptionLocalizations */
  description?: Maybe<Scalars['String']['output']>;
  descriptionLocalizations?: Maybe<Array<LocalizedString>>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ObjectID']['output'];
  isVisible: Scalars['Boolean']['output'];
  kind: SurveyItemKind;
  /** Localized field for nameLocalizations */
  name: Scalars['String']['output'];
  nameLocalizations: Array<LocalizedString>;
  templateOptions?: Maybe<SurveyItemTemplateOptions>;
  uploadRequired?: Maybe<Scalars['Boolean']['output']>;
  valueUnit?: Maybe<SurveyValueUnit>;
};


export type SurveyNumericQuestionAggregatesArgs = {
  periods?: InputMaybe<Array<Scalars['Date']['input']>>;
};


export type SurveyNumericQuestionAnswerArgs = {
  answeredFor: Scalars['SurveyAnsweredFor']['input'];
  period?: InputMaybe<Scalars['Date']['input']>;
};


export type SurveyNumericQuestionCombinedAggregateArgs = {
  periods: Array<Scalars['Date']['input']>;
};


export type SurveyNumericQuestionIsVisibleArgs = {
  answeredFor: Scalars['SurveyAnsweredFor']['input'];
  period?: InputMaybe<Scalars['Date']['input']>;
};

export type SurveyNumericQuestionAggregate = {
  __typename?: 'SurveyNumericQuestionAggregate';
  avg?: Maybe<Scalars['Float']['output']>;
  count: Scalars['Int']['output'];
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  period?: Maybe<Scalars['Date']['output']>;
  sum?: Maybe<Scalars['Float']['output']>;
};

export type SurveyNumericQuestionCombinedAggregate = {
  __typename?: 'SurveyNumericQuestionCombinedAggregate';
  avg?: Maybe<Scalars['Float']['output']>;
  count: Scalars['Int']['output'];
  sum?: Maybe<Scalars['Float']['output']>;
};

export type SurveyPredefinedItem = {
  __typename?: 'SurveyPredefinedItem';
  config: SurveyItem;
  id: Scalars['ObjectID']['output'];
  languages: Array<Scalars['String']['output']>;
  organizations: Array<Organization>;
};

export type SurveyPredefinedItemFilterInput = {
  _and?: InputMaybe<Array<SurveyPredefinedItemFilterInput>>;
  _or?: InputMaybe<Array<SurveyPredefinedItemFilterInput>>;
  languages?: InputMaybe<StringFilter>;
};

export enum SurveyReportAggregationLevel {
  Market = 'MARKET',
  None = 'NONE',
  Pag = 'PAG',
  Region = 'REGION'
}

export enum SurveyReportChartAnswerValueType {
  PercentAnswered = 'PERCENT_ANSWERED',
  Score = 'SCORE'
}

export enum SurveyReportChartTemplate {
  EsgDetailedOverviewPerKpi = 'ESG_DETAILED_OVERVIEW_PER_KPI',
  EsgFulfillmentOverTime = 'ESG_FULFILLMENT_OVER_TIME',
  EsgPerformanceCategoryLevel = 'ESG_PERFORMANCE_CATEGORY_LEVEL',
  EsgSpiderChartCategoryLevel = 'ESG_SPIDER_CHART_CATEGORY_LEVEL',
  Rcp = 'RCP'
}

export enum SurveyReportChartType {
  ByItem = 'BY_ITEM',
  ByOrganization = 'BY_ORGANIZATION'
}

export type SurveyReportChartVisualization = SurveyReportChartVisualizationBars | SurveyReportChartVisualizationList | SurveyReportChartVisualizationSpider | SurveyReportChartVisualizationTimeline;

export type SurveyReportChartVisualizationBars = {
  __typename?: 'SurveyReportChartVisualizationBars';
  color?: Maybe<Scalars['String']['output']>;
  includeValuesPerSurvey?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<SortOrder>;
  orderBy?: Maybe<SurveyReportOrderBy>;
  orientation: SurveyReportChartVisualizationBarsOrientation;
};

export type SurveyReportChartVisualizationBarsInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  includeValuesPerSurvey?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<SortOrder>;
  orderBy?: InputMaybe<SurveyReportOrderBy>;
  orientation: SurveyReportChartVisualizationBarsOrientation;
};

export enum SurveyReportChartVisualizationBarsOrientation {
  Horizontal = 'HORIZONTAL',
  Vertical = 'VERTICAL'
}

export type SurveyReportChartVisualizationList = {
  __typename?: 'SurveyReportChartVisualizationList';
  limit?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<SortOrder>;
  orderBy?: Maybe<SurveyReportOrderBy>;
};

export type SurveyReportChartVisualizationListInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<SortOrder>;
  orderBy?: InputMaybe<SurveyReportOrderBy>;
};

export type SurveyReportChartVisualizationSpider = {
  __typename?: 'SurveyReportChartVisualizationSpider';
  color?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<SortOrder>;
  orderBy?: Maybe<SurveyReportOrderBy>;
};

export type SurveyReportChartVisualizationSpiderInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<SortOrder>;
  orderBy?: InputMaybe<SurveyReportOrderBy>;
};

export type SurveyReportChartVisualizationTimeline = {
  __typename?: 'SurveyReportChartVisualizationTimeline';
  color?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['Date']['output'];
};

export type SurveyReportChartVisualizationTimelineInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['Date']['input'];
};

export type SurveyReportConfig = {
  __typename?: 'SurveyReportConfig';
  id: Scalars['ObjectID']['output'];
  name: Scalars['String']['output'];
  person: Person;
  sections: Array<SurveyReportConfigSection>;
  type: SurveyReportType;
};

export type SurveyReportConfigChart = {
  __typename?: 'SurveyReportConfigChart';
  aggregationLevel?: Maybe<SurveyReportAggregationLevel>;
  answerValueType?: Maybe<SurveyReportChartAnswerValueType>;
  cutoffDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ObjectID']['output'];
  onlyIncludeOrganizationsWithAnswers?: Maybe<Scalars['Boolean']['output']>;
  organizationIds: Array<Scalars['BigInt']['output']>;
  surveyIds: Array<Scalars['ObjectID']['output']>;
  surveyItemIds?: Maybe<Array<Scalars['ObjectID']['output']>>;
  template?: Maybe<SurveyReportChartTemplate>;
  title: Scalars['String']['output'];
  type: SurveyReportChartType;
  visualization: SurveyReportChartVisualization;
};

export type SurveyReportConfigSection = {
  __typename?: 'SurveyReportConfigSection';
  charts: Array<SurveyReportConfigChart>;
  id: Scalars['ObjectID']['output'];
  width: Scalars['Int']['output'];
};

export type SurveyReportInput = {
  compareToDate?: InputMaybe<Scalars['Date']['input']>;
  compareToOrganizations?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  cutoffDate?: InputMaybe<Scalars['Date']['input']>;
  organizations: Array<Scalars['BigInt']['input']>;
  surveyFilter?: InputMaybe<SurveyFilter>;
};

export enum SurveyReportOrderBy {
  Name = 'name',
  Value = 'value'
}

export enum SurveyReportType {
  Custom = 'CUSTOM',
  PredefinedUrbanFormats = 'PREDEFINED_URBAN_FORMATS',
  PredefinedUrbanFormatsPorscheNow = 'PREDEFINED_URBAN_FORMATS_PORSCHE_NOW'
}

export type SurveyReportValueWithTime = {
  __typename?: 'SurveyReportValueWithTime';
  timestamp: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export type SurveyResult = {
  __typename?: 'SurveyResult';
  answeredFor: Answerable;
  answeredPercentage: Scalars['Float']['output'];
  date: Scalars['Date']['output'];
  id: Scalars['ObjectID']['output'];
  itemResults: Array<Maybe<SurveyResultItem>>;
  totalPercentage: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SurveyResultItem = {
  __typename?: 'SurveyResultItem';
  answeredPercentage?: Maybe<Scalars['Float']['output']>;
  isAnswered?: Maybe<Scalars['Boolean']['output']>;
  itemId: Scalars['ObjectID']['output'];
  percentageOfTotal?: Maybe<Scalars['Float']['output']>;
  possiblePoints: Scalars['Float']['output'];
  reachedPoints: Scalars['Float']['output'];
};

export type SurveyResultsByItemConnection = {
  __typename?: 'SurveyResultsByItemConnection';
  nodes: Array<SurveyResultsByItemNode>;
};

export type SurveyResultsByItemInput = {
  aggregationLevel?: InputMaybe<SurveyReportAggregationLevel>;
  answerValueType?: InputMaybe<SurveyReportChartAnswerValueType>;
  cutoffDate?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIncludeOrganizationsWithAnswers?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<SortOrder>;
  orderBy?: InputMaybe<SurveyReportOrderBy>;
  organizations: Array<Scalars['BigInt']['input']>;
  surveyFilter: SurveyFilter;
  surveyItemFilter?: InputMaybe<SurveyItemFilter>;
};

export type SurveyResultsByItemNode = {
  __typename?: 'SurveyResultsByItemNode';
  id: Scalars['ObjectID']['output'];
  name: Scalars['String']['output'];
  values: Array<SurveyResultsByOrganizationNode>;
};

export type SurveyResultsByItemOverTimeInput = {
  aggregationLevel?: InputMaybe<SurveyReportAggregationLevel>;
  answerValueType?: InputMaybe<SurveyReportChartAnswerValueType>;
  cutoffDate: Scalars['Date']['input'];
  onlyIncludeOrganizationsWithAnswers?: InputMaybe<Scalars['Boolean']['input']>;
  organizations: Array<Scalars['BigInt']['input']>;
  startDate: Scalars['Date']['input'];
  surveyFilter: SurveyFilter;
  surveyItemFilter?: InputMaybe<SurveyItemFilter>;
};

export type SurveyResultsByItemOverTimeNode = {
  __typename?: 'SurveyResultsByItemOverTimeNode';
  id: Scalars['ObjectID']['output'];
  name: Scalars['String']['output'];
  values: Array<SurveyResultsByOrganizationOverTimeNode>;
};

export type SurveyResultsByOrganizationConnection = {
  __typename?: 'SurveyResultsByOrganizationConnection';
  nodes: Array<SurveyResultsByOrganizationNode>;
  totalCount: Scalars['Int']['output'];
};

export type SurveyResultsByOrganizationInput = {
  aggregationLevel?: InputMaybe<SurveyReportAggregationLevel>;
  answerValueType?: InputMaybe<SurveyReportChartAnswerValueType>;
  cutoffDate?: InputMaybe<Scalars['Date']['input']>;
  includeValuesPerSurvey?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIncludeOrganizationsWithAnswers?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<SortOrder>;
  orderBy?: InputMaybe<SurveyReportOrderBy>;
  organizations: Array<Scalars['BigInt']['input']>;
  surveyFilter: SurveyFilter;
  surveyItemFilter?: InputMaybe<SurveyItemFilter>;
};

export type SurveyResultsByOrganizationNode = {
  __typename?: 'SurveyResultsByOrganizationNode';
  id: Scalars['BigInt']['output'];
  name: Scalars['String']['output'];
  organizationCount: Scalars['Int']['output'];
  specificName?: Maybe<Scalars['String']['output']>;
  value: Scalars['Float']['output'];
};

export type SurveyResultsByOrganizationOverTimeInput = {
  aggregationLevel?: InputMaybe<SurveyReportAggregationLevel>;
  answerValueType?: InputMaybe<SurveyReportChartAnswerValueType>;
  cutoffDate: Scalars['Date']['input'];
  onlyIncludeOrganizationsWithAnswers?: InputMaybe<Scalars['Boolean']['input']>;
  organizations: Array<Scalars['BigInt']['input']>;
  startDate: Scalars['Date']['input'];
  surveyFilter: SurveyFilter;
  surveyItemFilter?: InputMaybe<SurveyItemFilter>;
};

export type SurveyResultsByOrganizationOverTimeNode = {
  __typename?: 'SurveyResultsByOrganizationOverTimeNode';
  id: Scalars['BigInt']['output'];
  name: Scalars['String']['output'];
  valueOverTime: Array<SurveyReportValueWithTime>;
};

export type SurveySection = SurveyItem & {
  __typename?: 'SurveySection';
  dependencies?: Maybe<SurveyItemDependencies>;
  depth: Scalars['Int']['output'];
  id: Scalars['ObjectID']['output'];
  isVisible: Scalars['Boolean']['output'];
  kind: SurveyItemKind;
  /** Localized field for nameLocalizations */
  name: Scalars['String']['output'];
  nameLocalizations: Array<LocalizedString>;
  templateOptions?: Maybe<SurveyItemTemplateOptions>;
  weight: Scalars['Int']['output'];
};


export type SurveySectionIsVisibleArgs = {
  answeredFor: Scalars['SurveyAnsweredFor']['input'];
  period?: InputMaybe<Scalars['Date']['input']>;
};

export type SurveyStaticPage = SurveyItem & {
  __typename?: 'SurveyStaticPage';
  dependencies?: Maybe<SurveyItemDependencies>;
  depth: Scalars['Int']['output'];
  /** Localized field for descriptionLocalizations */
  description?: Maybe<Scalars['String']['output']>;
  descriptionLocalizations?: Maybe<Array<LocalizedString>>;
  id: Scalars['ObjectID']['output'];
  isVisible: Scalars['Boolean']['output'];
  kind: SurveyItemKind;
  /** Localized field for nameLocalizations */
  name: Scalars['String']['output'];
  nameLocalizations: Array<LocalizedString>;
  templateOptions?: Maybe<SurveyItemTemplateOptions>;
};


export type SurveyStaticPageIsVisibleArgs = {
  answeredFor: Scalars['SurveyAnsweredFor']['input'];
  period?: InputMaybe<Scalars['Date']['input']>;
};

export enum SurveyTable {
  Overview = 'OVERVIEW'
}

export type SurveyTableConfig = {
  __typename?: 'SurveyTableConfig';
  id: Scalars['ObjectID']['output'];
  person: Person;
  table: SurveyTable;
  visibleColumns: Array<Scalars['String']['output']>;
};

export type SurveyTemplate = {
  __typename?: 'SurveyTemplate';
  ancestorVersion?: Maybe<SurveyTemplate>;
  anonymousAnswers?: Maybe<Scalars['Boolean']['output']>;
  author: Person;
  equalQuestionWeighting?: Maybe<Scalars['Boolean']['output']>;
  hasDefaultWeights?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ObjectID']['output'];
  isActive: Scalars['Boolean']['output'];
  isInUse: Scalars['Boolean']['output'];
  items: Array<SurveyItem>;
  languages: Array<Scalars['String']['output']>;
  /** Localized field for nameLocalizations */
  name: Scalars['String']['output'];
  nameLocalizations: Array<LocalizedString>;
  organizations?: Maybe<Array<Organization>>;
  template?: Maybe<SurveyTemplate>;
  type: SurveyType;
  version: Scalars['Int']['output'];
  weight: Scalars['Int']['output'];
};

export type SurveyTemplateItemReference = {
  __typename?: 'SurveyTemplateItemReference';
  /** Referenced item will never be another SurveyItemReference */
  item: SurveyItem;
  template: SurveyTemplate;
};

export type SurveyTemplateOptionsInput = {
  includeOnlyLockedItems?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SurveyTextAnswer = SurveyAnswer & {
  __typename?: 'SurveyTextAnswer';
  actionItemIds?: Maybe<Array<Scalars['ObjectID']['output']>>;
  answeredFor: Scalars['SurveyAnsweredFor']['output'];
  attachments?: Maybe<Array<Attachment>>;
  dependingAnswers?: Maybe<Array<SurveyAnswer>>;
  dependingItems?: Maybe<Array<SurveyItem>>;
  id: Scalars['ObjectID']['output'];
  isAnswered: Scalars['Boolean']['output'];
  isNotApplicable?: Maybe<Scalars['Boolean']['output']>;
  itemId: Scalars['ObjectID']['output'];
  period?: Maybe<Scalars['Date']['output']>;
  survey: Survey;
  value?: Maybe<Scalars['String']['output']>;
};

export type SurveyTextQuestion = SurveyItem & {
  __typename?: 'SurveyTextQuestion';
  allowNotApplicable?: Maybe<Scalars['Boolean']['output']>;
  allowUpload?: Maybe<Scalars['Boolean']['output']>;
  answer?: Maybe<SurveyTextAnswer>;
  /** Localized field for attachmentsLocalizations */
  attachments?: Maybe<Array<Attachment>>;
  attachmentsLocalizations?: Maybe<Array<LocalizedAttachments>>;
  dependencies?: Maybe<SurveyItemDependencies>;
  depth: Scalars['Int']['output'];
  /** Localized field for descriptionLocalizations */
  description?: Maybe<Scalars['String']['output']>;
  descriptionLocalizations?: Maybe<Array<LocalizedString>>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ObjectID']['output'];
  isVisible: Scalars['Boolean']['output'];
  kind: SurveyItemKind;
  /** Localized field for nameLocalizations */
  name: Scalars['String']['output'];
  nameLocalizations: Array<LocalizedString>;
  templateOptions?: Maybe<SurveyItemTemplateOptions>;
  uploadRequired?: Maybe<Scalars['Boolean']['output']>;
};


export type SurveyTextQuestionAnswerArgs = {
  answeredFor: Scalars['SurveyAnsweredFor']['input'];
  period?: InputMaybe<Scalars['Date']['input']>;
};


export type SurveyTextQuestionIsVisibleArgs = {
  answeredFor: Scalars['SurveyAnsweredFor']['input'];
  period?: InputMaybe<Scalars['Date']['input']>;
};

export type SurveyTranslation = {
  __typename?: 'SurveyTranslation';
  items: Array<SurveyTranslationItem>;
  nameLocalizations: Array<LocalizedString>;
};

export type SurveyTranslationDateQuestion = SurveyTranslationItem & {
  __typename?: 'SurveyTranslationDateQuestion';
  descriptionLocalizations?: Maybe<Array<LocalizedString>>;
  kind: SurveyItemKind;
  nameLocalizations: Array<LocalizedString>;
};

export type SurveyTranslationEntry = {
  __typename?: 'SurveyTranslationEntry';
  nameLocalizations: Array<LocalizedString>;
};

export type SurveyTranslationEntryInput = {
  nameLocalizations: Array<LocalizedStringInput>;
};

export type SurveyTranslationInput = {
  items: Array<SurveyTranslationItemInput>;
  nameLocalizations: Array<LocalizedStringInput>;
};

export type SurveyTranslationItem = {
  kind: SurveyItemKind;
  nameLocalizations: Array<LocalizedString>;
};

export type SurveyTranslationItemInput = {
  descriptionLocalizations?: InputMaybe<Array<LocalizedStringInput>>;
  entries?: InputMaybe<Array<SurveyTranslationEntryInput>>;
  kind: SurveyItemKind;
  nameLocalizations: Array<LocalizedStringInput>;
  options?: InputMaybe<Array<SurveyTranslationOptionInput>>;
};

export type SurveyTranslationLikertScaleQuestion = SurveyTranslationItem & {
  __typename?: 'SurveyTranslationLikertScaleQuestion';
  descriptionLocalizations?: Maybe<Array<LocalizedString>>;
  kind: SurveyItemKind;
  nameLocalizations: Array<LocalizedString>;
};

export type SurveyTranslationMultipleChoiceQuestion = SurveyTranslationItem & {
  __typename?: 'SurveyTranslationMultipleChoiceQuestion';
  descriptionLocalizations?: Maybe<Array<LocalizedString>>;
  kind: SurveyItemKind;
  nameLocalizations: Array<LocalizedString>;
  options?: Maybe<Array<SurveyTranslationOption>>;
};

export type SurveyTranslationMultipleEntryQuestion = SurveyTranslationItem & {
  __typename?: 'SurveyTranslationMultipleEntryQuestion';
  descriptionLocalizations?: Maybe<Array<LocalizedString>>;
  entries?: Maybe<Array<SurveyTranslationEntry>>;
  kind: SurveyItemKind;
  nameLocalizations: Array<LocalizedString>;
};

export type SurveyTranslationNumericQuestion = SurveyTranslationItem & {
  __typename?: 'SurveyTranslationNumericQuestion';
  descriptionLocalizations?: Maybe<Array<LocalizedString>>;
  kind: SurveyItemKind;
  nameLocalizations: Array<LocalizedString>;
};

export type SurveyTranslationOption = {
  __typename?: 'SurveyTranslationOption';
  nameLocalizations?: Maybe<Array<LocalizedString>>;
};

export type SurveyTranslationOptionInput = {
  nameLocalizations?: InputMaybe<Array<LocalizedStringInput>>;
};

export type SurveyTranslationSection = SurveyTranslationItem & {
  __typename?: 'SurveyTranslationSection';
  kind: SurveyItemKind;
  nameLocalizations: Array<LocalizedString>;
};

export type SurveyTranslationStaticPage = SurveyTranslationItem & {
  __typename?: 'SurveyTranslationStaticPage';
  descriptionLocalizations?: Maybe<Array<LocalizedString>>;
  kind: SurveyItemKind;
  nameLocalizations: Array<LocalizedString>;
};

export type SurveyTranslationTextQuestion = SurveyTranslationItem & {
  __typename?: 'SurveyTranslationTextQuestion';
  descriptionLocalizations?: Maybe<Array<LocalizedString>>;
  kind: SurveyItemKind;
  nameLocalizations: Array<LocalizedString>;
};

export type SurveyTranslationUploadQuestion = SurveyTranslationItem & {
  __typename?: 'SurveyTranslationUploadQuestion';
  descriptionLocalizations?: Maybe<Array<LocalizedString>>;
  kind: SurveyItemKind;
  nameLocalizations: Array<LocalizedString>;
};

export type SurveyTranslationYesNoQuestion = SurveyTranslationItem & {
  __typename?: 'SurveyTranslationYesNoQuestion';
  descriptionLocalizations?: Maybe<Array<LocalizedString>>;
  kind: SurveyItemKind;
  nameLocalizations: Array<LocalizedString>;
};

export type SurveyType = {
  __typename?: 'SurveyType';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  hasAssignedSurveys?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ObjectID']['output'];
  /** Localized field for nameLocalizations */
  name: Scalars['String']['output'];
  nameLocalizations: Array<LocalizedString>;
  surveys: Array<Survey>;
};


export type SurveyTypeSurveysArgs = {
  filter?: InputMaybe<SurveyFilter>;
};

export type SurveyUploadAnswer = SurveyAnswer & {
  __typename?: 'SurveyUploadAnswer';
  actionItemIds?: Maybe<Array<Scalars['ObjectID']['output']>>;
  answeredFor: Scalars['SurveyAnsweredFor']['output'];
  attachments?: Maybe<Array<Attachment>>;
  comment?: Maybe<Scalars['String']['output']>;
  dependingAnswers?: Maybe<Array<SurveyAnswer>>;
  dependingItems?: Maybe<Array<SurveyItem>>;
  id: Scalars['ObjectID']['output'];
  isAnswered: Scalars['Boolean']['output'];
  isNotApplicable?: Maybe<Scalars['Boolean']['output']>;
  itemId: Scalars['ObjectID']['output'];
  period?: Maybe<Scalars['Date']['output']>;
  survey: Survey;
  value?: Maybe<Array<Attachment>>;
};

export type SurveyUploadQuestion = SurveyItem & {
  __typename?: 'SurveyUploadQuestion';
  allowComment?: Maybe<Scalars['Boolean']['output']>;
  allowNotApplicable?: Maybe<Scalars['Boolean']['output']>;
  allowUpload?: Maybe<Scalars['Boolean']['output']>;
  answer?: Maybe<SurveyUploadAnswer>;
  /** Localized field for attachmentsLocalizations */
  attachments?: Maybe<Array<Attachment>>;
  attachmentsLocalizations?: Maybe<Array<LocalizedAttachments>>;
  commentRequired?: Maybe<Scalars['Boolean']['output']>;
  dependencies?: Maybe<SurveyItemDependencies>;
  depth: Scalars['Int']['output'];
  /** Localized field for descriptionLocalizations */
  description?: Maybe<Scalars['String']['output']>;
  descriptionLocalizations?: Maybe<Array<LocalizedString>>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ObjectID']['output'];
  isVisible: Scalars['Boolean']['output'];
  kind: SurveyItemKind;
  minimumCount: Scalars['Int']['output'];
  /** Localized field for nameLocalizations */
  name: Scalars['String']['output'];
  nameLocalizations: Array<LocalizedString>;
  templateOptions?: Maybe<SurveyItemTemplateOptions>;
};


export type SurveyUploadQuestionAnswerArgs = {
  answeredFor: Scalars['SurveyAnsweredFor']['input'];
  period?: InputMaybe<Scalars['Date']['input']>;
};


export type SurveyUploadQuestionIsVisibleArgs = {
  answeredFor: Scalars['SurveyAnsweredFor']['input'];
  period?: InputMaybe<Scalars['Date']['input']>;
};

export type SurveyValueUnit = {
  __typename?: 'SurveyValueUnit';
  id: Scalars['ObjectID']['output'];
  /** Localized field for nameLocalizations */
  name: Scalars['String']['output'];
  nameLocalizations: Array<LocalizedString>;
};

export type SurveyYesNoAnswer = SurveyAnswer & {
  __typename?: 'SurveyYesNoAnswer';
  actionItemIds?: Maybe<Array<Scalars['ObjectID']['output']>>;
  answeredFor: Scalars['SurveyAnsweredFor']['output'];
  attachments?: Maybe<Array<Attachment>>;
  comment?: Maybe<Scalars['String']['output']>;
  dependingAnswers?: Maybe<Array<SurveyAnswer>>;
  dependingItems?: Maybe<Array<SurveyItem>>;
  id: Scalars['ObjectID']['output'];
  isAnswered: Scalars['Boolean']['output'];
  isNotApplicable?: Maybe<Scalars['Boolean']['output']>;
  itemId: Scalars['ObjectID']['output'];
  period?: Maybe<Scalars['Date']['output']>;
  survey: Survey;
  value?: Maybe<SurveyYesNoAnswerValue>;
};

export enum SurveyYesNoAnswerValue {
  No = 'No',
  Yes = 'Yes'
}

export type SurveyYesNoQuestion = SurveyItem & {
  __typename?: 'SurveyYesNoQuestion';
  allowComment?: Maybe<Scalars['Boolean']['output']>;
  allowNotApplicable?: Maybe<Scalars['Boolean']['output']>;
  allowUpload?: Maybe<Scalars['Boolean']['output']>;
  answer?: Maybe<SurveyYesNoAnswer>;
  /** Localized field for attachmentsLocalizations */
  attachments?: Maybe<Array<Attachment>>;
  attachmentsLocalizations?: Maybe<Array<LocalizedAttachments>>;
  commentRequired?: Maybe<SurveyYesNoQuestionRequiredField>;
  dependencies?: Maybe<SurveyItemDependencies>;
  depth: Scalars['Int']['output'];
  /** Localized field for descriptionLocalizations */
  description?: Maybe<Scalars['String']['output']>;
  descriptionLocalizations?: Maybe<Array<LocalizedString>>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ObjectID']['output'];
  isVisible: Scalars['Boolean']['output'];
  kind: SurveyItemKind;
  /** Localized field for nameLocalizations */
  name: Scalars['String']['output'];
  nameLocalizations: Array<LocalizedString>;
  templateOptions?: Maybe<SurveyItemTemplateOptions>;
  uploadRequired?: Maybe<SurveyYesNoQuestionRequiredField>;
  weightNo: Scalars['Int']['output'];
  weightYes: Scalars['Int']['output'];
};


export type SurveyYesNoQuestionAnswerArgs = {
  answeredFor: Scalars['SurveyAnsweredFor']['input'];
  period?: InputMaybe<Scalars['Date']['input']>;
};


export type SurveyYesNoQuestionIsVisibleArgs = {
  answeredFor: Scalars['SurveyAnsweredFor']['input'];
  period?: InputMaybe<Scalars['Date']['input']>;
};

export type SurveyYesNoQuestionRequiredField = {
  __typename?: 'SurveyYesNoQuestionRequiredField';
  onNo?: Maybe<Scalars['Boolean']['output']>;
  onYes?: Maybe<Scalars['Boolean']['output']>;
};

export type SurveyYesNoQuestionRequiredFieldInput = {
  onNo?: InputMaybe<Scalars['Boolean']['input']>;
  onYes?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TaskCountFilter = {
  status?: InputMaybe<MultisensoryExperienceMeasureTaskStatusFilter>;
};

export type TranslateSurveyInput = {
  sourceLanguageCode: Scalars['String']['input'];
  survey: SurveyTranslationInput;
  targetLanguageCodes: Array<Scalars['String']['input']>;
};

export type TranslationFilter = {
  locale: Scalars['String']['input'];
  value: StringFilter;
};

export type TriggerPcRoadmapCommitmentCompletedNotificationInput = {
  afterSalesFieldForce?: InputMaybe<Scalars['Boolean']['input']>;
  headOfSales?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ObjectID']['input'];
  managingDirector?: InputMaybe<Scalars['Boolean']['input']>;
  pfsFieldForce?: InputMaybe<Scalars['Boolean']['input']>;
  salesFieldForce?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateActionItemStatusInput = {
  status: ActionItemStatus;
};

export type UpdateAnnouncementInput = {
  from?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  isActive: Scalars['Boolean']['input'];
  isUserFeedbackActive: Scalars['Boolean']['input'];
  message: Scalars['String']['input'];
  to?: InputMaybe<Scalars['Date']['input']>;
  userFeedbackUrl?: InputMaybe<Scalars['URL']['input']>;
};

export type UpdateApexEmailNotificationInput = {
  adhoc?: InputMaybe<Scalars['Boolean']['input']>;
  cron?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ObjectID']['input'];
  topic: ApexEmailNotificationTopic;
};

export type UpdateAttachmentInput = {
  filePrefix?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ObjectID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCommentInput = {
  attachments?: InputMaybe<ModifyAttachmentsInput>;
  id: Scalars['ObjectID']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDashboardEmailNotificationInput = {
  adhoc?: InputMaybe<Scalars['Boolean']['input']>;
  cron?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ObjectID']['input'];
  topic?: InputMaybe<DashboardEmailNotificationTopic>;
};

export type UpdateFeatureArticleInput = {
  apps?: InputMaybe<Array<Scalars['String']['input']>>;
  article?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<Scalars['BigInt']['input']>;
  id: Scalars['ObjectID']['input'];
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  organizations?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  publishedAt?: InputMaybe<Scalars['Date']['input']>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFieldForceManagementDashboardWidgetInput = {
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  settings: FieldForceManagementDashboardWidgetSettingsInput;
  type: FieldForceManagementDashboardWidgetType;
};

export type UpdateFieldForceManagementEmailNotificationInput = {
  adhoc?: InputMaybe<Scalars['Boolean']['input']>;
  cron?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ObjectID']['input'];
  options?: InputMaybe<FieldForceManagementEmailNotificationOptionInput>;
  topic?: InputMaybe<FieldForceManagementEmailNotificationTopic>;
};

export type UpdateFieldForceManagementFeatureFlagInput = {
  id: Scalars['ObjectID']['input'];
  organizations: Array<Scalars['BigInt']['input']>;
  persons: Array<Scalars['BigInt']['input']>;
};

export type UpdateFieldForceManagementFilterPresetInput = {
  id: Scalars['ObjectID']['input'];
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateHelpArticleInput = {
  article?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<AttachmentInput>>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  publishDate?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
  type: HelpArticleType;
  visibleToRoles?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateKpiUnitCategoryInput = {
  /** @deprecated Use actionItemKinds instead */
  actionItemKind?: InputMaybe<ActionItemKind>;
  actionItemKinds?: InputMaybe<Array<ActionItemKind>>;
  id: Scalars['ObjectID']['input'];
  kpiUnitIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  nameLocalizations?: InputMaybe<Array<LocalizedStringInput>>;
  organizationIds?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type UpdateKpiUnitInput = {
  /** @deprecated Use actionItemKinds instead */
  actionItemKind?: InputMaybe<ActionItemKind>;
  actionItemKinds?: InputMaybe<Array<ActionItemKind>>;
  id: Scalars['ObjectID']['input'];
  irisKey?: InputMaybe<Scalars['String']['input']>;
  nameLocalizations?: InputMaybe<Array<LocalizedStringInput>>;
  organizationIds?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type UpdateMeetingInput = {
  agenda?: InputMaybe<Array<InputMaybe<AgendaItemInput>>>;
  approver?: InputMaybe<PersonReferenceInput>;
  attachments?: InputMaybe<Array<InputMaybe<AttachmentInput>>>;
  attendees?: InputMaybe<Array<InputMaybe<PersonReferenceInput>>>;
  author?: InputMaybe<PersonReferenceInput>;
  categories?: InputMaybe<Array<InputMaybe<CategoryReferenceInput>>>;
  coachingModules?: InputMaybe<Array<CoachingModuleReferenceInput>>;
  comments?: InputMaybe<Array<InputMaybe<CommentInput>>>;
  consultants?: InputMaybe<Array<InputMaybe<PersonReferenceInput>>>;
  consultingMeetingType?: InputMaybe<Array<InputMaybe<ConsultingMeetingTypeReferenceInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  externals?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  isConfidential?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<MeetingKind>;
  meetingId?: InputMaybe<Scalars['ObjectID']['input']>;
  organization?: InputMaybe<OrganizationReferenceInput>;
  peerGroup?: InputMaybe<Scalars['ObjectID']['input']>;
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  scheduledTimeEnd?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledTimeStart?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<MeetingStatus>;
  subject?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<MeetingType>;
};

export type UpdateMeetingStatusInput = {
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  status: MeetingStatus;
};

export type UpdateMultisensoryExperienceAreaInput = {
  format?: InputMaybe<MultisensoryExperienceFormat>;
  id: Scalars['ObjectID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMultisensoryExperienceAttachmentInput = {
  comments?: InputMaybe<ModifyCommentsInput>;
  filePrefix?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ObjectID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<MultisensoryExperienceAttachmentVisibility>;
};

export type UpdateMultisensoryExperienceBundleInput = {
  areaIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  id: Scalars['ObjectID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  itemIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMultisensoryExperienceEmailNotificationInput = {
  adhoc?: InputMaybe<Scalars['Boolean']['input']>;
  cron?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ObjectID']['input'];
  options?: InputMaybe<MultisensoryExperienceEmailNotificationOptionInput>;
  topic: MultisensoryExperienceEmailNotificationTopic;
};

export type UpdateMultisensoryExperienceFilterPresetInput = {
  filter?: InputMaybe<MultisensoryExperienceFilterPresetConfigInput>;
  id: Scalars['ObjectID']['input'];
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMultisensoryExperienceInput = {
  attachments?: InputMaybe<ModifyMultisensoryExperienceAttachmentInput>;
  budgetIsAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  comments?: InputMaybe<ModifyCommentsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ObjectID']['input'];
  includesDestinationPorscheFurniture?: InputMaybe<Scalars['Boolean']['input']>;
  plannedCompletion?: InputMaybe<Scalars['Date']['input']>;
  projectCompletionWithinStartYear?: InputMaybe<Scalars['Boolean']['input']>;
  relatedMeasures?: InputMaybe<Array<MultisensoryExperienceRelatedMeasureInput>>;
  start?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<MultisensoryExperienceStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMultisensoryExperienceItemInput = {
  areaIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  category?: InputMaybe<MultisensoryExperienceItemCategory>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ObjectID']['input'];
  image?: InputMaybe<UpdateAttachmentInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['URL']['input']>;
};

export type UpdateMultisensoryExperienceMeasureInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ObjectID']['input'];
  implementationImages?: InputMaybe<ModifyImplementationImagesInput>;
  media?: InputMaybe<ModifyMediaInput>;
  status?: InputMaybe<MultisensoryExperienceMeasureStatus>;
};

export type UpdateMultisensoryExperienceMeasureTaskInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  bundleId?: InputMaybe<Scalars['ObjectID']['input']>;
  comments?: InputMaybe<ModifyCommentsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ObjectID']['input'];
  itemId?: InputMaybe<Scalars['ObjectID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  placements?: InputMaybe<ModifyMultisensoryExperienceMeasureTaskPlacementsInput>;
  status?: InputMaybe<MultisensoryExperienceMeasureTaskStatus>;
};

export type UpdateNetworkPlanningEmailNotificationInput = {
  adhoc?: InputMaybe<Scalars['Boolean']['input']>;
  cron?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ObjectID']['input'];
  topic: NetworkPlanningEmailNotificationTopic;
};

export type UpdateNetworkPlanningFeatureFlagInput = {
  id: Scalars['ObjectID']['input'];
  organizations: Array<Scalars['BigInt']['input']>;
  persons: Array<Scalars['BigInt']['input']>;
};

export type UpdateNetworkPlanningOrganizationInput = {
  actionItemIds?: InputMaybe<ModifyNetworkPlanningOrganizationActionItemsInput>;
  actualInvestor?: InputMaybe<Scalars['String']['input']>;
  actualWorkbays?: InputMaybe<Scalars['Int']['input']>;
  aftersalesAcCharger?: InputMaybe<NetworkPlanningAcChargerInput>;
  aftersalesDcCharger?: InputMaybe<NetworkPlanningDcChargerInput>;
  category?: InputMaybe<NetworkPlanningOrganizationCategory>;
  chargingBackendName?: InputMaybe<Scalars['String']['input']>;
  chargingBackendVendor?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<ModifyCommentsInput>;
  connectedInvestor?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  customerAreaAcCharger?: InputMaybe<NetworkPlanningAcChargerInput>;
  customerAreaDcCharger?: InputMaybe<NetworkPlanningDcChargerInput>;
  dpCompletionExterieur?: InputMaybe<Scalars['DateMonth']['input']>;
  dpCompletionInterieur?: InputMaybe<Scalars['DateMonth']['input']>;
  dpUpgradeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  formatDevelopmentDate?: InputMaybe<Scalars['String']['input']>;
  formatDevelopmentTarget?: InputMaybe<NetworkPlanningOrganizationFormatDevelopmentTarget>;
  importer?: InputMaybe<Scalars['String']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  lastCiUpdate?: InputMaybe<Scalars['Int']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  loadManagementPresent?: InputMaybe<Scalars['Boolean']['input']>;
  loadManagementVendor?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  marketId?: InputMaybe<Scalars['BigInt']['input']>;
  multiBrand?: InputMaybe<NetworkPlanningOrganizationBrand>;
  name?: InputMaybe<Scalars['String']['input']>;
  ncSales?: InputMaybe<Scalars['FloatPerYear']['input']>;
  numberOfWirelessChargers?: InputMaybe<Scalars['Int']['input']>;
  opening?: InputMaybe<Scalars['DateMonth']['input']>;
  organization?: InputMaybe<Scalars['BigInt']['input']>;
  partner?: InputMaybe<NetworkPlanningOrganizationPartner>;
  partnerNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  relatedOrganizationId?: InputMaybe<Scalars['BigInt']['input']>;
  sqm?: InputMaybe<Scalars['FloatPerYear']['input']>;
  status?: InputMaybe<OrganizationStatus>;
  street?: InputMaybe<Scalars['String']['input']>;
  subregion?: InputMaybe<NetworkPlanningOrganizationSubregion>;
  termination?: InputMaybe<Scalars['DateMonth']['input']>;
  type?: InputMaybe<NetworkPlanningOrganizationType>;
  uio?: InputMaybe<Scalars['FloatPerYear']['input']>;
  upgradeType?: InputMaybe<NetworkPlanningOrganizationUpgradeType>;
  wirelessChargerVendor?: InputMaybe<Scalars['String']['input']>;
  workbays?: InputMaybe<Scalars['IntPerYear']['input']>;
};

export type UpdateOccasionRelatedApprovalActionItemInput = {
  actionItemIds: Array<Scalars['ObjectID']['input']>;
  id: Scalars['ObjectID']['input'];
};

export type UpdateOccasionRelatedApprovalInput = {
  adHocResponsibleId?: InputMaybe<Scalars['BigInt']['input']>;
  applicantIds?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  attachments?: InputMaybe<ModifyAttachmentsInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<ModifyCommentsInput>;
  date?: InputMaybe<Scalars['Date']['input']>;
  externalApplicants?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ObjectID']['input'];
  reason?: InputMaybe<Reason>;
  reports?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateOccasionRelatedApprovalReviewInput = {
  id: Scalars['ObjectID']['input'];
  review: Review;
};

export type UpdatePcRoadmapActionItemInput = {
  attachments?: InputMaybe<ModifyAttachmentsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ObjectID']['input'];
  okr?: InputMaybe<Scalars['String']['input']>;
  porscheStrategy2030ActionItemId?: InputMaybe<Scalars['ObjectID']['input']>;
  responsibleId?: InputMaybe<Scalars['BigInt']['input']>;
  status?: InputMaybe<PcRoadmapActionItemStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  workPackages?: InputMaybe<ModifyPcRoadmapWorkPackagesInput>;
};

export type UpdatePcRoadmapActionItemWorkPackageInput = {
  id: Scalars['ObjectID']['input'];
  status?: InputMaybe<PcRoadmapActionItemWorkPackageStatus>;
  targetMonth?: InputMaybe<Scalars['DateMonth']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePcRoadmapAdditionalAgreementInput = {
  descriptionByStage?: InputMaybe<Array<PcRoadmapValueByStageInput>>;
  id: Scalars['ObjectID']['input'];
  kind?: InputMaybe<PcRoadmapAdditionalAgreementKind>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderByStage?: InputMaybe<Array<PcRoadmapOrderByStageInput>>;
  organizationId?: InputMaybe<Scalars['BigInt']['input']>;
  parentId?: InputMaybe<Scalars['ObjectID']['input']>;
  stageIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  templateVariablesByStage?: InputMaybe<Array<PcRoadmapTemplateVariablesByStageInput>>;
};

export type UpdatePcRoadmapAdditionalAgreementValueBonusplanInput = {
  attachments?: InputMaybe<ModifyAttachmentsInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePcRoadmapAdditionalAgreementValueInput = {
  additionalAgreementId: Scalars['ObjectID']['input'];
  bonusplan?: InputMaybe<UpdatePcRoadmapAdditionalAgreementValueBonusplanInput>;
  miscellaneous?: InputMaybe<UpdatePcRoadmapAdditionalAgreementValueMiscellaneousInput>;
  overviewCoachingModules?: InputMaybe<UpdatePcRoadmapAdditionalAgreementValueOverviewCoachingModulesInput>;
  pdaRewardsProgram?: InputMaybe<UpdatePcRoadmapAdditionalAgreementValuePdaRewardsProgramInput>;
  pdaRewardsProgramCounterBusiness?: InputMaybe<UpdatePcRoadmapAdditionalAgreementValuePdaRewardsProgramCounterBusinessInput>;
  porscheDestination?: InputMaybe<UpdatePcRoadmapAdditionalAgreementValuePorscheDestinationInput>;
  signatures?: InputMaybe<UpdatePcRoadmapAdditionalAgreementValueSignaturesInput>;
  sustainability?: InputMaybe<UpdatePcRoadmapAdditionalAgreementValueSustainabilityInput>;
};

export type UpdatePcRoadmapAdditionalAgreementValueMiscellaneousInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  complianceConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  equityRatioAllowance?: InputMaybe<Scalars['Boolean']['input']>;
  equityRatioStatementAcknowledged?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePcRoadmapAdditionalAgreementValueOverviewCoachingModulesInput = {
  coachingModuleIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
};

export type UpdatePcRoadmapAdditionalAgreementValuePdaRewardsProgramCounterBusinessInput = {
  attachments?: InputMaybe<ModifyAttachmentsInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  dutyOfCareResaleAndSanctionsObserved?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePcRoadmapAdditionalAgreementValuePdaRewardsProgramInput = {
  attachments?: InputMaybe<ModifyAttachmentsInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePcRoadmapAdditionalAgreementValuePorscheDestinationInput = {
  changeOptions?: InputMaybe<Array<PcRoadmapAdditionalAgreementValuePorscheDestinationChangeOption>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  plannedAdditionalLocationPorscheApprovedAndServiceCenterYear?: InputMaybe<Scalars['Int']['input']>;
  plannedAdditionalLocationPorscheCenterYear?: InputMaybe<Scalars['Int']['input']>;
  plannedAdditionalLocationPorscheServiceFactoryYear?: InputMaybe<Scalars['Int']['input']>;
  plannedAdditionalLocationSatellitePorscheCenterYear?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePcRoadmapAdditionalAgreementValueSignatureInput = {
  acknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  personId?: InputMaybe<Scalars['BigInt']['input']>;
};

export type UpdatePcRoadmapAdditionalAgreementValueSignaturesInput = {
  afterSalesFieldForce?: InputMaybe<UpdatePcRoadmapAdditionalAgreementValueSignatureInput>;
  headOfSales?: InputMaybe<UpdatePcRoadmapAdditionalAgreementValueSignatureInput>;
  managingDirector?: InputMaybe<UpdatePcRoadmapAdditionalAgreementValueSignatureInput>;
  pfsFieldForce?: InputMaybe<UpdatePcRoadmapAdditionalAgreementValueSignatureInput>;
  salesFieldForce?: InputMaybe<UpdatePcRoadmapAdditionalAgreementValueSignatureInput>;
};

export type UpdatePcRoadmapAdditionalAgreementValueSustainabilityInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  isoCertification?: InputMaybe<PcRoadmapAdditionalAgreementValueSustainabilityIsoCertification>;
};

export type UpdatePcRoadmapApplicableDocumentInput = {
  attachment?: InputMaybe<AttachmentInput>;
  id: Scalars['ObjectID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stageIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  strategyKpiId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type UpdatePcRoadmapCommitmentInput = {
  additionalAgreementValues?: InputMaybe<ModifyPcRoadmapAdditionalAgreementValueInput>;
  id: Scalars['ObjectID']['input'];
  mission?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PcRoadmapCommitmentStatus>;
  visibleForDealer?: InputMaybe<Scalars['Boolean']['input']>;
  vision?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePcRoadmapFurtherDetailInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ObjectID']['input'];
  stageIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  strategyKpiId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type UpdatePcRoadmapStageInput = {
  id: Scalars['ObjectID']['input'];
  visibleForDealer?: InputMaybe<Scalars['Date']['input']>;
  visibleForManager?: InputMaybe<Scalars['Date']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePcRoadmapStrategyFieldInput = {
  colorByStage?: InputMaybe<Array<PcRoadmapValueByStageInput>>;
  iconByStage?: InputMaybe<Array<PcRoadmapValueByStageInput>>;
  id: Scalars['ObjectID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  orderByStage?: InputMaybe<Array<PcRoadmapOrderByStageInput>>;
  organizationId?: InputMaybe<Scalars['BigInt']['input']>;
  stageIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
};

export type UpdatePcRoadmapStrategyKpiCategoryInput = {
  additionalDescriptionByStage?: InputMaybe<Array<PcRoadmapValueByStageInput>>;
  decimalPrecision?: InputMaybe<Scalars['Int']['input']>;
  descriptionByStage?: InputMaybe<Array<PcRoadmapValueByStageInput>>;
  id: Scalars['ObjectID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  orderByStage?: InputMaybe<Array<PcRoadmapOrderByStageInput>>;
  reportingDescriptionByStage?: InputMaybe<Array<PcRoadmapValueByStageInput>>;
  reportingDescriptionSourceByStage?: InputMaybe<Array<PcRoadmapValueByStageInput>>;
  stageIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  strategyKpiId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type UpdatePcRoadmapStrategyKpiInput = {
  additionalDescriptionByStage?: InputMaybe<Array<PcRoadmapValueByStageInput>>;
  decimalPrecision?: InputMaybe<Scalars['Int']['input']>;
  descriptionByStage?: InputMaybe<Array<PcRoadmapValueByStageInput>>;
  id: Scalars['ObjectID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  orderByStage?: InputMaybe<Array<PcRoadmapOrderByStageInput>>;
  reportingDescriptionByStage?: InputMaybe<Array<PcRoadmapValueByStageInput>>;
  reportingDescriptionSourceByStage?: InputMaybe<Array<PcRoadmapValueByStageInput>>;
  stageIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  strategyFieldId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type UpdatePersonInput = {
  acknowledgements?: InputMaybe<PersonAcknowledgementsInput>;
  /** @deprecated Field no longer supported */
  consents?: InputMaybe<PersonConsentsInput>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  settings?: InputMaybe<PersonSettingsInput>;
};

export type UpdatePersonSettingsInput = {
  actionItemListColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  dateFormat?: InputMaybe<Scalars['String']['input']>;
  defaultApprover?: InputMaybe<PersonReferenceInput>;
  defaultCurrency?: InputMaybe<Scalars['String']['input']>;
  emailReportTimezone?: InputMaybe<Scalars['String']['input']>;
  exportMode?: InputMaybe<Scalars['String']['input']>;
  is24HourFormat?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  meetingListColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  ppnuid?: InputMaybe<Scalars['String']['input']>;
  printMode?: InputMaybe<PrintMode>;
};

export type UpdatePorscheImportAgreementsChangeRequestApprovalInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<PorscheImportAgreementsChangeRequestApprovalDepartment>;
  id: Scalars['ObjectID']['input'];
  personId?: InputMaybe<Scalars['BigInt']['input']>;
  status?: InputMaybe<PorscheImportAgreementsChangeRequestApprovalStatus>;
};

export type UpdatePorscheImportAgreementsChangeRequestDeliveryTermsPartsDetailsInput = {
  attachments?: InputMaybe<ModifyAttachmentsInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  destinationCurrent: Scalars['String']['input'];
  destinationTarget: Scalars['String']['input'];
  incotermCurrent: Scalars['ObjectID']['input'];
  incotermTarget: Scalars['ObjectID']['input'];
};

export type UpdatePorscheImportAgreementsChangeRequestDeliveryTermsVehiclesDetailsInput = {
  attachments?: InputMaybe<ModifyAttachmentsInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  destinationCurrent: Scalars['String']['input'];
  destinationTarget: Scalars['String']['input'];
  incotermCurrent: Scalars['ObjectID']['input'];
  incotermTarget: Scalars['ObjectID']['input'];
};

export type UpdatePorscheImportAgreementsChangeRequestInput = {
  adjustmentAt?: InputMaybe<Scalars['Date']['input']>;
  approvals?: InputMaybe<ModifyPorscheImportAgreementsChangeRequestApprovalsInput>;
  deliveryTermsPartsDetails?: InputMaybe<UpdatePorscheImportAgreementsChangeRequestDeliveryTermsPartsDetailsInput>;
  deliveryTermsVehiclesDetails?: InputMaybe<UpdatePorscheImportAgreementsChangeRequestDeliveryTermsVehiclesDetailsInput>;
  id: Scalars['ObjectID']['input'];
  managingDirectorDetails?: InputMaybe<UpdatePorscheImportAgreementsChangeRequestManagingDirectorDetailsInput>;
  masterDataDetails?: InputMaybe<UpdatePorscheImportAgreementsChangeRequestMasterDataDetailsInput>;
  paymentTermsPartsDetails?: InputMaybe<UpdatePorscheImportAgreementsChangeRequestPaymentTermsPartsDetailsInput>;
  paymentTermsVehiclesDetails?: InputMaybe<UpdatePorscheImportAgreementsChangeRequestPaymentTermsVehiclesDetailsInput>;
  status?: InputMaybe<PorscheImportAgreementsChangeRequestStatus>;
  switchoverAt?: InputMaybe<Scalars['Date']['input']>;
  transferOfRiskVehiclesDetails?: InputMaybe<UpdatePorscheImportAgreementsChangeRequestTransferOfRiskVehiclesDetailsInput>;
};

export type UpdatePorscheImportAgreementsChangeRequestManagingDirectorDetailsInput = {
  attachments?: InputMaybe<ModifyAttachmentsInput>;
  externalPersonCurrent?: InputMaybe<Scalars['String']['input']>;
  externalPersonTarget?: InputMaybe<Scalars['String']['input']>;
  integritySearch: Scalars['Boolean']['input'];
  integritySearchHits?: InputMaybe<Scalars['Boolean']['input']>;
  personCurrent?: InputMaybe<Scalars['BigInt']['input']>;
  personTarget?: InputMaybe<Scalars['BigInt']['input']>;
};

export type UpdatePorscheImportAgreementsChangeRequestMasterDataDetailsInput = {
  businessCity?: InputMaybe<Scalars['String']['input']>;
  businessCompanyName?: InputMaybe<Scalars['String']['input']>;
  businessPostalCode?: InputMaybe<Scalars['String']['input']>;
  businessStreet?: InputMaybe<Scalars['String']['input']>;
  commercialRegister: Scalars['String']['input'];
  companyLegalName: Scalars['String']['input'];
  isBusinessAddressIdentical: Scalars['Boolean']['input'];
  registerCourt: Scalars['String']['input'];
  registeredCity: Scalars['String']['input'];
  registeredCompanyName: Scalars['String']['input'];
  registeredPostalCode: Scalars['String']['input'];
  registeredStreet: Scalars['String']['input'];
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePorscheImportAgreementsChangeRequestPaymentTermsPartsDetailsInput = {
  attachments?: InputMaybe<ModifyAttachmentsInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  paymentTermCurrent: Scalars['ObjectID']['input'];
  paymentTermTarget: Scalars['ObjectID']['input'];
};

export type UpdatePorscheImportAgreementsChangeRequestPaymentTermsVehiclesDetailsInput = {
  attachments?: InputMaybe<ModifyAttachmentsInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  paymentTermCurrent: Scalars['ObjectID']['input'];
  paymentTermTarget: Scalars['ObjectID']['input'];
};

export type UpdatePorscheImportAgreementsChangeRequestTransferOfRiskVehiclesDetailsInput = {
  attachments?: InputMaybe<ModifyAttachmentsInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePorscheImportAgreementsEmailNotificationInput = {
  adhoc?: InputMaybe<Scalars['Boolean']['input']>;
  cron?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ObjectID']['input'];
  topic: PorscheImportAgreementsEmailNotificationTopic;
};

export type UpdatePorscheImportAgreementsIncotermInput = {
  id: Scalars['ObjectID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePorscheImportAgreementsPaymentTermInput = {
  id: Scalars['ObjectID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePorscheStrategy2030EmailNotificationInput = {
  adhoc?: InputMaybe<Scalars['Boolean']['input']>;
  cron?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ObjectID']['input'];
  options?: InputMaybe<PorscheStrategy2030EmailNotificationOptionInput>;
  topic: PorscheStrategy2030EmailNotificationTopic;
};

export type UpdateRealEstatePropertyCommentInput = {
  id: Scalars['ObjectID']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Only supplied fields are changed. Explicit null clears optional fields. */
export type UpdateRealEstatePropertyInput = {
  annualRent?: InputMaybe<Scalars['SafeInt']['input']>;
  bookValue?: InputMaybe<Scalars['SafeInt']['input']>;
  buildingSizeInM2?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<ModifyRealEstatePropertyCommentsInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  earliestTermination?: InputMaybe<Scalars['DateTime']['input']>;
  headcount?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ObjectID']['input'];
  integratedFunctions?: InputMaybe<Scalars['String']['input']>;
  landlord?: InputMaybe<Scalars['String']['input']>;
  lastRenovation?: InputMaybe<Scalars['Int']['input']>;
  leaseEnd?: InputMaybe<Scalars['DateTime']['input']>;
  leaseStart?: InputMaybe<Scalars['DateTime']['input']>;
  marketId?: InputMaybe<Scalars['BigInt']['input']>;
  numberOfParking?: InputMaybe<Scalars['Int']['input']>;
  occupation?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['BigInt']['input']>;
  ownership?: InputMaybe<RealEstatePropertyOwnership>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  prolongation?: InputMaybe<Scalars['Boolean']['input']>;
  sharedWithOr?: InputMaybe<Scalars['Boolean']['input']>;
  siteLandplotSizeInM2?: InputMaybe<Scalars['Int']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  subsidiaryId?: InputMaybe<Scalars['BigInt']['input']>;
  usage?: InputMaybe<RealEstatePropertyUsageInput>;
  use?: InputMaybe<RealEstatePropertyUse>;
  yearOfConstruction?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateRetailDesignAbsenceNoteInput = {
  description: Scalars['String']['input'];
  from?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  isActive: Scalars['Boolean']['input'];
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateRetailDesignDocumentInput = {
  id: Scalars['ObjectID']['input'];
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  mandatoryForStatus: Array<RetailDesignProjectStatus>;
  mandatoryOnlyForFormatIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  name: Scalars['String']['input'];
  translations?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateRetailDesignEmailNotificationInput = {
  adhoc?: InputMaybe<Scalars['Boolean']['input']>;
  cron?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ObjectID']['input'];
  options?: InputMaybe<RetailDesignEmailNotificationOptionInput>;
  topic: RetailDesignEmailNotificationTopic;
};

export type UpdateRetailDesignFilterPresetInput = {
  filter?: InputMaybe<RetailDesignFilterPresetConfigInput>;
  id: Scalars['ObjectID']['input'];
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRetailDesignFormatInput = {
  /** @deprecated Use hasNoWorkshopThroughput instead */
  hasNoAftersalesThroughput?: InputMaybe<Scalars['Boolean']['input']>;
  hasNoBodyAndPaintThroughput?: InputMaybe<Scalars['Boolean']['input']>;
  hasNoNCSalesVolume?: InputMaybe<Scalars['Boolean']['input']>;
  hasNoWorkshopThroughput?: InputMaybe<Scalars['Boolean']['input']>;
  hasRelatedOrganization?: InputMaybe<RetailDesignFormatRelatedOrganizationInput>;
  id: Scalars['ObjectID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  needsAftersalesApproval?: InputMaybe<Scalars['Boolean']['input']>;
  needsApprovalProcessType?: InputMaybe<RetailDesignFormatApprovalProcessType>;
  needsBrandManagementApproval?: InputMaybe<RetailDesignFormatBrandManagementApprovalInput>;
  translations?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateRetailDesignProjectAttachmentInput = {
  comments?: InputMaybe<ModifyCommentsInput>;
  filePrefix?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ObjectID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<RetailDesignProjectAttachmentVisibility>;
};

export type UpdateRetailDesignProjectConstructionInput = {
  afterSalesApproved?: InputMaybe<Scalars['Boolean']['input']>;
  attachments?: InputMaybe<ModifyRetailDesignProjectAttachmentInput>;
  bookmark?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<ModifyCommentsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  expectedBodyAndPaintThroughputPerDay?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  expectedSalesVolumePerYear?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  expectedWorkshopThroughputPerDay?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  formatApprovalId?: InputMaybe<Scalars['ObjectID']['input']>;
  formatId?: InputMaybe<Scalars['ObjectID']['input']>;
  internalDocumentsEditingStatus?: InputMaybe<RetailDesignProjectInternalDocumentsEditingStatus>;
  organizationId?: InputMaybe<Scalars['BigInt']['input']>;
  plannedConstructionCompletion?: InputMaybe<Scalars['DateMonth']['input']>;
  plannedConstructionStart?: InputMaybe<Scalars['DateMonth']['input']>;
  relatedOrganizationId?: InputMaybe<Scalars['BigInt']['input']>;
  relationType?: InputMaybe<RetailDesignProjectRelationType>;
  retailDesignApproved?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<RetailDesignProjectStatus>;
  street?: InputMaybe<Scalars['String']['input']>;
  sustainabilityRcp?: InputMaybe<RetailDesignProjectConstructionSustainabilityRcpInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type UpdateRetailDesignProjectFormatApprovalInput = {
  attachments?: InputMaybe<ModifyRetailDesignProjectAttachmentInput>;
  bookmark?: InputMaybe<Scalars['Boolean']['input']>;
  brandManagementApproved?: InputMaybe<Scalars['Boolean']['input']>;
  brandType?: InputMaybe<RetailDesignProjectFormatApprovalBrandType>;
  brandTypeDescription?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  closingDate?: InputMaybe<Scalars['DateMonth']['input']>;
  collaborationWithOtherBrands?: InputMaybe<Scalars['Boolean']['input']>;
  collaborationWithOtherBrandsDescription?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<ModifyCommentsInput>;
  contactPersonId?: InputMaybe<Scalars['BigInt']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayOfNewVehicles?: InputMaybe<Scalars['Boolean']['input']>;
  foodAndBeverageIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  foodAndBeverageIntegrationDescription?: InputMaybe<Scalars['String']['input']>;
  formatId?: InputMaybe<Scalars['ObjectID']['input']>;
  investor?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<RetailDesignProjectFormatApprovalLocation>;
  locationDescription?: InputMaybe<Scalars['String']['input']>;
  merchandiseOrLifestyleProducts?: InputMaybe<Scalars['Boolean']['input']>;
  merchandiseOrLifestyleProductsDescription?: InputMaybe<Scalars['String']['input']>;
  openingDate?: InputMaybe<Scalars['DateMonth']['input']>;
  organizationId?: InputMaybe<Scalars['BigInt']['input']>;
  plannedEvents?: InputMaybe<Scalars['Boolean']['input']>;
  plannedEventsDescription?: InputMaybe<Scalars['String']['input']>;
  primaryObjective?: InputMaybe<RetailDesignProjectFormatApprovalPrimaryObjective>;
  primaryObjectiveDescription?: InputMaybe<Scalars['String']['input']>;
  relatedOrganizationId?: InputMaybe<Scalars['BigInt']['input']>;
  retailDesignApproved?: InputMaybe<Scalars['Boolean']['input']>;
  returnOnMarketingInvest?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<RetailDesignProjectStatus>;
  street?: InputMaybe<Scalars['String']['input']>;
  testDrives?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  validSpace?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateRetailDesignProjectInput = {
  construction?: InputMaybe<UpdateRetailDesignProjectConstructionInput>;
  formatApproval?: InputMaybe<UpdateRetailDesignProjectFormatApprovalInput>;
  id: Scalars['ObjectID']['input'];
};

export type UpdateRetailDesignProjectTypeInput = {
  id: Scalars['ObjectID']['input'];
  name: Scalars['String']['input'];
  translations?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateStrategyActionItemInput = {
  attachments?: InputMaybe<ModifyAttachmentsInput>;
  comments?: InputMaybe<ModifyCommentsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ObjectID']['input'];
  kpiCategoryId?: InputMaybe<Scalars['ObjectID']['input']>;
  kpiId?: InputMaybe<Scalars['ObjectID']['input']>;
  okr?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['BigInt']['input']>;
  responsibleId?: InputMaybe<Scalars['BigInt']['input']>;
  status?: InputMaybe<StrategyActionItemStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  workPackages?: InputMaybe<ModifyWorkPackagesInput>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateStrategyActionItemWorkPackageInput = {
  id: Scalars['ObjectID']['input'];
  status?: InputMaybe<StrategyActionItemWorkPackageStatus>;
  targetMonth?: InputMaybe<Scalars['DateMonth']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStrategyFieldInput = {
  assignmentType?: InputMaybe<AssignmentType>;
  color?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ObjectID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  organization: Scalars['BigInt']['input'];
  stage?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateStrategyKpiCategoryInput = {
  id: Scalars['ObjectID']['input'];
  name: Scalars['String']['input'];
  organization?: InputMaybe<Scalars['BigInt']['input']>;
  stage: Scalars['Int']['input'];
  strategyKpi: Scalars['ObjectID']['input'];
};

export type UpdateStrategyKpiInput = {
  id: Scalars['ObjectID']['input'];
  organization?: InputMaybe<Scalars['BigInt']['input']>;
  stage: Scalars['Int']['input'];
  strategyField: Scalars['ObjectID']['input'];
  title: Scalars['String']['input'];
};

export type UpdateStrategyStageInput = {
  id: Scalars['ObjectID']['input'];
  visibleForDealer: Scalars['Date']['input'];
  visibleForManager: Scalars['Date']['input'];
  year: Scalars['Int']['input'];
};

export type UpdateSupportRequestInput = {
  comments?: InputMaybe<ModifyCommentsInput>;
  id: Scalars['ObjectID']['input'];
  lastSeenAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<SupportRequestStatus>;
};

export type UpdateSurveyEmailNotificationInput = {
  adhoc?: InputMaybe<Scalars['Boolean']['input']>;
  cron?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ObjectID']['input'];
  options?: InputMaybe<SurveyEmailNotificationOptionInput>;
  topic: SurveyEmailNotificationTopic;
};

export type UpdateSurveyEntryValueUnitInput = {
  id: Scalars['ObjectID']['input'];
  nameLocalizations: Array<LocalizedStringInput>;
  type: SurveyEntryValueUnitType;
};

export type UpdateSurveyInput = {
  anonymousAnswers?: InputMaybe<Scalars['Boolean']['input']>;
  answersAllowedByIds?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  answersAllowedByPerOrganization?: InputMaybe<Array<AnswersAllowedByPerOrganizationInput>>;
  canCreateActionItems?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  effectiveFrom?: InputMaybe<Scalars['Date']['input']>;
  effectiveTo?: InputMaybe<Scalars['Date']['input']>;
  entryPeriodMode?: InputMaybe<SurveyEntryPeriodMode>;
  equalQuestionWeighting?: InputMaybe<Scalars['Boolean']['input']>;
  frequency?: InputMaybe<SurveyFrequency>;
  hasDefaultWeights?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ObjectID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<Array<UpdateSurveyItemInput>>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLocalizations?: InputMaybe<Array<LocalizedStringInput>>;
  organizationIds?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  personIds?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  typeId?: InputMaybe<Scalars['ObjectID']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSurveyItemDateQuestionInput = {
  allowComment?: InputMaybe<Scalars['Boolean']['input']>;
  allowNotApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  allowUpload?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentsLocalizations?: InputMaybe<Array<LocalizedAttachmentsInput>>;
  commentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  datePrecision?: InputMaybe<DatePrecision>;
  descriptionLocalizations?: InputMaybe<Array<LocalizedStringInput>>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  uploadRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSurveyItemInput = {
  dateQuestion?: InputMaybe<UpdateSurveyItemDateQuestionInput>;
  dependencies?: InputMaybe<SurveyItemDependenciesInput>;
  depth: Scalars['Int']['input'];
  id: Scalars['ObjectID']['input'];
  itemReference?: InputMaybe<UpdateSurveyItemItemReferenceInput>;
  kind: SurveyItemKind;
  likertScaleQuestion?: InputMaybe<UpdateSurveyItemLikertScaleQuestionInput>;
  multipleChoiceQuestion?: InputMaybe<UpdateSurveyItemMultipleChoiceQuestionInput>;
  multipleEntryQuestion?: InputMaybe<UpdateSurveyItemMultipleEntryQuestionInput>;
  nameLocalizations: Array<LocalizedStringInput>;
  numericQuestion?: InputMaybe<UpdateSurveyItemNumericQuestionInput>;
  section?: InputMaybe<UpdateSurveyItemSectionInput>;
  staticPage?: InputMaybe<UpdateSurveyItemStaticPageInput>;
  templateOptions?: InputMaybe<SurveyItemTemplateOptionsInput>;
  textQuestion?: InputMaybe<UpdateSurveyItemTextQuestionInput>;
  uploadQuestion?: InputMaybe<UpdateSurveyItemUploadQuestionInput>;
  yesNoQuestion?: InputMaybe<UpdateSurveyItemYesNoQuestionInput>;
};

export type UpdateSurveyItemItemReferenceInput = {
  attachmentsLocalizations?: InputMaybe<Array<LocalizedAttachmentsInput>>;
  descriptionLocalizations?: InputMaybe<Array<LocalizedStringInput>>;
  itemId?: InputMaybe<Scalars['ObjectID']['input']>;
  multipleChoiceLocalizationsOptions?: InputMaybe<Array<SurveyLocalizationItemInput>>;
  multipleEntryLocalizationsEntries?: InputMaybe<Array<SurveyLocalizationItemInput>>;
  templateId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type UpdateSurveyItemLikertScaleQuestionInput = {
  allowComment?: InputMaybe<Scalars['Boolean']['input']>;
  allowNotApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  allowUpload?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentsLocalizations?: InputMaybe<Array<LocalizedAttachmentsInput>>;
  commentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLocalizations?: InputMaybe<Array<LocalizedStringInput>>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  uploadRequired?: InputMaybe<Scalars['Boolean']['input']>;
  weightRange: Array<Scalars['Int']['input']>;
};

export type UpdateSurveyItemMultipleChoiceQuestionInput = {
  allowComment?: InputMaybe<Scalars['Boolean']['input']>;
  allowMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  allowNotApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  allowUpload?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentsLocalizations?: InputMaybe<Array<LocalizedAttachmentsInput>>;
  commentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLocalizations?: InputMaybe<Array<LocalizedStringInput>>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  options?: InputMaybe<Array<UpdateSurveyMultipleChoiceQuestionOptionInput>>;
  uploadRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSurveyItemMultipleEntryQuestionInput = {
  allowComment?: InputMaybe<Scalars['Boolean']['input']>;
  allowNotApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  allowUpload?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentsLocalizations?: InputMaybe<Array<LocalizedAttachmentsInput>>;
  commentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLocalizations?: InputMaybe<Array<LocalizedStringInput>>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  entries?: InputMaybe<Array<UpdateSurveyMultipleEntryQuestionEntryInput>>;
  entryValueUnit?: InputMaybe<UpdateSurveyEntryValueUnitInput>;
  uploadRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSurveyItemNumericQuestionInput = {
  allowComment?: InputMaybe<Scalars['Boolean']['input']>;
  allowNotApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  allowUpload?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentsLocalizations?: InputMaybe<Array<LocalizedAttachmentsInput>>;
  commentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLocalizations?: InputMaybe<Array<LocalizedStringInput>>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  uploadRequired?: InputMaybe<Scalars['Boolean']['input']>;
  valueUnit?: InputMaybe<UpdateSurveyValueUnitInput>;
};

export type UpdateSurveyItemSectionInput = {
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSurveyItemStaticPageInput = {
  descriptionLocalizations?: InputMaybe<Array<LocalizedStringInput>>;
};

export type UpdateSurveyItemTextQuestionInput = {
  allowComment?: InputMaybe<Scalars['Boolean']['input']>;
  allowNotApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  allowUpload?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentsLocalizations?: InputMaybe<Array<LocalizedAttachmentsInput>>;
  descriptionLocalizations?: InputMaybe<Array<LocalizedStringInput>>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  uploadRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSurveyItemUploadQuestionInput = {
  allowComment?: InputMaybe<Scalars['Boolean']['input']>;
  allowNotApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  allowUpload?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentsLocalizations?: InputMaybe<Array<LocalizedAttachmentsInput>>;
  commentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLocalizations?: InputMaybe<Array<LocalizedStringInput>>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  minimumCount?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSurveyItemYesNoQuestionInput = {
  allowComment?: InputMaybe<Scalars['Boolean']['input']>;
  allowNotApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  allowUpload?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentsLocalizations?: InputMaybe<Array<LocalizedAttachmentsInput>>;
  commentRequired?: InputMaybe<SurveyYesNoQuestionRequiredFieldInput>;
  descriptionLocalizations?: InputMaybe<Array<LocalizedStringInput>>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  uploadRequired?: InputMaybe<SurveyYesNoQuestionRequiredFieldInput>;
  weightNo?: InputMaybe<Scalars['Int']['input']>;
  weightYes?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSurveyMultipleChoiceQuestionOptionInput = {
  id: Scalars['ObjectID']['input'];
  isOther?: InputMaybe<Scalars['Boolean']['input']>;
  nameLocalizations: Array<LocalizedStringInput>;
  weight: Scalars['Int']['input'];
};

export type UpdateSurveyMultipleEntryQuestionEntryInput = {
  id: Scalars['ObjectID']['input'];
  nameLocalizations: Array<LocalizedStringInput>;
};

export type UpdateSurveyPredefinedItemInput = {
  config?: InputMaybe<UpdateSurveyItemInput>;
  id: Scalars['ObjectID']['input'];
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationIds?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type UpdateSurveyReportConfigChartInput = {
  aggregationLevel?: InputMaybe<SurveyReportAggregationLevel>;
  answerValueType?: InputMaybe<SurveyReportChartAnswerValueType>;
  cutoffDate?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ObjectID']['input'];
  onlyIncludeOrganizationsWithAnswers?: InputMaybe<Scalars['Boolean']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  surveyIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  surveyItemIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SurveyReportChartType>;
  visualizationBars?: InputMaybe<SurveyReportChartVisualizationBarsInput>;
  visualizationList?: InputMaybe<SurveyReportChartVisualizationListInput>;
  visualizationSpider?: InputMaybe<SurveyReportChartVisualizationSpiderInput>;
  visualizationTimeline?: InputMaybe<SurveyReportChartVisualizationTimelineInput>;
};

export type UpdateSurveyReportConfigInput = {
  id: Scalars['ObjectID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  sections?: InputMaybe<ModifySurveyReportConfigSectionInput>;
};

export type UpdateSurveyReportConfigSectionInput = {
  charts?: InputMaybe<ModifySurveyReportConfigChartInput>;
  id: Scalars['ObjectID']['input'];
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSurveyTableConfigInput = {
  id: Scalars['ObjectID']['input'];
  visibleColumns: Array<Scalars['String']['input']>;
};

export type UpdateSurveyTemplateInput = {
  anonymousAnswers?: InputMaybe<Scalars['Boolean']['input']>;
  equalQuestionWeighting?: InputMaybe<Scalars['Boolean']['input']>;
  hasDefaultWeights?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ObjectID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<Array<UpdateSurveyItemInput>>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLocalizations?: InputMaybe<Array<LocalizedStringInput>>;
  organizationIds?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  typeId?: InputMaybe<Scalars['ObjectID']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSurveyTypeInput = {
  id: Scalars['ObjectID']['input'];
  nameLocalizations: Array<LocalizedStringInput>;
};

export type UpdateSurveyValueUnitInput = {
  id: Scalars['ObjectID']['input'];
  nameLocalizations: Array<LocalizedStringInput>;
};

export type UpdateUserManagementItemInput = {
  additionalOrganizationIds?: InputMaybe<ModifyUserManagementItemOrganizationIdsInput>;
  id: Scalars['ObjectID']['input'];
};

export type UploadFileInput = {
  filePrefix?: InputMaybe<Scalars['String']['input']>;
  filename: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
};

export enum UploadReference {
  Dashboard = 'Dashboard',
  FieldForceManagement = 'FieldForceManagement',
  Greenland = 'Greenland',
  MultisensoryExperience = 'MultisensoryExperience',
  PcRoadmap = 'PcRoadmap',
  PorscheImportAgreements = 'PorscheImportAgreements',
  PorscheStrategy2030 = 'PorscheStrategy2030',
  RetailDesign = 'RetailDesign',
  Survey = 'Survey'
}

export enum UploadType {
  Attachment = 'Attachment',
  Image = 'Image',
  Import = 'Import',
  Pdf = 'Pdf',
  PublicImage = 'PublicImage',
  Video = 'Video'
}

export type UserFeedback = {
  __typename?: 'UserFeedback';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectID']['output'];
  rating: Scalars['Int']['output'];
};

export type UserManagementItem = {
  __typename?: 'UserManagementItem';
  additionalOrganizations: Array<Organization>;
  application: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  person: Person;
};

export type UserManagementItemFilter = {
  _and?: InputMaybe<Array<UserManagementItemFilter>>;
  _or?: InputMaybe<Array<UserManagementItemFilter>>;
  application?: InputMaybe<StringFilter>;
  person?: InputMaybe<BigIntFilter>;
};

export type UserManagementItemsInput = {
  filter?: InputMaybe<UserManagementItemFilter>;
};

export enum WidgetKind {
  FilledInAudit = 'FilledInAudit',
  FilledInQuestionnaire = 'FilledInQuestionnaire',
  FilledInSurvey = 'FilledInSurvey'
}

export enum YesNoAnswer {
  No = 'No',
  Yes = 'Yes'
}

export enum YesNoScoreValue {
  No = 'No',
  Yes = 'Yes'
}

export type AnalyticsQueryVariables = Exact<{
  input: AnalyticsInput;
}>;


export type AnalyticsQuery = { __typename?: 'Query', analytics?: Array<{ __typename?: 'Analytics', eventCount: number, eventDate: string, role?: string | null, organization?: { __typename?: 'Organization', id: number, name: string } | null }> | null };

export type AnalyticsMarketsQueryVariables = Exact<{ [key: string]: never; }>;


export type AnalyticsMarketsQuery = { __typename?: 'Query', organizations: { __typename?: 'PaginatedOrganizations', docs: Array<{ __typename?: 'Organization', id: number, name: string }> } };

export type AnnouncementsQueryVariables = Exact<{ [key: string]: never; }>;


export type AnnouncementsQuery = { __typename?: 'Query', announcements: Array<{ __typename?: 'Announcement', id: string, message?: string | null, isActive?: boolean | null, isUserFeedbackActive?: boolean | null, userFeedbackUrl?: any | null, from?: string | null, to?: string | null }> };

export type UpdateAnnouncementMutationVariables = Exact<{
  input: UpdateAnnouncementInput;
}>;


export type UpdateAnnouncementMutation = { __typename?: 'Mutation', updateAnnouncement: { __typename?: 'Announcement', id: string, message?: string | null, isActive?: boolean | null, isUserFeedbackActive?: boolean | null, userFeedbackUrl?: any | null, to?: string | null, from?: string | null } };

export type DashboardEmailNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardEmailNotificationsQuery = { __typename?: 'Query', dashboardEmailNotifications: Array<{ __typename?: 'DashboardEmailNotification', id: string, adhoc?: boolean | null, cron?: string | null, topic: DashboardEmailNotificationTopic }> };

export type UpdateDashboardEmailNotificationMutationVariables = Exact<{
  input: UpdateDashboardEmailNotificationInput;
}>;


export type UpdateDashboardEmailNotificationMutation = { __typename?: 'Mutation', updateDashboardEmailNotification: { __typename?: 'DashboardEmailNotification', id: string, adhoc?: boolean | null, cron?: string | null, topic: DashboardEmailNotificationTopic } };

export type CreateDashboardEmailNotificationMutationVariables = Exact<{
  input: CreateDashboardEmailNotificationInput;
}>;


export type CreateDashboardEmailNotificationMutation = { __typename?: 'Mutation', createDashboardEmailNotification: { __typename?: 'DashboardEmailNotification', id: string, adhoc?: boolean | null, cron?: string | null, topic: DashboardEmailNotificationTopic } };

export type DeleteDashboardEmailNotificationMutationVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;


export type DeleteDashboardEmailNotificationMutation = { __typename?: 'Mutation', deleteDashboardEmailNotification: { __typename?: 'DashboardEmailNotification', id: string } };

export type ExchangeRatesAdminListQueryVariables = Exact<{ [key: string]: never; }>;


export type ExchangeRatesAdminListQuery = { __typename?: 'Query', exchangeRates?: Array<{ __typename?: 'ExchangeRate', id: string, year: number, rates: any }> | null };

export type ExchangeRatesAdminItemQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;


export type ExchangeRatesAdminItemQuery = { __typename?: 'Query', exchangeRate?: { __typename?: 'ExchangeRate', id: string, year: number, rates: any } | null };

export type CreateExchangeRateMutationVariables = Exact<{
  input: ExchangeRateInput;
}>;


export type CreateExchangeRateMutation = { __typename?: 'Mutation', createExchangeRate: { __typename?: 'ExchangeRate', id: string } };

export type UpdateExchangeRateMutationVariables = Exact<{
  id: Scalars['ObjectID']['input'];
  input: ExchangeRateInput;
}>;


export type UpdateExchangeRateMutation = { __typename?: 'Mutation', updateExchangeRate: { __typename?: 'ExchangeRate', id: string } };

export type DeleteExchangeRateMutationVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;


export type DeleteExchangeRateMutation = { __typename?: 'Mutation', deleteExchangeRate: { __typename?: 'ExchangeRate', id: string } };

export type FeatureArticleQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;


export type FeatureArticleQuery = { __typename?: 'Query', featureArticle?: { __typename?: 'FeatureArticle', id: string, title: string, article: string, isPublished?: boolean | null, publishedAt?: string | null, apps: Array<string>, roles: Array<string>, author: { __typename?: 'Person', id: number, name: string }, organizations: Array<{ __typename?: 'Organization', id: number, name: string }> } | null };

export type FeatureArticlesQueryVariables = Exact<{ [key: string]: never; }>;


export type FeatureArticlesQuery = { __typename?: 'Query', featureArticles: Array<{ __typename?: 'FeatureArticle', id: string, title: string, article: string, isPublished?: boolean | null, publishedAt?: string | null, apps: Array<string>, roles: Array<string>, author: { __typename?: 'Person', id: number, name: string } }> };

export type AdminFeatureArticlesQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminFeatureArticlesQuery = { __typename?: 'Query', featureArticles: Array<{ __typename?: 'FeatureArticle', id: string, title: string, article: string, isPublished?: boolean | null, publishedAt?: string | null, apps: Array<string>, roles: Array<string>, author: { __typename?: 'Person', id: number, name: string }, organizations: Array<{ __typename?: 'Organization', id: number, name: string }> }> };

export type CreateFeatureArticleMutationVariables = Exact<{
  input: CreateFeatureArticleInput;
}>;


export type CreateFeatureArticleMutation = { __typename?: 'Mutation', createFeatureArticle: { __typename?: 'FeatureArticle', id: string } };

export type UpdateFeatureArticleMutationVariables = Exact<{
  input: UpdateFeatureArticleInput;
}>;


export type UpdateFeatureArticleMutation = { __typename?: 'Mutation', updateFeatureArticle: { __typename?: 'FeatureArticle', id: string, title: string, article: string, isPublished?: boolean | null, publishedAt?: string | null, apps: Array<string>, roles: Array<string>, author: { __typename?: 'Person', id: number, name: string }, organizations: Array<{ __typename?: 'Organization', id: number, name: string }> } };

export type DeleteFeatureArticleMutationVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;


export type DeleteFeatureArticleMutation = { __typename?: 'Mutation', deleteFeatureArticle: { __typename?: 'FeatureArticle', id: string } };

export type MovedOrganizationsQueryVariables = Exact<{
  filter?: InputMaybe<OrganizationFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MovedOrganizationsQuery = { __typename?: 'Query', organizations: { __typename?: 'PaginatedOrganizations', docs: Array<{ __typename?: 'Organization', id: number, name: string, partnerNumber?: string | null, createdAt?: string | null, previous?: { __typename?: 'Organization', id: number, name: string, partnerNumber?: string | null } | null }> } };

export type OrganizationsQueryVariables = Exact<{
  searchString?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OrganizationFilter>;
}>;


export type OrganizationsQuery = { __typename?: 'Query', organizations: { __typename?: 'PaginatedOrganizations', docs: Array<{ __typename?: 'Organization', id: number, name: string, partnerNumber?: string | null, status?: OrganizationStatus | null, organizationId: number }> } };

export type OrganizationQueryVariables = Exact<{
  id?: InputMaybe<Scalars['BigInt']['input']>;
}>;


export type OrganizationQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: number, name: string, partnerNumber?: string | null, organizationId: number } | null };

export type OrganizationTreeQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationTreeQuery = { __typename?: 'Query', organizations: { __typename?: 'PaginatedOrganizations', docs: Array<{ __typename?: 'Organization', id: number, name: string, parentId?: number | null, partnerNumber?: string | null }> } };

export type OrganizationInfoItemsQueryVariables = Exact<{
  filter?: InputMaybe<PersonFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OrganizationInfoItemsQuery = { __typename?: 'Query', persons: { __typename?: 'PaginatedPersons', docs: Array<{ __typename?: 'Person', id: number, name: string, ppnuid: string, roles: Array<string>, organization: { __typename?: 'Organization', id: number, name: string } }> } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me:
    | { __typename: 'AnonymousPerson', sessionId: string, ability: { __typename?: 'Ability', dashboard: Array<Record<string, any>> } }
    | { __typename: 'Person', id: number, ppnuid: string, name: string, mail: string, roles: Array<string>, organization: { __typename?: 'Organization', name: string, organizationId: number, parentMarket?: { __typename?: 'Organization', organizationId: number } | null }, ability: { __typename?: 'Ability', dashboard: Array<Record<string, any>> }, settings?: { __typename?: 'PersonSettings', dateFormat?: string | null, is24HourFormat?: boolean | null, locale?: string | null } | null, acknowledgements?: { __typename?: 'PersonAcknowledgements', userDeletionConsent?: string | null, emailNotificationsHint?: { __typename?: 'PersonAcknowledgementsEmailNotificationsHint', DASHBOARD?: string | null } | null } | null }
   };

export type PersonsQueryVariables = Exact<{
  searchString?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PersonFilter>;
}>;


export type PersonsQuery = { __typename?: 'Query', persons: { __typename?: 'PaginatedPersons', docs: Array<{ __typename?: 'Person', id: number, name: string, ppnuid: string, deletedAt?: string | null, organization: { __typename?: 'Organization', id: number, name: string } }> } };

export type PersonByIdQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type PersonByIdQuery = { __typename?: 'Query', person?: { __typename?: 'Person', id: number, name: string, deletedAt?: string | null, organization: { __typename?: 'Organization', id: number, name: string } } | null };

export type UpdatePersonSettingsMutationVariables = Exact<{
  input: UpdatePersonSettingsInput;
}>;


export type UpdatePersonSettingsMutation = { __typename?: 'Mutation', updatePersonSettings: { __typename?: 'Person', ppnuid: string, settings?: { __typename?: 'PersonSettings', locale?: string | null } | null } };

export type UpdatePersonMutationVariables = Exact<{
  input: UpdatePersonInput;
}>;


export type UpdatePersonMutation = { __typename?: 'Mutation', updatePerson: { __typename?: 'Person', id: number, ppnuid: string, acknowledgements?: { __typename?: 'PersonAcknowledgements', userDeletionConsent?: string | null, emailNotificationsHint?: { __typename?: 'PersonAcknowledgementsEmailNotificationsHint', DASHBOARD?: string | null } | null } | null } };

export type PersonFieldsFragment = { __typename?: 'Person', id: number, ppnuid: string, name: string, mail: string, pagCurrentAccountStatus?: string | null, deletedAt?: string | null, roles: Array<string>, groups?: Array<{ __typename?: 'Group', id: string, name: string }> | null, visibleGroups?: Array<{ __typename?: 'Group', id: string, name: string }> | null, visibleOrganizations?: Array<{ __typename?: 'Organization', id: number, name: string }> | null, peerGroups?: Array<{ __typename?: 'PeerGroup', id: string, name: string }> | null, visibleCategories?: Array<{ __typename?: 'Category', id: string, name: string }> | null, organization: { __typename?: 'Organization', id: number, name: string }, settings?: { __typename?: 'PersonSettings', dateFormat?: string | null, is24HourFormat?: boolean | null, locale?: string | null, defaultCurrency?: string | null, exportMode?: string | null, printMode?: PrintMode | null, emailReportTimezone?: string | null } | null, acknowledgements?: { __typename?: 'PersonAcknowledgements', userDeletionConsent?: string | null } | null };

export type PersonInfoQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type PersonInfoQuery = { __typename?: 'Query', person?: { __typename?: 'Person', id: number, ppnuid: string, name: string, mail: string, pagCurrentAccountStatus?: string | null, deletedAt?: string | null, roles: Array<string>, ability: { __typename?: 'Ability', dashboard: Array<Record<string, any>> }, groups?: Array<{ __typename?: 'Group', id: string, name: string }> | null, visibleGroups?: Array<{ __typename?: 'Group', id: string, name: string }> | null, visibleOrganizations?: Array<{ __typename?: 'Organization', id: number, name: string }> | null, peerGroups?: Array<{ __typename?: 'PeerGroup', id: string, name: string }> | null, visibleCategories?: Array<{ __typename?: 'Category', id: string, name: string }> | null, organization: { __typename?: 'Organization', id: number, name: string }, settings?: { __typename?: 'PersonSettings', dateFormat?: string | null, is24HourFormat?: boolean | null, locale?: string | null, defaultCurrency?: string | null, exportMode?: string | null, printMode?: PrintMode | null, emailReportTimezone?: string | null } | null, acknowledgements?: { __typename?: 'PersonAcknowledgements', userDeletionConsent?: string | null } | null } | null };

export type PersonInfoForFieldForceManagementQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type PersonInfoForFieldForceManagementQuery = { __typename?: 'Query', person?: { __typename?: 'Person', id: number, ppnuid: string, name: string, mail: string, pagCurrentAccountStatus?: string | null, deletedAt?: string | null, roles: Array<string>, ability: { __typename?: 'Ability', fieldForceManagement: Array<Record<string, any>> }, groups?: Array<{ __typename?: 'Group', id: string, name: string }> | null, visibleGroups?: Array<{ __typename?: 'Group', id: string, name: string }> | null, visibleOrganizations?: Array<{ __typename?: 'Organization', id: number, name: string }> | null, peerGroups?: Array<{ __typename?: 'PeerGroup', id: string, name: string }> | null, visibleCategories?: Array<{ __typename?: 'Category', id: string, name: string }> | null, organization: { __typename?: 'Organization', id: number, name: string }, settings?: { __typename?: 'PersonSettings', dateFormat?: string | null, is24HourFormat?: boolean | null, locale?: string | null, defaultCurrency?: string | null, exportMode?: string | null, printMode?: PrintMode | null, emailReportTimezone?: string | null } | null, acknowledgements?: { __typename?: 'PersonAcknowledgements', userDeletionConsent?: string | null } | null } | null, userManagementItems: Array<{ __typename?: 'UserManagementItem', additionalOrganizations: Array<{ __typename?: 'Organization', id: number, name: string }> }> };

export type PersonInfoForRetailDesignQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type PersonInfoForRetailDesignQuery = { __typename?: 'Query', person?: { __typename?: 'Person', id: number, ppnuid: string, name: string, mail: string, pagCurrentAccountStatus?: string | null, deletedAt?: string | null, roles: Array<string>, ability: { __typename?: 'Ability', retailDesign: Array<Record<string, any>> }, groups?: Array<{ __typename?: 'Group', id: string, name: string }> | null, visibleGroups?: Array<{ __typename?: 'Group', id: string, name: string }> | null, visibleOrganizations?: Array<{ __typename?: 'Organization', id: number, name: string }> | null, peerGroups?: Array<{ __typename?: 'PeerGroup', id: string, name: string }> | null, visibleCategories?: Array<{ __typename?: 'Category', id: string, name: string }> | null, organization: { __typename?: 'Organization', id: number, name: string }, settings?: { __typename?: 'PersonSettings', dateFormat?: string | null, is24HourFormat?: boolean | null, locale?: string | null, defaultCurrency?: string | null, exportMode?: string | null, printMode?: PrintMode | null, emailReportTimezone?: string | null } | null, acknowledgements?: { __typename?: 'PersonAcknowledgements', userDeletionConsent?: string | null } | null } | null, userManagementItems: Array<{ __typename?: 'UserManagementItem', additionalOrganizations: Array<{ __typename?: 'Organization', id: number, name: string }> }> };

export type PersonInfoForPorscheStrategy2030QueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type PersonInfoForPorscheStrategy2030Query = { __typename?: 'Query', person?: { __typename?: 'Person', id: number, ppnuid: string, name: string, mail: string, pagCurrentAccountStatus?: string | null, deletedAt?: string | null, roles: Array<string>, ability: { __typename?: 'Ability', porscheStrategy2030: Array<Record<string, any>> }, groups?: Array<{ __typename?: 'Group', id: string, name: string }> | null, visibleGroups?: Array<{ __typename?: 'Group', id: string, name: string }> | null, visibleOrganizations?: Array<{ __typename?: 'Organization', id: number, name: string }> | null, peerGroups?: Array<{ __typename?: 'PeerGroup', id: string, name: string }> | null, visibleCategories?: Array<{ __typename?: 'Category', id: string, name: string }> | null, organization: { __typename?: 'Organization', id: number, name: string }, settings?: { __typename?: 'PersonSettings', dateFormat?: string | null, is24HourFormat?: boolean | null, locale?: string | null, defaultCurrency?: string | null, exportMode?: string | null, printMode?: PrintMode | null, emailReportTimezone?: string | null } | null, acknowledgements?: { __typename?: 'PersonAcknowledgements', userDeletionConsent?: string | null } | null } | null, userManagementItems: Array<{ __typename?: 'UserManagementItem', additionalOrganizations: Array<{ __typename?: 'Organization', id: number, name: string }> }> };

export type PersonInfoForSurveyQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type PersonInfoForSurveyQuery = { __typename?: 'Query', person?: { __typename?: 'Person', id: number, ppnuid: string, name: string, mail: string, pagCurrentAccountStatus?: string | null, deletedAt?: string | null, roles: Array<string>, ability: { __typename?: 'Ability', survey: Array<Record<string, any>> }, groups?: Array<{ __typename?: 'Group', id: string, name: string }> | null, visibleGroups?: Array<{ __typename?: 'Group', id: string, name: string }> | null, visibleOrganizations?: Array<{ __typename?: 'Organization', id: number, name: string }> | null, peerGroups?: Array<{ __typename?: 'PeerGroup', id: string, name: string }> | null, visibleCategories?: Array<{ __typename?: 'Category', id: string, name: string }> | null, organization: { __typename?: 'Organization', id: number, name: string }, settings?: { __typename?: 'PersonSettings', dateFormat?: string | null, is24HourFormat?: boolean | null, locale?: string | null, defaultCurrency?: string | null, exportMode?: string | null, printMode?: PrintMode | null, emailReportTimezone?: string | null } | null, acknowledgements?: { __typename?: 'PersonAcknowledgements', userDeletionConsent?: string | null } | null } | null, userManagementItems: Array<{ __typename?: 'UserManagementItem', additionalOrganizations: Array<{ __typename?: 'Organization', id: number, name: string }> }> };

export type PersonInfoForGreenlandQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type PersonInfoForGreenlandQuery = { __typename?: 'Query', person?: { __typename?: 'Person', id: number, ppnuid: string, name: string, mail: string, pagCurrentAccountStatus?: string | null, deletedAt?: string | null, roles: Array<string>, ability: { __typename?: 'Ability', greenland: Array<Record<string, any>> }, groups?: Array<{ __typename?: 'Group', id: string, name: string }> | null, visibleGroups?: Array<{ __typename?: 'Group', id: string, name: string }> | null, visibleOrganizations?: Array<{ __typename?: 'Organization', id: number, name: string }> | null, peerGroups?: Array<{ __typename?: 'PeerGroup', id: string, name: string }> | null, visibleCategories?: Array<{ __typename?: 'Category', id: string, name: string }> | null, organization: { __typename?: 'Organization', id: number, name: string }, settings?: { __typename?: 'PersonSettings', dateFormat?: string | null, is24HourFormat?: boolean | null, locale?: string | null, defaultCurrency?: string | null, exportMode?: string | null, printMode?: PrintMode | null, emailReportTimezone?: string | null } | null, acknowledgements?: { __typename?: 'PersonAcknowledgements', userDeletionConsent?: string | null } | null } | null, userManagementItems: Array<{ __typename?: 'UserManagementItem', additionalOrganizations: Array<{ __typename?: 'Organization', id: number, name: string }> }> };

export type PersonInfoForApexQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type PersonInfoForApexQuery = { __typename?: 'Query', person?: { __typename?: 'Person', id: number, ppnuid: string, name: string, mail: string, pagCurrentAccountStatus?: string | null, deletedAt?: string | null, roles: Array<string>, ability: { __typename?: 'Ability', apex: Array<Record<string, any>> }, groups?: Array<{ __typename?: 'Group', id: string, name: string }> | null, visibleGroups?: Array<{ __typename?: 'Group', id: string, name: string }> | null, visibleOrganizations?: Array<{ __typename?: 'Organization', id: number, name: string }> | null, peerGroups?: Array<{ __typename?: 'PeerGroup', id: string, name: string }> | null, visibleCategories?: Array<{ __typename?: 'Category', id: string, name: string }> | null, organization: { __typename?: 'Organization', id: number, name: string }, settings?: { __typename?: 'PersonSettings', dateFormat?: string | null, is24HourFormat?: boolean | null, locale?: string | null, defaultCurrency?: string | null, exportMode?: string | null, printMode?: PrintMode | null, emailReportTimezone?: string | null } | null, acknowledgements?: { __typename?: 'PersonAcknowledgements', userDeletionConsent?: string | null } | null } | null, userManagementItems: Array<{ __typename?: 'UserManagementItem', additionalOrganizations: Array<{ __typename?: 'Organization', id: number, name: string }> }> };

export type PersonInfoForPorscheImportAgreementsQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type PersonInfoForPorscheImportAgreementsQuery = { __typename?: 'Query', person?: { __typename?: 'Person', id: number, ppnuid: string, name: string, mail: string, pagCurrentAccountStatus?: string | null, deletedAt?: string | null, roles: Array<string>, ability: { __typename?: 'Ability', porscheImportAgreements: Array<Record<string, any>> }, groups?: Array<{ __typename?: 'Group', id: string, name: string }> | null, visibleGroups?: Array<{ __typename?: 'Group', id: string, name: string }> | null, visibleOrganizations?: Array<{ __typename?: 'Organization', id: number, name: string }> | null, peerGroups?: Array<{ __typename?: 'PeerGroup', id: string, name: string }> | null, visibleCategories?: Array<{ __typename?: 'Category', id: string, name: string }> | null, organization: { __typename?: 'Organization', id: number, name: string }, settings?: { __typename?: 'PersonSettings', dateFormat?: string | null, is24HourFormat?: boolean | null, locale?: string | null, defaultCurrency?: string | null, exportMode?: string | null, printMode?: PrintMode | null, emailReportTimezone?: string | null } | null, acknowledgements?: { __typename?: 'PersonAcknowledgements', userDeletionConsent?: string | null } | null } | null, userManagementItems: Array<{ __typename?: 'UserManagementItem', additionalOrganizations: Array<{ __typename?: 'Organization', id: number, name: string }> }> };

export type PersonInfoForRealEstateQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type PersonInfoForRealEstateQuery = { __typename?: 'Query', person?: { __typename?: 'Person', id: number, ppnuid: string, name: string, mail: string, pagCurrentAccountStatus?: string | null, deletedAt?: string | null, roles: Array<string>, ability: { __typename?: 'Ability', realEstate: Array<Record<string, any>> }, groups?: Array<{ __typename?: 'Group', id: string, name: string }> | null, visibleGroups?: Array<{ __typename?: 'Group', id: string, name: string }> | null, visibleOrganizations?: Array<{ __typename?: 'Organization', id: number, name: string }> | null, peerGroups?: Array<{ __typename?: 'PeerGroup', id: string, name: string }> | null, visibleCategories?: Array<{ __typename?: 'Category', id: string, name: string }> | null, organization: { __typename?: 'Organization', id: number, name: string }, settings?: { __typename?: 'PersonSettings', dateFormat?: string | null, is24HourFormat?: boolean | null, locale?: string | null, defaultCurrency?: string | null, exportMode?: string | null, printMode?: PrintMode | null, emailReportTimezone?: string | null } | null, acknowledgements?: { __typename?: 'PersonAcknowledgements', userDeletionConsent?: string | null } | null } | null, userManagementItems: Array<{ __typename?: 'UserManagementItem', additionalOrganizations: Array<{ __typename?: 'Organization', id: number, name: string }> }> };

export type PersonInfoForNetworkPlanningQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type PersonInfoForNetworkPlanningQuery = { __typename?: 'Query', person?: { __typename?: 'Person', id: number, ppnuid: string, name: string, mail: string, pagCurrentAccountStatus?: string | null, deletedAt?: string | null, roles: Array<string>, ability: { __typename?: 'Ability', networkPlanning: Array<Record<string, any>> }, groups?: Array<{ __typename?: 'Group', id: string, name: string }> | null, visibleGroups?: Array<{ __typename?: 'Group', id: string, name: string }> | null, visibleOrganizations?: Array<{ __typename?: 'Organization', id: number, name: string }> | null, peerGroups?: Array<{ __typename?: 'PeerGroup', id: string, name: string }> | null, visibleCategories?: Array<{ __typename?: 'Category', id: string, name: string }> | null, organization: { __typename?: 'Organization', id: number, name: string }, settings?: { __typename?: 'PersonSettings', dateFormat?: string | null, is24HourFormat?: boolean | null, locale?: string | null, defaultCurrency?: string | null, exportMode?: string | null, printMode?: PrintMode | null, emailReportTimezone?: string | null } | null, acknowledgements?: { __typename?: 'PersonAcknowledgements', userDeletionConsent?: string | null } | null } | null, userManagementItems: Array<{ __typename?: 'UserManagementItem', additionalOrganizations: Array<{ __typename?: 'Organization', id: number, name: string }> }> };

export type PersonInfoForMultisensoryExperienceQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type PersonInfoForMultisensoryExperienceQuery = { __typename?: 'Query', person?: { __typename?: 'Person', id: number, ppnuid: string, name: string, mail: string, pagCurrentAccountStatus?: string | null, deletedAt?: string | null, roles: Array<string>, ability: { __typename?: 'Ability', multisensoryExperience: Array<Record<string, any>> }, groups?: Array<{ __typename?: 'Group', id: string, name: string }> | null, visibleGroups?: Array<{ __typename?: 'Group', id: string, name: string }> | null, visibleOrganizations?: Array<{ __typename?: 'Organization', id: number, name: string }> | null, peerGroups?: Array<{ __typename?: 'PeerGroup', id: string, name: string }> | null, visibleCategories?: Array<{ __typename?: 'Category', id: string, name: string }> | null, organization: { __typename?: 'Organization', id: number, name: string }, settings?: { __typename?: 'PersonSettings', dateFormat?: string | null, is24HourFormat?: boolean | null, locale?: string | null, defaultCurrency?: string | null, exportMode?: string | null, printMode?: PrintMode | null, emailReportTimezone?: string | null } | null, acknowledgements?: { __typename?: 'PersonAcknowledgements', userDeletionConsent?: string | null } | null } | null, userManagementItems: Array<{ __typename?: 'UserManagementItem', additionalOrganizations: Array<{ __typename?: 'Organization', id: number, name: string }> }> };

export type PersonInfoForPcRoadmapQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type PersonInfoForPcRoadmapQuery = { __typename?: 'Query', person?: { __typename?: 'Person', id: number, ppnuid: string, name: string, mail: string, pagCurrentAccountStatus?: string | null, deletedAt?: string | null, roles: Array<string>, ability: { __typename?: 'Ability', pcRoadmap: Array<Record<string, any>> }, groups?: Array<{ __typename?: 'Group', id: string, name: string }> | null, visibleGroups?: Array<{ __typename?: 'Group', id: string, name: string }> | null, visibleOrganizations?: Array<{ __typename?: 'Organization', id: number, name: string }> | null, peerGroups?: Array<{ __typename?: 'PeerGroup', id: string, name: string }> | null, visibleCategories?: Array<{ __typename?: 'Category', id: string, name: string }> | null, organization: { __typename?: 'Organization', id: number, name: string }, settings?: { __typename?: 'PersonSettings', dateFormat?: string | null, is24HourFormat?: boolean | null, locale?: string | null, defaultCurrency?: string | null, exportMode?: string | null, printMode?: PrintMode | null, emailReportTimezone?: string | null } | null, acknowledgements?: { __typename?: 'PersonAcknowledgements', userDeletionConsent?: string | null } | null } | null, userManagementItems: Array<{ __typename?: 'UserManagementItem', additionalOrganizations: Array<{ __typename?: 'Organization', id: number, name: string }> }> };

export type CheckMeetingAbilitiesQueryVariables = Exact<{
  meetingId: Scalars['ObjectID']['input'];
  personId: Scalars['BigInt']['input'];
}>;


export type CheckMeetingAbilitiesQuery = { __typename?: 'Query', person?: { __typename?: 'Person', id: number, ability: { __typename?: 'Ability', fieldForceManagementSubset: { __typename?: 'FieldForceManagementAbility', checkMeeting: { __typename?: 'FieldForceManagementAbilityCheckMeetingResult', subject: string, read: { __typename?: 'AbilityCheckResult', allowed: boolean, reason?: string | null }, update: { __typename?: 'AbilityCheckResult', allowed: boolean, reason?: string | null }, delete: { __typename?: 'AbilityCheckResult', allowed: boolean, reason?: string | null }, actionItems?: Array<{ __typename?: 'FieldForceManagementAbilityCheckActionItemResult', subject: string, read: { __typename?: 'AbilityCheckResult', allowed: boolean, reason?: string | null }, update: { __typename?: 'AbilityCheckResult', allowed: boolean, reason?: string | null }, delete: { __typename?: 'AbilityCheckResult', allowed: boolean, reason?: string | null } }> | null } } } } | null };

export type PpnMasterdataImportStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type PpnMasterdataImportStatusQuery = { __typename?: 'Query', ppnMasterdataImportStatus?: { __typename?: 'PpnMasterdataImportStatus', isRunning: boolean, startedAt: string, finishedAt?: string | null, organizationsFinishedAt?: string | null, personsFinishedAt?: string | null, groupsFinishedAt?: string | null, error?: string | null } | null };

export type StartPpnMasterdataImportMutationVariables = Exact<{ [key: string]: never; }>;


export type StartPpnMasterdataImportMutation = { __typename?: 'Mutation', startPpnMasterdataImport: { __typename?: 'PpnMasterdataImportStatus', isRunning: boolean, startedAt: string, finishedAt?: string | null, organizationsFinishedAt?: string | null, personsFinishedAt?: string | null, groupsFinishedAt?: string | null, error?: string | null } };

export type SupportRequestQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;


export type SupportRequestQuery = { __typename?: 'Query', supportRequest?: { __typename?: 'SupportRequest', id: string, status: SupportRequestStatus, title: string, description: string, application: string, hasNewActivity: boolean, createdAt: string, organization: { __typename?: 'Organization', id: number, name: string }, author: { __typename?: 'Person', name: string, ppnuid: string }, referencePerson?: { __typename?: 'Person', name: string, ppnuid: string } | null, details?: { __typename?: 'SupportRequestDetails', userAgent: string, screenSize: { __typename?: 'SupportRequestSize', width: number, height: number }, browserWindowSize: { __typename?: 'SupportRequestSize', width: number, height: number } } | null, attachments?: Array<{ __typename?: 'Attachment', id: string, name: string, type: string, size: number, createdAt: string }> | null, comments: Array<{ __typename?: 'Comment', id: string, text: string, createdAt: string, author: { __typename?: 'PersonReference', name: string, id: number }, attachments?: Array<{ __typename?: 'Attachment', id: string, name: string, type: string, size: number, createdAt: string }> | null }> } | null };

export type SupportRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type SupportRequestsQuery = { __typename?: 'Query', supportRequests: Array<{ __typename?: 'SupportRequest', id: string, status: SupportRequestStatus, title: string, createdAt: string, hasNewActivity: boolean, author: { __typename?: 'Person', name: string }, organization: { __typename?: 'Organization', name: string } }> };

export type SupportRequestsActivityQueryVariables = Exact<{ [key: string]: never; }>;


export type SupportRequestsActivityQuery = { __typename?: 'Query', supportRequests: Array<{ __typename?: 'SupportRequest', id: string, hasNewActivity: boolean }> };

export type CreateSupportRequestMutationVariables = Exact<{
  input: CreateSupportRequestInput;
}>;


export type CreateSupportRequestMutation = { __typename?: 'Mutation', createSupportRequest: { __typename?: 'SupportRequest', id: string, status: SupportRequestStatus, title: string, description: string, application: string, hasNewActivity: boolean, createdAt: string, organization: { __typename?: 'Organization', name: string }, author: { __typename?: 'Person', name: string }, referencePerson?: { __typename?: 'Person', name: string } | null, details?: { __typename?: 'SupportRequestDetails', userAgent: string, screenSize: { __typename?: 'SupportRequestSize', width: number, height: number }, browserWindowSize: { __typename?: 'SupportRequestSize', width: number, height: number } } | null, attachments?: Array<{ __typename?: 'Attachment', id: string, name: string, type: string, size: number, createdAt: string }> | null } };

export type UpdateSupportRequestMutationVariables = Exact<{
  input: UpdateSupportRequestInput;
}>;


export type UpdateSupportRequestMutation = { __typename?: 'Mutation', updateSupportRequest: { __typename?: 'SupportRequest', id: string, status: SupportRequestStatus, title: string, hasNewActivity: boolean, createdAt: string, organization: { __typename?: 'Organization', name: string }, author: { __typename?: 'Person', name: string }, comments: Array<{ __typename?: 'Comment', id: string, text: string, createdAt: string, author: { __typename?: 'PersonReference', name: string, id: number }, attachments?: Array<{ __typename?: 'Attachment', id: string, name: string, type: string, size: number, createdAt: string }> | null }> } };

export type DeleteSupportRequestMutationVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;


export type DeleteSupportRequestMutation = { __typename?: 'Mutation', deleteSupportRequest: { __typename?: 'SupportRequest', id: string } };

export type CreatePresignedUploadUrlsMutationVariables = Exact<{
  files: Array<UploadFileInput> | UploadFileInput;
  type: UploadType;
  reference: UploadReference;
}>;


export type CreatePresignedUploadUrlsMutation = { __typename?: 'Mutation', createPresignedUploadUrls: Array<{ __typename?: 'PresignedUpload', id: string, url: string, fields: Record<string, any> }> };

export type CreateDownloadUrlMutationVariables = Exact<{
  id: Scalars['ObjectID']['input'];
  type: DownloadType;
  reference: DownloadReference;
}>;


export type CreateDownloadUrlMutation = { __typename?: 'Mutation', createDownloadUrl: string };

export type UserFeedbacksQueryVariables = Exact<{ [key: string]: never; }>;


export type UserFeedbacksQuery = { __typename?: 'Query', userFeedbacks: Array<{ __typename?: 'UserFeedback', id: string, rating: number, comment?: string | null, createdAt?: string | null }> };

export type CreateUserFeedbackMutationVariables = Exact<{
  input: CreateUserFeedbackInput;
}>;


export type CreateUserFeedbackMutation = { __typename?: 'Mutation', createUserFeedback: { __typename?: 'UserFeedback', id: string } };

export type DeleteUserFeedbackMutationVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;


export type DeleteUserFeedbackMutation = { __typename?: 'Mutation', deleteUserFeedback: { __typename?: 'UserFeedback', id: string } };

export type UserManagementItemsQueryVariables = Exact<{
  input?: InputMaybe<UserManagementItemsInput>;
}>;


export type UserManagementItemsQuery = { __typename?: 'Query', userManagementItems: Array<{ __typename?: 'UserManagementItem', id: string, application: string, person: { __typename?: 'Person', id: number, name: string, ppnuid: string }, additionalOrganizations: Array<{ __typename?: 'Organization', id: number, name: string }> }> };

export type CreateUserManagementItemMutationVariables = Exact<{
  input: CreateUserManagementItemInput;
}>;


export type CreateUserManagementItemMutation = { __typename?: 'Mutation', createUserManagementItem: { __typename?: 'UserManagementItem', id: string, application: string, person: { __typename?: 'Person', id: number, name: string, ppnuid: string }, additionalOrganizations: Array<{ __typename?: 'Organization', id: number, name: string }> } };

export type UpdateUserManagementItemMutationVariables = Exact<{
  input: UpdateUserManagementItemInput;
}>;


export type UpdateUserManagementItemMutation = { __typename?: 'Mutation', updateUserManagementItem: { __typename?: 'UserManagementItem', id: string, application: string, person: { __typename?: 'Person', id: number, name: string, ppnuid: string }, additionalOrganizations: Array<{ __typename?: 'Organization', id: number, name: string }> } };

export type DeleteUserManagementItemMutationVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;


export type DeleteUserManagementItemMutation = { __typename?: 'Mutation', deleteUserManagementItem: { __typename?: 'UserManagementItem', id: string } };


export const PersonFieldsFragmentDoc = `
    fragment personFields on Person {
  id
  ppnuid
  name
  mail
  groups {
    id
    name
  }
  visibleGroups {
    id
    name
  }
  visibleOrganizations {
    id
    name
  }
  peerGroups {
    id
    name
  }
  visibleCategories {
    id
    name
  }
  pagCurrentAccountStatus
  deletedAt
  organization {
    id
    name
  }
  roles
  settings {
    dateFormat
    is24HourFormat
    locale
    defaultCurrency
    exportMode
    printMode
    emailReportTimezone
  }
  acknowledgements {
    userDeletionConsent
  }
}
    `;
export const AnalyticsDocument = `
    query analytics($input: AnalyticsInput!) {
  analytics(input: $input) {
    eventCount
    eventDate
    organization {
      id
      name
    }
    role
  }
}
    `;

export const useAnalyticsQuery = <
      TData = AnalyticsQuery,
      TError = unknown
    >(
      variables: AnalyticsQueryVariables,
      options?: Omit<UseQueryOptions<AnalyticsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AnalyticsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AnalyticsQuery, TError, TData>(
      {
    queryKey: ['analytics', variables],
    queryFn: request<AnalyticsQuery, AnalyticsQueryVariables>(AnalyticsDocument, variables),
    ...options
  }
    )};

useAnalyticsQuery.getKey = (variables: AnalyticsQueryVariables) => ['analytics', variables];


useAnalyticsQuery.fetcher = (variables: AnalyticsQueryVariables, options?: RequestInit['headers']) => request<AnalyticsQuery, AnalyticsQueryVariables>(AnalyticsDocument, variables, options);

export const AnalyticsMarketsDocument = `
    query analyticsMarkets {
  organizations(
    filter: {businessType: {_in: [PORSCHE_IMPORTER, PORSCHE_SUBSIDIARY]}, facilityType: {_in: [PORSCHE_OWNED_IMPORTER_SUBSIDIARY, INDEPENDENT_IMPORTER, PORSCHE_REGIONAL_OFFICE, NSC]}, organizationType: {_eq: ORGANIZATION}, status: {_eq: OPERATIVE}, parent: {_or: [{organizationType: {_eq: MARKET}}, {isVRegion: {_eq: true}}]}}
    limit: 0
  ) {
    docs {
      id
      name
    }
  }
}
    `;

export const useAnalyticsMarketsQuery = <
      TData = AnalyticsMarketsQuery,
      TError = unknown
    >(
      variables?: AnalyticsMarketsQueryVariables,
      options?: Omit<UseQueryOptions<AnalyticsMarketsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AnalyticsMarketsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AnalyticsMarketsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['analyticsMarkets'] : ['analyticsMarkets', variables],
    queryFn: request<AnalyticsMarketsQuery, AnalyticsMarketsQueryVariables>(AnalyticsMarketsDocument, variables),
    ...options
  }
    )};

useAnalyticsMarketsQuery.getKey = (variables?: AnalyticsMarketsQueryVariables) => variables === undefined ? ['analyticsMarkets'] : ['analyticsMarkets', variables];


useAnalyticsMarketsQuery.fetcher = (variables?: AnalyticsMarketsQueryVariables, options?: RequestInit['headers']) => request<AnalyticsMarketsQuery, AnalyticsMarketsQueryVariables>(AnalyticsMarketsDocument, variables, options);

export const AnnouncementsDocument = `
    query announcements {
  announcements {
    id
    message
    isActive
    isUserFeedbackActive
    userFeedbackUrl
    from
    to
  }
}
    `;

export const useAnnouncementsQuery = <
      TData = AnnouncementsQuery,
      TError = unknown
    >(
      variables?: AnnouncementsQueryVariables,
      options?: Omit<UseQueryOptions<AnnouncementsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AnnouncementsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AnnouncementsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['announcements'] : ['announcements', variables],
    queryFn: request<AnnouncementsQuery, AnnouncementsQueryVariables>(AnnouncementsDocument, variables),
    ...options
  }
    )};

useAnnouncementsQuery.getKey = (variables?: AnnouncementsQueryVariables) => variables === undefined ? ['announcements'] : ['announcements', variables];


useAnnouncementsQuery.fetcher = (variables?: AnnouncementsQueryVariables, options?: RequestInit['headers']) => request<AnnouncementsQuery, AnnouncementsQueryVariables>(AnnouncementsDocument, variables, options);

export const UpdateAnnouncementDocument = `
    mutation updateAnnouncement($input: UpdateAnnouncementInput!) {
  updateAnnouncement(input: $input) {
    id
    message
    isActive
    isUserFeedbackActive
    userFeedbackUrl
    to
    from
  }
}
    `;

export const useUpdateAnnouncementMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateAnnouncementMutation, TError, UpdateAnnouncementMutationVariables, TContext>) => {
    
    return useMutation<UpdateAnnouncementMutation, TError, UpdateAnnouncementMutationVariables, TContext>(
      {
    mutationKey: ['updateAnnouncement'],
    mutationFn: (variables?: UpdateAnnouncementMutationVariables) => request<UpdateAnnouncementMutation, UpdateAnnouncementMutationVariables>(UpdateAnnouncementDocument, variables)(),
    ...options
  }
    )};


useUpdateAnnouncementMutation.fetcher = (variables: UpdateAnnouncementMutationVariables, options?: RequestInit['headers']) => request<UpdateAnnouncementMutation, UpdateAnnouncementMutationVariables>(UpdateAnnouncementDocument, variables, options);

export const DashboardEmailNotificationsDocument = `
    query dashboardEmailNotifications {
  dashboardEmailNotifications {
    id
    adhoc
    cron
    topic
  }
}
    `;

export const useDashboardEmailNotificationsQuery = <
      TData = DashboardEmailNotificationsQuery,
      TError = unknown
    >(
      variables?: DashboardEmailNotificationsQueryVariables,
      options?: Omit<UseQueryOptions<DashboardEmailNotificationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DashboardEmailNotificationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<DashboardEmailNotificationsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['dashboardEmailNotifications'] : ['dashboardEmailNotifications', variables],
    queryFn: request<DashboardEmailNotificationsQuery, DashboardEmailNotificationsQueryVariables>(DashboardEmailNotificationsDocument, variables),
    ...options
  }
    )};

useDashboardEmailNotificationsQuery.getKey = (variables?: DashboardEmailNotificationsQueryVariables) => variables === undefined ? ['dashboardEmailNotifications'] : ['dashboardEmailNotifications', variables];


useDashboardEmailNotificationsQuery.fetcher = (variables?: DashboardEmailNotificationsQueryVariables, options?: RequestInit['headers']) => request<DashboardEmailNotificationsQuery, DashboardEmailNotificationsQueryVariables>(DashboardEmailNotificationsDocument, variables, options);

export const UpdateDashboardEmailNotificationDocument = `
    mutation updateDashboardEmailNotification($input: UpdateDashboardEmailNotificationInput!) {
  updateDashboardEmailNotification(input: $input) {
    id
    adhoc
    cron
    topic
  }
}
    `;

export const useUpdateDashboardEmailNotificationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateDashboardEmailNotificationMutation, TError, UpdateDashboardEmailNotificationMutationVariables, TContext>) => {
    
    return useMutation<UpdateDashboardEmailNotificationMutation, TError, UpdateDashboardEmailNotificationMutationVariables, TContext>(
      {
    mutationKey: ['updateDashboardEmailNotification'],
    mutationFn: (variables?: UpdateDashboardEmailNotificationMutationVariables) => request<UpdateDashboardEmailNotificationMutation, UpdateDashboardEmailNotificationMutationVariables>(UpdateDashboardEmailNotificationDocument, variables)(),
    ...options
  }
    )};


useUpdateDashboardEmailNotificationMutation.fetcher = (variables: UpdateDashboardEmailNotificationMutationVariables, options?: RequestInit['headers']) => request<UpdateDashboardEmailNotificationMutation, UpdateDashboardEmailNotificationMutationVariables>(UpdateDashboardEmailNotificationDocument, variables, options);

export const CreateDashboardEmailNotificationDocument = `
    mutation createDashboardEmailNotification($input: CreateDashboardEmailNotificationInput!) {
  createDashboardEmailNotification(input: $input) {
    id
    adhoc
    cron
    topic
  }
}
    `;

export const useCreateDashboardEmailNotificationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateDashboardEmailNotificationMutation, TError, CreateDashboardEmailNotificationMutationVariables, TContext>) => {
    
    return useMutation<CreateDashboardEmailNotificationMutation, TError, CreateDashboardEmailNotificationMutationVariables, TContext>(
      {
    mutationKey: ['createDashboardEmailNotification'],
    mutationFn: (variables?: CreateDashboardEmailNotificationMutationVariables) => request<CreateDashboardEmailNotificationMutation, CreateDashboardEmailNotificationMutationVariables>(CreateDashboardEmailNotificationDocument, variables)(),
    ...options
  }
    )};


useCreateDashboardEmailNotificationMutation.fetcher = (variables: CreateDashboardEmailNotificationMutationVariables, options?: RequestInit['headers']) => request<CreateDashboardEmailNotificationMutation, CreateDashboardEmailNotificationMutationVariables>(CreateDashboardEmailNotificationDocument, variables, options);

export const DeleteDashboardEmailNotificationDocument = `
    mutation deleteDashboardEmailNotification($id: ObjectID!) {
  deleteDashboardEmailNotification(id: $id) {
    id
  }
}
    `;

export const useDeleteDashboardEmailNotificationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteDashboardEmailNotificationMutation, TError, DeleteDashboardEmailNotificationMutationVariables, TContext>) => {
    
    return useMutation<DeleteDashboardEmailNotificationMutation, TError, DeleteDashboardEmailNotificationMutationVariables, TContext>(
      {
    mutationKey: ['deleteDashboardEmailNotification'],
    mutationFn: (variables?: DeleteDashboardEmailNotificationMutationVariables) => request<DeleteDashboardEmailNotificationMutation, DeleteDashboardEmailNotificationMutationVariables>(DeleteDashboardEmailNotificationDocument, variables)(),
    ...options
  }
    )};


useDeleteDashboardEmailNotificationMutation.fetcher = (variables: DeleteDashboardEmailNotificationMutationVariables, options?: RequestInit['headers']) => request<DeleteDashboardEmailNotificationMutation, DeleteDashboardEmailNotificationMutationVariables>(DeleteDashboardEmailNotificationDocument, variables, options);

export const ExchangeRatesAdminListDocument = `
    query exchangeRatesAdminList {
  exchangeRates {
    id
    year
    rates
  }
}
    `;

export const useExchangeRatesAdminListQuery = <
      TData = ExchangeRatesAdminListQuery,
      TError = unknown
    >(
      variables?: ExchangeRatesAdminListQueryVariables,
      options?: Omit<UseQueryOptions<ExchangeRatesAdminListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ExchangeRatesAdminListQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ExchangeRatesAdminListQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['exchangeRatesAdminList'] : ['exchangeRatesAdminList', variables],
    queryFn: request<ExchangeRatesAdminListQuery, ExchangeRatesAdminListQueryVariables>(ExchangeRatesAdminListDocument, variables),
    ...options
  }
    )};

useExchangeRatesAdminListQuery.getKey = (variables?: ExchangeRatesAdminListQueryVariables) => variables === undefined ? ['exchangeRatesAdminList'] : ['exchangeRatesAdminList', variables];


useExchangeRatesAdminListQuery.fetcher = (variables?: ExchangeRatesAdminListQueryVariables, options?: RequestInit['headers']) => request<ExchangeRatesAdminListQuery, ExchangeRatesAdminListQueryVariables>(ExchangeRatesAdminListDocument, variables, options);

export const ExchangeRatesAdminItemDocument = `
    query exchangeRatesAdminItem($id: ObjectID!) {
  exchangeRate(id: $id) {
    id
    year
    rates
  }
}
    `;

export const useExchangeRatesAdminItemQuery = <
      TData = ExchangeRatesAdminItemQuery,
      TError = unknown
    >(
      variables: ExchangeRatesAdminItemQueryVariables,
      options?: Omit<UseQueryOptions<ExchangeRatesAdminItemQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ExchangeRatesAdminItemQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ExchangeRatesAdminItemQuery, TError, TData>(
      {
    queryKey: ['exchangeRatesAdminItem', variables],
    queryFn: request<ExchangeRatesAdminItemQuery, ExchangeRatesAdminItemQueryVariables>(ExchangeRatesAdminItemDocument, variables),
    ...options
  }
    )};

useExchangeRatesAdminItemQuery.getKey = (variables: ExchangeRatesAdminItemQueryVariables) => ['exchangeRatesAdminItem', variables];


useExchangeRatesAdminItemQuery.fetcher = (variables: ExchangeRatesAdminItemQueryVariables, options?: RequestInit['headers']) => request<ExchangeRatesAdminItemQuery, ExchangeRatesAdminItemQueryVariables>(ExchangeRatesAdminItemDocument, variables, options);

export const CreateExchangeRateDocument = `
    mutation createExchangeRate($input: ExchangeRateInput!) {
  createExchangeRate(input: $input) {
    id
  }
}
    `;

export const useCreateExchangeRateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateExchangeRateMutation, TError, CreateExchangeRateMutationVariables, TContext>) => {
    
    return useMutation<CreateExchangeRateMutation, TError, CreateExchangeRateMutationVariables, TContext>(
      {
    mutationKey: ['createExchangeRate'],
    mutationFn: (variables?: CreateExchangeRateMutationVariables) => request<CreateExchangeRateMutation, CreateExchangeRateMutationVariables>(CreateExchangeRateDocument, variables)(),
    ...options
  }
    )};


useCreateExchangeRateMutation.fetcher = (variables: CreateExchangeRateMutationVariables, options?: RequestInit['headers']) => request<CreateExchangeRateMutation, CreateExchangeRateMutationVariables>(CreateExchangeRateDocument, variables, options);

export const UpdateExchangeRateDocument = `
    mutation updateExchangeRate($id: ObjectID!, $input: ExchangeRateInput!) {
  updateExchangeRate(id: $id, input: $input) {
    id
  }
}
    `;

export const useUpdateExchangeRateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateExchangeRateMutation, TError, UpdateExchangeRateMutationVariables, TContext>) => {
    
    return useMutation<UpdateExchangeRateMutation, TError, UpdateExchangeRateMutationVariables, TContext>(
      {
    mutationKey: ['updateExchangeRate'],
    mutationFn: (variables?: UpdateExchangeRateMutationVariables) => request<UpdateExchangeRateMutation, UpdateExchangeRateMutationVariables>(UpdateExchangeRateDocument, variables)(),
    ...options
  }
    )};


useUpdateExchangeRateMutation.fetcher = (variables: UpdateExchangeRateMutationVariables, options?: RequestInit['headers']) => request<UpdateExchangeRateMutation, UpdateExchangeRateMutationVariables>(UpdateExchangeRateDocument, variables, options);

export const DeleteExchangeRateDocument = `
    mutation deleteExchangeRate($id: ObjectID!) {
  deleteExchangeRate(id: $id) {
    id
  }
}
    `;

export const useDeleteExchangeRateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteExchangeRateMutation, TError, DeleteExchangeRateMutationVariables, TContext>) => {
    
    return useMutation<DeleteExchangeRateMutation, TError, DeleteExchangeRateMutationVariables, TContext>(
      {
    mutationKey: ['deleteExchangeRate'],
    mutationFn: (variables?: DeleteExchangeRateMutationVariables) => request<DeleteExchangeRateMutation, DeleteExchangeRateMutationVariables>(DeleteExchangeRateDocument, variables)(),
    ...options
  }
    )};


useDeleteExchangeRateMutation.fetcher = (variables: DeleteExchangeRateMutationVariables, options?: RequestInit['headers']) => request<DeleteExchangeRateMutation, DeleteExchangeRateMutationVariables>(DeleteExchangeRateDocument, variables, options);

export const FeatureArticleDocument = `
    query featureArticle($id: ObjectID!) {
  featureArticle(id: $id) {
    id
    title
    article
    isPublished
    publishedAt
    author {
      id
      name
    }
    organizations {
      id
      name
    }
    apps
    roles
  }
}
    `;

export const useFeatureArticleQuery = <
      TData = FeatureArticleQuery,
      TError = unknown
    >(
      variables: FeatureArticleQueryVariables,
      options?: Omit<UseQueryOptions<FeatureArticleQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FeatureArticleQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FeatureArticleQuery, TError, TData>(
      {
    queryKey: ['featureArticle', variables],
    queryFn: request<FeatureArticleQuery, FeatureArticleQueryVariables>(FeatureArticleDocument, variables),
    ...options
  }
    )};

useFeatureArticleQuery.getKey = (variables: FeatureArticleQueryVariables) => ['featureArticle', variables];


useFeatureArticleQuery.fetcher = (variables: FeatureArticleQueryVariables, options?: RequestInit['headers']) => request<FeatureArticleQuery, FeatureArticleQueryVariables>(FeatureArticleDocument, variables, options);

export const FeatureArticlesDocument = `
    query featureArticles {
  featureArticles {
    id
    title
    article
    isPublished
    publishedAt
    author {
      id
      name
    }
    apps
    roles
  }
}
    `;

export const useFeatureArticlesQuery = <
      TData = FeatureArticlesQuery,
      TError = unknown
    >(
      variables?: FeatureArticlesQueryVariables,
      options?: Omit<UseQueryOptions<FeatureArticlesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FeatureArticlesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FeatureArticlesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['featureArticles'] : ['featureArticles', variables],
    queryFn: request<FeatureArticlesQuery, FeatureArticlesQueryVariables>(FeatureArticlesDocument, variables),
    ...options
  }
    )};

useFeatureArticlesQuery.getKey = (variables?: FeatureArticlesQueryVariables) => variables === undefined ? ['featureArticles'] : ['featureArticles', variables];


useFeatureArticlesQuery.fetcher = (variables?: FeatureArticlesQueryVariables, options?: RequestInit['headers']) => request<FeatureArticlesQuery, FeatureArticlesQueryVariables>(FeatureArticlesDocument, variables, options);

export const AdminFeatureArticlesDocument = `
    query adminFeatureArticles {
  featureArticles {
    id
    title
    article
    isPublished
    publishedAt
    author {
      id
      name
    }
    organizations {
      id
      name
    }
    apps
    roles
  }
}
    `;

export const useAdminFeatureArticlesQuery = <
      TData = AdminFeatureArticlesQuery,
      TError = unknown
    >(
      variables?: AdminFeatureArticlesQueryVariables,
      options?: Omit<UseQueryOptions<AdminFeatureArticlesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AdminFeatureArticlesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AdminFeatureArticlesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['adminFeatureArticles'] : ['adminFeatureArticles', variables],
    queryFn: request<AdminFeatureArticlesQuery, AdminFeatureArticlesQueryVariables>(AdminFeatureArticlesDocument, variables),
    ...options
  }
    )};

useAdminFeatureArticlesQuery.getKey = (variables?: AdminFeatureArticlesQueryVariables) => variables === undefined ? ['adminFeatureArticles'] : ['adminFeatureArticles', variables];


useAdminFeatureArticlesQuery.fetcher = (variables?: AdminFeatureArticlesQueryVariables, options?: RequestInit['headers']) => request<AdminFeatureArticlesQuery, AdminFeatureArticlesQueryVariables>(AdminFeatureArticlesDocument, variables, options);

export const CreateFeatureArticleDocument = `
    mutation createFeatureArticle($input: CreateFeatureArticleInput!) {
  createFeatureArticle(featureArticle: $input) {
    id
  }
}
    `;

export const useCreateFeatureArticleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateFeatureArticleMutation, TError, CreateFeatureArticleMutationVariables, TContext>) => {
    
    return useMutation<CreateFeatureArticleMutation, TError, CreateFeatureArticleMutationVariables, TContext>(
      {
    mutationKey: ['createFeatureArticle'],
    mutationFn: (variables?: CreateFeatureArticleMutationVariables) => request<CreateFeatureArticleMutation, CreateFeatureArticleMutationVariables>(CreateFeatureArticleDocument, variables)(),
    ...options
  }
    )};


useCreateFeatureArticleMutation.fetcher = (variables: CreateFeatureArticleMutationVariables, options?: RequestInit['headers']) => request<CreateFeatureArticleMutation, CreateFeatureArticleMutationVariables>(CreateFeatureArticleDocument, variables, options);

export const UpdateFeatureArticleDocument = `
    mutation updateFeatureArticle($input: UpdateFeatureArticleInput!) {
  updateFeatureArticle(featureArticle: $input) {
    id
    title
    article
    isPublished
    publishedAt
    author {
      id
      name
    }
    organizations {
      id
      name
    }
    apps
    roles
  }
}
    `;

export const useUpdateFeatureArticleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateFeatureArticleMutation, TError, UpdateFeatureArticleMutationVariables, TContext>) => {
    
    return useMutation<UpdateFeatureArticleMutation, TError, UpdateFeatureArticleMutationVariables, TContext>(
      {
    mutationKey: ['updateFeatureArticle'],
    mutationFn: (variables?: UpdateFeatureArticleMutationVariables) => request<UpdateFeatureArticleMutation, UpdateFeatureArticleMutationVariables>(UpdateFeatureArticleDocument, variables)(),
    ...options
  }
    )};


useUpdateFeatureArticleMutation.fetcher = (variables: UpdateFeatureArticleMutationVariables, options?: RequestInit['headers']) => request<UpdateFeatureArticleMutation, UpdateFeatureArticleMutationVariables>(UpdateFeatureArticleDocument, variables, options);

export const DeleteFeatureArticleDocument = `
    mutation deleteFeatureArticle($id: ObjectID!) {
  deleteFeatureArticle(id: $id) {
    id
  }
}
    `;

export const useDeleteFeatureArticleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteFeatureArticleMutation, TError, DeleteFeatureArticleMutationVariables, TContext>) => {
    
    return useMutation<DeleteFeatureArticleMutation, TError, DeleteFeatureArticleMutationVariables, TContext>(
      {
    mutationKey: ['deleteFeatureArticle'],
    mutationFn: (variables?: DeleteFeatureArticleMutationVariables) => request<DeleteFeatureArticleMutation, DeleteFeatureArticleMutationVariables>(DeleteFeatureArticleDocument, variables)(),
    ...options
  }
    )};


useDeleteFeatureArticleMutation.fetcher = (variables: DeleteFeatureArticleMutationVariables, options?: RequestInit['headers']) => request<DeleteFeatureArticleMutation, DeleteFeatureArticleMutationVariables>(DeleteFeatureArticleDocument, variables, options);

export const MovedOrganizationsDocument = `
    query movedOrganizations($filter: OrganizationFilter, $limit: Int) {
  organizations(filter: $filter, limit: $limit) {
    docs {
      id
      name
      partnerNumber
      createdAt
      previous {
        id
        name
        partnerNumber
      }
    }
  }
}
    `;

export const useMovedOrganizationsQuery = <
      TData = MovedOrganizationsQuery,
      TError = unknown
    >(
      variables?: MovedOrganizationsQueryVariables,
      options?: Omit<UseQueryOptions<MovedOrganizationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MovedOrganizationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MovedOrganizationsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['movedOrganizations'] : ['movedOrganizations', variables],
    queryFn: request<MovedOrganizationsQuery, MovedOrganizationsQueryVariables>(MovedOrganizationsDocument, variables),
    ...options
  }
    )};

useMovedOrganizationsQuery.getKey = (variables?: MovedOrganizationsQueryVariables) => variables === undefined ? ['movedOrganizations'] : ['movedOrganizations', variables];


useMovedOrganizationsQuery.fetcher = (variables?: MovedOrganizationsQueryVariables, options?: RequestInit['headers']) => request<MovedOrganizationsQuery, MovedOrganizationsQueryVariables>(MovedOrganizationsDocument, variables, options);

export const OrganizationsDocument = `
    query organizations($searchString: String, $filter: OrganizationFilter) {
  organizations(searchString: $searchString, filter: $filter) {
    docs {
      id
      organizationId: id
      name
      partnerNumber
      status
    }
  }
}
    `;

export const useOrganizationsQuery = <
      TData = OrganizationsQuery,
      TError = unknown
    >(
      variables?: OrganizationsQueryVariables,
      options?: Omit<UseQueryOptions<OrganizationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OrganizationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OrganizationsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['organizations'] : ['organizations', variables],
    queryFn: request<OrganizationsQuery, OrganizationsQueryVariables>(OrganizationsDocument, variables),
    ...options
  }
    )};

useOrganizationsQuery.getKey = (variables?: OrganizationsQueryVariables) => variables === undefined ? ['organizations'] : ['organizations', variables];


useOrganizationsQuery.fetcher = (variables?: OrganizationsQueryVariables, options?: RequestInit['headers']) => request<OrganizationsQuery, OrganizationsQueryVariables>(OrganizationsDocument, variables, options);

export const OrganizationDocument = `
    query organization($id: BigInt) {
  organization(id: $id) {
    id
    organizationId: id
    name
    partnerNumber
  }
}
    `;

export const useOrganizationQuery = <
      TData = OrganizationQuery,
      TError = unknown
    >(
      variables?: OrganizationQueryVariables,
      options?: Omit<UseQueryOptions<OrganizationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OrganizationQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OrganizationQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['organization'] : ['organization', variables],
    queryFn: request<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, variables),
    ...options
  }
    )};

useOrganizationQuery.getKey = (variables?: OrganizationQueryVariables) => variables === undefined ? ['organization'] : ['organization', variables];


useOrganizationQuery.fetcher = (variables?: OrganizationQueryVariables, options?: RequestInit['headers']) => request<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, variables, options);

export const OrganizationTreeDocument = `
    query organizationTree {
  organizations(limit: 0) {
    docs {
      id
      name
      parentId
      partnerNumber
    }
  }
}
    `;

export const useOrganizationTreeQuery = <
      TData = OrganizationTreeQuery,
      TError = unknown
    >(
      variables?: OrganizationTreeQueryVariables,
      options?: Omit<UseQueryOptions<OrganizationTreeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OrganizationTreeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OrganizationTreeQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['organizationTree'] : ['organizationTree', variables],
    queryFn: request<OrganizationTreeQuery, OrganizationTreeQueryVariables>(OrganizationTreeDocument, variables),
    ...options
  }
    )};

useOrganizationTreeQuery.getKey = (variables?: OrganizationTreeQueryVariables) => variables === undefined ? ['organizationTree'] : ['organizationTree', variables];


useOrganizationTreeQuery.fetcher = (variables?: OrganizationTreeQueryVariables, options?: RequestInit['headers']) => request<OrganizationTreeQuery, OrganizationTreeQueryVariables>(OrganizationTreeDocument, variables, options);

export const OrganizationInfoItemsDocument = `
    query organizationInfoItems($filter: PersonFilter, $limit: Int) {
  persons(filter: $filter, limit: $limit) {
    docs {
      id
      name
      ppnuid
      roles
      organization {
        id
        name
      }
    }
  }
}
    `;

export const useOrganizationInfoItemsQuery = <
      TData = OrganizationInfoItemsQuery,
      TError = unknown
    >(
      variables?: OrganizationInfoItemsQueryVariables,
      options?: Omit<UseQueryOptions<OrganizationInfoItemsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OrganizationInfoItemsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OrganizationInfoItemsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['organizationInfoItems'] : ['organizationInfoItems', variables],
    queryFn: request<OrganizationInfoItemsQuery, OrganizationInfoItemsQueryVariables>(OrganizationInfoItemsDocument, variables),
    ...options
  }
    )};

useOrganizationInfoItemsQuery.getKey = (variables?: OrganizationInfoItemsQueryVariables) => variables === undefined ? ['organizationInfoItems'] : ['organizationInfoItems', variables];


useOrganizationInfoItemsQuery.fetcher = (variables?: OrganizationInfoItemsQueryVariables, options?: RequestInit['headers']) => request<OrganizationInfoItemsQuery, OrganizationInfoItemsQueryVariables>(OrganizationInfoItemsDocument, variables, options);

export const MeDocument = `
    query me {
  me {
    __typename
    ... on Person {
      id
      ppnuid
      name
      mail
      organization {
        parentMarket {
          organizationId: id
        }
        organizationId: id
        name
      }
      ability {
        dashboard
      }
      roles
      settings {
        dateFormat
        is24HourFormat
        locale
      }
      acknowledgements {
        userDeletionConsent
        emailNotificationsHint {
          DASHBOARD
        }
      }
    }
    ... on AnonymousPerson {
      sessionId: id
      ability {
        dashboard
      }
    }
  }
}
    `;

export const useMeQuery = <
      TData = MeQuery,
      TError = unknown
    >(
      variables?: MeQueryVariables,
      options?: Omit<UseQueryOptions<MeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MeQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['me'] : ['me', variables],
    queryFn: request<MeQuery, MeQueryVariables>(MeDocument, variables),
    ...options
  }
    )};

useMeQuery.getKey = (variables?: MeQueryVariables) => variables === undefined ? ['me'] : ['me', variables];


useMeQuery.fetcher = (variables?: MeQueryVariables, options?: RequestInit['headers']) => request<MeQuery, MeQueryVariables>(MeDocument, variables, options);

export const PersonsDocument = `
    query persons($searchString: String, $filter: PersonFilter) {
  persons(searchString: $searchString, filter: $filter) {
    docs {
      id
      name
      ppnuid
      organization {
        id
        name
      }
      deletedAt
    }
  }
}
    `;

export const usePersonsQuery = <
      TData = PersonsQuery,
      TError = unknown
    >(
      variables?: PersonsQueryVariables,
      options?: Omit<UseQueryOptions<PersonsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PersonsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PersonsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['persons'] : ['persons', variables],
    queryFn: request<PersonsQuery, PersonsQueryVariables>(PersonsDocument, variables),
    ...options
  }
    )};

usePersonsQuery.getKey = (variables?: PersonsQueryVariables) => variables === undefined ? ['persons'] : ['persons', variables];


usePersonsQuery.fetcher = (variables?: PersonsQueryVariables, options?: RequestInit['headers']) => request<PersonsQuery, PersonsQueryVariables>(PersonsDocument, variables, options);

export const PersonByIdDocument = `
    query personById($id: BigInt!) {
  person(id: $id) {
    id
    name
    deletedAt
    organization {
      id
      name
    }
  }
}
    `;

export const usePersonByIdQuery = <
      TData = PersonByIdQuery,
      TError = unknown
    >(
      variables: PersonByIdQueryVariables,
      options?: Omit<UseQueryOptions<PersonByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PersonByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PersonByIdQuery, TError, TData>(
      {
    queryKey: ['personById', variables],
    queryFn: request<PersonByIdQuery, PersonByIdQueryVariables>(PersonByIdDocument, variables),
    ...options
  }
    )};

usePersonByIdQuery.getKey = (variables: PersonByIdQueryVariables) => ['personById', variables];


usePersonByIdQuery.fetcher = (variables: PersonByIdQueryVariables, options?: RequestInit['headers']) => request<PersonByIdQuery, PersonByIdQueryVariables>(PersonByIdDocument, variables, options);

export const UpdatePersonSettingsDocument = `
    mutation updatePersonSettings($input: UpdatePersonSettingsInput!) {
  updatePersonSettings(input: $input) {
    ppnuid
    settings {
      locale
    }
  }
}
    `;

export const useUpdatePersonSettingsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdatePersonSettingsMutation, TError, UpdatePersonSettingsMutationVariables, TContext>) => {
    
    return useMutation<UpdatePersonSettingsMutation, TError, UpdatePersonSettingsMutationVariables, TContext>(
      {
    mutationKey: ['updatePersonSettings'],
    mutationFn: (variables?: UpdatePersonSettingsMutationVariables) => request<UpdatePersonSettingsMutation, UpdatePersonSettingsMutationVariables>(UpdatePersonSettingsDocument, variables)(),
    ...options
  }
    )};


useUpdatePersonSettingsMutation.fetcher = (variables: UpdatePersonSettingsMutationVariables, options?: RequestInit['headers']) => request<UpdatePersonSettingsMutation, UpdatePersonSettingsMutationVariables>(UpdatePersonSettingsDocument, variables, options);

export const UpdatePersonDocument = `
    mutation updatePerson($input: UpdatePersonInput!) {
  updatePerson(input: $input) {
    id
    ppnuid
    acknowledgements {
      userDeletionConsent
      emailNotificationsHint {
        DASHBOARD
      }
    }
  }
}
    `;

export const useUpdatePersonMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdatePersonMutation, TError, UpdatePersonMutationVariables, TContext>) => {
    
    return useMutation<UpdatePersonMutation, TError, UpdatePersonMutationVariables, TContext>(
      {
    mutationKey: ['updatePerson'],
    mutationFn: (variables?: UpdatePersonMutationVariables) => request<UpdatePersonMutation, UpdatePersonMutationVariables>(UpdatePersonDocument, variables)(),
    ...options
  }
    )};


useUpdatePersonMutation.fetcher = (variables: UpdatePersonMutationVariables, options?: RequestInit['headers']) => request<UpdatePersonMutation, UpdatePersonMutationVariables>(UpdatePersonDocument, variables, options);

export const PersonInfoDocument = `
    query personInfo($id: BigInt!) {
  person(id: $id) {
    ...personFields
    ability {
      dashboard
    }
  }
}
    ${PersonFieldsFragmentDoc}`;

export const usePersonInfoQuery = <
      TData = PersonInfoQuery,
      TError = unknown
    >(
      variables: PersonInfoQueryVariables,
      options?: Omit<UseQueryOptions<PersonInfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PersonInfoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PersonInfoQuery, TError, TData>(
      {
    queryKey: ['personInfo', variables],
    queryFn: request<PersonInfoQuery, PersonInfoQueryVariables>(PersonInfoDocument, variables),
    ...options
  }
    )};

usePersonInfoQuery.getKey = (variables: PersonInfoQueryVariables) => ['personInfo', variables];


usePersonInfoQuery.fetcher = (variables: PersonInfoQueryVariables, options?: RequestInit['headers']) => request<PersonInfoQuery, PersonInfoQueryVariables>(PersonInfoDocument, variables, options);

export const PersonInfoForFieldForceManagementDocument = `
    query personInfoForFieldForceManagement($id: BigInt!) {
  person(id: $id) {
    ...personFields
    ability {
      fieldForceManagement
    }
  }
  userManagementItems(
    input: {filter: {person: {_eq: $id}, application: {_eq: "FIELD_FORCE_MANAGEMENT"}}}
  ) {
    additionalOrganizations {
      id
      name
    }
  }
}
    ${PersonFieldsFragmentDoc}`;

export const usePersonInfoForFieldForceManagementQuery = <
      TData = PersonInfoForFieldForceManagementQuery,
      TError = unknown
    >(
      variables: PersonInfoForFieldForceManagementQueryVariables,
      options?: Omit<UseQueryOptions<PersonInfoForFieldForceManagementQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PersonInfoForFieldForceManagementQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PersonInfoForFieldForceManagementQuery, TError, TData>(
      {
    queryKey: ['personInfoForFieldForceManagement', variables],
    queryFn: request<PersonInfoForFieldForceManagementQuery, PersonInfoForFieldForceManagementQueryVariables>(PersonInfoForFieldForceManagementDocument, variables),
    ...options
  }
    )};

usePersonInfoForFieldForceManagementQuery.getKey = (variables: PersonInfoForFieldForceManagementQueryVariables) => ['personInfoForFieldForceManagement', variables];


usePersonInfoForFieldForceManagementQuery.fetcher = (variables: PersonInfoForFieldForceManagementQueryVariables, options?: RequestInit['headers']) => request<PersonInfoForFieldForceManagementQuery, PersonInfoForFieldForceManagementQueryVariables>(PersonInfoForFieldForceManagementDocument, variables, options);

export const PersonInfoForRetailDesignDocument = `
    query personInfoForRetailDesign($id: BigInt!) {
  person(id: $id) {
    ...personFields
    ability {
      retailDesign
    }
  }
  userManagementItems(
    input: {filter: {person: {_eq: $id}, application: {_eq: "RETAIL_DESIGN"}}}
  ) {
    additionalOrganizations {
      id
      name
    }
  }
}
    ${PersonFieldsFragmentDoc}`;

export const usePersonInfoForRetailDesignQuery = <
      TData = PersonInfoForRetailDesignQuery,
      TError = unknown
    >(
      variables: PersonInfoForRetailDesignQueryVariables,
      options?: Omit<UseQueryOptions<PersonInfoForRetailDesignQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PersonInfoForRetailDesignQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PersonInfoForRetailDesignQuery, TError, TData>(
      {
    queryKey: ['personInfoForRetailDesign', variables],
    queryFn: request<PersonInfoForRetailDesignQuery, PersonInfoForRetailDesignQueryVariables>(PersonInfoForRetailDesignDocument, variables),
    ...options
  }
    )};

usePersonInfoForRetailDesignQuery.getKey = (variables: PersonInfoForRetailDesignQueryVariables) => ['personInfoForRetailDesign', variables];


usePersonInfoForRetailDesignQuery.fetcher = (variables: PersonInfoForRetailDesignQueryVariables, options?: RequestInit['headers']) => request<PersonInfoForRetailDesignQuery, PersonInfoForRetailDesignQueryVariables>(PersonInfoForRetailDesignDocument, variables, options);

export const PersonInfoForPorscheStrategy2030Document = `
    query personInfoForPorscheStrategy2030($id: BigInt!) {
  person(id: $id) {
    ...personFields
    ability {
      porscheStrategy2030
    }
  }
  userManagementItems(
    input: {filter: {person: {_eq: $id}, application: {_eq: "PORSCHE_STRATEGY_2030"}}}
  ) {
    additionalOrganizations {
      id
      name
    }
  }
}
    ${PersonFieldsFragmentDoc}`;

export const usePersonInfoForPorscheStrategy2030Query = <
      TData = PersonInfoForPorscheStrategy2030Query,
      TError = unknown
    >(
      variables: PersonInfoForPorscheStrategy2030QueryVariables,
      options?: Omit<UseQueryOptions<PersonInfoForPorscheStrategy2030Query, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PersonInfoForPorscheStrategy2030Query, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PersonInfoForPorscheStrategy2030Query, TError, TData>(
      {
    queryKey: ['personInfoForPorscheStrategy2030', variables],
    queryFn: request<PersonInfoForPorscheStrategy2030Query, PersonInfoForPorscheStrategy2030QueryVariables>(PersonInfoForPorscheStrategy2030Document, variables),
    ...options
  }
    )};

usePersonInfoForPorscheStrategy2030Query.getKey = (variables: PersonInfoForPorscheStrategy2030QueryVariables) => ['personInfoForPorscheStrategy2030', variables];


usePersonInfoForPorscheStrategy2030Query.fetcher = (variables: PersonInfoForPorscheStrategy2030QueryVariables, options?: RequestInit['headers']) => request<PersonInfoForPorscheStrategy2030Query, PersonInfoForPorscheStrategy2030QueryVariables>(PersonInfoForPorscheStrategy2030Document, variables, options);

export const PersonInfoForSurveyDocument = `
    query personInfoForSurvey($id: BigInt!) {
  person(id: $id) {
    ...personFields
    ability {
      survey
    }
  }
  userManagementItems(
    input: {filter: {person: {_eq: $id}, application: {_eq: "SURVEY"}}}
  ) {
    additionalOrganizations {
      id
      name
    }
  }
}
    ${PersonFieldsFragmentDoc}`;

export const usePersonInfoForSurveyQuery = <
      TData = PersonInfoForSurveyQuery,
      TError = unknown
    >(
      variables: PersonInfoForSurveyQueryVariables,
      options?: Omit<UseQueryOptions<PersonInfoForSurveyQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PersonInfoForSurveyQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PersonInfoForSurveyQuery, TError, TData>(
      {
    queryKey: ['personInfoForSurvey', variables],
    queryFn: request<PersonInfoForSurveyQuery, PersonInfoForSurveyQueryVariables>(PersonInfoForSurveyDocument, variables),
    ...options
  }
    )};

usePersonInfoForSurveyQuery.getKey = (variables: PersonInfoForSurveyQueryVariables) => ['personInfoForSurvey', variables];


usePersonInfoForSurveyQuery.fetcher = (variables: PersonInfoForSurveyQueryVariables, options?: RequestInit['headers']) => request<PersonInfoForSurveyQuery, PersonInfoForSurveyQueryVariables>(PersonInfoForSurveyDocument, variables, options);

export const PersonInfoForGreenlandDocument = `
    query personInfoForGreenland($id: BigInt!) {
  person(id: $id) {
    ...personFields
    ability {
      greenland
    }
  }
  userManagementItems(
    input: {filter: {person: {_eq: $id}, application: {_eq: "GREENLAND"}}}
  ) {
    additionalOrganizations {
      id
      name
    }
  }
}
    ${PersonFieldsFragmentDoc}`;

export const usePersonInfoForGreenlandQuery = <
      TData = PersonInfoForGreenlandQuery,
      TError = unknown
    >(
      variables: PersonInfoForGreenlandQueryVariables,
      options?: Omit<UseQueryOptions<PersonInfoForGreenlandQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PersonInfoForGreenlandQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PersonInfoForGreenlandQuery, TError, TData>(
      {
    queryKey: ['personInfoForGreenland', variables],
    queryFn: request<PersonInfoForGreenlandQuery, PersonInfoForGreenlandQueryVariables>(PersonInfoForGreenlandDocument, variables),
    ...options
  }
    )};

usePersonInfoForGreenlandQuery.getKey = (variables: PersonInfoForGreenlandQueryVariables) => ['personInfoForGreenland', variables];


usePersonInfoForGreenlandQuery.fetcher = (variables: PersonInfoForGreenlandQueryVariables, options?: RequestInit['headers']) => request<PersonInfoForGreenlandQuery, PersonInfoForGreenlandQueryVariables>(PersonInfoForGreenlandDocument, variables, options);

export const PersonInfoForApexDocument = `
    query personInfoForApex($id: BigInt!) {
  person(id: $id) {
    ...personFields
    ability {
      apex
    }
  }
  userManagementItems(
    input: {filter: {person: {_eq: $id}, application: {_eq: "APEX"}}}
  ) {
    additionalOrganizations {
      id
      name
    }
  }
}
    ${PersonFieldsFragmentDoc}`;

export const usePersonInfoForApexQuery = <
      TData = PersonInfoForApexQuery,
      TError = unknown
    >(
      variables: PersonInfoForApexQueryVariables,
      options?: Omit<UseQueryOptions<PersonInfoForApexQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PersonInfoForApexQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PersonInfoForApexQuery, TError, TData>(
      {
    queryKey: ['personInfoForApex', variables],
    queryFn: request<PersonInfoForApexQuery, PersonInfoForApexQueryVariables>(PersonInfoForApexDocument, variables),
    ...options
  }
    )};

usePersonInfoForApexQuery.getKey = (variables: PersonInfoForApexQueryVariables) => ['personInfoForApex', variables];


usePersonInfoForApexQuery.fetcher = (variables: PersonInfoForApexQueryVariables, options?: RequestInit['headers']) => request<PersonInfoForApexQuery, PersonInfoForApexQueryVariables>(PersonInfoForApexDocument, variables, options);

export const PersonInfoForPorscheImportAgreementsDocument = `
    query personInfoForPorscheImportAgreements($id: BigInt!) {
  person(id: $id) {
    ...personFields
    ability {
      porscheImportAgreements
    }
  }
  userManagementItems(
    input: {filter: {person: {_eq: $id}, application: {_eq: "PORSCHE_IMPORT_AGREEMENTS"}}}
  ) {
    additionalOrganizations {
      id
      name
    }
  }
}
    ${PersonFieldsFragmentDoc}`;

export const usePersonInfoForPorscheImportAgreementsQuery = <
      TData = PersonInfoForPorscheImportAgreementsQuery,
      TError = unknown
    >(
      variables: PersonInfoForPorscheImportAgreementsQueryVariables,
      options?: Omit<UseQueryOptions<PersonInfoForPorscheImportAgreementsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PersonInfoForPorscheImportAgreementsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PersonInfoForPorscheImportAgreementsQuery, TError, TData>(
      {
    queryKey: ['personInfoForPorscheImportAgreements', variables],
    queryFn: request<PersonInfoForPorscheImportAgreementsQuery, PersonInfoForPorscheImportAgreementsQueryVariables>(PersonInfoForPorscheImportAgreementsDocument, variables),
    ...options
  }
    )};

usePersonInfoForPorscheImportAgreementsQuery.getKey = (variables: PersonInfoForPorscheImportAgreementsQueryVariables) => ['personInfoForPorscheImportAgreements', variables];


usePersonInfoForPorscheImportAgreementsQuery.fetcher = (variables: PersonInfoForPorscheImportAgreementsQueryVariables, options?: RequestInit['headers']) => request<PersonInfoForPorscheImportAgreementsQuery, PersonInfoForPorscheImportAgreementsQueryVariables>(PersonInfoForPorscheImportAgreementsDocument, variables, options);

export const PersonInfoForRealEstateDocument = `
    query personInfoForRealEstate($id: BigInt!) {
  person(id: $id) {
    ...personFields
    ability {
      realEstate
    }
  }
  userManagementItems(
    input: {filter: {person: {_eq: $id}, application: {_eq: "REAL_ESTATE"}}}
  ) {
    additionalOrganizations {
      id
      name
    }
  }
}
    ${PersonFieldsFragmentDoc}`;

export const usePersonInfoForRealEstateQuery = <
      TData = PersonInfoForRealEstateQuery,
      TError = unknown
    >(
      variables: PersonInfoForRealEstateQueryVariables,
      options?: Omit<UseQueryOptions<PersonInfoForRealEstateQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PersonInfoForRealEstateQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PersonInfoForRealEstateQuery, TError, TData>(
      {
    queryKey: ['personInfoForRealEstate', variables],
    queryFn: request<PersonInfoForRealEstateQuery, PersonInfoForRealEstateQueryVariables>(PersonInfoForRealEstateDocument, variables),
    ...options
  }
    )};

usePersonInfoForRealEstateQuery.getKey = (variables: PersonInfoForRealEstateQueryVariables) => ['personInfoForRealEstate', variables];


usePersonInfoForRealEstateQuery.fetcher = (variables: PersonInfoForRealEstateQueryVariables, options?: RequestInit['headers']) => request<PersonInfoForRealEstateQuery, PersonInfoForRealEstateQueryVariables>(PersonInfoForRealEstateDocument, variables, options);

export const PersonInfoForNetworkPlanningDocument = `
    query personInfoForNetworkPlanning($id: BigInt!) {
  person(id: $id) {
    ...personFields
    ability {
      networkPlanning
    }
  }
  userManagementItems(
    input: {filter: {person: {_eq: $id}, application: {_eq: "NETWORK_PLANNING"}}}
  ) {
    additionalOrganizations {
      id
      name
    }
  }
}
    ${PersonFieldsFragmentDoc}`;

export const usePersonInfoForNetworkPlanningQuery = <
      TData = PersonInfoForNetworkPlanningQuery,
      TError = unknown
    >(
      variables: PersonInfoForNetworkPlanningQueryVariables,
      options?: Omit<UseQueryOptions<PersonInfoForNetworkPlanningQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PersonInfoForNetworkPlanningQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PersonInfoForNetworkPlanningQuery, TError, TData>(
      {
    queryKey: ['personInfoForNetworkPlanning', variables],
    queryFn: request<PersonInfoForNetworkPlanningQuery, PersonInfoForNetworkPlanningQueryVariables>(PersonInfoForNetworkPlanningDocument, variables),
    ...options
  }
    )};

usePersonInfoForNetworkPlanningQuery.getKey = (variables: PersonInfoForNetworkPlanningQueryVariables) => ['personInfoForNetworkPlanning', variables];


usePersonInfoForNetworkPlanningQuery.fetcher = (variables: PersonInfoForNetworkPlanningQueryVariables, options?: RequestInit['headers']) => request<PersonInfoForNetworkPlanningQuery, PersonInfoForNetworkPlanningQueryVariables>(PersonInfoForNetworkPlanningDocument, variables, options);

export const PersonInfoForMultisensoryExperienceDocument = `
    query personInfoForMultisensoryExperience($id: BigInt!) {
  person(id: $id) {
    ...personFields
    ability {
      multisensoryExperience
    }
  }
  userManagementItems(
    input: {filter: {person: {_eq: $id}, application: {_eq: "MULTISENSORY_EXPERIENCE"}}}
  ) {
    additionalOrganizations {
      id
      name
    }
  }
}
    ${PersonFieldsFragmentDoc}`;

export const usePersonInfoForMultisensoryExperienceQuery = <
      TData = PersonInfoForMultisensoryExperienceQuery,
      TError = unknown
    >(
      variables: PersonInfoForMultisensoryExperienceQueryVariables,
      options?: Omit<UseQueryOptions<PersonInfoForMultisensoryExperienceQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PersonInfoForMultisensoryExperienceQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PersonInfoForMultisensoryExperienceQuery, TError, TData>(
      {
    queryKey: ['personInfoForMultisensoryExperience', variables],
    queryFn: request<PersonInfoForMultisensoryExperienceQuery, PersonInfoForMultisensoryExperienceQueryVariables>(PersonInfoForMultisensoryExperienceDocument, variables),
    ...options
  }
    )};

usePersonInfoForMultisensoryExperienceQuery.getKey = (variables: PersonInfoForMultisensoryExperienceQueryVariables) => ['personInfoForMultisensoryExperience', variables];


usePersonInfoForMultisensoryExperienceQuery.fetcher = (variables: PersonInfoForMultisensoryExperienceQueryVariables, options?: RequestInit['headers']) => request<PersonInfoForMultisensoryExperienceQuery, PersonInfoForMultisensoryExperienceQueryVariables>(PersonInfoForMultisensoryExperienceDocument, variables, options);

export const PersonInfoForPcRoadmapDocument = `
    query personInfoForPcRoadmap($id: BigInt!) {
  person(id: $id) {
    ...personFields
    ability {
      pcRoadmap
    }
  }
  userManagementItems(
    input: {filter: {person: {_eq: $id}, application: {_eq: "PC_ROADMAP"}}}
  ) {
    additionalOrganizations {
      id
      name
    }
  }
}
    ${PersonFieldsFragmentDoc}`;

export const usePersonInfoForPcRoadmapQuery = <
      TData = PersonInfoForPcRoadmapQuery,
      TError = unknown
    >(
      variables: PersonInfoForPcRoadmapQueryVariables,
      options?: Omit<UseQueryOptions<PersonInfoForPcRoadmapQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PersonInfoForPcRoadmapQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PersonInfoForPcRoadmapQuery, TError, TData>(
      {
    queryKey: ['personInfoForPcRoadmap', variables],
    queryFn: request<PersonInfoForPcRoadmapQuery, PersonInfoForPcRoadmapQueryVariables>(PersonInfoForPcRoadmapDocument, variables),
    ...options
  }
    )};

usePersonInfoForPcRoadmapQuery.getKey = (variables: PersonInfoForPcRoadmapQueryVariables) => ['personInfoForPcRoadmap', variables];


usePersonInfoForPcRoadmapQuery.fetcher = (variables: PersonInfoForPcRoadmapQueryVariables, options?: RequestInit['headers']) => request<PersonInfoForPcRoadmapQuery, PersonInfoForPcRoadmapQueryVariables>(PersonInfoForPcRoadmapDocument, variables, options);

export const CheckMeetingAbilitiesDocument = `
    query checkMeetingAbilities($meetingId: ObjectID!, $personId: BigInt!) {
  person(id: $personId) {
    id
    ability {
      fieldForceManagementSubset {
        checkMeeting(id: $meetingId, includeActionItems: true) {
          subject
          read {
            allowed
            reason
          }
          update {
            allowed
            reason
          }
          delete {
            allowed
            reason
          }
          actionItems {
            subject
            read {
              allowed
              reason
            }
            update {
              allowed
              reason
            }
            delete {
              allowed
              reason
            }
          }
        }
      }
    }
  }
}
    `;

export const useCheckMeetingAbilitiesQuery = <
      TData = CheckMeetingAbilitiesQuery,
      TError = unknown
    >(
      variables: CheckMeetingAbilitiesQueryVariables,
      options?: Omit<UseQueryOptions<CheckMeetingAbilitiesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CheckMeetingAbilitiesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CheckMeetingAbilitiesQuery, TError, TData>(
      {
    queryKey: ['checkMeetingAbilities', variables],
    queryFn: request<CheckMeetingAbilitiesQuery, CheckMeetingAbilitiesQueryVariables>(CheckMeetingAbilitiesDocument, variables),
    ...options
  }
    )};

useCheckMeetingAbilitiesQuery.getKey = (variables: CheckMeetingAbilitiesQueryVariables) => ['checkMeetingAbilities', variables];


useCheckMeetingAbilitiesQuery.fetcher = (variables: CheckMeetingAbilitiesQueryVariables, options?: RequestInit['headers']) => request<CheckMeetingAbilitiesQuery, CheckMeetingAbilitiesQueryVariables>(CheckMeetingAbilitiesDocument, variables, options);

export const PpnMasterdataImportStatusDocument = `
    query ppnMasterdataImportStatus {
  ppnMasterdataImportStatus {
    isRunning
    startedAt
    finishedAt
    organizationsFinishedAt
    personsFinishedAt
    groupsFinishedAt
    error
  }
}
    `;

export const usePpnMasterdataImportStatusQuery = <
      TData = PpnMasterdataImportStatusQuery,
      TError = unknown
    >(
      variables?: PpnMasterdataImportStatusQueryVariables,
      options?: Omit<UseQueryOptions<PpnMasterdataImportStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PpnMasterdataImportStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PpnMasterdataImportStatusQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ppnMasterdataImportStatus'] : ['ppnMasterdataImportStatus', variables],
    queryFn: request<PpnMasterdataImportStatusQuery, PpnMasterdataImportStatusQueryVariables>(PpnMasterdataImportStatusDocument, variables),
    ...options
  }
    )};

usePpnMasterdataImportStatusQuery.getKey = (variables?: PpnMasterdataImportStatusQueryVariables) => variables === undefined ? ['ppnMasterdataImportStatus'] : ['ppnMasterdataImportStatus', variables];


usePpnMasterdataImportStatusQuery.fetcher = (variables?: PpnMasterdataImportStatusQueryVariables, options?: RequestInit['headers']) => request<PpnMasterdataImportStatusQuery, PpnMasterdataImportStatusQueryVariables>(PpnMasterdataImportStatusDocument, variables, options);

export const StartPpnMasterdataImportDocument = `
    mutation startPpnMasterdataImport {
  startPpnMasterdataImport {
    isRunning
    startedAt
    finishedAt
    organizationsFinishedAt
    personsFinishedAt
    groupsFinishedAt
    error
  }
}
    `;

export const useStartPpnMasterdataImportMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<StartPpnMasterdataImportMutation, TError, StartPpnMasterdataImportMutationVariables, TContext>) => {
    
    return useMutation<StartPpnMasterdataImportMutation, TError, StartPpnMasterdataImportMutationVariables, TContext>(
      {
    mutationKey: ['startPpnMasterdataImport'],
    mutationFn: (variables?: StartPpnMasterdataImportMutationVariables) => request<StartPpnMasterdataImportMutation, StartPpnMasterdataImportMutationVariables>(StartPpnMasterdataImportDocument, variables)(),
    ...options
  }
    )};


useStartPpnMasterdataImportMutation.fetcher = (variables?: StartPpnMasterdataImportMutationVariables, options?: RequestInit['headers']) => request<StartPpnMasterdataImportMutation, StartPpnMasterdataImportMutationVariables>(StartPpnMasterdataImportDocument, variables, options);

export const SupportRequestDocument = `
    query supportRequest($id: ObjectID!) {
  supportRequest(id: $id) {
    id
    status
    title
    description
    application
    organization {
      id
      name
    }
    author {
      name
      ppnuid
    }
    referencePerson {
      name
      ppnuid
    }
    details {
      userAgent
      screenSize {
        width
        height
      }
      browserWindowSize {
        width
        height
      }
    }
    attachments {
      id
      name
      type
      size
      createdAt
    }
    comments {
      id
      text
      createdAt
      author {
        id: personId
        name
      }
      attachments {
        id
        name
        type
        size
        createdAt
      }
    }
    hasNewActivity
    createdAt
  }
}
    `;

export const useSupportRequestQuery = <
      TData = SupportRequestQuery,
      TError = unknown
    >(
      variables: SupportRequestQueryVariables,
      options?: Omit<UseQueryOptions<SupportRequestQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SupportRequestQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SupportRequestQuery, TError, TData>(
      {
    queryKey: ['supportRequest', variables],
    queryFn: request<SupportRequestQuery, SupportRequestQueryVariables>(SupportRequestDocument, variables),
    ...options
  }
    )};

useSupportRequestQuery.getKey = (variables: SupportRequestQueryVariables) => ['supportRequest', variables];


useSupportRequestQuery.fetcher = (variables: SupportRequestQueryVariables, options?: RequestInit['headers']) => request<SupportRequestQuery, SupportRequestQueryVariables>(SupportRequestDocument, variables, options);

export const SupportRequestsDocument = `
    query supportRequests {
  supportRequests {
    id
    status
    title
    author {
      name
    }
    organization {
      name
    }
    createdAt
    hasNewActivity
  }
}
    `;

export const useSupportRequestsQuery = <
      TData = SupportRequestsQuery,
      TError = unknown
    >(
      variables?: SupportRequestsQueryVariables,
      options?: Omit<UseQueryOptions<SupportRequestsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SupportRequestsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SupportRequestsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['supportRequests'] : ['supportRequests', variables],
    queryFn: request<SupportRequestsQuery, SupportRequestsQueryVariables>(SupportRequestsDocument, variables),
    ...options
  }
    )};

useSupportRequestsQuery.getKey = (variables?: SupportRequestsQueryVariables) => variables === undefined ? ['supportRequests'] : ['supportRequests', variables];


useSupportRequestsQuery.fetcher = (variables?: SupportRequestsQueryVariables, options?: RequestInit['headers']) => request<SupportRequestsQuery, SupportRequestsQueryVariables>(SupportRequestsDocument, variables, options);

export const SupportRequestsActivityDocument = `
    query supportRequestsActivity {
  supportRequests {
    id
    hasNewActivity
  }
}
    `;

export const useSupportRequestsActivityQuery = <
      TData = SupportRequestsActivityQuery,
      TError = unknown
    >(
      variables?: SupportRequestsActivityQueryVariables,
      options?: Omit<UseQueryOptions<SupportRequestsActivityQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SupportRequestsActivityQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SupportRequestsActivityQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['supportRequestsActivity'] : ['supportRequestsActivity', variables],
    queryFn: request<SupportRequestsActivityQuery, SupportRequestsActivityQueryVariables>(SupportRequestsActivityDocument, variables),
    ...options
  }
    )};

useSupportRequestsActivityQuery.getKey = (variables?: SupportRequestsActivityQueryVariables) => variables === undefined ? ['supportRequestsActivity'] : ['supportRequestsActivity', variables];


useSupportRequestsActivityQuery.fetcher = (variables?: SupportRequestsActivityQueryVariables, options?: RequestInit['headers']) => request<SupportRequestsActivityQuery, SupportRequestsActivityQueryVariables>(SupportRequestsActivityDocument, variables, options);

export const CreateSupportRequestDocument = `
    mutation createSupportRequest($input: CreateSupportRequestInput!) {
  createSupportRequest(input: $input) {
    id
    status
    title
    description
    application
    organization {
      name
    }
    author {
      name
    }
    referencePerson {
      name
    }
    details {
      userAgent
      screenSize {
        width
        height
      }
      browserWindowSize {
        width
        height
      }
    }
    attachments {
      id
      name
      type
      size
      createdAt
    }
    hasNewActivity
    createdAt
  }
}
    `;

export const useCreateSupportRequestMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateSupportRequestMutation, TError, CreateSupportRequestMutationVariables, TContext>) => {
    
    return useMutation<CreateSupportRequestMutation, TError, CreateSupportRequestMutationVariables, TContext>(
      {
    mutationKey: ['createSupportRequest'],
    mutationFn: (variables?: CreateSupportRequestMutationVariables) => request<CreateSupportRequestMutation, CreateSupportRequestMutationVariables>(CreateSupportRequestDocument, variables)(),
    ...options
  }
    )};


useCreateSupportRequestMutation.fetcher = (variables: CreateSupportRequestMutationVariables, options?: RequestInit['headers']) => request<CreateSupportRequestMutation, CreateSupportRequestMutationVariables>(CreateSupportRequestDocument, variables, options);

export const UpdateSupportRequestDocument = `
    mutation updateSupportRequest($input: UpdateSupportRequestInput!) {
  updateSupportRequest(input: $input) {
    id
    status
    title
    organization {
      name
    }
    author {
      name
    }
    comments {
      id
      text
      createdAt
      author {
        id: personId
        name
      }
      attachments {
        id
        name
        type
        size
        createdAt
      }
    }
    hasNewActivity
    createdAt
  }
}
    `;

export const useUpdateSupportRequestMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSupportRequestMutation, TError, UpdateSupportRequestMutationVariables, TContext>) => {
    
    return useMutation<UpdateSupportRequestMutation, TError, UpdateSupportRequestMutationVariables, TContext>(
      {
    mutationKey: ['updateSupportRequest'],
    mutationFn: (variables?: UpdateSupportRequestMutationVariables) => request<UpdateSupportRequestMutation, UpdateSupportRequestMutationVariables>(UpdateSupportRequestDocument, variables)(),
    ...options
  }
    )};


useUpdateSupportRequestMutation.fetcher = (variables: UpdateSupportRequestMutationVariables, options?: RequestInit['headers']) => request<UpdateSupportRequestMutation, UpdateSupportRequestMutationVariables>(UpdateSupportRequestDocument, variables, options);

export const DeleteSupportRequestDocument = `
    mutation deleteSupportRequest($id: ObjectID!) {
  deleteSupportRequest(id: $id) {
    id
  }
}
    `;

export const useDeleteSupportRequestMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteSupportRequestMutation, TError, DeleteSupportRequestMutationVariables, TContext>) => {
    
    return useMutation<DeleteSupportRequestMutation, TError, DeleteSupportRequestMutationVariables, TContext>(
      {
    mutationKey: ['deleteSupportRequest'],
    mutationFn: (variables?: DeleteSupportRequestMutationVariables) => request<DeleteSupportRequestMutation, DeleteSupportRequestMutationVariables>(DeleteSupportRequestDocument, variables)(),
    ...options
  }
    )};


useDeleteSupportRequestMutation.fetcher = (variables: DeleteSupportRequestMutationVariables, options?: RequestInit['headers']) => request<DeleteSupportRequestMutation, DeleteSupportRequestMutationVariables>(DeleteSupportRequestDocument, variables, options);

export const CreatePresignedUploadUrlsDocument = `
    mutation createPresignedUploadUrls($files: [UploadFileInput!]!, $type: UploadType!, $reference: UploadReference!) {
  createPresignedUploadUrls(files: $files, type: $type, reference: $reference) {
    id
    url
    fields
  }
}
    `;

export const useCreatePresignedUploadUrlsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreatePresignedUploadUrlsMutation, TError, CreatePresignedUploadUrlsMutationVariables, TContext>) => {
    
    return useMutation<CreatePresignedUploadUrlsMutation, TError, CreatePresignedUploadUrlsMutationVariables, TContext>(
      {
    mutationKey: ['createPresignedUploadUrls'],
    mutationFn: (variables?: CreatePresignedUploadUrlsMutationVariables) => request<CreatePresignedUploadUrlsMutation, CreatePresignedUploadUrlsMutationVariables>(CreatePresignedUploadUrlsDocument, variables)(),
    ...options
  }
    )};


useCreatePresignedUploadUrlsMutation.fetcher = (variables: CreatePresignedUploadUrlsMutationVariables, options?: RequestInit['headers']) => request<CreatePresignedUploadUrlsMutation, CreatePresignedUploadUrlsMutationVariables>(CreatePresignedUploadUrlsDocument, variables, options);

export const CreateDownloadUrlDocument = `
    mutation createDownloadUrl($id: ObjectID!, $type: DownloadType!, $reference: DownloadReference!) {
  createDownloadUrl(id: $id, type: $type, reference: $reference)
}
    `;

export const useCreateDownloadUrlMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateDownloadUrlMutation, TError, CreateDownloadUrlMutationVariables, TContext>) => {
    
    return useMutation<CreateDownloadUrlMutation, TError, CreateDownloadUrlMutationVariables, TContext>(
      {
    mutationKey: ['createDownloadUrl'],
    mutationFn: (variables?: CreateDownloadUrlMutationVariables) => request<CreateDownloadUrlMutation, CreateDownloadUrlMutationVariables>(CreateDownloadUrlDocument, variables)(),
    ...options
  }
    )};


useCreateDownloadUrlMutation.fetcher = (variables: CreateDownloadUrlMutationVariables, options?: RequestInit['headers']) => request<CreateDownloadUrlMutation, CreateDownloadUrlMutationVariables>(CreateDownloadUrlDocument, variables, options);

export const UserFeedbacksDocument = `
    query userFeedbacks {
  userFeedbacks {
    id
    rating
    comment
    createdAt
  }
}
    `;

export const useUserFeedbacksQuery = <
      TData = UserFeedbacksQuery,
      TError = unknown
    >(
      variables?: UserFeedbacksQueryVariables,
      options?: Omit<UseQueryOptions<UserFeedbacksQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UserFeedbacksQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<UserFeedbacksQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['userFeedbacks'] : ['userFeedbacks', variables],
    queryFn: request<UserFeedbacksQuery, UserFeedbacksQueryVariables>(UserFeedbacksDocument, variables),
    ...options
  }
    )};

useUserFeedbacksQuery.getKey = (variables?: UserFeedbacksQueryVariables) => variables === undefined ? ['userFeedbacks'] : ['userFeedbacks', variables];


useUserFeedbacksQuery.fetcher = (variables?: UserFeedbacksQueryVariables, options?: RequestInit['headers']) => request<UserFeedbacksQuery, UserFeedbacksQueryVariables>(UserFeedbacksDocument, variables, options);

export const CreateUserFeedbackDocument = `
    mutation createUserFeedback($input: CreateUserFeedbackInput!) {
  createUserFeedback(input: $input) {
    id
  }
}
    `;

export const useCreateUserFeedbackMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateUserFeedbackMutation, TError, CreateUserFeedbackMutationVariables, TContext>) => {
    
    return useMutation<CreateUserFeedbackMutation, TError, CreateUserFeedbackMutationVariables, TContext>(
      {
    mutationKey: ['createUserFeedback'],
    mutationFn: (variables?: CreateUserFeedbackMutationVariables) => request<CreateUserFeedbackMutation, CreateUserFeedbackMutationVariables>(CreateUserFeedbackDocument, variables)(),
    ...options
  }
    )};


useCreateUserFeedbackMutation.fetcher = (variables: CreateUserFeedbackMutationVariables, options?: RequestInit['headers']) => request<CreateUserFeedbackMutation, CreateUserFeedbackMutationVariables>(CreateUserFeedbackDocument, variables, options);

export const DeleteUserFeedbackDocument = `
    mutation deleteUserFeedback($id: ObjectID!) {
  deleteUserFeedback(id: $id) {
    id
  }
}
    `;

export const useDeleteUserFeedbackMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteUserFeedbackMutation, TError, DeleteUserFeedbackMutationVariables, TContext>) => {
    
    return useMutation<DeleteUserFeedbackMutation, TError, DeleteUserFeedbackMutationVariables, TContext>(
      {
    mutationKey: ['deleteUserFeedback'],
    mutationFn: (variables?: DeleteUserFeedbackMutationVariables) => request<DeleteUserFeedbackMutation, DeleteUserFeedbackMutationVariables>(DeleteUserFeedbackDocument, variables)(),
    ...options
  }
    )};


useDeleteUserFeedbackMutation.fetcher = (variables: DeleteUserFeedbackMutationVariables, options?: RequestInit['headers']) => request<DeleteUserFeedbackMutation, DeleteUserFeedbackMutationVariables>(DeleteUserFeedbackDocument, variables, options);

export const UserManagementItemsDocument = `
    query userManagementItems($input: UserManagementItemsInput) {
  userManagementItems(input: $input) {
    id
    person {
      id
      name
      ppnuid
    }
    application
    additionalOrganizations {
      id
      name
    }
  }
}
    `;

export const useUserManagementItemsQuery = <
      TData = UserManagementItemsQuery,
      TError = unknown
    >(
      variables?: UserManagementItemsQueryVariables,
      options?: Omit<UseQueryOptions<UserManagementItemsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UserManagementItemsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<UserManagementItemsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['userManagementItems'] : ['userManagementItems', variables],
    queryFn: request<UserManagementItemsQuery, UserManagementItemsQueryVariables>(UserManagementItemsDocument, variables),
    ...options
  }
    )};

useUserManagementItemsQuery.getKey = (variables?: UserManagementItemsQueryVariables) => variables === undefined ? ['userManagementItems'] : ['userManagementItems', variables];


useUserManagementItemsQuery.fetcher = (variables?: UserManagementItemsQueryVariables, options?: RequestInit['headers']) => request<UserManagementItemsQuery, UserManagementItemsQueryVariables>(UserManagementItemsDocument, variables, options);

export const CreateUserManagementItemDocument = `
    mutation createUserManagementItem($input: CreateUserManagementItemInput!) {
  createUserManagementItem(input: $input) {
    id
    person {
      id
      name
      ppnuid
    }
    application
    additionalOrganizations {
      id
      name
    }
  }
}
    `;

export const useCreateUserManagementItemMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateUserManagementItemMutation, TError, CreateUserManagementItemMutationVariables, TContext>) => {
    
    return useMutation<CreateUserManagementItemMutation, TError, CreateUserManagementItemMutationVariables, TContext>(
      {
    mutationKey: ['createUserManagementItem'],
    mutationFn: (variables?: CreateUserManagementItemMutationVariables) => request<CreateUserManagementItemMutation, CreateUserManagementItemMutationVariables>(CreateUserManagementItemDocument, variables)(),
    ...options
  }
    )};


useCreateUserManagementItemMutation.fetcher = (variables: CreateUserManagementItemMutationVariables, options?: RequestInit['headers']) => request<CreateUserManagementItemMutation, CreateUserManagementItemMutationVariables>(CreateUserManagementItemDocument, variables, options);

export const UpdateUserManagementItemDocument = `
    mutation updateUserManagementItem($input: UpdateUserManagementItemInput!) {
  updateUserManagementItem(input: $input) {
    id
    person {
      id
      name
      ppnuid
    }
    application
    additionalOrganizations {
      id
      name
    }
  }
}
    `;

export const useUpdateUserManagementItemMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateUserManagementItemMutation, TError, UpdateUserManagementItemMutationVariables, TContext>) => {
    
    return useMutation<UpdateUserManagementItemMutation, TError, UpdateUserManagementItemMutationVariables, TContext>(
      {
    mutationKey: ['updateUserManagementItem'],
    mutationFn: (variables?: UpdateUserManagementItemMutationVariables) => request<UpdateUserManagementItemMutation, UpdateUserManagementItemMutationVariables>(UpdateUserManagementItemDocument, variables)(),
    ...options
  }
    )};


useUpdateUserManagementItemMutation.fetcher = (variables: UpdateUserManagementItemMutationVariables, options?: RequestInit['headers']) => request<UpdateUserManagementItemMutation, UpdateUserManagementItemMutationVariables>(UpdateUserManagementItemDocument, variables, options);

export const DeleteUserManagementItemDocument = `
    mutation deleteUserManagementItem($id: ObjectID!) {
  deleteUserManagementItem(id: $id) {
    id
  }
}
    `;

export const useDeleteUserManagementItemMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteUserManagementItemMutation, TError, DeleteUserManagementItemMutationVariables, TContext>) => {
    
    return useMutation<DeleteUserManagementItemMutation, TError, DeleteUserManagementItemMutationVariables, TContext>(
      {
    mutationKey: ['deleteUserManagementItem'],
    mutationFn: (variables?: DeleteUserManagementItemMutationVariables) => request<DeleteUserManagementItemMutation, DeleteUserManagementItemMutationVariables>(DeleteUserManagementItemDocument, variables)(),
    ...options
  }
    )};


useDeleteUserManagementItemMutation.fetcher = (variables: DeleteUserManagementItemMutationVariables, options?: RequestInit['headers']) => request<DeleteUserManagementItemMutation, DeleteUserManagementItemMutationVariables>(DeleteUserManagementItemDocument, variables, options);
